// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../assets/img/exam/scholor3.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Caveat:wght@400;500&family=Jost:ital,wght@0,200;0,300;0,400;0,500;0,600;0,700;0,800;1,100;1,300;1,400;1,500;1,600&family=Poppins&display=swap);"]);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
/*=====================================================
Table of contents
=======================================================

=======================================================*/


/*====================
1. Google fonts
======================*/

/*@import url('https://fonts.googleapis.com/css2?family=Yantramanav:wght@100;300;400;500;700;900&amp;family=Roboto:wght@100;300;400;500;700;900&amp;display=swap');*/

/*====================
2. Theme variables
======================*/

:root {
/*    --body-font:'Jost', sans-serif;*/
 --body-font: 'Roboto', sans-serif;
  --heading-font: 'Jost', sans-serif;
  --theme-color: #116E63;
  --theme-color2: #f58634;
  --theme-color-light: rgb(17, 110, 99, 0.09);
  --theme-bg-light: #F2F3F5;
  --body-text-color: #757F95;
  --color-white: #ffffff;
  --color-black: #ffffff;
  --color-dark: #19232B;
  --hero-overlay-color: #000000;
  --slider-arrow-bg: rgba(255, 255, 255, 0.2);
  --box-shadow: 0 0 40px 5px rgb(0 0 0 / 5%);
  --box-shadow2: 0 0 15px rgba(0, 0, 0, 0.17);
  --transition: all .5s ease-in-out;
  --transition2: all .3s ease-in-out;
  --border-info-color: rgba(0, 0, 0, 0.08);
  --border-info-color2: rgba(0, 0, 0, 0.05);
  --border-white-color: rgba(255, 255, 255, 0.08);
  --border-white-color2: rgba(255, 255, 255, 0.05);
  --footer-bg: #012758;
  --footer-bg2: #116E63;
  --footer-text-color: #F5FAFF;
  --heading-border: #c7c2c2;
    
}



/*====================
3. General css
======================*/

*,
*:before,
*:after {
  box-sizing: inherit;
}

* {
  scroll-behavior: inherit !important;
}

html,
body {
  height: auto;
  width: 100%;
  margin: 0;
  padding: 0;
  overflow-x: hidden;
  box-sizing: border-box;
 
}

body {
  font-family: var(--body-font);
  font-style: normal;
  font-size: 16px;
  font-weight: normal;
  color: var(--body-text-color);
  line-height: 1.8;
}

a {
  color:  var(--color-dark);
  display: inline-block;
}

a,
a:active,
a:focus,
a:hover {
  outline: none;
  transition: all 0.3s ease-out 0s;
  text-decoration: none;
}

a:hover {
  color: var(--color-blue);
}

ul {
  margin: 0;
  padding: 0;
}

li {
  list-style: none;
}

h1,
h2,
h3,
h4,
h5,
h6 {
  color:  var(--color-dark);
  margin: 0px;
  font-weight: 600;
  font-family: var(--heading-font);
  line-height: 1;
}

h1 {
  font-size: 40px;
}

h2 {
  font-size: 35px;
}

h3 {
  font-size: 28px;
}

h4 {
  font-size: 22px;
}

h5 {
  font-size: 18px;
}

h6 {
  font-size: 16px;
}

p {
  margin: 0px;
}

.img,
img {
  max-width: 100%;
  transition: all 0.3s ease-out 0s;
  height: auto;
}

label {
  color: #999;
  cursor: pointer;
  font-weight: 400;
}

::selection {
  background: #555;
  color: var(--color-white);
  text-shadow: none;
}

*::placeholder {
  color: #999;
  font-size: 16px;
  opacity: 1;
}



/*====================
4. Preloader
======================*/

.preloader {
  position: fixed;
  width: 100%;
  height: 100%;
  background: var(--theme-color);
  top: 0;
  left: 0;
  z-index: 9999;
  display: flex;
  align-items: center;
  justify-content: center;
}

.loader-book {
  border: 5px solid var(--color-white);
  width: 100px;
  height: 61px;
  position: relative;
  perspective: 150px;
}

.loader-book-page {
  display: block;
  width: 50px;
  height: 60px;
  border: 5px solid var(--color-white);
  border-left: 5px solid var(--color-white);
  margin: 0;
  position: absolute;
  right: -4px;
  top: -4px;
  overflow: hidden;
  background: var(--theme-color);
  transform-style: preserve-3d;
  transform-origin: left center;
}

.loader-book-page:nth-child(1) {
  animation: loader-book 1.2s cubic-bezier(0, .39, 1, .68) 1.6s infinite;
}

.loader-book-page:nth-child(2) {
  animation: loader-book 1.2s cubic-bezier(0, .39, 1, .68) 1.45s infinite;
}

.loader-book-page:nth-child(3) {
  animation: loader-book 1.2s cubic-bezier(0, .39, 1, .68) 1.2s infinite;
}

@keyframes loader-book {
  0% {
    transform: rotateY( 0deg);
  }
  20% {
    background: var(--theme-color2);
  }
  40% {
    background: var(--theme-color2);
    transform: rotateY( -180deg);
  }
  100% {
    background: var(--theme-color);
    transform: rotateY( -180deg);
  }
}




/*===================
5. Theme default css
======================*/

.ovrflow-hidden {
  overflow: hidden;
}

.position-relative {
  position: relative;
  z-index: 1;
}

.text-right {
  text-align: right;
}

.space-between {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.c-pd {
  padding: 0 7rem;
}

.s-pd {
  padding: 0 12rem;
}

.h-100 {
  height: 100%;
}

.h-100vh {
  height: 100vh;
}

.bg {
  background: var(--theme-bg-light);
}




/*====================
6. Margin & padding
======================*/

.pb-140 {
  padding-bottom: 140px;
}

.pd-50 {
  padding: 50px 0;
}

.py-120 {
  padding: 120px 0;
}

.pt-120 {
  padding-top: 120px;
}

.pb-120 {
  padding-bottom: 120px;
}

.pt-0 {
  padding-top: 0px;
}

.pt-10 {
  padding-top: 10px;
}

.pt-20 {
  padding-top: 20px;
}

.pt-30 {
  padding-top: 30px;
}

.pt-40 {
  padding-top: 40px;
}

.pt-50 {
  padding-top: 50px;
}

.pt-60 {
  padding-top: 60px;
}

.pt-70 {
  padding-top: 70px;
}

.pt-80 {
  padding-top: 80px;
}

.pt-90 {
  padding-top: 90px;
}

.pt-100 {
  padding-top: 100px;
}

.pb-0 {
  padding-bottom: 0px;
}

.pb-10 {
  padding-bottom: 10px;
}

.pb-20 {
  padding-bottom: 20px;
}

.pb-30 {
  padding-bottom: 30px;
}

.pb-40 {
  padding-bottom: 40px;
}

.pb-50 {
  padding-bottom: 50px;
}

.pb-60 {
  padding-bottom: 60px;
}

.pb-70 {
  padding-bottom: 70px;
}

.pb-80 {
  padding-bottom: 80px;
}

.pb-90 {
  padding-bottom: 90px;
}

.pb-100 {
  padding-bottom: 100px;
}

.mt-0 {
  margin-top: 0px;
}

.mt-10 {
  margin-top: 10px;
}

.mt-20 {
  margin-top: 20px;
}

.mt-30 {
  margin-top: 30px;
}

.mt-40 {
  margin-top: 40px;
}

.mt-50 {
  margin-top: 50px;
}

.mt-60 {
  margin-top: 60px;
}

.mt-70 {
  margin-top: 70px;
}

.mt-80 {
  margin-top: 80px;
}

.mt-90 {
  margin-top: 90px;
}

.mt-100 {
  margin-top: 100px;
}

.mt-120 {
  margin-top: 120px;
}

.mb-0 {
  margin-bottom: 0px;
}

.mb-10 {
  margin-bottom: 10px;
}

.mb-20 {
  margin-bottom: 20px;
}

.mb-30 {
  margin-bottom: 30px;
}

.mb-40 {
  margin-bottom: 40px;
}

.mb-50 {
  margin-bottom: 50px;
}

.mb-60 {
  margin-bottom: 60px;
}

.mb-70 {
  margin-bottom: 70px;
}

.mb-80 {
  margin-bottom: 80px;
}

.mb-90 {
  margin-bottom: 90px;
}

.mb-100 {
  margin-bottom: 100px;
}

.mb-120 {
  margin-bottom: 120px;
}

.mr-300 {
  margin-right: 300px;
}

.ml-300 {
  margin-left: 300px;
}


/*====================
1. inner all wraper
======================*/


   .pd-dashboard-banner-bg {background-position: 50%;background-repeat: no-repeat;background-size: cover;border-radius: 14px;
    padding-top: 154px;position: relative;}
        
  .pd-instructor-wrap {padding: 0 36px 0 48px;transform: translateY(46px);}
        
     .pd-instructor-avatar {flex: 0 0 auto;margin-right: 40px;}
        
    .pd-instructor-title {color: var(--color-white);display: inline-block;font-size: 22px;font-weight: 600;margin-bottom: 2px;}
    .pd-instructor-rating{margin-right: 10px;}
        
    .pd-instructor-content{margin-top: 32px;}
    .pd-instructor-rating i{ color: var(--theme-color2);}
    .pd-instructor-rate span {color: var(--color-white);font-size: 16px;font-weight: 400;}
        
    .pd-instructor-avatar img{background-color: var(--color-white);border-radius: 50%;height: 166px;
    object-fit: cover;padding: 8px;width: 166px;}
        
  .pd-banner .form-group input[type="search"]{max-width: 840px;}
        
 .bg_all{background: #f2f3f8;}

.pd_outerall{position: relative;z-index: 1;}
.pd-user-sidebar {margin-right: 4px;}
.pd-user-wrap {background-color: var(--color-white);border-radius: 10px;box-shadow: 0 1px 1px 0 rgba(3, 11, 30, .14), 0 1px 2px 1px rgba(3, 11, 30, .06);display: block;padding: 28px 22px 12px 18px;}
.pd-user-menu {padding: 0 0 12px;}
.pd-user-menu ul li:not(:last-of-type) {margin-bottom: 5px;}
.pd-user-menu-title {color: #8f9195;font-size: 12px;font-weight: 500;letter-spacing: .24px;padding: 6px 16px 4px;text-transform: uppercase;    margin-bottom: 15px;}
.pd-user-menu ul li a { border-radius: 8px;color: #4f5158;display: flex;font-size: 15px;font-weight: 500;padding: 6px 16px 8px;
transition: all .3s ease-out 0s;}
.pd-user-menu ul li a span {display: inline-block;transform: translateY(-1px);width: 30px;}
.pd-user-menu ul li a.active {background-color: var(--theme-color2);border-radius: 8px;box-shadow: 0 0 1px 0 #1438b5, 0 1px 2px 0 rgba(20, 56, 181, .25);color: var(--color-white);}
.pd-user-menu ul li a:hover {background: rgba(85, 109, 245, .14);color: #0b5ed7;}
.pd-user-banner {border: 1px solid #e6e8f0;border-radius: 8px;margin-top: 20px;padding: 25px 0 27px 16px;position: relative;z-index: 1;}
.pd-user-banner-text {width: 50%;}
.pd-user-banner-title {color: #303651;font-size: 20px;font-weight: 600;line-height: 24px;margin-bottom: 14px;}
.pd-user-banner-shape {bottom: 8px;position: absolute;right: 0;z-index: -1;}
.pd-user-banner-btn .theme-btn {padding: 4px 10px;border-radius: 6px;font-size: 12px;text-transform: none;}

.pd-sidebar-box-right {background-color: var(--color-white);border-radius: 16px;
    box-shadow: 0 1px 1px rgba(3, 11, 30, .14), 0 1px 2px rgba(3, 11, 30, .06);
    padding: 46px 34px;}


textarea::-webkit-input-placeholder {color: #999!important; font-size: 14px!important; opacity: 1;}
.theme-btn.whatsapp{background: #00b890;}
.location-text{font-size: 14px;}
.location-area{width: 30px; height: 30px;border: 1px solid #767873;border-radius: 50%;display: inline-block;text-align: center;line-height: 30px;margin-right: 10px;}
.location-area i{color: #f9b418;}
.slider_wrap{background: #d9ecfd; border-radius: 6px;position: relative;background-repeat: no-repeat;}

.slider_wrap:before {
    content: " ";
    /* background-image: url(../../assets/img/bg/curve.png); */
    position: absolute;
    width: 100%;
    height: 100%;
    background-repeat: no-repeat;
    background-position: left top;
    left: -23px;
    background-size: 40%;
    top: -22px;
}
.result h4{font-size: 30px;line-height: 40px;padding-top: 40px;padding-left: 20px;}
.years{color: var(--theme-color2);}
.video_wraper{border-radius: 5px;}

.pb-130{padding-bottom: 130px;}


.video_wraper.last-thumb::before {
    content: "";
    position: absolute;
    width: 100%;
    height: 100%;
    left: -0.5px;
    top: 0;
    background: rgba(11, 28, 57, .7);
    z-index: +1;border-radius: 5px;
}
.more_text{position: absolute;left: 50%;top: 50%;    transform: translate(-50%, -50%);color: #fff;font-size: 28px;font-weight: 600;z-index: +2;line-height: 26px;}
.bg2{background: #fff7f0;}
.doubt-title{font-size: 32px;font-weight: 700;color: #9b4e08;font-family: 'Jost';text-align: center;line-height:1;}
.evolve{font-size: 36px;font-weight: 300;color: #21201f;line-height: 1;padding-bottom: 12px;font-family: 'Jost';}
.org-clr{color: var(--theme-color2);}

.schedule label.hide {
    margin: 0;
    position: absolute;
    right: 3px;
    top: 24%;
}
.schedule label span {
    background: #000;
    border-radius: 4px;
    color: var(--color-white);
    cursor: pointer;
    font-size: 15px;
    font-weight: 500;
    padding: 14px 25px;
    transition: all .3s ease-out 0s;
}

.slv_btn .theme-btn{border-radius: 10px; padding: 10px;}
.btn_center{display: flex;justify-content: flex-end;align-items: center;}
.topper_title{font-family: 'Jost';font-size: 26px;color: #093285;font-weight: 500;}
.name_title{font-size: 18px;font-weight: 500;color: #222;font-family: 'Jost';}
.course_title{font-size: 12px;font-weight: 500;color: #222;font-family: 'Jost';}
.topr_ctr{transform: translateY(50%);}
.find_center{display: flex;justify-content: space-between;}
.frm_inpt select, .frm_inpt input{border: none;background: none; padding: 0;border-radius: 0;}
.form_row label{font-size: 16px;color: var(--theme-color2);font-weight: 500;}
.form_row select{font-size: 14px;color: #434242;}
.video_head h6{line-height: 24px;}

.pd-dashboard-course-meta span {
    color: #8f9195;
    display: inline-block;
    font-size: 14px;
    margin-right: 10px;
}

.pd_10{padding: 5px 10px;}
.video_title i{font-size: 12px;}

.meet_title{font-family: 'Jost';font-size: 22px;color: #093285;font-weight: 500;}
.pos_title{font-size: 18px;font-weight: 500;color: #222;font-family: 'Jost';}
.course_title{font-size: 12px;font-weight: 500;color: #222;font-family: 'Jost';}

.pd_branches .course-item{padding: 0; }
.heading_branch {background: #fda31b;border-radius:12px 12px 0 0;padding: 8px 12px;color: #fff;font-size: 22px;font-weight: 500;    font-family: 'Jost';}

.common_round{float: left; width: 30px;height: 30px;background: #fef3e9;border: 1px solid #f9b418;line-height: 30px;text-align: center;border-radius: 50%;}

.common_round i{font-size: 16px; color: #f9b418;font-weight: 600;}

.info_txt{font-size: 14px; color: #222;}
.banner_pd_bottom{padding-bottom: 100px!important;}
.banner_social{margin-top: -80px;}
.theme-btn.veryfied{background: #e2f0e9;border: 1px solid #84c8a2;color:#1da45f;}
.theme-btn.veryfied i{font-size: 16px;}
.theme-btn.connect{background: #fff;border: 1px solid #fda31b;color: #fda31b;}
.theme-btn.connect i{font-size: 16px;}
.theme-btn.share{background: #fff;border: 1px solid #fda31b;color: #fda31b;}
.theme-btn.share i{font-size: 16px;}

.profile_img_chng{position: absolute;top: 50px;right: 50px;width: 50px; height: 50px;border-radius: 50%;background: #fff;line-height: 62px;text-align: center;z-index: +2;}
.profile_img_chng i{font-size: 32px;}
.pd-profile-pic-btn{width: 50px;height: 50px;position: absolute;background: #fff;border: 3px solid #fda31b;border-radius: 50%;line-height: 50px;text-align: center;left: 110px; top: 110px;}
.pd-profile-pic-btn i{font-size: 24px;color: var(--theme-color2);font-weight: 600;}

.slider_wrap .owl-carousel .owl-item img {display: block;width: 78%;}

.meet-slider.owl-carousel .owl-item img{ width: 88%;}

.form-control {padding: 15px 20px;}

.topper-slider .owl-nav {width: 100%;opacity: 0;visibility: hidden;transition: var(--transition);margin: 0;}

        .topper-slider:hover .owl-nav {display: block;opacity: 1; visibility: visible;}

        .topper-slider .owl-nav button {height: 48px;width: 48px;line-height: 45px !important;top: 50%;background: var(--theme-color2) !important;color: var(--color-white) !important;font-size: 25px !important;position: absolute;border: none;margin: 0;
        padding: 0;transition: var(--transition);border-radius: 100%;margin-top: -24px;
        }

        .topper-slider .owl-nav button:hover {background: var(--theme-color) !important;}

        .topper-slider .owl-nav .owl-prev { left: -24px;}

        .topper-slider .owl-nav .owl-prev:hover {left: -24px;}

        .topper-slider .owl-nav .owl-next { right: -24px;}

        .topper-slider .owl-nav .owl-next:hover {right: -24px;}

        /*video slider---------------------------------*/

        .video-slider .owl-nav,
        .meet-slider .owl-nav,  .result-slider .owl-nav {width: 100%;opacity: 0;visibility: hidden;
        transition: var(--transition);margin: 0;}

        .video-slider:hover .owl-nav,
        .meet-slider:hover .owl-nav,  .result-slider:hover .owl-nav {
            display: block;
            opacity: 1;
            visibility: visible;
        }

        .video-slider .owl-nav button,
        .meet-slider .owl-nav button, .result-slider .owl-nav button {height: 48px;width: 48px;line-height: 45px !important;
        top: 50%;background: var(--theme-color2) !important; color: var(--color-white) !important;font-size: 25px !important;
         position: absolute;border: none;margin: 0;padding: 0;transition: var(--transition);border-radius: 100%;margin-top: -24px;}

        .video-slider .owl-nav button:hover,
        .meet-slider .owl-nav button:hover, .result-slider .owl-nav button:hover  {
            background: var(--theme-color) !important;
        }

        .video-slider .owl-nav .owl-prev,
        .meet-slider .owl-nav .owl-prev, .result-slider .owl-nav .owl-prev{left: -24px;}

        .video-slider .owl-nav .owl-prev:hover,
        .meet-slider .owl-nav .owl-prev:hover,  .result-slider .owl-nav .owl-prev:hover {
            left: -24px;}

        .video-slider .owl-nav .owl-next,
        .meet-slider .owl-nav .owl-next, .result-slider .owl-nav .owl-next {right: -24px;}

        .video-slider .owl-nav .owl-next:hover,
        .meet-slider .owl-nav .owl-next:hover, .reslut-slider .owl-nav .owl-next:hover {right: -24px;}

@media only screen and (max-width: 767px) {
    .tp-instructor-info {
        flex-wrap: wrap;
    }
    
    .banner_social{margin-top: 20px;} 
    
    .add-dvd{display: inline-block!important;}
    
    .find_center{display: inherit;}
    
    .pd-instructor-wrap {
        transform: translateY(-50px);
    }
}

    

/*====================
7. Site title css
======================*/

.site-heading {
  margin-bottom: 40px;
  position: relative;
  z-index: 1;
}

.site-title-tagline {
  text-transform: uppercase;
  letter-spacing: 4px;
  font-size: 18px;
  font-weight: 700;
  color: var(--theme-color2);
  position: relative;
  border-bottom: 2px solid var(--theme-color2);
}

.site-title-tagline i{
  line-height: 0;
  font-size: 20px;
}

.site-title {
  font-weight: 500;
  text-transform: capitalize;
  font-size: 34px;
  color:  var(--color-dark);
  margin-top: 10px;
  margin-bottom: 0;
  position: relative;
}

.site-title span{
  color: var(--theme-color2);
}

.site-heading p {
  margin-top: 15px;
}

.heading-divider {
  display: inline-block;
  position: relative;
  width: 90px;
  height: 10px; 
  border: 3px solid rgba(33, 46, 84, 1);
  border-right-color: transparent;
}

.heading-divider.light{
  border-color: rgba(255, 255, 255, 0.2);
  border-right-color: transparent;
}

.heading-divider::after {
  position: absolute;
  content: '';
  width: 30px;
  background-color: var(--theme-color);
  top: 0;
  bottom: 0;
  left: 18px;
}




/*====================
8. Theme button
======================*/

.theme-btn {
  font-size: 14px;
  color: var(--color-white);
  padding: 14px 20px;
  transition: var(--transition);
  text-transform: uppercase;
  position: relative;
  border-radius: 50px 50px 50px 0;
  font-weight: 600;
  letter-spacing: 1px;
  cursor: pointer;
  text-align: center;
  overflow: hidden;
  border: none;
  background: var(--theme-color2);
  box-shadow: var(--box-shadow);
  z-index: 1;
}

.theme-btn::before {
  content: "";
  height: 300px;
  width: 300px;
  background:  var(--theme-color);
  border-radius: 50%;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translateY(-50%) translateX(-50%) scale(0);
  transition: 0.5s cubic-bezier(0.25, 0.46, 0.45, 0.94);
  z-index: -1;
}

.theme-btn:hover {
  color: var(--color-white);
}

.theme-btn:hover::before {
  transform: translateY(-50%) translateX(-50%) scale(1);
}

.theme-btn i {
  margin-left: 5px;
}

.theme-btn span {
  margin-right: 5px;
}

.theme-btn2{
  background: var(--color-white);
  color: var(--color-dark);
}

.theme-btn2::before{
  background: var(--theme-color);
}

.theme-btn2:hover{
  color: var(--color-white);
}




/*====================
9. Container
======================*/

@media (min-width: 1200px) {
  .container,
  .container-sm,
  .container-md,
  .container-lg,
  .container-xl {
    max-width: 1200px;
  }
}



/*====================
10. Scroll top css
======================*/

#scroll-top {
  position: fixed;
  bottom: -20px;
  right: 30px;
  z-index: 99;
  font-size: 20px;
  border: none;
  outline: none;
  border-radius: 50px;
  color: var(--color-white);
  background-color: var(--theme-color2);
  cursor: pointer;
  width: 50px;
  height: 50px;
  line-height: 50px;
  text-align: center;
  box-shadow: var(--box-shadow2);
  transition: var(--transition);
  opacity: 0;
  visibility: hidden;
  z-index: 1;
}

#scroll-top.active{
  opacity: 1;
  visibility: visible;
  bottom: 20px;
}


@media all and (min-width: 768px) and (max-width: 1199px) {
  #scroll-top.active {
    bottom: 100px;
  }
}



/*====================
11. Header top css
======================*/

.header-top {
  padding: 9px 0 10px 0;
  position: relative;
  background: #f2f3f8;
  z-index: 1;
}

/*
.header-top::before{
  content: "";
  position: absolute;
  left: 0;
  top: 0;
  bottom: -1px;
  width: 30%;
  background: var(--theme-color2);
  z-index: -1;
}
*/

.header-top-wrap {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.header-top-contact ul {
  display: flex;
  align-items: center;
  gap: 20px;
}

.header-top-contact ul li{
  display: flex;
  gap: 10px;
  border-right: 1px solid rgba(255, 255, 255, .2);
  padding-right: 20px;
}

.header-top-contact ul li:last-child{
  border: none;
  padding-right: 0;
}

.header-top-contact ul li a {
  color: #000;
  font-weight: 400;
}

.header-top-contact ul li a i{
  color: var(--theme-color2);
  margin-right: 5px;
}

.header-top-social span{
  color: #000;
  font-weight: 500;
}

.header-top-social a {
  width: 35px;
  height: 35px;
  line-height: 35px;
  color: var(--theme-color2);
  font-size: 16px;
  text-align: center;
  margin-left: 5px;
  border-radius: 50px;
  transition: all .5s ease-in-out;
}

.header-top-social a:hover {
  color: var(--theme-color2);
}


@media all and (max-width: 1199px) {
  .header-top-contact ul{
    gap: 10px;
  }

  .header-top-social a{
    width: 34px;
    height: 34px;
    line-height: 37px;
    margin-left: 0;
  }
}

@media all and (max-width: 992px) {
  .header-top {
    display: none;
  }
}



/*====================
12. Navbar css
======================*/

.navbar {
  background: var(--color-white);
  padding-top: 0px;
  padding-bottom: 0px;
  z-index: 999;
}

.custom-nav{
  background: var(--color-white);
  position: relative;
}

.navbar.fixed-top {
  background: var(--color-white) !important;
  box-shadow: var(--box-shadow2);
  animation: slide-down 0.7s;
}


@keyframes slide-down {
  0% {
    transform: translateY(-100%);
  }

  100% {
    transform: translateY(0);
  }
}

.navbar .navbar-brand .logo-display {
  display: block;
}

.navbar .navbar-brand .logo-scrolled {
  display: none;
}

.navbar.fixed-top .navbar-brand .logo-display {
  display: none;
}

.navbar.fixed-top .navbar-brand .logo-scrolled {
  display: block;
}

.navbar .navbar-toggler:focus {
  outline: none;
  box-shadow: none;
}

.navbar-toggler-mobile-icon {
  display: inline-block;
  width: inherit;
  height: inherit;
}

.navbar-brand {
  margin-right: 0;
}

.navbar-brand img {
  width: 200px;
}

.navbar .dropdown-toggle::after {
  display: inline-block;
  margin-left: 5px;
  vertical-align: baseline;
  font-family: 'Font Awesome 6 Pro';
  content: "\\f107";
  font-weight: 600;
  border: none;
  font-size: 14px;
}

@media all and (max-width: 1199px) {
  .nav-right {
    margin-left: 25px !important;
  }

  .navbar .nav-item .nav-link {
    margin-right: 15px;
  }

  .navbar-brand img{ width: 166px; }

  .navbar .nav-right-btn {
    display: flex;
  }
}

@media all and (min-width: 992px) {
  .navbar .nav-item .nav-link {
    margin-right: 8px;
    padding: 20px 0 30px 0;
    font-size: 12px;
    font-weight: 400;
    color: #000;
    text-transform: capitalize;
  }

  .navbar .nav-item:last-child .nav-link {
    margin-right: 0;
  }

  .navbar .nav-item .dropdown-menu {
    display: block;
    opacity: 0;
    visibility: hidden;
    transition: .3s;
    margin-top: 0;
    border: none;
    left: -15px;
    border-radius: 0px;
    border-top: 4px solid var(--theme-color2);
    background: var(--theme-color);
    width: 220px;
    box-shadow: var(--box-shadow);
  }

  .navbar .nav-item .dropdown-menu li {
    border-bottom: 1px solid var(--border-white-color);
  }

  .navbar .nav-item .dropdown-menu li:last-child {
    margin-bottom: 0;
    border-bottom: none;
  }

  .navbar .nav-item .dropdown-menu .dropdown-item {
    font-size: 16px;
    padding: 8px 25px;
    font-weight: 500;
    color:  var(--color-white);
    position: relative;
    overflow: hidden;
    text-transform: capitalize;
    transition: all .3s ease-in-out;
  }

  .navbar .nav-item .dropdown-menu .dropdown-item:hover {
    background: transparent;
    color: var(--theme-color2);
    padding-left: 32px;
  }

  .navbar .nav-item .dropdown-menu .dropdown-item::before {
    content: "//";
    position: absolute;
    left: 15px;
    top: 8px;
    color: var(--theme-color2);
    opacity: 0;
    visibility: hidden;
    transition: var(--transition);
    z-index: -1;
  }

  .navbar .nav-item .dropdown-menu .dropdown-item:hover::before {
    opacity: 1;
    visibility: visible;
  }

  .navbar .nav-item .nav-link {
    position: relative;
  }

  .navbar .nav-item .nav-link.active,
  .navbar .nav-item:hover .nav-link {
    color: var(--theme-color2);
  }

  .navbar .nav-item:hover .dropdown-menu {
    transition: .3s;
    opacity: 1;
    visibility: visible;
    top: 100%;
    transform: rotateX(0deg);
  }

  .navbar .dropdown-menu-end {
    right: 0;
    left: auto;
  }

  .navbar .dropdown-menu.fade-down {
    top: 80%;
    transform: rotateX(-75deg);
    transform-origin: 0% 0%;
  }

  .navbar .dropdown-menu.fade-up {
    top: 140%;
  }

  .navbar #main_nav {
    justify-content: flex-end;
  }

  /* nav right */
  .nav-right {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 30px;
    margin-left: 45px;
  }

  .nav-right-link {
    position: relative;
    font-size: 20px;
    color:  var(--color-dark);
    transition: var(--transition);
  }

  .nav-right-link:hover {
    color: var(--theme-color) !important;
  }

  .nav-right .sidebar-btn .nav-right-link,
  .nav-right .search-btn .nav-right-link {
    border: none;
    background: transparent;
    color: var(--color-dark);
    font-size: 28px;
    padding-right: 0;
  }

  .nav-right .search-btn .nav-right-link {
    font-size: 20px;
    padding: 0;
  }

  .nav-right .cart-btn .nav-right-link {
    position: relative;
    font-size: 20px;
    padding: 0;
    margin-right: 15px;
  }

  .nav-right .cart-btn span{
    position: absolute;
    right: -9px;
    top: -2px;
    width: 15px;
    height: 15px;
    line-height: 15px;
    text-align: center;
    font-size: 12px;
    border-radius: 50px;
    background: var(--theme-color);
    color: var(--color-white);
  }

}


/* mobile menu */
.mobile-menu-right {
  display: none;
}

@media all and (max-width: 991px) {
  .navbar {
    top: 0;
    right: 0;
    left: 0;
    position: fixed;
  }
  .navbar-brand {
    padding-left: 10px;
  }

  .navbar-brand img {
    width: 130px;
  }

  .navbar-collapse {
    max-height: 220px;
    overflow: hidden;
    overflow-y: auto;
    padding: 0 20px;
    background-color: var(--color-white);
  }

  .dropdown-toggle::after {
    float: right;
  }

  .navbar .nav-item .nav-link {
    color:  var(--color-dark);
    font-weight: 700;
    transition: var(--transition);
  }

  .navbar .nav-item .nav-link:hover {
    color: var(--theme-color) !important;
  }

  .navbar-toggler {
    padding: 0;
    border: none;
  }

  .mobile-menu-right {
    display: flex;
    align-items: center;
    gap: 20px;
  }

  .mobile-menu-right .nav-right-link {
    background: transparent;
    border: none;
    font-size: 20px;
    color: var(--color-dark);
  }

  .mobile-menu-right .nav-right-link:hover{
    color: var(--theme-color);
  }

  .search-area.open{
    top: 50px !important;
  }

  .navbar-toggler-mobile-icon {
    font-size: 25px;
    color:  var(--color-dark);
    font-weight: 500;
  }

  .navbar .dropdown-menu {
    border-radius: 0px;
  }

  .nav-right {
    display: none;
  }

}


/*============================
13. Mega menu
==============================*/

@media (min-width: 992px){
  .nav-item.mega-menu {
    position: static;
  }
  
  .navbar .nav-item.mega-menu .dropdown-menu{
    width: 98%;
    left: 12px;
  } 

  .mega-menu .mega-content{
    padding: 30px;
  }

  .mega-menu .mega-content h5{
    color: var(--theme-color2);
    font-size: 22px;
    margin-bottom: 20px;
  }

  .navbar .nav-item.mega-menu .dropdown-menu .dropdown-item{
    padding-left: 0;
  }

  .navbar .nav-item.mega-menu .dropdown-menu .dropdown-item::before{
    left: 0;
  }

  .navbar .nav-item.mega-menu .dropdown-menu .dropdown-item:hover{
    padding-left: 15px;
  }

  .menu-about-logo{
    margin-top: 15px;
    margin-bottom: 15px;
  }

  .menu-about-logo img{
    width: 180px;
  }

  .menu-about p{
    color: var(--color-white);
  }
}


@media (max-width: 991px){
  .menu-about-logo{
    display: none;
  }

  .mega-menu .mega-content h5{
    margin: 15px 0;
  }
}



/*============================
14. Multi level dropdown menu
==============================*/

.navbar .nav-item .dropdown-submenu {
  position: relative;
}

.navbar .nav-item .dropdown-submenu .dropdown-menu::before {
  display: none;
}

.navbar .nav-item .dropdown-submenu a::after {
  transform: rotate(-90deg);
  position: absolute;
  right: 15px;
  top: 10px;
  font-weight: 600;
}

.navbar .nav-item .dropdown-submenu a:hover {
  background: transparent;
  color: var(--color-white);
}

.navbar .nav-item .dropdown-submenu .dropdown-menu {
  top: 120%;
  left: 100%;
  opacity: 0;
  visibility: hidden;
}

.navbar .nav-item .dropdown-submenu:hover .dropdown-menu {
  top: 0;
  opacity: 1;
  visibility: visible;
}

@media all and (max-width: 991px) {
  .navbar .nav-item .dropdown-submenu .dropdown-menu {
    margin: 0 17px;
  }

  .navbar .nav-item .dropdown-submenu .dropdown-menu {
    opacity: unset;
    visibility: unset;
  }

  .navbar .nav-item .dropdown-submenu a::after {
    top: 4px;
  }

  .navbar .nav-item .dropdown-submenu a:hover {
    color: var(--theme-color);
  }
}



/*====================
15. Search popup css 
======================*/

.search-popup {
  position: fixed;
  left: 0;
  top: 0;
  height: 100vh;
  width: 100%;
  z-index: 99999;
  margin-top: -540px;
  transform: translateY(-100%);
  background-color: rgba(0, 0, 0, .8);
  transition: all 1500ms cubic-bezier(0.860, 0.000, 0.070, 1.000);
  transition-timing-function: cubic-bezier(0.860, 0.000, 0.070, 1.000);
}

.sidenav-bar-visible .search-popup {
  width: 80%;
}

.search-active .search-popup {
  transform: translateY(0%);
  margin-top: 0;
}

.search-popup .close-search {
  position: absolute;
  left: 0;
  right: 0;
  top: 75%;
  border: none;
  margin: 0 auto;
  margin-top: -200px;
  text-align: center;
  background: var(--theme-color2);
  text-align: center;
  width: 50px;
  height: 50px;
  color: var(--color-white);
  font-size: 20px;
  cursor: pointer;
  border-radius: 50px;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.05);
  transition: all 500ms ease;
  opacity: 0;
  visibility: hidden;
}

.search-popup .close-search:hover{
  background: var(--theme-color);
}

.search-active .search-popup .close-search {
  visibility: visible;
  opacity: 1;
  top: 50%;
  transition-delay: 1500ms;
}

.search-popup form {
  position: absolute;
  max-width: 700px;
  top: 50%;
  left: 15px;
  right: 15px;
  margin: -35px auto 0;
  transform: scaleX(0);
  transform-origin: center;
  transition: all 300ms ease;
}

.search-active .search-popup form {
  transform: scaleX(1);
  transition-delay: 1200ms;
}

.search-popup .form-group {
  position: relative;
  margin: 0px;
  overflow: hidden;
}

.search-popup .form-group input[type="text"], 
.search-popup .form-group input[type="search"] {
  position: relative;
  width: 100%;
  height: 65px;
  outline: none;
  border-radius: 8px;
  border: none;
  padding: 0 100px 0 35px;
  transition: all 500ms ease;
  text-transform: capitalize;
}

.search-popup .form-group input[type="submit"],
.search-popup .form-group button {
  position: absolute;
  right: 10px;
  top: 9px;
  background: var(--theme-color2);
  text-align: center;
  font-size: 20px;
  color: var(--color-white);
  padding: 6px 18px;
  border-radius: 8px;
  border: none;
  cursor: pointer;
  transition: all 500ms ease;
}

.search-popup .form-group input[type="submit"]:hover,
.search-popup .form-group button:hover {
  background: var(--theme-color);
  color: var(--color-white);
}



/*====================
16. Main section css 
======================*/

.main {
  margin-top: 0rem;
}



/*====================
17. Hero css 
======================*/
.offcanvas .contact-form .form-group .form-control{padding: 12px 20px;}
.enquire_now{position: fixed !important;top: 50%;right: -40px;z-index: +9;transform: rotate(90deg);top: 50%;}
button.enquire_now{border-radius: 0 0 10px 10px;}
.tooltip_bx{background: var(--theme-color2);border-radius: 20px;padding: 4px 10px;font-size: 11px;position: absolute;color: #fff;top: 0px;right: 62px;line-height: 1;}
.tooltip_bx:before{content: "";width: 0;height: 0;position: absolute;border-bottom: 11px solid var(--theme-color2); border-right: 12px solid transparent;
left: 40%;transform: rotate(316deg);bottom: -4px;}
.nav-right-btn i{font-size: 20px; color: #ff7900;}
.scan-me .tooltip_bx{right: -13px;}
.orange{color: #f58634;}
.offcanvas-header{border-bottom: 1px solid #ccc;}
.hero-section {
  position: relative;
}

.hero-single {
  padding-top: 20px;
  padding-bottom: 30px;
  background-position: center !important;
  background-size: cover !important;
  background-repeat: no-repeat !important;
  background: #f2f3f8;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  z-index: 1;
}
.hero-section .form-group button{
   position: absolute;
   right: 0px;
    top: 0px;
    background: var(--color-dark);
    text-align: center;
    font-size: 20px;
    color: var(--color-white);
    padding: 6px 18px;
    border-radius: 8px;
    border: none;
    cursor: pointer;
    transition: all 500ms ease;line-height: 42px;
}

h2.site-title::before {
  position: absolute;
  content: '';
  width: 25px;
  border-bottom: 3px solid var(--theme-color2);
  bottom: -8px;
  left: 0;
}

h2.site-title::after {
  position: absolute;
  content: '';
  width: 90px;
  border-bottom: 3px solid var(--heading-border);
  bottom: -8px;
  left: 32px;
}

.srch_glass{position: absolute;
    left: 20px;
    line-height: 55px;}
   
.banner_padhai1{
  position: absolute;
  left: 0;
  top: 0;
  /* background-image: url(../img/logo/element1.png); */
  background-repeat: no-repeat;
  width: 100%;
  height: 100%;
  background-size: 8%;
}  
.banner_padhai{position: relative;}
.banner_padhai2{
    position: absolute;
    /* background-image: url(../img/logo/element2.png); */
    background-repeat: no-repeat;
    width: 100%;
    height: 100%;
    background-size: 8%;
    background-position: right bottom;
    right: 0;
    bottom: 0;} 

.srch_area{position: relative  !important;
    max-width: 700px !important;
    margin: auto !important}

.layer_up{position: relative;z-index: +3;}

    
 .form-group input[type="search"]{max-width: 700px;
    width: 100%;
    height: 55px!important;
    outline: none;
    border-radius: 8px;
    border: none;
    padding: 0 100px 0 35px;
    text-transform: capitalize;
    background: #fff;border: 1px solid #a5a5a1;
}


.hero-single .hero-content {
  height: 100%;
}

.hero-single .hero-content .hero-title {
  color: var(--color-dark);
  font-size: 50px;
  font-weight: 700;
  margin: 10px 0;
  text-transform: uppercase;
}

.hero-single .hero-content .hero-title span{
  color: var(--theme-color2);
}

.hero-single .hero-content .hero-sub-title {
  display: inline-block;
  color: var(--theme-color2);
  font-size: 25px;
  letter-spacing: 6px;
  font-weight: 800;
  position: relative;
  text-transform: uppercase;
  border-bottom: 3px solid var(--theme-color2);
}

.hero-single .hero-content p {
  color: var(--theme-color2);
  line-height: 30px;
  font-size: 28px;
  font-weight: 400;
  margin-bottom: 20px;
}

.hero-single .hero-content .hero-btn {
  gap: 1rem;
  display: flex;
  margin-top: 35px;
  justify-content: start;
}

.hero-single .hero-img::before{
  content: "";
  position: absolute;
  width: 500px;
  height: 500px;
  background: var(--theme-color);
  right: 100px;
  bottom: 0px;
  border-radius: 50%;
  filter: blur(150px);
  z-index: -1;
}

.hero-single .hero-img{
  position: absolute;
  right: 100px;
  bottom: 120px;
  width: 50%;
  z-index: -1;
}

.hero-slider.owl-theme .owl-nav {
  margin-top: 0px;
}

.hero-slider.owl-theme .owl-nav [class*=owl-] {
  color: var(--color-white);
  font-size: 25px;
  margin: 0;
  padding: 0;
  background: var(--slider-arrow-bg);
  display: inline-block;
  cursor: pointer;
  height: 55px;
  width: 55px;
  line-height: 55px;
  border-radius: 50px;
  text-align: center;
  transition: var(--transition);
}

.hero-slider.owl-theme .owl-nav [class*=owl-]:hover {
  background: var(--color-white);
  color: var(--theme-color);
}

.hero-slider.owl-theme .owl-nav .owl-prev {
  left: 40px;
}

.hero-slider.owl-theme .owl-nav .owl-next {
  right: 40px;
}

.hero-slider.owl-theme .owl-nav .owl-prev,
.hero-slider.owl-theme .owl-nav .owl-next {
  position: absolute;
  top: 50%;
  transform: translate(0, -50%);
}

@media all and (max-width: 1199px) {

  .hero-single .hero-content .hero-title {
    font-size: 37px;
  }

  .hero-slider.owl-theme .owl-nav .owl-prev,
  .hero-slider.owl-theme .owl-nav .owl-next {
    top: unset;
    bottom: 30px !important;
  }

  .hero-slider.owl-theme .owl-nav .owl-prev {
    left: unset;
    right: 120px;
  }

  .hero-slider.owl-theme .owl-nav .owl-next {
    right: 40px;
  }

}

@media all and (max-width: 991px) {

  .hero-single .hero-content .hero-title {
    font-size: 50px;
  }

  .hero-single .hero-img {
    position: relative;
    width: 100%;
    right: unset;
    bottom: unset;
    margin-top: 50px;
  }

  .hero-single .hero-img::before{
    width: 250px;
    height: 250px;
  }

}

@media all and (max-width: 767px) {

  /* /exam css start-------------/ */
  .title_slc{font-size: 24px!important;}
    .course_name_hold{font-size: 12px!important;}
    .read_boy img {width: 56% !important;}
    .expert_right_img img{width: 62%!important;}
    .expert_right_img{ right: -99px!important;}
    .round_thumb img{width: 70%!important;}
    .student_right {right: -279px!important;}
    .student_right img {width: 46%!important;}
    .scholor1 img{opacity: 0.1!important;}
    .application_bg-title{font-size: 22px!important;}
    .award{display: unset!important;}
    .no-one{line-height: 30px;}
    .most-title{font-size: 32px!important;}
/* /exam css end-------------/ */

    .hero-single .hero-content p{}
    .counter-box .icon{width: 70px!important; height: 70px!important;line-height: 60px!important;}
    .counter-box{gap: 0!important;}
    .site-title{font-size: 26px;}
    .hero-single .hero-content .hero-title{font-size: 28px;}
    .hero-single .hero-content .hero-sub-title {font-size: 18px;}
    .counter-box .icon::before{left: 7px!important;top: 7px!important;}

  .hero-single .hero-content .hero-btn {
    gap: 1rem;
  }

}


.study-abroad .event-item{padding: 0;border-radius: 10px 10px 10px 0;}
.study-abroad .event-img img{border-radius: 10px 10px 10px 0;}
/*===================
18. Play btn
=====================*/

.play-btn {
  display: inline-block;
  padding: 0;
  height: 75px;
  width: 75px;
  line-height: 75px;
  font-size: 20px;
  text-align: center;
  background: var(--theme-color2);
  color: var(--color-white) !important;
  position: absolute;
  border-radius: 50%;
  z-index: 1;
}

.play-btn i::after {
  content: "";
  position: absolute;
  height: 100%;
  width: 100%;
  top: 0;
  left: 0;
  z-index: -1;
  background-color: var(--theme-color2);
  border-radius: 50px;
  animation: ripple-wave 1s linear infinite;
  transform: scale(1);
  transition: all 0.5s ease-in-out;
}

@keyframes ripple-wave {
  0% {
    opacity: 0.8;
    transform: scale(0.9);
  }

  100% {
    opacity: 0;
    transform: scale(2);
  }
}



/*====================
19. About css 
======================*/

.about-area{
  position: relative;
}

.about-left{
  margin-right: 20px;
}

.about-img{
  display: flex;
  gap: 30px;
  position: relative;
}

.about-img .img-1{
  border-radius: 80px 80px 0 80px;
}

.about-img .img-2{
  border-radius: 50%;
  border: 2px dashed var(--theme-color2);
  padding: 8px;
}

.about-img .img-3{
  border-radius: 0 80px 80px 80px;
}

.about-experience{
  display: flex;
  align-items: center;
  text-align: center;
  background: var(--theme-color2);
  padding: 15px 20px 15px 15px;
  color: var(--color-white);
  border-radius: 50px 50px 50px 0;
  box-shadow: 0 0 40px 5px rgb(0 0 0 / 10%);
}

.about-experience-icon{
  color: var(--theme-color);
  font-size: 65px;
  width: 90px;
  height: 90px;
  line-height: 70px;
  text-align: center;
  margin: auto;
  background: var(--color-white);
  border-radius: 50px;
  margin-bottom: 5px;
}

.about-experience-icon img{
  width: 65px;
}

.about-right {
  position: relative;
  display: block;
}

.about-content {
  margin-top: 30px;
  padding-bottom: 20px;
  border-bottom: 1px solid var(--border-info-color);
}

.about-item {
  position: relative;
  display: flex;
  gap: 12px;
  margin-bottom: 25px;
}

.about-item-icon {
  width: 70px;
  height: 70px;
  line-height: 58px;
  text-align: center;
  margin-bottom: 12px;
  background: var(--theme-color2);
  border-radius: 50px;
  font-size: 45px;
  color: var(--theme-color);
  box-shadow: -5px 5px 0 var(--theme-color-light);
}

.about-item-icon img{
  width: 45px;
  filter: brightness(0) invert(1);
}

.about-item-content {
  flex: 1 1;
}

.about-item-content h5 {
  font-size: 22px;
  margin-bottom: 5px;
}

.about-quote{
  position: relative;
  color: var(--color-dark);
  padding: 20px 22px;
  background: var(--theme-color-light);
  border-radius: 20px;
}

.about-quote i{
  position: absolute;
  font-size: 45px;
  color: var(--theme-color);
  right: 15px;
  bottom: -15px;
}

.about-bottom{
  display: flex;
  flex-wrap: wrap;
  gap: 25px;
  margin-top: 30px;
}

.about-phone{
  display: flex;
  align-items: center;
  gap: 12px;
}

.about-phone .icon{
  width: 48px;
  height: 48px;
  line-height: 48px;
  background: var(--theme-color);
  color: var(--color-white);
  border-radius: 50px;
  text-align: center;
  font-size: 22px;
  box-shadow: -5px 5px 0 var(--theme-color-light);
}

.about-phone .number{
  line-height: 1;
}

.about-phone .number span{
  color: var(--theme-color2);
  font-weight: 500;
}

.about-phone .number h6{
  font-size: 20px;
  margin-top: 8px;
}

.about-phone .number h6 a{
  color: var(--theme-color);
}


@media all and (max-width: 991px) {

  /* /exam css start-------------/ */
    .student_right{right: -216px!important;} 
    .scholor1 img{opacity: 0.1!important;}
    .student_right img {width: 42%!important;}
    .scholorship .theme-btn{padding: 2px 8px!important;}
    .add-bld{font-size: 30px!important;}
     .banner_exm_lft img{opacity: 0.2!important;}
    .banner_exm_right img{opacity: 0.2!important;}
    .nws_scroll{padding-top: 50px!important;}

    /* /exam css end-------------/ */
  .about-right {
    margin-top: 30px;
  }
}

@media all and (max-width: 767px) {
  .about-item {
    margin-top: 30px;
  }
}

/*====================
20. universities 
======================*/
.explore_course.universities .course-meta{justify-content: space-between;}
.explore_course.universities .course-item{border-radius: 4px;padding: 0;}
.pd_20{padding: 20px;}
.universities .course-tag2 {
    position: absolute;
    right:0;
    bottom: 0;
    background: var(--theme-color2);
    color: var(--color-white);
    border-radius: 20px 20px 0 0;
    padding: 2px 16px;
    margin-bottom: 10px;
    display: inline-block;
    box-shadow: var(--box-shadow2);
    z-index: 1;font-size: 12px;margin: auto;
}



/*====================
20. courses 
======================*/
.explore_course .theme-btn{padding: 7px 20px;border-radius: 10px;}
/*====================
20. exam 
======================*/
.pd-20{padding: 20px 0 0px 20px;}
.exams .curve {
    width: 0;
    height: 0;
    position: absolute;
    bottom: -17px;
    border-top: 15px solid #24272b;
    border-left: 15px solid transparent;
    left: -33px;
}
.exams .course-tag{left: -33px;bottom: -14px; padding: 12px 30px; }

/*====================
20. learn from the best 
======================*/
.tchr_info_wraper{background: #fff;position: absolute;padding: 20px;border-radius: 10px;bottom: 34px; z-index: +99;left: 50%;transform: translateX(-50%);width: 320px;}
.learn .event-item{padding: 0;}
.learn .course-meta{display: inherit;} 
.learn .course-meta p{font-size: 14px;} 
.learn .event-img img{border-radius: 10px 10px 10px 0;}
.register_btn{position: absolute;left: 50%;transform: translateX(-50%);width: 175px;}
.learn .theme-btn{border-radius: 10px; padding: 7px 20px;}
    

/*====================
20. Course css 
======================*/
.add-norm{font-family: jost; font-size: 28px;color: #3a294b;font-weight: 300;line-height: 40px;}
.add-bld{font-family: jost; font-size: 38px;color: #3a294b;font-weight: 600;}
.course-area{
  position: relative;
}

.course-item{
  position: relative;
  background: var(--color-white);
  padding: 20px;
  border-radius: 10px 10px 10px 0;
  margin-bottom: 25px;
  box-shadow: var(--box-shadow)!important;border: 1px solid #bfc4c8;
    
}

.sec_bg{background: #ffe4cc;}
.add-dvd{display: flex;justify-content: space-between;align-items: center;}

.curve{width: 0;
    height: 0;
    position: absolute;
    bottom: -27px;
    border-top: 15px solid #24272b;
    border-left: 15px solid transparent;
    left: -33px;}

.course-tag{
  position: absolute;
  left: -33px;
  bottom: -23px;
  background: var(--theme-color2);
  color: var(--color-white);
  border-radius: 40px 40px 40px 0;
  padding: 2px 10px;
  margin-bottom: 10px;
  display: inline-block;
  box-shadow: var(--box-shadow2);
  z-index: 1;font-size: 12px;
}

.course-img{
  position: relative;
}

.course-img img{
  border-radius: 10px 10px 10px 0;
  height:300px;
}


.course-item:hover .course-img::before{
	opacity: 0.5;
	visibility: visible;
}

.course-img a {
	position: absolute;
	top: 50%;
	left: 50%;
	width: 50px;
	height: 50px;
	line-height: 50px;
	border-radius: 100%;
	line-height: 50px;
	padding: 0;
	margin: -25px 0 0 -25px;
	color: var(--color-white);
	background: var(--theme-color2);
	transform: scale(3);
	opacity: 0;
	visibility: hidden;
	transition: var(--transition);
	z-index: 1;
}

.explore_course .course-meta{justify-content: end;}
.explore_course .course-bottom{padding: 5px 0;margin-top: 0;}
.explore_course .course-bottom-left span{font-size: 15px;}

.course-item:hover .course-img a{
	transform: scale(1);
	opacity: 1;
	visibility: visible;
}

.course-item:hover .course-img a:hover{
	background: var(--color-white);
	color: var(--theme-color2);
}

.course-meta{
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin: 5px 0;
}

.course-meta-left{
  font-weight: 500;
}

.course-meta-left i{
  color: var(--theme-color2);
}

.course-rating{
  color: var(--theme-color2);
  font-weight: 500;
}

.course-title{
  margin-bottom: 10px;
}

.course-title:hover{
  color: var(--theme-color2);
}

.course-bottom{
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-top: 15px;
  margin-top: 15px;
  border-top: 1px solid var(--border-info-color);
}

.course-bottom-left span{
  margin-right: 10px;
  font-weight: 500;
}

.course-bottom-left i{
  color: var(--theme-color2);
  margin-right: 8px;
}

.course-price{
  display: inline-block;
  background: var(--theme-color2);
  color: var(--color-white);
  padding: 1px 10px;
  border-radius: 50px 50px 50px 0;
  font-weight: 500;font-size: 12px;
}

.course-sidebar .form-select{
  padding: 12px 15px;
  box-shadow: none;
  border-radius: 8px;
}

.course-sidebar .form-select:focus{
  border-color: var(--theme-color);
}

.course-sidebar .form-check-input{
  margin-top: 7.5px;
  box-shadow: none;
}

.course-sidebar .form-check-input:focus{
  border-color: var(--theme-color);
}

.course-sidebar .form-check-label{
  color: var(--color-dark);
}

@media all and (max-width: 991px) {
  .course-sidebar {
    margin-top: 40px;
  }
}




/*====================
21. Course single css 
======================*/

.course-details-img{
  position: relative;
}

.course-details-img .play-btn{
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
}

.course-details img{
  border-radius: 20px;
}

.course-single-info .single-info{
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 20px;
}

.course-single-info .author img{
	width: 50px;
	height: 50px;
	border-radius: 100%;
}

.course-single-info .single-info i{
	width: 50px;
	height: 50px;
	line-height: 45px;
	border-radius: 100%;
	font-size: 29px;
	color: var(--theme-color2);
	border: 2px solid var(--theme-color2);
	font-size: 20px;
  text-align: center;
}

.course-single-info .single-info-content{
  margin-top: 5px;
}

.course-single-info .single-info h4{
	font-size: 16px;
	text-transform: uppercase;
}

.course-single-list i{
  color: var(--theme-color2);
  margin-right: 12px;
}

.course-feature-list a{
  display: block;
  padding: 10px 0;
  font-weight: 500;
  color: var(--color-dark);
  border-bottom: 1px solid var(--border-info-color);
}

.course-feature-list a:last-child{
  border-bottom: none;
}

.course-feature-list a span{
  float: right;
}

.course-feature-list a i{
  color: var(--theme-color2);
  width: 24px;
}

.course-single-sidebar .theme-btn{
  width: 100%;
  margin-top: 30px;
}

.course-single-sidebar .theme-btn::before{
  width: 350px;
  height: 350px;
}



/*====================
22. Feature css 
======================*/

.feature-area {
  position: relative;
  z-index: 1;
}

.fa-negative{
  margin-top: -150px;
  margin-right: 20px;
}

.feature-item {
  position: relative;
  padding: 20px 25px;
  background: var(--color-white);
  border-radius: 50px 50px 50px 0px;
  box-shadow: var(--box-shadow);
  z-index: 1;
}

.feature-item .count{
  position: absolute;
  right: 30px;
  top: 0px;
  font-size: 50px;
  font-weight: 800;
  -webkit-text-stroke: 2px var(--theme-color);
  -webkit-text-fill-color: transparent;
}

.feature-icon {
  width: 80px;
  height: 80px;
  line-height: 65px;
  border-radius: 50%;
  text-align: center;
  color: var(--color-white);
  font-size: 60px;
  background: var(--theme-color);
  margin-bottom: 25px;
  box-shadow: 5px 5px 0 var(--theme-bg-light);
  position: relative;
  transition: var(--transition);
}

.feature-item:hover .feature-icon {
  transform: rotateY(360deg);
}

.feature-icon img{
  width: 48px;
  filter: brightness(0) invert(1);
}

.feature-content{
  flex: 1 1;
}

.feature-content h4 {
  color: var(--color-dark);
  font-size: 22px;
  font-weight: 600;
  margin-bottom: 10px;
}

.feature-content p{
  color: var(--color-dark);
}

@media all and (max-width: 1199px) {
  .fa-negative {
    margin-top: -50px;
    margin-left: 20px;
  }

  .feature-item.active::before{
    transform: scale(1);
  }
}




/* ========================
23. Portfolio css 
=========================== */

.portfolio-area{
  position: relative;
}

.portfolio-item {
  position: relative;
  width: 100%;
  margin-bottom: 25px;
}

.portfolio-img {
  height: 100%;
}

.portfolio-img img {
  width: 100%;
  border-radius: 50px 50px 50px 0;
}

.portfolio-content {
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
}

.portfolio-info {
  position: absolute;
  left: 20px;
  right: 20px;
  bottom: 20px;
  background: var(--color-white);
  border-radius: 50px 50px 50px 0;
  padding: 20px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  transition: 0.3s;
}

.portfolio-item:hover .portfolio-info{
  bottom: 30px;
}

.portfolio-subtitle {
  font-size: 14px;
  color: var(--theme-color);
  margin-bottom: 7px;
  letter-spacing: 2px;
  text-transform: uppercase;
}

.portfolio-subtitle span {
  color: var(--theme-color);
}

.portfolio-title {
  color: var(--color-dark);
  font-size: 24px;
}

.portfolio-btn {
  width: 50px;
  height: 50px;
  line-height: 50px;
  background: var(--theme-color);
  color: var(--color-white);
  text-align: center;
  font-size: 24px;
  border-radius: 50px;
}

.portfolio-btn:hover{
  background: var(--theme-color2);
  color: var(--color-white);
}



/* ======================
24. Portfolio single
====================== */

.portfolio-sidebar .portfolio-sidebar-content ul li {
  border-bottom: 1px solid var(--border-info-color);
  display: block;
  margin-bottom: 10px;
  padding-bottom: 10px;
  font-size: 16px;
  font-weight: 600;
  line-height: 33px;
}

.portfolio-sidebar .portfolio-sidebar-content ul li:last-child {
  border-bottom: none;
}

.portfolio-sidebar-title {
  margin-bottom: 30px;
  font-size: 26px;
  font-weight: 600;
}

.portfolio-sidebar .portfolio-sidebar-content ul li span {
  display: block;
  font-weight: normal;
  margin: 0;
}

.portfolio-sidebar .portfolio-sidebar-content .rating a {
  color: var(--theme-color2);
}

.new-portfolio {
  background: var(--theme-color) !important;
}

.new-portfolio h4 {
  color: var(--color-white);
  margin-bottom: 30px;
  font-size: 28px;
}

.new-portfolio .theme-btn::before{
  background: var(--color-dark);
}

.portfolio-single-list i {
  color: var(--theme-color2);
  margin-right: 10px;
}

.portfolio-details h3 {
  font-weight: 700;
}

.portfolio-details img{
  border-radius: 20px;
}




/* ========================
25. Gallery css 
=========================== */

.gallery-item {
  position: relative;
  width: 100%;
  margin-bottom: 25px;
}

.gallery-img {
  height: 100%;
}

.gallery-img img {
  width: 100%;
  border-radius: 50px 50px 50px 0;
}

.gallery-content {
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
}

.gallery-content::before {
  content: "";
  position: absolute;
  left: 10px;
  top: 10px;
  right: 10px;
  bottom: 10px;
  background: var(--theme-color2);
  border-radius: 50px 50px 50px 0;
  opacity: 0;
  visibility: hidden;
  transition: 0.3s;
}

.gallery-content:hover::before {
  opacity: 0.9;
  visibility: visible
}

.gallery-link {
  width: 70px;
  height: 70px;
  display: flex;
  align-items: center;
  justify-content: center;
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%) scale(0);
  transition: 0.5s;
  border-radius: 50px;
  opacity: 0;
  visibility: hidden;
  font-size: 60px;
  color: var(--color-white);
}

.gallery-link:hover {
  color: var(--color-white);
}

.gallery-content:hover .gallery-link {
  opacity: 1;
  visibility: visible;
  transform: translate(-50%, -50%) scale(1);
}



/*====================
26. Choose css 
======================*/

.choose-area{
  position: relative;
  background: var(--footer-bg);
  z-index: 1;
}

.choose-area::before{
  content: "";
  position: absolute;
  left: 0;
  top: 0;
  /* background-image: url(../img/shape/01.png); */
  background-repeat: no-repeat;
  background-position: center;
  background-size: cover;
  width: 100%;
  height: 100%;
  opacity: 0.08;
  z-index: -1;
}

.choose-content-wrap{
  margin-top: 30px;
}

.choose-img {
  position: relative;
  margin-left: 50px;
}

.choose-img::before{
  content: "";
  position: absolute;
  left: -15px;
  bottom: -15px;
  width: 100%;
  height: 100%;
  border: 5px solid var(--theme-color2);
  border-radius: 30% 0 30% 30%;
}

.choose-img img{
  border-radius: 30% 0 30% 30%;
}

.choose-item{
  display: flex;
  align-items: center;
  gap: 10px;
  background: var(--color-white);
  border-radius: 50px 50px 50px 0;
  box-shadow: var(--box-shadow);
  padding: 15px 15px 15px 0;
  overflow: hidden;
}

.choose-item-icon{
  width: 80px;
  height: 80px;
  line-height: 75px;
  text-align: right;
  background: var(--theme-color2);
  border-radius: 50px 50px 50px 0;
  padding-right: 12px;
  margin-left: -12px;
}

.choose-item-icon i{
  color: var(--theme-color);
  font-size: 50px;
}

.choose-item-icon img{
  width: 45px;
  filter: brightness(0) invert(1);
}

.choose-item-info{
  flex: 1 1;
}

.choose-item-info h4{
  color: var(--color-dark);
  margin-bottom: 10px;
  font-size: 21px;
}

.choose-video-wrap{
  height: 100%;
  width: 100%;
  display: flex;
  align-items: flex-end;
  justify-content: center;
}

@media all and (max-width: 991px) {
  .choose-content-info{
    margin-right: 100px;
  }

  .choose-video-wrap{
    padding-top: 210px;
  }

  .choose-img{
    margin-top: 50px;
    margin-left: 10px;
  }
}

@media all and (max-width: 767px) {
  .choose-content-info{
    margin-right: 40px;
  }
}



/*====================
27. Testimonial css 
======================*/

.testimonial-area {
  position: relative;
}

.ts-bg{
  /* background-image: url(../img/testimonial/bg.jpg); */
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center;
  position: relative;
}

.ts-bg::before{
  content: "";
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  background: rgba(1, 39, 88, .85);
}

.testimonial-item {
  background: var(--color-white);
  border-radius: 40px 40px 40px 0;
  padding: 25px 25px;
  margin: 6px;
  position: relative;
  border-bottom: 5px solid var(--theme-color2);
}

.testimonial-content{
  display: flex;
  align-items: center;
  gap: 10px;
  margin-top: 20px;
}

.testimonial-quote p {
  color: var(--body-text-color);
  font-style: italic;
  font-weight: 500;
}

.testimonial-author-info{
  margin: 15px 0 10px 0;
}

.testimonial-author-img {
  width: 75px;
  padding: 4px;
  border-radius: 50px;
  border: 2px dashed var(--theme-color2);
}

.testimonial-author-img img {
  border-radius: 50%;
}

.testimonial-author-info h4 {
  font-size: 20px;
  color:  var(--color-dark);
  margin-bottom: 2px;
}

.testimonial-author-info p {
  color: var(--theme-color2);
  font-weight: 500;
}

.testimonial-quote-icon {
  position: absolute;
  right: 0px;
  top: 0px;
  color: var(--color-white);
  font-size: 30px;
  width: 40px;
  height: 40px;
  line-height: 41px;
  text-align: center;
  background: var(--theme-color2);
  border-radius: 50px 50px 50px 0;
}

.testimonial-area .owl-dots {
  text-align: center;
  margin-top: 30px;
}

.testimonial-area .owl-dots .owl-dot span {
  background: var(--theme-color2);
  border-radius: 50px;
  margin: 5px;
  width: 8px;
  height: 8px;
  display: inline-block;
  transition: var(--transition);
}

.testimonial-area .owl-dots .owl-dot.active span {
  width: 20px;
}

.testimonial-rate {
  color: var(--theme-color2);
  margin-bottom: 15px;
}

.testimonial-area2.ts-bg{
  padding-top: 120px;
  background-attachment: fixed;
}




/*====================
28. Counter css 
======================*/

.counter-area {
  position: relative;
  /* background-image: url(../img/counter/01.jpg); */
  background-repeat: no-repeat;
  background-position: center;
  background-size: cover;
  background-attachment: fixed;
  z-index: 1;
}

.counter-area::before{
  content: "";
  position: absolute;
  background: var(--theme-color);
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  opacity: .7;
  z-index: -1;
}

.counter-box {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  text-align: center;
  gap: 0;
  position: relative;
  z-index: 1;
}

.counter-box .icon {
  position: relative;
  text-align: center;
  font-size: 60px;
  width: 100px;
  height: 100px;
  line-height: 88px;
  color: var(--color-white);
  background:  var(--theme-color2);
  border-radius: 30% 70% 70% 30% / 30% 30% 70% 70%;
}

.counter-box .icon img{
padding: 20px;
  filter: brightness(0) invert(1);
}

.counter-box .icon::before{
  content: "";
  position: absolute;
  left: 10px;
  top: 10px;
  width: 100%;
  height: 100%;
  border-radius: 30px;
  border: 3px solid var(--color-dark);
  transition: var(--transition);
  border-radius: 30% 70% 70% 30% / 30% 30% 70% 70%;
  z-index: -1;
}

.counter-box:hover .icon::before{
  left: 0;
  top: 0;
}

.counter-box .counter {
  display: block;
  line-height: 1;
  color: var(--color-white);
  font-size: 50px;
  font-weight: 600;
}

.counter-box .title {
  color: var(--color-dark);
  margin-top: 20px;
  font-size: 20px;
  font-weight: 600;
  text-transform: capitalize;
}

@media all and (max-width: 991px) {
  .counter-area .counter-box {
    margin: 40px 0;
  }
}




/*====================
29. Cta css 
======================*/

.cta-area{
  position: relative;
  /* background-image: url(../img/cta/01.jpg); */
  background-repeat: no-repeat;
  background-position: center;
  background-size: cover;
}

.cta-content{
  position: relative;
  padding: 80px 40px;
  margin-top: -40px;
  z-index: 1;
}

.cta-content::before{
  content: "";
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  background: var(--theme-color2);
  border-radius: 80px 80px 80px 0;
  z-index: -1;
}

.cta-content::after{
  content: "";
  position: absolute;
  left: 8px;
  top: 8px;
  bottom: 8px;
  right: 8px;
  border: 8px double var(--color-white);
  border-radius: 70px 70px 70px 0;
  z-index: -1;
}

.cta-content h1{
  color: var(--color-white);
  font-size: 45px;
}

.cta-content p{
  color: var(--color-white);
  margin-top: 15px;
  margin-bottom: 30px;
  font-size: 18px;
}

.cta-btn .theme-btn{
  background: var(--color-white);
  color: var(--color-dark);
}

.cta-btn .theme-btn:hover{
  color: var(--color-white);
}



/* ===================
30. Event css 
====================== */
.dvder{border-top: 1px solid var(--border-info-color);padding-top: 10px;}
.event-item{
  position: relative;
  background: var(--color-white);
  border-radius: 20px 20px 20px 0;
  padding: 20px 20px 20px 20px;
  margin-bottom: 25px;
  box-shadow: var(--box-shadow);
  border: 1px solid #bfc4c8;
}

.event-location{
  margin-bottom: 12px;
}

.event-location i{
  color: var(--theme-color2);
}

.event-img{
  position: relative;
  overflow: hidden;
  border-radius: 20px 20px 20px 0;
}

.event-img img{
  border-radius: 40px 40px 40px 0;
  box-shadow: var(--box-shadow);
  height: 230px;
}

.teacher-img img{
  border-radius: 40px 40px 40px 0;
  box-shadow: var(--box-shadow);
  height: 350px;
}

.event-item:hover .event-img img{
  transform: scale(1.1);
} 

.event-meta{
  display: flex;
  gap: 15px;
  margin: 14px 0;
}

.event-meta i{
  color: var(--theme-color2);
  margin-right: 5px;
}

.event-title{
  margin-bottom: 10px;
}

.event-title:hover{
  color: var(--theme-color2);
}

.event-btn{
  margin-top: 20px;
}

.event-btn .theme-btn{
  padding: 11px 15px;
}

.event-slider .event-item{
  box-shadow: none;
  margin-bottom: 0;
}

.event-slider .owl-dots {
  text-align: center;
  margin-top: 10px;
}

.event-slider .owl-dots .owl-dot span {
  background: var(--theme-color2);
  border-radius: 50px;
  margin: 5px;
  width: 8px;
  height: 8px;
  display: inline-block;
  transition: var(--transition);
}

.event-slider .owl-dots .owl-dot.active span {
  background-color: var(--theme-color2);
  width: 20px;
}

.event-slider .owl-nav {
	width: 100%;
	opacity: 0;
	visibility: hidden;
	transition: var(--transition);
	margin: 0;
}

.event-slider:hover .owl-nav{
	display: block;
	opacity:1;
	visibility:visible;
}

.event-slider .owl-nav button {
	height: 48px;
	width: 48px;
	line-height: 45px !important;
	top: 50%;
	background: var(--theme-color2) !important;
	color: var(--color-white) !important;
	font-size: 25px !important;
	position: absolute;
	border: none;
	margin: 0;
	padding: 0;
	transition: var(--transition);
	border-radius: 100%;
	margin-top: -24px;
}

.event-slider .owl-nav button:hover{
	background: var(--theme-color) !important;
}

.event-slider .owl-nav .owl-prev{
	left:-75px;
}

.event-slider .owl-nav .owl-prev:hover{
	left:-65px;
}

.event-slider .owl-nav .owl-next{
	right:-75px;
}

.event-slider .owl-nav .owl-next:hover{
	right:-65px;
}


/* ===================
 creators css 
====================== */

.creators_wrap{box-shadow: var(--box-shadow);    padding: 30px 20px;border-radius: 20px; border: 1px solid #bfc4c8;}
.application_bg {display: flex;flex-direction: column;align-items: center;justify-content: center;text-align: center;
background-repeat: no-repeat !important;background-position: center !important;background-size: cover !important;position: relative;
padding-top: 70px;padding-bottom: 50px;z-index: 1;}
.award{display: flex;justify-content: center;align-items: center;gap: 2rem;}
.award img{width: 70px;}
.application_bg-title {font-size: 32px;color: var(--color-white);font-weight: 700;margin-bottom: 10px;text-transform: capitalize;}
.no-one{font-size: 22px;font-weight: 600;color: #fff;}
.click{font-size: 20px;color: #fff;font-weight: 600; padding-top: 20px;}
.college{color: #f7a700;}
/* ===================
31. Event single css 
====================== */

.event-details img{
  border-radius: 20px;
}

.event-map{
  margin-bottom: 20px;
}

.event-map iframe{
  border-radius: 20px;
  height: 400px;
  width: 100%;
}

.event-content-single{
  margin-bottom: 20px;
}

.event-content-single h5{
  margin-bottom: 5px;
}

.event-content-single i{
  color: var(--theme-color2);
  margin-right: 5px;
}

.event-single-info p{
  margin-bottom: 20px;
}

.event-author-info{
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  gap: 10px;
  margin-top: 50px;
}

.event-author-info img{
  border-radius: 50%;
}

.event-author-info h5{
  margin-top: 5px;
}



/*====================
32. Enroll css 
======================*/

.enroll-area{
  position: relative;
  /* background-image: url(../img/enroll/01.jpg); */
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center;
  z-index: 1;
}

.enroll-area::before{
  content: "";
  position: absolute;
  left: 0;
  top: 0;
  background: var(--footer-bg);
  opacity: .8;
  width: 100%;
  height: 100%;
  z-index: -1;
}

.enroll-left{
  margin-right: 30px;
}

.enroll-form{
  background: var(--color-white);
  border-radius: 80px 80px 80px 0;
  box-shadow: var(--box-shadow);
}

.enroll-form form{
  padding: 30px;
}

.enroll-form-header{
  background: var(--theme-color2);
  border-radius: 50px 50px 50px 0;
  padding: 20px 30px;
}

.enroll-form-header h3{
  color: var(--color-white);
}

.enroll-form-header p{
  color: var(--color-white);
}

.enroll-form .form-group {
  margin-bottom: 20px
}

.enroll-form .form-group .form-control {
  padding: 16px 22px;
  font-size: 16px;
  border-radius: 12px;
  color: #6C757D;
  background-color: var(--theme-bg-light);
  border: none;
  box-shadow: none
}

.enroll-form .form-group .form-select{
  padding: 15px 22px;
  background-color: var(--theme-bg-light);
  color: #6C757D;
  border: none;
  box-shadow: none;
  border-radius: 8px;
}

@media all and (max-width: 991px) {
  .enroll-left{
    margin-right: 0px;
  }
}



/* ===================
33. Skill css 
====================== */

.progress-box {
  margin: 30px 0;
  position: relative;
  z-index: 1;
}

.progress-box:last-child {
  margin-bottom: 0;
}

.progress-box h5 {
  color: var(--color-white);
  font-size: 16px;
  text-transform: uppercase;
  font-weight: 600;
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 15px;
}

.progress-box .progress {
  height: 8px;
  background: var(--color-white);
  border-radius: 50px;
}

.progress-box .progress .progress-bar {
  background: var(--theme-color2);
}



/* ===================
34. Department css 
====================== */

.explore-study-area{
  position: relative;
}

.department-item{
  position: relative;
  border-radius: 10px;
  padding: 20px;
  margin-bottom: 25px;
  overflow: hidden;
  box-shadow: var(--box-shadow);border: 1px solid #ff7d08;
} 



.department-item:hover::before{
  opacity: 1;
}



.department-icon img{
  width: 60px !important;
}

.department-title{
  margin-bottom: 10px;
}

.department-title:hover{
  color: var(--theme-color2);
}

.department-btn{
  margin-top: 10px;
}

.department-btn a{
  font-size: 14px;
  font-weight: 500;
  text-transform: uppercase;
}

.department-btn a:hover{
  color: var(--theme-color2);
}

.department-btn a i{
  margin-left: 5px;
}

.department-slider .department-item{
  box-shadow: none;
  margin-bottom: 0;
}

.department-slider .owl-dots {
  text-align: center;
  margin-top: 10px;
}

.department-slider .owl-dots .owl-dot span {
  background: var(--theme-color2);
  border-radius: 50px;
  margin: 5px;
  width: 8px;
  height: 8px;
  display: inline-block;
  transition: var(--transition);
}

.department-slider .owl-dots .owl-dot.active span {
  background-color: var(--theme-color2);
  width: 20px;
}

.department-slider .owl-nav {
	width: 100%;
	opacity: 0;
	visibility: hidden;
	transition: var(--transition);
	margin: 0;
}

.department-slider:hover .owl-nav{
	display: block;
	opacity:1;
	visibility:visible;
}

.department-slider .owl-nav button {
	height: 48px;
	width: 48px;
	line-height: 45px !important;
	top: 50%;
	background: var(--theme-color2) !important;
	color: var(--color-white) !important;
	font-size: 25px !important;
	position: absolute;
	border: none;
	margin: 0;
	padding: 0;
	transition: var(--transition);
	border-radius: 100%;
	margin-top: -54px;
}

.department-slider .owl-nav button:hover{
	background: var(--theme-color) !important;
}

.department-slider .owl-nav .owl-prev{
	left:-75px;
}

.department-slider .owl-nav .owl-prev:hover{
	left:-65px;
}

.department-slider .owl-nav .owl-next{
	right:-75px;
}

.department-slider .owl-nav .owl-next:hover{
	right:-65px;
}



/*==================
35. Department single
====================*/

.department-single-list i {
  color: var(--theme-color2);
  margin-right: 10px;
}

.department-download a {
  border: 2px solid var(--theme-color2);
  padding: 12px 20px;
  color:  var(--color-dark);
  display: block;
  margin-bottom: 20px;
  border-radius: 30px 30px 30px 0;
  font-weight: 600;
  transition: var(--transition);
}

.department-download a i {
  margin-right: 10px;
}

.department-download a:hover {
  background-color: var(--theme-color2);
  color: var(--color-white);
}

.department-details h3 {
  color:  var(--color-dark);
}

.department-details img{
  border-radius: 20px;
}




/*====================
36. Partner css 
======================*/

.partner-area{
  position: relative;
}
/*====================
37. Blog css 
======================*/
.ft_head {
    position: absolute;
    left: 28px;
    top:8px;
    background: #F2F3F5;
    display: table;
    margin: auto;
    padding: 0 13px;
    width: auto;
    font-weight: 500;
    font-family: jost;
    font-size: 20px;z-index: +2
}

.department-icon{display: flex;align-items: center;justify-content: center;}


/*====================
37. Blog css 
======================*/

.blog-area{
  position: relative;
}

.blog-item{
  position: relative;
  margin-bottom: 25px;
  padding: 20px 20px 15px 20px;
  border-radius: 20px 20px 20px 0;
  background: var(--color-white);
  box-shadow: var(--box-shadow);
  transition: var(--transition);
}

.blog-item-img{
  position: relative;
  overflow: hidden;
  border-radius: 30px 30px 30px 0;
}

.blog-item-img img{
  border-radius: 30px 30px 30px 0;
}

.blog-item:hover .blog-item-img img{
  transform: scale(1.1);
} 

.blog-date{
  position: absolute;
  padding: 4px 12px 4px 12px;
  right: -10px;
  top: 40px;
  font-weight: 500;
  background: var(--theme-color2);
  color: var(--color-white);
  border-radius: 50px 50px 50px 0;
  box-shadow: var(--box-shadow);
  z-index: 2;
}

.blog-item-info {
  position: relative;
}

.blog-item-meta ul {
  margin: 0;
  padding: 0;
  margin: 12px 0;
  border-bottom: 1px solid var(--border-info-color);
  padding-bottom: 14px;
}

.blog-item-meta ul li {
  display: inline-block;
  margin-right: 15px;
  font-weight: 500;
  position: relative;
  color: var(--color-dark);
}

.blog-item-meta ul li i {
  margin-right: 5px;
  color: var(--theme-color2);
}

.blog-item-meta a:hover {
  color: var(--theme-color2);
}

.blog-title {
  font-size: 18px;
  margin-bottom: 15px;
  line-height: 1.2;
  text-transform: capitalize;
  font-weight: 600 !important;
}

.blog-item-info p {
  margin-bottom: 16px;
}

.blog-item-info .theme-btn {
  margin-top: 15px;
  padding: 11px 15px;
}

.blog-item-info h4 a {
  color: var(--color-dark);
}

.blog-item-info h4 a:hover {
  color: var(--theme-color2);
}




/*========================
38. Blog single css
==========================*/

.blog-single-content img{
  border-radius: 20px;
}

.blog-thumb-img {
  margin-bottom: 20px;
}

.blog-meta {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
}

.blog-meta .blog-meta-left ul {
  display: flex;
  align-items: center;
  gap: 20px;
}

.blog-meta .blog-meta-left ul li{
  font-weight: 500;
}

.blog-meta i {
  margin-right: 5px;
  color: var(--theme-color2);
}

.blog-meta a {
  color: var(--body-text-color);
  font-weight: 500;
}

.blog-meta a:hover {
  color: var(--theme-color);
}

.blog-details-title {
  font-size: 34px;
  color:  var(--color-dark);
}

.blockqoute {
  background: var(--theme-bg-light);
  border-left: 5px solid var(--theme-color2);
  padding: 30px;
  font-size: 17px;
  font-style: italic;
  margin: 20px 0;
  border-radius: 50px 50px 50px 0;
}

.blockqoute-author {
  margin-top: 20px;
  padding-left: 60px;
  position: relative;
  color: var(--color-dark);
}

.blockqoute-author::before {
  content: "";
  position: absolute;
  height: 2px;
  width: 40px;
  background: var(--theme-color2);
  left: 0;
  top: 10px;
}

.blog-details-tags {
  display: flex;
  align-items: center;
  gap: 20px;
}

.blog-details-tags h5 {
  color: var(--color-dark);
}

.blog-details-tags ul {
  display: flex;
  align-items: center;
  gap: 15px;
}

.blog-details-tags ul a {
  background: var(--theme-bg-light);
  color:  var(--color-dark);
  padding: 6px 18px;
  border-radius: 8px;
  transition: var(--transition);
}

.blog-details-tags ul a:hover {
  background: var(--theme-color);
  color: var(--color-white);
}

.blog-author {
  display: flex;
  justify-content: start;
  align-items: center;
  background: var(--color-white);
  border-radius: 50px 50px 50px 0;
  box-shadow: var(--box-shadow);
  margin: 50px 0;
  padding: 20px;
}

.blog-author-img {
  width: 320px;
}

.blog-author-img img{
  border-radius: 40px 40px 40px 0;
}

.author-name {
  font-size: 22px;
  color: var(--theme-color);
  margin: 8px 0;
}

.author-info {
  padding: 0 20px;
}

.author-social {
  margin-top: 10px;
}

.author-social a {
  width: 35px;
  height: 35px;
  line-height: 31px;
  text-align: center;
  border: 2px solid var(--theme-color);
  border-radius: 50px;
  margin-right: 5px;
  color: var(--theme-color);
  transition: var(--transition);
}

.author-social a:hover {
  color: var(--color-white);
  background: var(--theme-color);
}

.blog-comments {
  margin-bottom: 50px;
}

.blog-comments h3 {
  color: var(--color-dark);
}

.blog-comments-wrapper {
  margin: 30px 0;
}

.blog-comments-single {
  display: flex;
  justify-content: start;
  align-items: flex-start;
  margin-top: 50px;
}

.blog-comments-single img {
  border-radius: 50%;
}

.blog-comments-content {
  padding: 0 0 0 20px;
}

.blog-comments-content span {
  font-size: 14px;
  color: var(--theme-color2);
  font-weight: 500;
}

.blog-comments-content a {
  font-weight: 500;
  margin-top: 5px;
  color: var(--theme-color2);
}

.blog-comments-content a:hover {
  color: var(--theme-color);
}

.blog-comments-content h5 {
  color: var(--color-dark);
}

.blog-comments-reply {
  margin-left: 50px;
}

.blog-comments-form {
  padding: 30px;
  margin-top: 50px;
  border-radius: 20px;
  background: var(--theme-bg-light);
}

.blog-comments-form h3 {
  margin-bottom: 20px;
}

.blog-comments-form .form-group {
  margin-bottom: 20px;
}

.blog-comments-form .form-control {
  padding: 15px 20px;
  border-radius: 12px;
  box-shadow: none;
  transition: var(--transition);
}

.blog-comments-form .form-control:focus {
  border-color: var(--theme-color2);
}



@media all and (max-width: 767px) {
  .blog-meta {
    flex-direction: column;
    font-size: 15px;
  }

  .blog-meta .blog-meta-left ul {
    gap: 10px;
  }

  .blog-details-tags {
    flex-direction: column;
    align-items: flex-start;
  }

  .blog-author {
    flex-direction: column;
    text-align: center;
    padding: 25px;
  }

  .author-info{
    margin-top: 25px;
  }

  .blog-comments-single {
    flex-direction: column;
    text-align: center;
    padding: 30px 0px;
    box-shadow: var(--box-shadow);
    margin-bottom: 30px;
    border-radius: 10px;
  }

  .blog-comments-single img{
    margin: 0 auto 20px auto;
  }

  .blog-comments-reply {
    margin-left: 0px;
  }
}



/*=======================
39. Widget sidebar css
=========================*/

.widget {
  background: var(--theme-bg-light);
  padding: 30px;
  margin-bottom: 30px;
  border-radius: 20px;
}

.widget .widget-title {
  padding-bottom: 10px;
  margin-bottom: 30px;
  position: relative;
  font-size: 22px;
  color:  var(--color-dark);
}

.widget .widget-title::before {
  position: absolute;
  content: '';
  width: 15px;
  border-bottom: 3px solid var(--theme-color2);
  bottom: 0;
  left: 0;
}

.widget .widget-title::after {
  position: absolute;
  content: '';
  width: 30px;
  border-bottom: 3px solid var(--theme-color2);
  bottom: 0;
  left: 22px;
}

.widget .search-form .form-control {
  padding: 12px 15px 12px 15px;
  border-radius: 8px;
  box-shadow: none;
}

.widget .search-form {
  position: relative;
}

.widget .search-form .form-control:focus {
  border-color: var(--theme-color);
}

.widget .search-form button {
  position: absolute;
  right: 0;
  top: 0;
  font-size: 18px;
  padding: 8px 18px 6px 18px;
  background: transparent;
  border: none;
  color: var(--theme-color2);
}

.widget .category-list a {
  display: block;
  padding: 10px 0;
  font-weight: 500;
  border-bottom: 1px solid #ced4da;
  transition: var(--transition);
}

.widget .category-list a:last-child {
  margin-bottom: 0px;
  border-bottom: none;
}

.widget .category-list a:hover {
  padding-left: 10px;
  color: var(--theme-color2);
}

.widget .category-list a i {
  margin-right: 5px;
  color: var(--theme-color2);
}

.widget .category-list a span {
  float: right;
}

.widget .recent-post-single {
  display: flex;
  justify-content: start;
  align-items: center;
  margin-bottom: 20px;
}

.widget .recent-post-img {
  margin-right: 20px;
}

.widget .recent-post-img img {
  width: 120px;
  border-radius: 10px;
}

.widget .recent-post-bio h6 {
  font-size: 18px;
  font-weight: 600;
  text-transform: capitalize;
}

.widget .recent-post-bio span {
  font-size: 14px;
  color: var(--theme-color2);
  font-weight: 500;
}

.widget .recent-post-bio span i {
  margin-right: 5px;
}

.widget .recent-post-bio h6 a:hover {
  color: var(--theme-color2);
}

.widget .social-share-link a {
  width: 35px;
  height: 35px;
  line-height: 31px;
  border: 2px solid var(--theme-color);
  color: var(--theme-color);
  text-align: center;
  margin-right: 5px;
  border-radius: 50px;
  transition: var(--transition);
}

.widget .social-share-link a:hover {
  background: var(--theme-color);
  color: var(--color-white);
}

.widget .tag-list a {
  background: var(--color-white);
  color:  var(--color-dark);
  padding: 5px 15px;
  margin-bottom: 10px;
  margin-right: 10px;
  border-radius: 10px;
  display: inline-block;
  transition: var(--transition);
}

.widget .tag-list a:hover {
  background-color: var(--theme-color2);
  color: var(--color-white);
}



/*===================
40. Contact us css 
=====================*/

.contact-wrapper {
  position: relative;
  background: var(--color-white);
  border-radius: 20px;
  box-shadow: var(--box-shadow);
  z-index: 1;
}

.contact-img{
  position: relative;
  padding-left: 20px;
}

.contact-img::before{
  content: "";
  position: absolute;
  left: 0;
  top: 0;
  width: 50px;
  height: 100%;
  background: var(--theme-color);
  border-radius: 20px 0 0 20px;
  clip-path: polygon(100% 0, 20% 50%, 100% 100%, 0 100%, 0 0);
  z-index: -1;
}

.contact-img img{
  width: 100%;
  clip-path: polygon(100% 0, 100% 100%, 10% 100%, 0 50%, 10% 0);
}

.contact-form{
  padding: 25px 0 0 0;
}

.contact-form-header {
  margin-bottom: 30px;
}

.contact-form-header h2 {
  font-size: 30px;
  font-weight: 700;
  margin-bottom: 10px;
  color:  var(--color-dark);
}

.contact-form .form-group {
  margin-bottom: 25px;
}

.contact-form .form-group .form-control {
  padding: 15px 20px;
  border-radius: 12px;
  box-shadow: none;
  transition: var(--transition);
}

.contact-form .form-group .form-control:focus {
  border-color: var(--theme-color2);
}

.contact-map {
  margin-bottom: -9px;
}

.contact-map iframe {
  width: 100%;
  height: 450px;
}

.contact-content {
  margin-bottom: 50px;
}

.contact-info {
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  gap: 35px;
  padding: 30px 20px;
  position: relative;
  margin-bottom: 25px;
  border-radius: 50px 50px 50px 0;
  background:var(--color-white);
  box-shadow: var(--box-shadow);
  transition: var(--transition);
}

.contact-info::before{
  content: "";
  position: absolute;
  left: 20px;
  right: 20px;
  bottom: -8px;
  background: var(--theme-color);
  clip-path: polygon(20% 0%, 80% 0%, 100% 100%, 0% 100%);
  height: 20px;
  z-index: -1;
}

.contact-info-icon{
  font-size: 35px;
  color: var(--color-white);
  width: 70px;
  height: 70px;
  line-height: 70px;
  text-align: center;
  position: relative;
  border-radius: 30px;
  background: var(--theme-color);
}

.contact-info-icon::before{
  content: "";
  position: absolute;
  left: -15px;
  right: -15px;
  top: -15px;
  bottom: -15px;
  border: 3px solid var(--theme-color);
  border-radius: 40px;
}

.contact-info h5 {
  font-size: 20px;
  font-weight: 600;
  margin-bottom: 8px;
  color:  var(--color-dark);
}

.contact-info p{
  color:  var(--color-dark);
  font-weight: 500;
  font-size: 16px;
}


@media all and (max-width: 768px) {
  .contact-content {
    margin-bottom: 50px;
  }
}




/*===================
41. Team css 
=====================*/

.team-area {
  position: relative;
  overflow: hidden;
}

.team-item {
  position: relative;
  background: var(--color-white);
  padding: 15px;
  margin-bottom: 25px;
  border-radius: 60px 60px 60px 0;
  overflow: hidden;
  box-shadow: var(--box-shadow);
  transition: var(--transition);
}

.team-item:hover {
  transform: translateY(-10px);
}

.team-img img{
  border-radius: 50px 50px 50px 0;
}

.team-content {
  margin-top: 15px;
  position: relative;
}

.team-bio h5 {
  font-size: 22px;
  margin-top: 5px;
  margin-bottom: 5px;
  text-transform: capitalize;
}

.team-bio span {
  font-size: 13px;
  font-weight: 500;
  color: var(--theme-color);
  text-transform: uppercase;
  letter-spacing: 2px;
}

.team-bio h5 a:hover {
  color:  var(--theme-color);
}

.team-social-btn {
  position: absolute;
  right: -5px;
  bottom: 25px;
  width: 45px;
  height: 45px;
  line-height: 45px;
  padding-left: 12px;
  border-radius: 50px 50px 0 50px;
  cursor: pointer;
  background: var(--theme-color);
  color: var(--color-white);
  transition: var(--transition);
}

.team-item:hover .team-social-btn{
  background: var(--theme-color2);
}

.team-social {
  position: absolute;
  margin-bottom: 10px;
  text-align: center;
  top: 50px;
  right: 0px;
  bottom: 0;
  opacity: 0;
  transition: var(--transition);
}

.team-item:hover .team-social {
  opacity: 1;
  right: 30px;
}

.team-social a {
  display: block;
  color: var(--color-white);
  width: 40px;
  height: 40px;
  line-height: 40px;
  margin-bottom: 10px;
  border-radius: 50px 50px 50px 0;
  background: var(--theme-color2);
  box-shadow: var(--box-shadow);
  transition: var(--transition);
}

.team-social a:hover {
  background:  var(--theme-color);
  color: var(--color-white);
}

.team-area2 .team-item{
  padding: 0px 30px 30px 30px;
  background: transparent;
  box-shadow: none;
  overflow: unset;
}

.team-area2 .team-item::before{
  content: "";
  position: absolute;
  left: 0;
  bottom: 0;
  width: 100%;
  height: 80%;
  border-radius: 15px;
  background: var(--color-white);
  box-shadow: var(--box-shadow) !important;
  z-index: -1;
}

.team-area2 .team-img img{
  border-radius: 50px 50px 50px 0;
}

.team-area2 .team-content{
  margin-top: 30px;
}

.team-area2 .team-social-btn{
  bottom: 39px;
}

.team-area2 .team-social-btn{
  right: 0;
}



/* ===================
42. Team single css 
====================== */

.team-single-img img{
  border-radius: 50px 50px 50px 0;
}

.team-details{
  padding: 45px;
  background: var(--theme-bg-light);
  border-radius: 50px 50px 50px 0;
}

.team-details strong{
  color: var(--theme-color2);
}

.team-details-info{
  margin: 20px 0;
}

.team-details-info li{
  margin-bottom: 10px;
}

.team-details-info a:hover{
  color: var(--theme-color2);
}

.team-details-info a i{
  margin-right: 10px;
  color: var(--theme-color2);
}

.team-details-social a{
  margin-right: 15px;
  font-size: 20px;
  color: var(--theme-color2);
  display: inline-block;
  transition: all .5s ease-in-out;
}

.team-details-social a:hover{
  color: var(--theme-color);
}

.biography{
  padding-right: 20px;
  margin-bottom: 30px;
}

.team-skill .progress-box h5{
  color: var(--color-dark)
}

.team-skill .pull-right{
  color: var(--theme-color2);
}

.team-skill .progress-box .progress{
  background: var(--theme-bg-light);
}



/*====================
43. Video css 
======================*/

.video-content {
  position: relative;
  background-repeat: no-repeat;
  background-position: center;
  background-size: cover;
  border-radius: 80px 80px 80px 0;
}

.video-content::before {
  content: "";
  position: absolute;
  background: rgba(3, 2, 7, .2);
  border-radius: 80px 80px 80px 0;
  width: 100%;
  height: 100%;
  left: 0;
  top: 0;
}

.video-wrapper {
  position: relative;
  display: flex;
  justify-content: center;
  border-radius: 5px;
  height: 350px;
  z-index: 100;
}

.video-wrapper img {
  border-radius: 12px;
}

.video-area .play-btn {
  display: inline-block;
  padding: 0;
  height: 75px;
  width: 75px;
  text-align: center;
  position: absolute;
  border-radius: 50%;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}

@media all and (max-width: 767px) {
  .video-wrapper {
    height: 250px;
  }
}



/*===================
44. Pricing css 
=====================*/

.pricing-area{
  position: relative;
}

.pricing-item{
  position: relative;
  padding: 20px 40px;
  text-align: center;
  border-radius: 50px 50px 50px 0;
  background: var(--color-white);
  margin-bottom: 25px;
}

.pricing-item::before{
  content: "";
  position: absolute;
  left: 50px;
  right: 50px;
  top: -5px;
  height: 5px;
  border-radius: 10px 10px 0 0;
  background: var(--theme-color);
}

.pricing-icon{
  width: 100px;
  height: 100px;
  line-height: 90px;
  background: var(--theme-color2);
  margin: 20px auto 0 auto;
  position: relative;
  border-radius: 50%;
  color: var(--color-white);
  font-size: 70px;
}

.pricing-icon img{
  width: 60px;
  filter: brightness(0) invert(1);
}

.pricing-icon::before{
  content: "";
  position: absolute;
  left: -8px;
  right: -8px;
  top: -8px;
  bottom: -8px;
  border-radius: 50%;
  border: 3px solid var(--theme-color2);
}

.pricing-header-content{
  margin: 30px 0 20px 0;
}

.pricing-header-content h4{
  margin-bottom: 20px;
  color: var(--theme-color2);
  font-size: 30px;
}

.pricing-duration{
  color: var(--theme-color2);
  font-size: 16px;
}

.pricing-amount{
  font-size: 60px;
  color: var(--theme-color);
}

.pricing-feature ul{
  padding-top: 10px;
  margin-bottom: 25px;
  text-align: left;
  border-top: 1px solid var(--border-info-color);
}

.pricing-feature ul li{
  position: relative;
  margin: 10px 0;
  padding-left: 25px;
}

.pricing-feature ul li::before{
  content: "\\f560";
  position: absolute;
  font-family: "Font Awesome 6 Pro";
  color: var(--theme-color);
  left: 0;
  top: 0;
}

.pricing-feature .theme-btn{
  width: 100%;
}

.pricing-item.active{
  background: var(--theme-color);
}

.pricing-item.active::before{
  background: var(--theme-color2);
}

.pricing-item.active .pricing-amount{
  color: var(--color-white);
}

.pricing-item.active ul li{
  color: var(--color-white);
}

.pricing-item.active ul li::before{
  color: var(--color-white);
}

.pricing-item.active .theme-btn{
  background: var(--theme-color2);
}

.pricing-item.active .theme-btn:hover{
  color: var(--theme-color);
}

.pricing-item.active .theme-btn::before{
  background: var(--color-white);
}




/*====================
45. Faq css 
======================*/

.faq-area .accordion-item {
  border: none;
  margin-bottom: 30px;
  background: var(--color-white);
  border-radius: 30px 30px 30px 0 !important;
  box-shadow: var(--box-shadow);
}

.faq-area .accordion-item span {
  width: 45px;
  height: 45px;
  margin-right: 15px;
}

.faq-area .accordion-item i {
  width: 45px;
  height: 45px;
  line-height: 45px;
  border-radius: 50px;
  background: var(--theme-color);
  text-align: center;
  color: var(--color-white);
}

.faq-area .accordion-button:not(.collapsed) {
  color: var(--theme-color);
  background: transparent;
  box-shadow: inset 0 -1px 0 rgb(0 0 0 / 13%);
}

.accordion-button {
  border-radius: 0px !important;
  background: transparent;
  font-weight: 600;
  font-size: 20px;
  color:  var(--color-dark);
  box-shadow: none !important;
}

.accordion-button:not(.collapsed) {
  border-bottom: 1px solid var(--theme-color);
}

/* .accordion-button:not(.collapsed)::after {
  background-image: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='%23212529'%3e%3cpath fill-rule='evenodd' d='M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z'/%3e%3c/svg%3e");
} */

@media all and (max-width: 991px) {
  .faq-right {
    margin-bottom: 50px;
  }

  .accordion-button {
    font-size: 16px;
  }
}



/*====================
46. Breadcrumb css
======================*/

.site-breadcrumb {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  background-repeat: no-repeat !important;
  background-position: center !important;
  background-size: cover !important;
  position: relative;
  padding-top: 170px;
  padding-bottom: 150px;
  z-index: 1;
}

.site-breadcrumb::before {
  content: "";
  position: absolute;
  height: 100%;
  width: 100%;
  top: 0;
  left: 0;
  background: var(--hero-overlay-color);
  opacity: 0.65;
  z-index: -1;
}

.site-breadcrumb .breadcrumb-title {
  font-size: 45px;
  color: var(--color-white);
  font-weight: 700;
  margin-bottom: 10px;
  text-transform: capitalize;
}

.site-breadcrumb .breadcrumb-menu {
  position: relative;
  z-index: 1;
}

.site-breadcrumb .breadcrumb-menu li {
  position: relative;
  display: inline-block;
  margin-left: 25px;
  color: var(--color-white);
  font-weight: 500;
  text-transform: capitalize;
}

.site-breadcrumb .breadcrumb-menu li a {
  color: var(--color-white);
  transition: all 0.5s ease-in-out;
}

.site-breadcrumb .breadcrumb-menu li::before {
  position: absolute;
  content: '\\f101';
  font-family: 'Font Awesome 6 Pro';
  right: -21px;
  top: 1px;
  text-align: center;
  font-size: 16px;
  color: var(--color-white);
}

.site-breadcrumb .breadcrumb-menu li:first-child {
  margin-left: 0;
}

.site-breadcrumb .breadcrumb-menu li:last-child:before {
  display: none;
}

.site-breadcrumb .breadcrumb-menu li a:hover {
  color: var(--theme-color);
}

.site-breadcrumb .breadcrumb-menu li.active {
  color: var(--theme-color2);
}
.mobile_list{
  display:none;
}

@media (max-width: 991px) {
  .site-breadcrumb {
    padding-top: 230px;
  }
  .mobile_list{
    display: block;
    margin: 10px;;
  }
  .mobile_view{
    right: auto !important;
  }
}




/*====================
47. Pagination css 
======================*/

.pagination {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 40px;
}

.pagination .page-link {
  border: none;
  background:  var(--theme-color2);
  color: var(--color-white);
  margin: 0 10px;
  border-radius: 12px !important;
  width: 40px;
  height: 40px;
  line-height: 28px;
  text-align: center;
  transition: var(--transition);
}

.pagination .page-link:hover,
.pagination .page-item.active .page-link {
  background: var(--theme-color);
  color: var(--color-white);
}




/*====================
48. Auth css 
======================*/

.login-form {
  position: relative;
  padding: 40px;
  border-radius: 50px 50px 50px 0;
  background: var(--color-white);
  box-shadow: var(--box-shadow);
}

.login-form::before{
  content: "";
  position: absolute;
  left: 0;
  top: 50px;
  bottom: 50px;
  width: 4px;
  background: var(--theme-color);
}

.login-form .login-header {
  text-align: center;
  margin-bottom: 20px;
  padding-bottom: 20px;
  border-bottom: 1px solid var(--border-info-color);
}

.login-form .login-header img {
  width: 200px;
  margin-bottom: 10px;
}

.login-form .login-header h3 {
  color: var(--theme-color);
  margin-bottom: 5px;
  font-weight: 800;
}

.login-form .login-header p {
  font-size: 20px;
}

.login-form .login-footer {
  margin-top: 25px;
}

.login-form .login-footer p {
  text-align: center;
}

.login-form .login-footer a {
  color: var(--theme-color);
  transition: .5s;
}

.login-form .login-footer a:hover {
  color:  var(--theme-color2);
}

.login-form .form-group {
  margin-bottom: 20px;
}

.login-form label {
  color:  var(--color-dark);
  margin-bottom: 5px;
}

.login-form .form-group .form-control {
  border: 1px solid #e8e8e8;
  border-radius: 8px;
  padding: 12px 18px;
  box-shadow: none;
  transition: .5s;
}

.login-form .form-group .form-control:focus {
  border-color: var(--theme-color);
}

.login-form .form-check-input {
  box-shadow: none;
}

.login-form .form-check-input:focus{
  border-color: var(--theme-color);
}

.login-form .forgot-pass {
  color: var(--theme-color);
  transition: .5s;
}

.login-form .forgot-pass:hover {
  color:  var(--theme-color2);
}

.login-form .theme-btn {
  width: 100%;
}

.login-form .theme-btn::before{
  width: 420px;
  height: 420px;
}

.login-form .theme-btn i {
  margin-right: 5px;
}

.login-form .form-check-input {
  margin-top: 6.3px;
}

.login-form .form-check-label a {
  color: var(--theme-color);
  transition: .5s;
}

.login-form .form-check-label a:hover {
  color: var(--theme-color);
}

.form-check-input:checked {
  background-color: var(--theme-color);
  border-color: var(--theme-color);
}

.social-login {
  border-top: 1px solid #F1F1F1;
  margin-top: 15px;
}

.social-login p {
  margin: 10px 0;
}

.social-login-list {
  text-align: center;
}

.social-login-list a {
  width: 40px;
  height: 40px;
  line-height: 40px;
  background: var(--theme-color);
  border-radius: 50px;
  margin: 5px;
}

.social-login-list a i {
  color: var(--color-white);
}

.social-login-list a:hover {
  background:  var(--color-dark);
}


@media only screen and (max-width: 991px) {
  .login-form {
    padding: 40px 20px;
  }
}



/*====================
49. Coming soon css 
======================*/

.coming-soon {
  background-repeat: no-repeat;
  background-size: cover !important;
  background-position: center !important;
  min-height: 100vh;
  width: 100%;
  top: 0;
  left: 0;
  position: relative;
}

.coming-soon .container {
  position: relative;
}

.coming-soon:before {
  position: absolute;
  content: '';
  background: rgba(0, 0, 0, .7);
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
}

.coming-soon .newsletter-form {
  position: relative;
  margin-top: 30px;
}

.coming-soon .newsletter-form .input-newsletter {
  height: 55px;
  display: block;
  width: 100%;
  border: none;
  border-radius: 10px;
  font-size: 14px;
  padding-top: 0;
  padding-right: 0;
  padding-bottom: 0;
  padding-left: 25px;
}

.coming-soon .newsletter-form button {
  position: absolute;
  right: 4px;
  top: 4px;
  bottom: 4px;
  height: auto;
  border: none;
  border-radius: 10px;
  background: var(--theme-color2);
  display: inline-block;
  color: var(--color-white);
  padding-left: 30px;
  padding-right: 30px;
  font-weight: 500;
  transition: .5s;
}

.coming-soon .newsletter-form button:hover {
  background-color: var(--theme-color);
  color: var(--color-white);
}

.coming-social {
  margin-top: 30px;
  text-align: center;
}

.coming-social a {
  color: var(--color-white);
  margin: 5px;
  width: 40px;
  height: 40px;
  line-height: 36px;
  text-align: center;
  border-radius: 50px;
  border: 2px solid var(--color-white);
  display: inline-block;
  transition: .5s;
}

.coming-social a:hover {
  background: var(--theme-color);
  border-color: var(--theme-color);
}

.countdown-wrap {
  margin-top: 30px;
}

.countdown-single {
  background: var(--theme-color2);
  padding: 20px;
  margin: 10px;
  position: relative;
  overflow: hidden;
  border-radius: 50px 50px 50px 0;
  box-shadow: var(--box-shadow);
}

.countdown-single h2 {
  color: var(--color-white);
}

.countdown-single h5 {
  color: var(--color-white);
}




/*====================
50. Error css 
======================*/

.error-wrapper {
  text-align: center;
}

.error-wrapper h1 {
  font-size: 250px;
  letter-spacing: 5px;
  font-weight: bold;
  color: var(--theme-color);
}

.error-wrapper h1 span {
  color:  var(--color-dark);
}

.error-wrapper h2 {
  margin-top: 30px;
  margin-bottom: 10px;
}

.error-wrapper img {
  width: 100%;
}

.error-wrapper .theme-btn {
  margin-top: 30px;
}


@media all and (max-width: 767px) {
  .error-wrapper h1 {
    font-size: 160px;
  }
}




/*====================
51. Terms/privacy css 
====================== */

.terms-content:not(:last-child) {
  margin-bottom: 54px;
}

.terms-content:first-child {
  margin-top: -3px;
}

.terms-content .terms-list {
  margin-top: 37px;
}

.terms-content h3 {
  margin-bottom: 23px;
  position: relative;
}

.terms-content p:not(:last-child) {
  margin-bottom: 26px;
}

.terms-list li:not(:last-child) {
  margin-bottom: 16px;
}



/*====================
52. How Apply
======================*/

.how-apply{
  position: relative;
}

.how-apply .content-img{
  margin-left: 30px;
  position: relative;
  z-index: 1;
}

.how-apply .content-img::before{
  content: "";
  position: absolute;
  left: 0;
  bottom: 0;
  width: 100%;
  height: 100%;
  background: var(--theme-color);
  border-radius: 100px 100px 100px 0;
  transform: rotate(-8deg);
  z-index: -1;
}

.how-apply .content-img img{
  border-radius: 100px 100px 100px 0;
  width: 100%;
}

.how-apply .content-list li{
  margin-top: 8px;
}

.how-apply .content-list i{
  color: var(--theme-color);
  margin-right: 8px;
}

.how-apply .content-btn{
  margin-top: 40px;
}

.apply-details .details-wrapper{
  border-top: 1px solid var(--border-info-color);
  padding-top: 60px;
}

.apply-details .content-list li{
  margin-top: 8px;
}

.apply-details .content-list i{
  color: var(--theme-color);
  margin-right: 8px;
}

@media all and (max-width: 991px) {
  .how-apply .content-img{
    margin-left: 0px;
  }

  .how-apply .content-info{
    margin-bottom: 70px;
  }

  .apply-details .details-left{
    margin-bottom: 40px;
  }
}



/*====================
53. Application css 
======================*/

.application{
  position: relative;
}

.application-form{
  padding: 40px;
  border-radius: 10px;
  background: var(--color-white);
  box-shadow: var(--box-shadow);
}

.application-form h3{
  padding-bottom: 15px;
  margin-bottom: 30px;
  border-bottom: 1px solid var(--border-info-color);
}

.application-form .form-group{
  margin-bottom: 18px;
}

.application-form .form-group label{
  color: #212536;
  margin-bottom: 5px;
}

.application-form .form-control,
.application-form .form-select{
  padding: 12px 18px;
  border-radius: 8px;
  box-shadow: none;
}

.application-form .form-control:focus,
.application-form .form-select:focus{
  border-color: var(--theme-color);
}

.application-form .form-check-input{
  margin-top: 6.5px;
  box-shadow: none;
}

.application-form .form-check-input:focus{
  border-color: var(--theme-color);
}

.application-form .form-check a{
  color: var(--theme-color);
}

.application-form .form-check label{
  color: #212536;
  font-weight: 500;
}

.application-form .theme-btn{
  margin-top: 30px;
}



/*====================
54. Campus tour css 
======================*/

.campus-tour{
  position: relative;
}

.campus-tour .content-img{
  margin-left: 30px;
  position: relative;
  z-index: 1;
}

.campus-tour .content-img::before{
  content: "";
  position: absolute;
  left: 0;
  bottom: 0;
  width: 100%;
  height: 100%;
  background: var(--theme-color);
  border-radius: 50px 50px 50px 0;
  transform: rotate(-8deg);
  z-index: -1;
}

.campus-tour .content-img img{
  border-radius: 100px 100px 100px 0;
  width: 100%;
}

.campus-tour .content-btn{
  margin-top: 40px;
}

.tour-details .details-wrapper{
  border-top: 1px solid var(--border-info-color);
  padding-top: 60px;
}

.tour-details .content-list li{
  margin-top: 8px;
}

.tour-details .content-list i{
  color: var(--theme-color);
  margin-right: 8px;
}

@media all and (max-width: 991px) {
  .campus-tour .content-img{
    margin-left: 0px;
  }

  .campus-tour .content-info{
    margin-bottom: 70px;
  }

  .tour-details .details-left{
    margin-bottom: 40px;
  }
}




/*====================
55. Campus life css 
======================*/

.campus-life{
  position: relative;
}

.campus-life .content-img{
  margin-right: 30px;
  position: relative;
  z-index: 1;
}

.campus-life .content-img::before{
  content: "";
  position: absolute;
  left: -30px;
  top: -30px;
  bottom: -30px;
  width: 80%;
  border: 7px solid var(--theme-color2);
  border-radius: 100px 100px 100px 0;
  z-index: -1;
}

.campus-life .content-img img{
  border-radius: 90px 90px 90px 0;
  width: 100%;
}

.campus-life .content-btn{
  margin-top: 40px;
}

.campus-life-details .details-wrapper{
  border-top: 1px solid var(--border-info-color);
  padding-top: 60px;
}

.campus-life-details .content-list li{
  margin-top: 8px;
}

.campus-life-details .content-list i{
  color: var(--theme-color);
  margin-right: 8px;
}

.campus-life-details .details-item{
  margin-bottom: 40px;
}

.campus-life-details .details-item img{
  border-radius: 20px;
}

@media all and (max-width: 991px) {
  .campus-life .content-info{
    margin-top: 70px;
  }
}


/*====================
56. Notice board css 
======================*/

.notice-board{
  position: relative;
}

.notice-item{
  padding: 25px 25px;
  border-radius: 50px 50px 50px 0;
  margin-bottom: 25px;
  border: 2px solid transparent;
  background: var(--theme-bg-light);
  transition: var(--transition);
}

.notice-item:hover{
  border-color: var(--theme-color);
}

.notice-item h4:hover{
  color: var(--theme-color);
}

.notice-meta{
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  margin-top: 15px;
}

.notice-meta i{
  color: var(--theme-color);
}



/*====================
57. Student Activity css 
======================*/

.activity{
  position: relative;
}

.activity .content-img{
  margin-left: 30px;
  position: relative;
  z-index: 1;
}

.activity .content-img::before{
  content: "";
  position: absolute;
  left: -30px;
  top: -30px;
  bottom: -30px;
  width: 80%;
  border: 7px solid var(--theme-color2);
  border-radius: 100px 100px 100px 0;
  z-index: -1;
}

.activity .content-img img{
  border-radius: 90px 90px 90px 0;
  width: 100%;
}

.activity .content-btn{
  margin-top: 40px;
}

.activity-details .details-wrapper{
  border-top: 1px solid var(--border-info-color);
  padding-top: 60px;
}

.activity-details .content-list li{
  margin-top: 8px;
}

.activity-details .content-list i{
  color: var(--theme-color);
  margin-right: 8px;
}

.activity-details .details-item{
  margin-bottom: 40px;
}

.activity-details .details-item img{
  border-radius: 20px;
}

@media all and (max-width: 991px) {
  .activity .content-info{
    margin-bottom: 70px;
  }
}



/*====================
58. Facility css 
======================*/

.facility-area {
  position: relative;
  display: block;
  overflow: hidden;
}

.facility-item {
  position: relative;
  margin-bottom: 25px;
  border-radius: 50px 50px 50px 0;
  background: var(--color-white);
  transition: var(--transition);
  box-shadow: var(--box-shadow);
  z-index: 1;
}

.facility-item:hover {
  transform: translateY(-10px);
}

.facility-img {
  position: relative;
  z-index: 1;
}

.facility-img img{
  border-radius: 50px 50px 50px 0;
}

.facility-content {
  position: relative;
  padding: 20px 20px 15px 20px;
}

.facility-arrow {
  margin-top: 25px;
}

.facility-title a {
  font-size: 22px;
  font-weight: 600;
  margin-bottom: 10px;
  color:  var(--color-dark);
}

.facility-title a:hover {
  color: var(--theme-color);
}

.facility-arrow .theme-btn{
  padding: 12px 22px;
}




/*==================
59. Facility single
====================*/

.facility-details img{
  border-radius: 20px;
}

.facility-single-list i {
  color: var(--theme-color2);
  margin-right: 10px;
}

.facility-download a {
  border: 2px solid var(--theme-color2);
  padding: 12px 20px;
  color:  var(--color-dark);
  display: block;
  margin-bottom: 20px;
  border-radius: 50px 50px 50px 0;
  font-weight: 600;
  transition: var(--transition);
}

.facility-download a i {
  margin-right: 10px;
}

.facility-download a:hover {
  background-color: var(--theme-color2);
  color: var(--color-white);
}

.facility-details h3 {
  color: var(--color-dark);
}




/*====================
60. Research css 
======================*/

.research-area {
  position: relative;
  display: block;
  overflow: hidden;
}

.research-item {
  position: relative;
  margin-bottom: 25px;
  border-radius: 50px 50px 50px 0;
  padding: 20px 20px 15px 20px;
  background: var(--color-white);
  transition: var(--transition);
  box-shadow: var(--box-shadow);
  z-index: 1;
}

.research-item:hover {
  transform: translateY(-10px);
}

.research-img {
  position: relative;
  z-index: 1;
}

.research-img img{
  border-radius: 40px 40px 40px 0;
}

.research-content {
  position: relative;
  margin-top: 15px;
}

.research-arrow {
  margin-top: 25px;
}

.research-title a {
  font-size: 22px;
  font-weight: 600;
  margin-bottom: 10px;
  color:  var(--color-dark);
}

.research-title a:hover {
  color: var(--theme-color);
}

.research-arrow .theme-btn{
  padding: 12px 22px;
}




/*==================
61. Research single
====================*/

.research-details img{
  border-radius: 20px;
}

.research-single-list i {
  color: var(--theme-color2);
  margin-right: 10px;
}

.research-download a {
  border: 2px solid var(--theme-color2);
  padding: 12px 20px;
  color:  var(--color-dark);
  display: block;
  margin-bottom: 20px;
  border-radius: 50px 50px 50px 0;
  font-weight: 600;
  transition: var(--transition);
}

.research-download a i {
  margin-right: 10px;
}

.research-download a:hover {
  background-color: var(--theme-color2);
  color: var(--color-white);
}

.research-details h3 {
  color: var(--color-dark);
}



/*====================
62. Club css 
======================*/

.club-area {
  position: relative;
  display: block;
  overflow: hidden;
}

.club-item {
  position: relative;
  margin-bottom: 25px;
  border-radius: 50px 50px 50px 0;
  padding: 20px 20px 15px 20px;
  background: var(--color-white);
  transition: var(--transition);
  box-shadow: var(--box-shadow);
  z-index: 1;
}

.club-item:hover {
  transform: translateY(-10px);
}

.club-img {
  position: relative;
  z-index: 1;
}

.club-img img{
  border-radius: 40px 40px 40px 0;
}

.club-content {
  position: relative;
  margin-top: 15px;
}

.club-arrow {
  margin-top: 25px;
}

.club-title a {
  font-size: 22px;
  font-weight: 600;
  margin-bottom: 10px;
  color:  var(--color-dark);
}

.club-title a:hover {
  color: var(--theme-color);
}

.club-arrow .theme-btn{
  padding: 12px 22px;
}




/*==================
63. Club single
====================*/

.club-details img{
  border-radius: 20px;
}

.club-single-list i {
  color: var(--theme-color2);
  margin-right: 10px;
}

.club-download a {
  border: 2px solid var(--theme-color2);
  padding: 12px 20px;
  color:  var(--color-dark);
  display: block;
  margin-bottom: 20px;
  border-radius: 50px 50px 50px 0;
  font-weight: 600;
  transition: var(--transition);
}

.club-download a i {
  margin-right: 10px;
}

.club-download a:hover {
  background-color: var(--theme-color2);
  color: var(--color-white);
}

.club-details h3 {
  color: var(--color-dark);
}



/*====================
64. Tuition fee css 
======================*/

.tuition-fee{
  position: relative;
}



/*====================
65. Alumni css 
======================*/

.alumni{
  position: relative;
}

.alumni .content-img{
  margin-right: 30px;
  position: relative;
  z-index: 1;
}

.alumni .content-img::before{
  content: "";
  position: absolute;
  left: 30px;
  top: -30px;
  bottom: -30px;
  width: 80%;
  background: var(--theme-color2);
  border-radius: 50px 50px 50px 0;
  transform: rotate(5deg);
  z-index: -1;
}

.alumni .content-img img{
  border-radius: 50px 50px 50px 0;
  width: 100%;
}

.alumni .content-btn{
  margin-top: 40px;
}

.alumni-details .details-wrapper{
  border-top: 1px solid var(--border-info-color);
  padding-top: 60px;
}

.alumni-details .content-list li{
  margin-top: 8px;
}

.alumni-details .content-list i{
  color: var(--theme-color);
  margin-right: 8px;
}

.alumni-details .details-item{
  margin-bottom: 40px;
}

.alumni-details .details-item img{
  border-radius: 20px;
}

@media all and (max-width: 991px) {
  .alumni .content-info{
    margin-top: 70px;
  }
}



/*====================
66. Scholarship css 
======================*/

.scholarship{
  position: relative;
}

.scholarship-content img{
  border-radius: 20px;
}

.scholarship-item{
  margin-bottom: 25px;
}

.scholarship-icon img{
  width: 60px;
}

.scholarship-item h4{
  margin-top: 20px;
  margin-bottom: 10px;
}

.scholarship-details .details-wrapper{
  border-top: 1px solid var(--border-info-color);
  padding-top: 60px;
}

.scholarship-details .content-list li{
  margin-top: 8px;
}

.scholarship-details .content-list i{
  color: var(--theme-color);
  margin-right: 8px;
}

.scholarship-details .details-item{
  margin-bottom: 40px;
}



/*====================
67. Fund css 
======================*/

.fund-area{
  position: relative;
}

.fund-content img{
  border-radius: 20px;
}

.fund-contact{
  margin: 20px 0;
  background: var(--theme-bg-light);
  padding: 30px;
  border-radius: 10px;
}

.fund-contact li{
  margin: 8px 0;
}

.fund-contact i{
  color: var(--theme-color2);
  margin-right: 5px;
}

.fund-btn{
  margin-bottom: 20px;
}

.fund-btn .theme-btn{
  width: 100%;
}

.fund-btn .theme-btn::before{
  width: 400px;
  height: 400px;
}

.fund-list i {
  color: var(--theme-color2);
  margin-right: 10px;
}


/*====================
68. Athletic css 
======================*/

.athletic{
  position: relative;
}

.athletic-content img{
  border-radius: 20px;
}



/*====================
69. Health care css 
======================*/

.health-care{
  position: relative;
}

.health-care-content img{
  border-radius: 20px;
}

.health-care-content .content-list li{
  margin-top: 8px;
}

.health-care-content .content-list i{
  color: var(--theme-color);
  margin-right: 8px;
}



/*====================
70. Footer css 
======================*/

.footer-area {
  background: var(--footer-bg);
  position: relative;
  z-index: 1;
}

.footer-shape{
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  opacity: .05;
  z-index: -1;
}

.footer-widget-box {
  margin-bottom: 20px;
}

.footer-widget {
  position: relative;
  z-index: 1;
}

.footer-logo img {
  width: 220px;
  margin-bottom: 25px;
}

.copyright {
  position: relative;background: #ff7a00;
}

.copyright .copyright-wrapper{
  padding: 15px 10px;
  border-top: 1px solid var(--border-white-color);
}

.copyright .footer-menu {
  margin: 0;
  padding: 0;
  text-align: right;
}

.copyright .footer-menu li {
  display: inline-block;
  margin-left: 25px;
  font-size: 16px;
}

.copyright .footer-menu li a {
  color: var(--footer-text-color);
  transition: var(--transition);
}

.copyright .footer-menu li a:hover {
  color: var(--theme-color2);
}

.copyright .copyright-text {
  color: var(--footer-text-color);
  margin-bottom: 0px;
  font-size: 16px;
}

.copyright .copyright-text a {
  /* color: var(--theme-color2); */
  font-weight: 500;
}

.footer-widget-title {
  color: var(--color-white);
  position: relative;
  padding-bottom: 20px;
  margin-bottom: 0px;
  font-size: 18px;
  z-index: 1;
}

/*
.footer-widget-title::before {
  content: '';
  position: absolute;
  width: 90px;
  height: 3px;
  background: rgba(255, 255, 255, 0.2);
  bottom: 0;
  left: 0;
  z-index: -1;
}
*/

/*
.footer-widget-title::after {
  content: '';
  position: absolute;
  width: 30px;
  height: 3px;
  background: var(--theme-color2);
  bottom: 0;
  left: 18px;
  z-index: -1;
}
*/

ul.copyright-text li{display: inline-block;padding-right: 10px;}
.footer-list {
  display: flex;
  flex-direction: column;
  gap: .65rem;
}

.footer-list li a {
  color: var(--color-white);
  transition: var(--transition);font-size: 14px;
}

.footer-list li a i {
  margin-right: 5px;
  color: var(--theme-color2);
}

.footer-list li a:hover {
  padding-left: 10px;
  color: var(--theme-color2);
}

.footer-widget-box p {
  color: var(--color-white);
  padding-right: 18px;
  margin-bottom: 20px;
}

.footer-social {
  display: flex;
  gap: 15px;
  justify-content: end;
}

.footer-social li a i {
  height: 38px;
  width: 38px;
  line-height: 38px;
  text-align: center;
  border-radius: 10px 10px 10px 0;
  background: var(--color-white);
  color: var(--theme-color2);
  transition: var(--transition);
}

.footer-social li a i:hover {
  background: var(--theme-color2);
  color: var(--color-white);
}

.footer-contact li {
  position: relative;
  display: flex;
  justify-content: start;
  align-items: center;
  color: var(--footer-text-color);
  font-size: 16px;
  margin-bottom: 15px;
}

.footer-contact li a {
  color: var(--footer-text-color);
  transition: 0.3s;
}

.footer-contact li i {
  width: 30px;
  height: 30px;
  line-height: 30px;
  font-size: 16px;
  margin-right: 15px;
  border-radius: 10px 10px 10px 0;
  background: var(--theme-color2);
  text-align: center;
  transition: 0.3s;
  color: var(--color-white);
}

.subscribe-form .form-control {
  padding: 16px 20px;
  border-radius: 12px;
  box-shadow: none;
  border: none;
}

.subscribe-form .theme-btn {
  margin-top: 20px;
  width: 100%;
  padding: 14px;
}

.subscribe-form .theme-btn:hover {
  color: var(--theme-color2);
}

.subscribe-form .theme-btn::before{
  background: var(--color-white);
}

.subscribe-form .theme-btn:hover::after{
  border-color: var(--theme-color2);
}


@media all and (max-width: 1199px) {
  .footer-widget-box {
    margin-bottom: 50px;
  }
}

@media all and (max-width: 991px) {
  .footer-widget-wrapper {
    padding-bottom: 0px;
  }

  .copyright .footer-menu {
    float: left;
    margin-top: 20px;
    text-align: left;
  }

  .copyright .footer-menu li {
    margin-left: 0;
    margin-right: 15px;
  }

}

@media all and (max-width: 767px) {
  .footer-widget-wrapper {
    padding-bottom: 0px;
  }

  .footer-social {
    justify-content: flex-start;
    margin-top: 20px;
  }

  .copyright::before{
    width: 40%;
  }
}



/*====================
71. Home 2
======================*/

.home-2 .header{
  background: var(--theme-color);
}

.home-2 .header-top{
  padding: 12px 0 13px 0;
}

.home-2 .header-top::before{
  display: none;
}

.home-2 .header-top::after{
  display: none;
}

.home-2 .header-top-contact ul li{
  border-color: rgba(255, 255, 255, 0.5);
}

.home-2 .header-top-social a{
  background: var(--color-white);
  color: var(--theme-color2);
}

.home-2 .header-top-social a:hover{
  background: var(--theme-color);
  color: var(--color-white);
}

.home-2 .hero-single{
  padding-top: 200px;
  padding-bottom: 180px;
}

.home-2 .hero-single::before{
  background: rgba(0, 0, 0, .65);
}

.home-2 .hero-single .hero-title span{
  -webkit-text-stroke: 2px var(--theme-color2);
  -webkit-text-fill-color: transparent;
}


@media all and (min-width: 1199px) {
  .home-2 .navbar{
    background: transparent;
    padding-right: 25px;
  }
  
  .home-2 .navbar.fixed-top{
    padding-right: 0;
  }
  
  .home-2 .navbar::before{
    content: "";
    position: absolute;
    left: 0;
    top: 0;
    right: 11%;
    background: var(--color-white);
    height: 100%;
    border-radius: 0 10px 10px 0;
  }
  
  .home-2 .main{
    margin-top: -3rem;
  }
  
}

@media all and (min-width: 992px) {
  .home-2 .navbar .dropdown-menu{
    border-top: none;
    border-radius: 20px;
    background: var(--color-white);
  }
  
  .home-2 .navbar .dropdown-menu .dropdown-item{
    color: var(--color-dark);
    border-bottom: 1px dashed var(--border-info-color);
  }
  
  .home-2 .navbar .dropdown-menu li:last-child .dropdown-item{
    border-bottom: none;
  }
  
  .home-2 .menu-about p{
    color: var(--color-dark);
  }
}

@media (max-width: 991px) {
  .navbar .dropdown-menu {
      border-radius: 20px;
  }
}




/*====================
72. Home 3
======================*/

.home-3 .theme-btn{
  border-radius: 50px;
}

.home-3 .header-top{
  padding: 12px 0 14px 0;
  background: var(--theme-color);
}

.home-3 .header-top::before,
.home-3 .header-top::after{
  display: none;
}

.home-3 .header-top-news{
  color: var(--color-white);
  text-transform: capitalize;
}

.home-3 .header-top-menu a{
  color: var(--color-white);
  margin-right: 6px;
  padding-right: 8px;
  border-right: 1px solid rgba(255, 255, 255, 0.1);
}

.home-3 .header-top-menu a:last-child{
  border-right: none;
  margin-right: 0;
  padding-right: 0;
}

.home-3 .header-top-menu a:hover{
  color: var(--theme-color);
}

.home-3 .hero-single{
  padding-bottom: 150px;
}

.home-3 .hero-single::before{
  background: rgba(0, 0, 0, .6);
  opacity: unset;
}

.home-3 .hero-single .hero-title span{
  -webkit-text-stroke: 2px var(--theme-color2);
  -webkit-text-fill-color: transparent;
}

.home-3 .counter-box .icon{
  border-radius: 30px 30px 30px 0;
}

.home-3 .counter-box .icon::before{
  border-radius: 30px 30px 30px 0;
}

.home-3 .footer-area{
  position: relative;
  /* background-image: url(../img/footer/01.jpg); */
  background-repeat: no-repeat;
  background-position: center;
  background-size: cover;
  z-index: 1;
}

.home-3 .footer-area::before{
  content: "";
  position: absolute;
  background: var(--footer-bg);
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  opacity: .95;
}
.copyright-text a{ color:#ffffff;}
.srch_area ul{
  text-align: left;
  background: #f2f3f8;
  border: 1px solid #ccc;
  border-radius: 5px;
}

.srch_area ul li{
  padding: 10px;
  border-bottom: 1px solid #ccc;
}

.institute_card .img {
  width: 100% !important;
  height: 186px !important;
  border: 1px solid #ccc;
  border-radius: 10px !important;
  padding: 5px;
}
.institute_card .img img{
  border-radius: 10px !important;
}

.institute_list{
  margin-bottom: 20px;
}

.teacher_list{
  margin-bottom: 20px;
}



/* new hom page css start */


.nws_scroll{background: #ff7900;display: flex;padding: 8px 0; color: #fff;}
.nws_scroll p{font-size: 14px; color: #fff;margin-bottom: 0;}
.counter_wrap{background: var(--color-white);box-shadow: var(--box-shadow);border-radius: 6px;}
.user_bx_pd{display: flex;align-items: center;justify-content: center;gap: .75rem;width: 100%;height: 100%;border-radius: 6px;padding: 20px 0; }
.bg_use_pd{background: #fff3ed;}
.use_icn_hold{background: #feab31;border-radius: 10px;padding: 8px;}
.exm_bg1{background: #fffae8;}
 .exm_bg2{background: #f4f1ff;}
.exm_bg3{background: #fff3ed;}
.prp_bg{background: #06513c;}
.selection_wrap{border-radius: 8px;padding: 40px 0;}
.title_slc{color: #fff;font-size: 32px;font-weight: 500;}
.read_boy{position: absolute;left: 0;bottom: 0;}
.read_boy img{width: 78%;}
.selection_wrap .theme-btn {border-radius: 10px;}
.crcle_elm{position: absolute;right: 0;bottom: 0;right: -32px;}
.crcle_elm img{width: 78%;}
.bg_sec_all{background: #f5f6fa;}
.course_name_hold{background: var(--color-white);box-shadow: var(--box-shadow);border-radius: 8px;font-size: 14px;padding: 10px;text-align: center;}
.course_inr_wrap{box-shadow: var(--box-shadow);border-radius: 8px;}
.bg_crse1{background: #faf2e2;}
 .bg_crse2{background: #e1f7d7;}
 .bg_crse3{background: #f5e7fe;}
.exm_content_pd{display: flex;justify-content: space-between;align-items: center;padding: 10px 14px;border: 8px;}


.fame_slider_item{background: var(--color-white);box-shadow: var(--box-shadow);border-radius: 8px;padding: 30px;text-align: center;border: 1px solid #ccc; padding-top: 57px;}
.round_thumb img{border-radius: 100%;border: 5px solid #ff7900;}
.round_thumb{position: absolute;transform: translateX(-50%);left: 50%;top: 0;}
.fame_cnt_all{position: relative;padding-top: 79px;}
.nrm_title{color: var(--theme-color2);font-weight: 500;}
.bookfree_bx{background: linear-gradient(45deg,  #ffbd61 0%,#ffffff 63%,#ffffff 100%); border-radius: 12px; padding: 42px;border: 1px solid #eae7e7;position: relative;}

.title_add{font-size: 30px;font-weight: 500;color: #222222;line-height: 32px;}
.title_add2{font-size: 20px;font-weight: 500;color: #222222;line-height: 32px;}
.bookfree_bx .form-control{padding: 15px 20px;}
.bookfree_bx button{border-radius: 10px;}
.expert_right_img{position: absolute;right: 0;bottom: 0;}
.expert_right_img img{width: 82%;}

.test_series{background: linear-gradient(to bottom,  #f8eefe 0%,#ffffff 63%,#ffffff 100%); border: 1px solid #e1e2e1;border-radius: 12px;padding: 16px;}
.tst_logo_wrap{display: flex;justify-content: space-between;align-items: flex-start;}
.logo_tst_srs{width: 44px;height: 44px;}
.usr_count{font-size: 12px;background: #fff;border-radius: 30px;padding: 1px 10px;border: 1px solid #ebe3f1;}
.total_test_wraper{display: flex;justify-content:flex-start;gap:1rem;}
.tst_wrap_txt{font-size: 11px; color: #222;}
.grn_wrap{background: #3fb766;color:var(--color-white);padding: 0 8px;border-radius: 4px;}
.orange{color: var(--theme-color2);}
.highligt_orng{font-size: 13px;}
.test_series ul li{font-size: 12px;list-style: disc;line-height: 28px;margin-left: 14px;}
.test_series ul li:last-child{font-size: 12px;color: #3fb766;}
.test_series .theme-btn{border-radius: 10px; padding: 10px 20px;margin-top: 10px;width: 100%;}
.test_series_pd{background: rgb(255,255,255);background: linear-gradient(185deg, rgba(255,255,255,1) 14%, rgba(223,243,229,1) 95%);}
.spl_plans{background: rgb(255,255,255);background: linear-gradient(185deg, rgba(255,255,255,1) 14%, rgba(255,241,221,1) 95%);}
.student_right{position: absolute;bottom: 0;right: 0;}
.spl_pln_bx_wrp{display: flex;gap:1rem;}
.spl_pln_bx_one{padding: 14px;border: 1px dashed #3fb766;width: 322px;border-radius: 10px;}
.spl_text_orange{color: #ff7900;line-height: 1.3}
.spl_price{font-size: 20px;font-weight: 600;color: #3fb766;}
.dark_color{color: #222;}
.login_txt{font-size: 20px;font-weight: 500;}
.student_right img{width: 78%;}
.tst_btn .theme-btn{border-radius: 30px; padding: 6px 20px;}

.solved_question .test_series{background: linear-gradient(to bottom,  #ebfae4 0%,#ffffff 63%,#ffffff 100%);}
.simulating{font-size: 20px;font-weight: 500;}
.sof_box{background: #3fb766;border-radius: 20px 20px 0 0;font-size: 34px;color: #fff;font-weight: 700;}
.mock-text{font-size: 18px;}
.mk_test_blw{display: flex;gap:1rem;justify-content: center;}
.tst_mok_bx1{display: flex;gap:0.3rem;align-items: center;justify-content: center;font-size: 24px;color: #fff;font-weight: 600;}
.mkst_bdr_rgt{border-right: 2px solid #fff;}
.wdth_mg_tst_bx{width: 40px;height: 60px;display: flex; justify-content: center;align-items: center;}
.orange_bg{background: #eb763c;}
 .ylw_bg{background: #dda512;}
.drk-grn_bg{background: #095747;}
.green_grndt {background: rgb(255, 255, 255);background: linear-gradient(185deg, rgba(255, 255, 255, 1) 14%, rgba(223, 243, 229, 1) 95%);}
.scholorship .theme-btn{padding: 2px 20px;border-radius: 6px;}
.Scholorship_txt{font-size: 36px; font-weight: 600;color: #2e363b;}
.Scholorship_txt:before{content: "";position: absolute;left: 0; top:-31px;background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});background-repeat: no-repeat;width: 100%;height: 100%;}
.scholor2 img{width: 20%;opacity: 0.3;}
.scholor1{position: absolute;right: 0;bottom: 0;}
.scholor1 img{width: 70%;}
.most-title{font-size: 36px;font-weight: 500;line-height: 38px;}
.prepare_txt{font-size: 18px!important;color: #222!important;}
.hub{font-size: 20px;}
.orange_grndt{background: linear-gradient(185deg, rgba(255, 255, 255, 1) 14%, rgba(255, 241, 221, 1) 95%);}
.theme2_color{color: #ff7900;}
ul.bnr_ftrs{text-align: center;}
ul.bnr_ftrs li{display: inline-block;padding-right: 12px;color: #222;}
.start_btn .theme-btn{border-radius: 10px;padding: 6px 20px;}
.banner_exm_lft{position: absolute;left: 0;bottom: 0;}
.banner_exm_right{position: absolute;right: 0;bottom: 0;}
.banner_exm_lft img{width: 70%;}
 .banner_exm_right img{width: 70%;}


/* new hom page css end */


/* feed page css*/
.srch_glass {
position: absolute;
left: 22px;
line-height: 55px;
}
    
    .spl_cards {
background-color: #fff;
box-shadow: 0 0 15px rgba(0, 0, 0, 0.1);
padding: 20px;
border-radius: 16px;
background: #FFF;
border: none;
}
    
    .feed_img {
width: 56px;
height: 56px;
}
    
    .feed_img img {
width: 100%;
height: 100%;
border-radius: 50%;
object-fit: cover;
}
    
    .coment_all_wrap{display: flex;justify-content: space-around;}

/* feed page css end*/

/* exam detail page ui style start*/
.fixed-scrll  nav ul li a.active{
  background-color: var(--theme-color)!important;color: var(--color-white);} 
 
/*    .fixed-scrll nav{width: 1528px;height: 60px;position: fixed;top: 0;left: 0; background: #fff;}*/
  .faq-area .accordion-item{border-radius: 10px !important;}
  
  .faq-area .accordion-button{font-weight: 400;font-size: 18px;}
  .site-breadcrumb.test_series_pd:before{display: none;}
  .site-breadcrumb.test_series_pd .breadcrumb-title{    color: var(--color-dark); font-size: 38px;font-weight: 500;}
  .site-breadcrumb.test_series_pd .breadcrumb-menu li::before{color: var(--color-dark);}
  .site-breadcrumb .breadcrumb-menu li a{color: var(--color-dark);}
  .site-breadcrumb.test_series_pd{text-align: left; padding-top: 70px;padding-bottom: 50px; border-top: 1px solid #ccc;}
  .site-breadcrumb.test_series_pd .theme-btn{border-radius: 8px;    padding: 6px 20px;}
  .item__enrolled{color:  var(--theme-color);font-size: .75rem;width: 100%;margin-top: .5rem;display: flex;align-items: center;gap: .5rem;}
  .exm_dls_banner_small_dsc{ display: flex;align-items: center;gap: 4px;}
  .quiz_exm .course-bottom { font-size: 12px;  line-height: 28px;padding-top: 0;margin-top: 0;}

/* exam detail page ui style end*/

/* exam detail prev paper ui style start*/
.fixed-scrll  nav ul li a.active{
  background-color: var(--theme-color)!important;color: var(--color-white);} 
 
/*    .fixed-scrll nav{width: 1528px;height: 60px;position: fixed;top: 0;left: 0; background: #fff;}*/
  .faq-area .accordion-item{border-radius: 10px !important;}
  
  .faq-area .accordion-button{font-weight: 400;font-size: 18px;}
  .site-breadcrumb.test_series_pd:before{display: none;}
  .site-breadcrumb.test_series_pd .breadcrumb-title{    color: var(--color-dark); font-size: 38px;font-weight: 500;}
  .site-breadcrumb.test_series_pd .breadcrumb-menu li::before{color: var(--color-dark);}
  .site-breadcrumb .breadcrumb-menu li a{color: var(--color-dark);}
  .site-breadcrumb.test_series_pd{text-align: left; padding-top: 70px;padding-bottom: 50px; border-top: 1px solid #ccc;}
  .site-breadcrumb.test_series_pd .theme-btn{border-radius: 8px;    padding: 6px 20px;}
  .item__enrolled{color:  var(--theme-color);font-size: .75rem;width: 100%;margin-top: .5rem;display: flex;align-items: center;gap: .5rem;}
  .exm_dls_banner_small_dsc{ display: flex;align-items: center;gap: 4px;}
  .quiz_exm .course-bottom { font-size: 12px;  line-height: 28px;padding-top: 0;margin-top: 0;}
  .whitebx_btn{min-width: 140px;padding-left: 0;padding-right: 0;}

/*modal code start here----------*/
  
  .modal.exam_prepration{ --bs-modal-width: 520px; --bs-border-radius-lg: 1.2rem;} 
  .modal.exam_prepration .modal-header { background: #F4F7FC;}
  .modal.exam_prepration .theme-btn{border-radius: 10px;}
  .modal.stepingform {--bs-modal-width: 990px;--bs-border-radius-lg: 1.4rem;}
  .step_right_plan_wrap{display: flex;justify-content: space-between;font-size: 1rem;margin-bottom: 1rem;}
  .plan{font-size: 16px;font-weight: 600;color: var(--color-dark);}
  .change{color: var(--theme-color);}
  .foundation_wrap{border: 2px solid #ff7900;background: #f6f3f0;position: relative;padding: 1rem;border-radius: 8px;margin-bottom: 18px;}
  
   .recommended {background: #3fb766;width: auto;padding: 2px 6px;position: absolute; right: 36px;top: -13px;font-size: 14px;text-align: center;border-radius: 4px;font-family: 'Jost';cursor: pointer;color: #fff;}
  
  .common_wrap{display: flex;align-items: center;justify-content: space-between;text-align: left;}
  .old-price{font-weight: 400;font-size: .875rem;color: #86a1ae;margin-bottom: 0;text-decoration: line-through;}
  .price_drop{color: #3fb766;font-size: 11px;}
  .price_bold{font-size: 16px;font-weight: 600;color: var(--color-dark);}
  .coupon{background: #3fb766;padding: 4px; color: #fff;border-radius: 4px;font-size: 11px;text-align: center;margin-bottom: 28px;}
  .total_save{font-size: 15px;color: #3fb766; font-weight: 500;}
  
  /*prev paper-------------------*/
  .whitebox{box-shadow: var(--box-shadow);background: #fff;padding: 20px;border-radius: 10px;border: 1px solid var(--border-info-color);margin-bottom: 20px;}
  .white_innerbox_wrap{display: grid;grid-gap: .75rem;grid-template-columns: repeat(2, 1fr);grid-template-columns: 1fr min-content;}
  .text_wrp_prv{ display: grid;gap: .5rem;padding-bottom: 40px;}
  
  .prv_whtbx_cta_area{display: grid;grid-auto-flow: column;align-items: center;gap: .5rem;}
  .prv_whtbx_cta_area .theme-btn{border-radius: 10px;padding: 8px;}
  .pro{background: var(--theme-color2);font-size: 11px;padding: 4px 8px;color:#fff;border-radius: 5px;}
  .off-paper-head{font-size: 15px;font-weight: 500;color: var(--color-dark); }
  .no_space{white-space: nowrap;}
  
  .subjct_hold{background: rgba(223,243,229,0.5);;position: absolute;left: 0;right: 0;bottom: 0;padding: 10px 20px;font-size: 14px;color: #000;border-radius: 0 0 10px 10px;}
   .free_ppr{background: var(--theme-color);font-size: 11px;padding: 4px 8px;color:#fff;border-radius: 5px;}
  .icn_color{color: var(--theme-color2);}
  
  @media all and (max-width: 767px) {
      
  .white_innerbox_wrap{display: flow;}
      .text_wrp_prv{padding-bottom: 0;}  
      .white_innerbox_wrap{padding-bottom: 40px;}  
      
  }
  
  
  
  ul.form-stepper {counter-reset: section;margin-bottom: 1.5rem;}
ul.form-stepper .form-stepper-circle {position: relative;}
ul.form-stepper .form-stepper-circle span {position: absolute;top: 50%;left: 50%;transform: translateY(-50%) translateX(-50%);}
.form-stepper-horizontal {position: relative;display: flex;justify-content: space-between;    width: 54%;}
ul.form-stepper > li:not(:last-of-type) {margin-bottom: 0.625rem;transition: margin-bottom 0.4s;}
.form-stepper-horizontal > li:not(:last-of-type) {margin-bottom: 0 !important;}
.form-stepper-horizontal li {position: relative;
display: flex;flex: 1 1;align-items: start;transition: 0.5s;}
.form-stepper-horizontal li:not(:last-child):after {position: relative;flex: 1 1;height: 1px;content: "";
top: 19%;}
.form-stepper-horizontal li:after {background-color: #d3d3d3;}
.form-stepper-horizontal li.form-stepper-completed:after {background-color: #4da3ff;}
.form-stepper-horizontal li:last-child {flex: unset;}
ul.form-stepper li a .form-stepper-circle {display: inline-block;width: 20px;height: 20px;margin-right: 0;line-height: 20px;
text-align: center;background: rgba(0, 0, 0, 0.38);border-radius: 50%;}
.form-stepper .form-stepper-active .form-stepper-circle {background-color: #0b9ef0 !important;color: #fff;}
.form-stepper .form-stepper-active .label {color: #0b9ef0 !important;}
.form-stepper .form-stepper-active .form-stepper-circle:hover {background-color: #024f94 !important;color: #fff !important;}
.form-stepper .form-stepper-unfinished .form-stepper-circle {background-color: #d3d3d3;}
.form-stepper .form-stepper-completed .form-stepper-circle {background-color: #21ae51 !important;color: #fff;font-size: 12px;}
.form-stepper .form-stepper-completed .form-stepper-circle:before {content: "\\f00c"; font-family: "Font Awesome 6 Pro"; line-height: 20px;}              
.form-stepper .form-stepper-completed .label { color: #21ae51 !important;}
.form-stepper .form-stepper-completed .form-stepper-circle:hover {background-color: #0e9594 !important; color: #fff !important;}
.form-stepper .form-stepper-active span.text-muted { color: #fff !important;}
.form-stepper .form-stepper-completed span.text-muted {color: #fff !important;}
.form-stepper .label {font-size: 0.9rem;font-family: 'Jost', sans-serif;margin-top: 0.5rem;}
.form-stepper a { cursor: default;}  
     

/* exam detail prev paper ui style end*/`, "",{"version":3,"sources":["webpack://./src/assets/stylesheet/style.css"],"names":[],"mappings":";AACA;;;;wDAIwD;;;AAGxD;;uBAEuB;;AAEvB,oKAAoK;;AAIpK;;uBAEuB;;AAEvB;AACA,sCAAsC;CACrC,iCAAiC;EAChC,kCAAkC;EAClC,sBAAsB;EACtB,uBAAuB;EACvB,2CAA2C;EAC3C,yBAAyB;EACzB,0BAA0B;EAC1B,sBAAsB;EACtB,sBAAsB;EACtB,qBAAqB;EACrB,6BAA6B;EAC7B,2CAA2C;EAC3C,0CAA0C;EAC1C,2CAA2C;EAC3C,iCAAiC;EACjC,kCAAkC;EAClC,wCAAwC;EACxC,yCAAyC;EACzC,+CAA+C;EAC/C,gDAAgD;EAChD,oBAAoB;EACpB,qBAAqB;EACrB,4BAA4B;EAC5B,yBAAyB;;AAE3B;;;;AAIA;;uBAEuB;;AAEvB;;;EAGE,mBAAmB;AACrB;;AAEA;EACE,mCAAmC;AACrC;;AAEA;;EAEE,YAAY;EACZ,WAAW;EACX,SAAS;EACT,UAAU;EACV,kBAAkB;EAClB,sBAAsB;;AAExB;;AAEA;EACE,6BAA6B;EAC7B,kBAAkB;EAClB,eAAe;EACf,mBAAmB;EACnB,6BAA6B;EAC7B,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;;;;EAIE,aAAa;EAKb,gCAAgC;EAChC,qBAAqB;AACvB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,gBAAgB;AAClB;;AAEA;;;;;;EAME,yBAAyB;EACzB,WAAW;EACX,gBAAgB;EAChB,gCAAgC;EAChC,cAAc;AAChB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,WAAW;AACb;;AAEA;;EAEE,eAAe;EAKf,gCAAgC;EAChC,YAAY;AACd;;AAEA;EACE,WAAW;EACX,eAAe;EACf,gBAAgB;AAClB;;AAcA;EACE,gBAAgB;EAChB,yBAAyB;EACzB,iBAAiB;AACnB;;AAQA;EACE,WAAW;EACX,eAAe;EACf,UAAU;AACZ;;;;AAIA;;uBAEuB;;AAEvB;EACE,eAAe;EACf,WAAW;EACX,YAAY;EACZ,8BAA8B;EAC9B,MAAM;EACN,OAAO;EACP,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,oCAAoC;EACpC,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,oCAAoC;EACpC,yCAAyC;EACzC,SAAS;EACT,kBAAkB;EAClB,WAAW;EACX,SAAS;EACT,gBAAgB;EAChB,8BAA8B;EAC9B,4BAA4B;EAE5B,6BAA6B;AAC/B;;AAEA;EAEE,sEAAsE;AACxE;;AAEA;EAEE,uEAAuE;AACzE;;AAEA;EAEE,sEAAsE;AACxE;;AAsBA;EACE;IACE,yBAAyB;EAC3B;EACA;IACE,+BAA+B;EACjC;EACA;IACE,+BAA+B;IAC/B,4BAA4B;EAC9B;EACA;IACE,8BAA8B;IAC9B,4BAA4B;EAC9B;AACF;;;;;AAKA;;uBAEuB;;AAEvB;EACE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,iCAAiC;AACnC;;;;;AAKA;;uBAEuB;;AAEvB;EACE,qBAAqB;AACvB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;AACpB;;;AAGA;;uBAEuB;;;GAGpB,yBAAyB,wBAAwB,CAAC,4BAA4B,CAAC,sBAAsB,CAAC,mBAAmB;IACxH,kBAAkB,CAAC,kBAAkB,CAAC;;EAExC,qBAAqB,sBAAsB,CAAC,2BAA2B,CAAC;;KAErE,uBAAuB,cAAc,CAAC,kBAAkB,CAAC;;IAE1D,sBAAsB,yBAAyB,CAAC,qBAAqB,CAAC,eAAe,CAAC,gBAAgB,CAAC,kBAAkB,CAAC;IAC1H,sBAAsB,kBAAkB,CAAC;;IAEzC,uBAAuB,gBAAgB,CAAC;IACxC,yBAAyB,0BAA0B,CAAC;IACpD,0BAA0B,yBAAyB,CAAC,eAAe,CAAC,gBAAgB,CAAC;;IAErF,0BAA0B,oCAAoC,CAAC,kBAAkB,CAAC,aAAa;IAC/F,iBAAiB,CAAC,YAAY,CAAC,YAAY,CAAC;;EAE9C,4CAA4C,gBAAgB,CAAC;;CAE9D,QAAQ,mBAAmB,CAAC;;AAE7B,aAAa,kBAAkB,CAAC,UAAU,CAAC;AAC3C,kBAAkB,iBAAiB,CAAC;AACpC,eAAe,oCAAoC,CAAC,mBAAmB,CAAC,gFAAgF,CAAC,cAAc,CAAC,4BAA4B,CAAC;AACrM,eAAe,iBAAiB,CAAC;AACjC,wCAAwC,kBAAkB,CAAC;AAC3D,qBAAqB,cAAc,CAAC,eAAe,CAAC,gBAAgB,CAAC,qBAAqB,CAAC,qBAAqB,CAAC,yBAAyB,KAAK,mBAAmB,CAAC;AACnK,wBAAwB,kBAAkB,CAAC,cAAc,CAAC,aAAa,CAAC,eAAe,CAAC,gBAAgB,CAAC,qBAAqB;AAC9H,+BAA+B,CAAC;AAChC,4BAA4B,qBAAqB,CAAC,2BAA2B,CAAC,WAAW,CAAC;AAC1F,8BAA8B,qCAAqC,CAAC,kBAAkB,CAAC,iEAAiE,CAAC,yBAAyB,CAAC;AACnL,6BAA6B,mCAAmC,CAAC,cAAc,CAAC;AAChF,iBAAiB,yBAAyB,CAAC,kBAAkB,CAAC,gBAAgB,CAAC,yBAAyB,CAAC,kBAAkB,CAAC,UAAU,CAAC;AACvI,sBAAsB,UAAU,CAAC;AACjC,uBAAuB,cAAc,CAAC,eAAe,CAAC,gBAAgB,CAAC,iBAAiB,CAAC,mBAAmB,CAAC;AAC7G,uBAAuB,WAAW,CAAC,kBAAkB,CAAC,QAAQ,CAAC,WAAW,CAAC;AAC3E,gCAAgC,iBAAiB,CAAC,kBAAkB,CAAC,eAAe,CAAC,oBAAoB,CAAC;;AAE1G,uBAAuB,oCAAoC,CAAC,mBAAmB;IAC3E,0EAA0E;IAC1E,kBAAkB,CAAC;;;AAGvB,qCAAqC,qBAAqB,EAAE,yBAAyB,EAAE,UAAU,CAAC;AAClG,oBAAoB,mBAAmB,CAAC;AACxC,eAAe,eAAe,CAAC;AAC/B,eAAe,WAAW,EAAE,YAAY,CAAC,yBAAyB,CAAC,kBAAkB,CAAC,qBAAqB,CAAC,kBAAkB,CAAC,iBAAiB,CAAC,kBAAkB,CAAC;AACpK,iBAAiB,cAAc,CAAC;AAChC,aAAa,mBAAmB,EAAE,kBAAkB,CAAC,kBAAkB,CAAC,4BAA4B,CAAC;;AAErG;IACI,YAAY;IACZ,0DAA0D;IAC1D,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,4BAA4B;IAC5B,6BAA6B;IAC7B,WAAW;IACX,oBAAoB;IACpB,UAAU;AACd;AACA,WAAW,eAAe,CAAC,iBAAiB,CAAC,iBAAiB,CAAC,kBAAkB,CAAC;AAClF,OAAO,0BAA0B,CAAC;AAClC,cAAc,kBAAkB,CAAC;;AAEjC,QAAQ,qBAAqB,CAAC;;;AAG9B;IACI,WAAW;IACX,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,YAAY;IACZ,MAAM;IACN,gCAAgC;IAChC,WAAW,CAAC,kBAAkB;AAClC;AACA,WAAW,kBAAkB,CAAC,SAAS,CAAC,QAAQ,KAAK,gCAAgC,CAAC,WAAW,CAAC,eAAe,CAAC,gBAAgB,CAAC,WAAW,CAAC,iBAAiB,CAAC;AACjK,KAAK,mBAAmB,CAAC;AACzB,aAAa,eAAe,CAAC,gBAAgB,CAAC,cAAc,CAAC,mBAAmB,CAAC,kBAAkB,CAAC,aAAa,CAAC;AAClH,QAAQ,eAAe,CAAC,gBAAgB,CAAC,cAAc,CAAC,cAAc,CAAC,oBAAoB,CAAC,mBAAmB,CAAC;AAChH,SAAS,0BAA0B,CAAC;;AAEpC;IACI,SAAS;IACT,kBAAkB;IAClB,UAAU;IACV,QAAQ;AACZ;AACA;IACI,gBAAgB;IAChB,kBAAkB;IAClB,yBAAyB;IACzB,eAAe;IACf,eAAe;IACf,gBAAgB;IAChB,kBAAkB;IAClB,+BAA+B;AACnC;;AAEA,oBAAoB,mBAAmB,EAAE,aAAa,CAAC;AACvD,YAAY,aAAa,CAAC,yBAAyB,CAAC,mBAAmB,CAAC;AACxE,cAAc,mBAAmB,CAAC,eAAe,CAAC,cAAc,CAAC,gBAAgB,CAAC;AAClF,YAAY,eAAe,CAAC,gBAAgB,CAAC,WAAW,CAAC,mBAAmB,CAAC;AAC7E,cAAc,eAAe,CAAC,gBAAgB,CAAC,WAAW,CAAC,mBAAmB,CAAC;AAC/E,UAAU,0BAA0B,CAAC;AACrC,aAAa,aAAa,CAAC,8BAA8B,CAAC;AAC1D,kCAAkC,YAAY,CAAC,gBAAgB,EAAE,UAAU,CAAC,gBAAgB,CAAC;AAC7F,gBAAgB,eAAe,CAAC,0BAA0B,CAAC,gBAAgB,CAAC;AAC5E,iBAAiB,eAAe,CAAC,cAAc,CAAC;AAChD,eAAe,iBAAiB,CAAC;;AAEjC;IACI,cAAc;IACd,qBAAqB;IACrB,eAAe;IACf,kBAAkB;AACtB;;AAEA,OAAO,iBAAiB,CAAC;AACzB,eAAe,eAAe,CAAC;;AAE/B,YAAY,mBAAmB,CAAC,eAAe,CAAC,cAAc,CAAC,gBAAgB,CAAC;AAChF,WAAW,eAAe,CAAC,gBAAgB,CAAC,WAAW,CAAC,mBAAmB,CAAC;AAC5E,cAAc,eAAe,CAAC,gBAAgB,CAAC,WAAW,CAAC,mBAAmB,CAAC;;AAE/E,0BAA0B,UAAU,EAAE;AACtC,iBAAiB,mBAAmB,CAAC,2BAA2B,CAAC,iBAAiB,CAAC,WAAW,CAAC,eAAe,CAAC,gBAAgB,KAAK,mBAAmB,CAAC;;AAExJ,cAAc,WAAW,EAAE,WAAW,CAAC,YAAY,CAAC,mBAAmB,CAAC,yBAAyB,CAAC,iBAAiB,CAAC,kBAAkB,CAAC,kBAAkB,CAAC;;AAE1J,gBAAgB,eAAe,EAAE,cAAc,CAAC,gBAAgB,CAAC;;AAEjE,UAAU,eAAe,EAAE,WAAW,CAAC;AACvC,kBAAkB,+BAA+B,CAAC;AAClD,eAAe,iBAAiB,CAAC;AACjC,oBAAoB,mBAAmB,CAAC,yBAAyB,CAAC,aAAa,CAAC;AAChF,sBAAsB,eAAe,CAAC;AACtC,mBAAmB,gBAAgB,CAAC,yBAAyB,CAAC,cAAc,CAAC;AAC7E,qBAAqB,eAAe,CAAC;AACrC,iBAAiB,gBAAgB,CAAC,yBAAyB,CAAC,cAAc,CAAC;AAC3E,mBAAmB,eAAe,CAAC;;AAEnC,kBAAkB,kBAAkB,CAAC,SAAS,CAAC,WAAW,CAAC,WAAW,EAAE,YAAY,CAAC,kBAAkB,CAAC,gBAAgB,CAAC,iBAAiB,CAAC,kBAAkB,CAAC,WAAW,CAAC;AAC1K,oBAAoB,eAAe,CAAC;AACpC,oBAAoB,WAAW,CAAC,YAAY,CAAC,kBAAkB,CAAC,gBAAgB,CAAC,yBAAyB,CAAC,kBAAkB,CAAC,iBAAiB,CAAC,kBAAkB,CAAC,WAAW,EAAE,UAAU,CAAC;AAC3L,sBAAsB,eAAe,CAAC,0BAA0B,CAAC,gBAAgB,CAAC;;AAElF,0CAA0C,cAAc,CAAC,UAAU,CAAC;;AAEpE,yCAAyC,UAAU,CAAC;;AAEpD,eAAe,kBAAkB,CAAC;;AAElC,yBAAyB,WAAW,CAAC,UAAU,CAAC,kBAAkB,CAAC,6BAA6B,CAAC,SAAS,CAAC;;QAEnG,+BAA+B,cAAc,CAAC,UAAU,EAAE,mBAAmB,CAAC;;QAE9E,gCAAgC,YAAY,CAAC,WAAW,CAAC,4BAA4B,CAAC,QAAQ,CAAC,0CAA0C,CAAC,oCAAoC,CAAC,0BAA0B,CAAC,kBAAkB,CAAC,YAAY,CAAC,SAAS;QACnP,UAAU,CAAC,6BAA6B,CAAC,mBAAmB,CAAC,iBAAiB;QAC9E;;QAEA,sCAAsC,yCAAyC,CAAC;;QAEhF,oCAAoC,WAAW,CAAC;;QAEhD,yCAAyC,WAAW,CAAC;;QAErD,oCAAoC,YAAY,CAAC;;QAEjD,yCAAyC,YAAY,CAAC;;QAEtD,gDAAgD;;QAEhD;yDACiD,WAAW,CAAC,UAAU,CAAC,kBAAkB;QAC1F,6BAA6B,CAAC,SAAS,CAAC;;QAExC;;YAEI,cAAc;YACd,UAAU;YACV,mBAAmB;QACvB;;QAEA;sEAC8D,YAAY,CAAC,WAAW,CAAC,4BAA4B;QACnH,QAAQ,CAAC,0CAA0C,EAAE,oCAAoC,CAAC,0BAA0B;SACnH,kBAAkB,CAAC,YAAY,CAAC,SAAS,CAAC,UAAU,CAAC,6BAA6B,CAAC,mBAAmB,CAAC,iBAAiB,CAAC;;QAE1H;;YAEI,yCAAyC;QAC7C;;QAEA;2EACmE,WAAW,CAAC;;QAE/E;;YAEI,WAAW,CAAC;;QAEhB;4EACoE,YAAY,CAAC;;QAEjF;wFACgF,YAAY,CAAC;;AAErG;IACI;QACI,eAAe;IACnB;;IAEA,eAAe,gBAAgB,CAAC;;IAEhC,SAAS,+BAA+B,CAAC;;IAEzC,aAAa,gBAAgB,CAAC;;IAE9B;QACI,4BAA4B;IAChC;AACJ;;;;AAIA;;uBAEuB;;AAEvB;EACE,mBAAmB;EACnB,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,0BAA0B;EAC1B,kBAAkB;EAClB,4CAA4C;AAC9C;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,0BAA0B;EAC1B,eAAe;EACf,yBAAyB;EACzB,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,qCAAqC;EACrC,+BAA+B;AACjC;;AAEA;EACE,sCAAsC;EACtC,+BAA+B;AACjC;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,WAAW;EACX,oCAAoC;EACpC,MAAM;EACN,SAAS;EACT,UAAU;AACZ;;;;;AAKA;;uBAEuB;;AAEvB;EACE,eAAe;EACf,yBAAyB;EACzB,kBAAkB;EAClB,6BAA6B;EAC7B,yBAAyB;EACzB,kBAAkB;EAClB,+BAA+B;EAC/B,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,YAAY;EACZ,+BAA+B;EAC/B,6BAA6B;EAC7B,UAAU;AACZ;;AAEA;EACE,WAAW;EACX,aAAa;EACb,YAAY;EACZ,+BAA+B;EAC/B,kBAAkB;EAClB,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,qDAAqD;EACrD,qDAAqD;EACrD,WAAW;AACb;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,qDAAqD;AACvD;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,8BAA8B;EAC9B,wBAAwB;AAC1B;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,yBAAyB;AAC3B;;;;;AAKA;;uBAEuB;;AAEvB;EACE;;;;;IAKE,iBAAiB;EACnB;AACF;;;;AAIA;;uBAEuB;;AAEvB;EACE,eAAe;EACf,aAAa;EACb,WAAW;EACX,WAAW;EACX,eAAe;EACf,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,qCAAqC;EACrC,eAAe;EACf,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,8BAA8B;EAC9B,6BAA6B;EAC7B,UAAU;EACV,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,UAAU;EACV,mBAAmB;EACnB,YAAY;AACd;;;AAGA;EACE;IACE,aAAa;EACf;AACF;;;;AAIA;;uBAEuB;;AAEvB;EACE,qBAAqB;EACrB,kBAAkB;EAClB,mBAAmB;EACnB,UAAU;AACZ;;AAEA;;;;;;;;;;;CAWC;;AAED;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,SAAS;EACT,+CAA+C;EAC/C,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,0BAA0B;EAC1B,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,0BAA0B;EAC1B,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,+BAA+B;AACjC;;AAEA;EACE,0BAA0B;AAC5B;;;AAGA;EACE;IACE,SAAS;EACX;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,iBAAiB;IACjB,cAAc;EAChB;AACF;;AAEA;EACE;IACE,aAAa;EACf;AACF;;;;AAIA;;uBAEuB;;AAEvB;EACE,8BAA8B;EAC9B,gBAAgB;EAChB,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,8BAA8B;EAC9B,kBAAkB;AACpB;;AAEA;EACE,yCAAyC;EACzC,8BAA8B;EAC9B,0BAA0B;AAC5B;;;AAGA;EACE;IACE,4BAA4B;EAC9B;;EAEA;IACE,wBAAwB;EAC1B;AACF;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,qBAAqB;EACrB,gBAAgB;EAChB,wBAAwB;EACxB,iCAAiC;EACjC,gBAAgB;EAChB,gBAAgB;EAChB,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE;IACE,4BAA4B;EAC9B;;EAEA;IACE,kBAAkB;EACpB;;EAEA,mBAAmB,YAAY,EAAE;;EAEjC;IACE,aAAa;EACf;AACF;;AAEA;EACE;IACE,iBAAiB;IACjB,sBAAsB;IACtB,eAAe;IACf,gBAAgB;IAChB,WAAW;IACX,0BAA0B;EAC5B;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,cAAc;IACd,UAAU;IACV,kBAAkB;IAClB,eAAe;IACf,aAAa;IACb,YAAY;IACZ,WAAW;IACX,kBAAkB;IAClB,yCAAyC;IACzC,8BAA8B;IAC9B,YAAY;IACZ,6BAA6B;EAC/B;;EAEA;IACE,kDAAkD;EACpD;;EAEA;IACE,gBAAgB;IAChB,mBAAmB;EACrB;;EAEA;IACE,eAAe;IACf,iBAAiB;IACjB,gBAAgB;IAChB,0BAA0B;IAC1B,kBAAkB;IAClB,gBAAgB;IAChB,0BAA0B;IAC1B,+BAA+B;EACjC;;EAEA;IACE,uBAAuB;IACvB,0BAA0B;IAC1B,kBAAkB;EACpB;;EAEA;IACE,aAAa;IACb,kBAAkB;IAClB,UAAU;IACV,QAAQ;IACR,0BAA0B;IAC1B,UAAU;IACV,kBAAkB;IAClB,6BAA6B;IAC7B,WAAW;EACb;;EAEA;IACE,UAAU;IACV,mBAAmB;EACrB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;;IAEE,0BAA0B;EAC5B;;EAEA;IACE,eAAe;IACf,UAAU;IACV,mBAAmB;IACnB,SAAS;IACT,wBAAwB;EAC1B;;EAEA;IACE,QAAQ;IACR,UAAU;EACZ;;EAEA;IACE,QAAQ;IACR,0BAA0B;IAC1B,uBAAuB;EACzB;;EAEA;IACE,SAAS;EACX;;EAEA;IACE,yBAAyB;EAC3B;;EAEA,cAAc;EACd;IACE,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,SAAS;IACT,iBAAiB;EACnB;;EAEA;IACE,kBAAkB;IAClB,eAAe;IACf,yBAAyB;IACzB,6BAA6B;EAC/B;;EAEA;IACE,oCAAoC;EACtC;;EAEA;;IAEE,YAAY;IACZ,uBAAuB;IACvB,wBAAwB;IACxB,eAAe;IACf,gBAAgB;EAClB;;EAEA;IACE,eAAe;IACf,UAAU;EACZ;;EAEA;IACE,kBAAkB;IAClB,eAAe;IACf,UAAU;IACV,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;IAClB,WAAW;IACX,SAAS;IACT,WAAW;IACX,YAAY;IACZ,iBAAiB;IACjB,kBAAkB;IAClB,eAAe;IACf,mBAAmB;IACnB,8BAA8B;IAC9B,yBAAyB;EAC3B;;AAEF;;;AAGA,gBAAgB;AAChB;EACE,aAAa;AACf;;AAEA;EACE;IACE,MAAM;IACN,QAAQ;IACR,OAAO;IACP,eAAe;EACjB;EACA;IACE,kBAAkB;EACpB;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,iBAAiB;IACjB,gBAAgB;IAChB,gBAAgB;IAChB,eAAe;IACf,oCAAoC;EACtC;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,yBAAyB;IACzB,gBAAgB;IAChB,6BAA6B;EAC/B;;EAEA;IACE,oCAAoC;EACtC;;EAEA;IACE,UAAU;IACV,YAAY;EACd;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,SAAS;EACX;;EAEA;IACE,uBAAuB;IACvB,YAAY;IACZ,eAAe;IACf,wBAAwB;EAC1B;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,oBAAoB;EACtB;;EAEA;IACE,eAAe;IACf,yBAAyB;IACzB,gBAAgB;EAClB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,aAAa;EACf;;AAEF;;;AAGA;;+BAE+B;;AAE/B;EACE;IACE,gBAAgB;EAClB;;EAEA;IACE,UAAU;IACV,UAAU;EACZ;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,0BAA0B;IAC1B,eAAe;IACf,mBAAmB;EACrB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,OAAO;EACT;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,gBAAgB;IAChB,mBAAmB;EACrB;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,yBAAyB;EAC3B;AACF;;;AAGA;EACE;IACE,aAAa;EACf;;EAEA;IACE,cAAc;EAChB;AACF;;;;AAIA;;+BAE+B;;AAE/B;EACE,kBAAkB;AACpB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,WAAW;EACX,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,uBAAuB;EACvB,yBAAyB;AAC3B;;AAEA;EACE,SAAS;EACT,UAAU;EACV,UAAU;EACV,kBAAkB;AACpB;;AAEA;EACE,MAAM;EACN,UAAU;EACV,mBAAmB;AACrB;;AAEA;EACE;IACE,cAAc;EAChB;;EAEA;IACE,cAAc;IACd,iBAAiB;EACnB;;EAEA;IACE,QAAQ;EACV;;EAEA;IACE,yBAAyB;EAC3B;AACF;;;;AAIA;;uBAEuB;;AAEvB;EACE,eAAe;EACf,OAAO;EACP,MAAM;EACN,aAAa;EACb,WAAW;EACX,cAAc;EACd,kBAAkB;EAClB,4BAA4B;EAC5B,mCAAmC;EACnC,+DAA+D;EAC/D,oEAAoE;AACtE;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,yBAAyB;EACzB,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,OAAO;EACP,QAAQ;EACR,QAAQ;EACR,YAAY;EACZ,cAAc;EACd,kBAAkB;EAClB,kBAAkB;EAClB,+BAA+B;EAC/B,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,eAAe;EACf,eAAe;EACf,mBAAmB;EACnB,wCAAwC;EACxC,0BAA0B;EAC1B,UAAU;EACV,kBAAkB;AACpB;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,mBAAmB;EACnB,UAAU;EACV,QAAQ;EACR,wBAAwB;AAC1B;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,QAAQ;EACR,UAAU;EACV,WAAW;EACX,oBAAoB;EACpB,oBAAoB;EACpB,wBAAwB;EACxB,0BAA0B;AAC5B;;AAEA;EACE,oBAAoB;EACpB,wBAAwB;AAC1B;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,gBAAgB;AAClB;;AAEA;;EAEE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,aAAa;EACb,kBAAkB;EAClB,YAAY;EACZ,uBAAuB;EACvB,0BAA0B;EAC1B,0BAA0B;AAC5B;;AAEA;;EAEE,kBAAkB;EAClB,WAAW;EACX,QAAQ;EACR,+BAA+B;EAC/B,kBAAkB;EAClB,eAAe;EACf,yBAAyB;EACzB,iBAAiB;EACjB,kBAAkB;EAClB,YAAY;EACZ,eAAe;EACf,0BAA0B;AAC5B;;AAEA;;EAEE,8BAA8B;EAC9B,yBAAyB;AAC3B;;;;AAIA;;uBAEuB;;AAEvB;EACE,gBAAgB;AAClB;;;;AAIA;;uBAEuB;AACvB,mDAAmD,kBAAkB,CAAC;AACtE,aAAa,0BAA0B,CAAC,QAAQ,CAAC,YAAY,CAAC,WAAW,CAAC,wBAAwB,CAAC,QAAQ,CAAC;AAC5G,mBAAmB,4BAA4B,CAAC;AAChD,YAAY,+BAA+B,CAAC,mBAAmB,CAAC,iBAAiB,CAAC,eAAe,CAAC,kBAAkB,CAAC,WAAW,CAAC,QAAQ,CAAC,WAAW,CAAC,cAAc,CAAC;AACrK,mBAAmB,WAAW,CAAC,QAAQ,CAAC,SAAS,CAAC,kBAAkB,CAAC,6CAA6C,EAAE,oCAAoC;AACxJ,SAAS,CAAC,yBAAyB,CAAC,YAAY,CAAC;AACjD,iBAAiB,eAAe,EAAE,cAAc,CAAC;AACjD,qBAAqB,YAAY,CAAC;AAClC,QAAQ,cAAc,CAAC;AACvB,kBAAkB,6BAA6B,CAAC;AAChD;EACE,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,oBAAoB;EACpB,sCAAsC;EACtC,iCAAiC;EACjC,uCAAuC;EACvC,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,UAAU;AACZ;AACA;GACG,kBAAkB;GAClB,UAAU;IACT,QAAQ;IACR,6BAA6B;IAC7B,kBAAkB;IAClB,eAAe;IACf,yBAAyB;IACzB,iBAAiB;IACjB,kBAAkB;IAClB,YAAY;IACZ,eAAe;IACf,0BAA0B,CAAC,iBAAiB;AAChD;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,WAAW;EACX,4CAA4C;EAC5C,YAAY;EACZ,OAAO;AACT;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,WAAW;EACX,8CAA8C;EAC9C,YAAY;EACZ,UAAU;AACZ;;AAEA,YAAY,kBAAkB;IAC1B,UAAU;IACV,iBAAiB,CAAC;;AAEtB;EACE,kBAAkB;EAClB,OAAO;EACP,MAAM;EACN,qDAAqD;EACrD,4BAA4B;EAC5B,WAAW;EACX,YAAY;EACZ,mBAAmB;AACrB;AACA,eAAe,kBAAkB,CAAC;AAClC;IACI,kBAAkB;IAClB,qDAAqD;IACrD,4BAA4B;IAC5B,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,iCAAiC;IACjC,QAAQ;IACR,SAAS,CAAC;;AAEd,WAAW,8BAA8B;IACrC,2BAA2B;IAC3B,uBAAuB;;AAE3B,UAAU,kBAAkB,CAAC,WAAW,CAAC;;;CAGxC,iCAAiC,gBAAgB;IAC9C,WAAW;IACX,sBAAsB;IACtB,aAAa;IACb,kBAAkB;IAClB,YAAY;IACZ,uBAAuB;IACvB,0BAA0B;IAC1B,gBAAgB,CAAC,yBAAyB;AAC9C;;;AAGA;EACE,YAAY;AACd;;AAEA;EACE,wBAAwB;EACxB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,qBAAqB;EACrB,0BAA0B;EAC1B,eAAe;EACf,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;EAClB,yBAAyB;EACzB,4CAA4C;AAC9C;;AAEA;EACE,0BAA0B;EAC1B,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,aAAa;EACb,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,YAAY;EACZ,aAAa;EACb,8BAA8B;EAC9B,YAAY;EACZ,WAAW;EACX,kBAAkB;EAClB,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,aAAa;EACb,UAAU;EACV,WAAW;AACb;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,eAAe;EACf,SAAS;EACT,UAAU;EACV,kCAAkC;EAClC,qBAAqB;EACrB,eAAe;EACf,YAAY;EACZ,WAAW;EACX,iBAAiB;EACjB,mBAAmB;EACnB,kBAAkB;EAClB,6BAA6B;AAC/B;;AAEA;EACE,8BAA8B;EAC9B,yBAAyB;AAC3B;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,WAAW;AACb;;AAEA;;EAEE,kBAAkB;EAClB,QAAQ;EACR,6BAA6B;AAC/B;;AAEA;;EAEE;IACE,eAAe;EACjB;;EAEA;;IAEE,UAAU;IACV,uBAAuB;EACzB;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,WAAW;EACb;;AAEF;;AAEA;;EAEE;IACE,eAAe;EACjB;;EAEA;IACE,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,aAAa;IACb,gBAAgB;EAClB;;EAEA;IACE,YAAY;IACZ,aAAa;EACf;;AAEF;;AAEA;;EAEE,kCAAkC;EAClC,WAAW,yBAAyB,CAAC;IACnC,kBAAkB,yBAAyB,CAAC;IAC5C,eAAe,qBAAqB,CAAC;IACrC,sBAAsB,oBAAoB,CAAC;IAC3C,mBAAmB,sBAAsB,CAAC;IAC1C,iBAAiB,oBAAoB,CAAC;IACtC,gBAAgB,uBAAuB,CAAC;IACxC,oBAAoB,oBAAoB,CAAC;IACzC,cAAc,sBAAsB,CAAC;IACrC,sBAAsB,yBAAyB,CAAC;IAChD,OAAO,wBAAwB,CAAC;IAChC,QAAQ,iBAAiB,CAAC;IAC1B,YAAY,yBAAyB,CAAC;AAC1C,gCAAgC;;IAE5B,6BAA6B;IAC7B,mBAAmB,qBAAqB,EAAE,sBAAsB,CAAC,2BAA2B,CAAC;IAC7F,aAAa,gBAAgB,CAAC;IAC9B,YAAY,eAAe,CAAC;IAC5B,uCAAuC,eAAe,CAAC;IACvD,4CAA4C,eAAe,CAAC;IAC5D,2BAA2B,mBAAmB,CAAC,kBAAkB,CAAC;;EAEpE;IACE,SAAS;EACX;;AAEF;;;AAGA,0BAA0B,UAAU,CAAC,+BAA+B,CAAC;AACrE,6BAA6B,+BAA+B,CAAC;AAC7D;;sBAEsB;;AAEtB;EACE,qBAAqB;EACrB,UAAU;EACV,YAAY;EACZ,WAAW;EACX,iBAAiB;EACjB,eAAe;EACf,kBAAkB;EAClB,+BAA+B;EAC/B,oCAAoC;EACpC,kBAAkB;EAClB,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,YAAY;EACZ,WAAW;EACX,MAAM;EACN,OAAO;EACP,WAAW;EACX,qCAAqC;EACrC,mBAAmB;EACnB,yCAAyC;EAEzC,mBAAmB;EACnB,gCAAgC;AAClC;;AAEA;EACE;IACE,YAAY;IAEZ,qBAAqB;EACvB;;EAEA;IACE,UAAU;IAEV,mBAAmB;EACrB;AACF;;;;AAIA;;uBAEuB;;AAEvB;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,kBAAkB;EAClB,sCAAsC;EACtC,YAAY;AACd;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,+BAA+B;EAC/B,4BAA4B;EAC5B,yBAAyB;EACzB,+BAA+B;EAC/B,yCAAyC;AAC3C;;AAEA;EACE,yBAAyB;EACzB,eAAe;EACf,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,YAAY;EACZ,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,oBAAoB;EACpB,iDAAiD;AACnD;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,mBAAmB;EACnB,+BAA+B;EAC/B,mBAAmB;EACnB,eAAe;EACf,yBAAyB;EACzB,+CAA+C;AACjD;;AAEA;EACE,WAAW;EACX,+BAA+B;AACjC;;AAEA;EACE,SAAO;AACT;;AAEA;EACE,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,wBAAwB;EACxB,kBAAkB;EAClB,oCAAoC;EACpC,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,yBAAyB;EACzB,WAAW;EACX,aAAa;AACf;;AAEA;EACE,aAAa;EACb,eAAe;EACf,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,8BAA8B;EAC9B,yBAAyB;EACzB,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;EACf,+CAA+C;AACjD;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,0BAA0B;EAC1B,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,yBAAyB;AAC3B;;;AAGA;;EAEE,kCAAkC;IAChC,eAAe,uBAAuB,CAAC;IACvC,cAAc,sBAAsB,CAAC;IACrC,oBAAoB,oBAAoB,CAAC;IACzC,wBAAwB,0BAA0B,CAAC;IACnD,SAAS,yBAAyB,CAAC;KAClC,oBAAoB,sBAAsB,CAAC;IAC5C,sBAAsB,sBAAsB,CAAC;IAC7C,YAAY,2BAA2B,CAAC;;IAExC,gCAAgC;EAClC;IACE,gBAAgB;EAClB;AACF;;AAEA;EACE;IACE,gBAAgB;EAClB;AACF;;AAEA;;uBAEuB;AACvB,0CAA0C,8BAA8B,CAAC;AACzE,0CAA0C,kBAAkB,CAAC,UAAU,CAAC;AACxE,OAAO,aAAa,CAAC;AACrB;IACI,kBAAkB;IAClB,OAAO;IACP,SAAS;IACT,+BAA+B;IAC/B,yBAAyB;IACzB,4BAA4B;IAC5B,iBAAiB;IACjB,mBAAmB;IACnB,qBAAqB;IACrB,8BAA8B;IAC9B,UAAU,CAAC,eAAe,CAAC,YAAY;AAC3C;;;;AAIA;;uBAEuB;AACvB,2BAA2B,iBAAiB,CAAC,mBAAmB,CAAC;AACjE;;uBAEuB;AACvB,OAAO,wBAAwB,CAAC;AAChC;IACI,QAAQ;IACR,SAAS;IACT,kBAAkB;IAClB,aAAa;IACb,8BAA8B;IAC9B,mCAAmC;IACnC,WAAW;AACf;AACA,mBAAmB,WAAW,CAAC,aAAa,EAAE,kBAAkB,EAAE;;AAElE;;uBAEuB;AACvB,kBAAkB,gBAAgB,CAAC,kBAAkB,CAAC,aAAa,CAAC,mBAAmB,CAAC,YAAY,EAAE,YAAY,CAAC,SAAS,CAAC,2BAA2B,CAAC,YAAY,CAAC;AACtK,mBAAmB,UAAU,CAAC;AAC9B,oBAAoB,gBAAgB,CAAC;AACrC,sBAAsB,eAAe,CAAC;AACtC,sBAAsB,+BAA+B,CAAC;AACtD,cAAc,kBAAkB,CAAC,SAAS,CAAC,2BAA2B,CAAC,YAAY,CAAC;AACpF,kBAAkB,mBAAmB,EAAE,iBAAiB,CAAC;;;AAGzD;;uBAEuB;AACvB,UAAU,iBAAiB,EAAE,eAAe,CAAC,cAAc,CAAC,gBAAgB,CAAC,iBAAiB,CAAC;AAC/F,SAAS,iBAAiB,EAAE,eAAe,CAAC,cAAc,CAAC,gBAAgB,CAAC;AAC5E;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,8BAA8B;EAC9B,aAAa;EACb,+BAA+B;EAC/B,mBAAmB;EACnB,uCAAuC,CAAC,yBAAyB;;AAEnE;;AAEA,QAAQ,mBAAmB,CAAC;AAC5B,SAAS,aAAa,CAAC,8BAA8B,CAAC,mBAAmB,CAAC;;AAE1E,OAAO,QAAQ;IACX,SAAS;IACT,kBAAkB;IAClB,aAAa;IACb,8BAA8B;IAC9B,mCAAmC;IACnC,WAAW,CAAC;;AAEhB;EACE,kBAAkB;EAClB,WAAW;EACX,aAAa;EACb,+BAA+B;EAC/B,yBAAyB;EACzB,+BAA+B;EAC/B,iBAAiB;EACjB,mBAAmB;EACnB,qBAAqB;EACrB,8BAA8B;EAC9B,UAAU,CAAC,eAAe;AAC5B;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,+BAA+B;EAC/B,YAAY;AACd;;;AAGA;CACC,YAAY;CACZ,mBAAmB;AACpB;;AAEA;CACC,kBAAkB;CAClB,QAAQ;CACR,SAAS;CACT,WAAW;CACX,YAAY;CACZ,iBAAiB;CACjB,mBAAmB;CACnB,iBAAiB;CACjB,UAAU;CACV,uBAAuB;CACvB,yBAAyB;CACzB,+BAA+B;CAC/B,mBAAmB;CACnB,UAAU;CACV,kBAAkB;CAClB,6BAA6B;CAC7B,UAAU;AACX;;AAEA,6BAA6B,oBAAoB,CAAC;AAClD,+BAA+B,cAAc,CAAC,aAAa,CAAC;AAC5D,yCAAyC,eAAe,CAAC;;AAEzD;CACC,mBAAmB;CACnB,UAAU;CACV,mBAAmB;AACpB;;AAEA;CACC,8BAA8B;CAC9B,0BAA0B;AAC3B;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,0BAA0B;EAC1B,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,iBAAiB;EACjB,gBAAgB;EAChB,8CAA8C;AAChD;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,0BAA0B;EAC1B,iBAAiB;AACnB;;AAEA;EACE,qBAAqB;EACrB,+BAA+B;EAC/B,yBAAyB;EACzB,iBAAiB;EACjB,+BAA+B;EAC/B,gBAAgB,CAAC,eAAe;AAClC;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE;IACE,gBAAgB;EAClB;AACF;;;;;AAKA;;uBAEuB;;AAEvB;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,QAAQ;EACR,gCAAgC;AAClC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,mBAAmB;AACrB;;AAEA;CACC,WAAW;CACX,YAAY;CACZ,mBAAmB;AACpB;;AAEA;CACC,WAAW;CACX,YAAY;CACZ,iBAAiB;CACjB,mBAAmB;CACnB,eAAe;CACf,0BAA0B;CAC1B,qCAAqC;CACrC,eAAe;EACd,kBAAkB;AACpB;;AAEA;EACE,eAAe;AACjB;;AAEA;CACC,eAAe;CACf,yBAAyB;AAC1B;;AAEA;EACE,0BAA0B;EAC1B,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,wBAAwB;EACxB,iDAAiD;AACnD;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,0BAA0B;EAC1B,WAAW;AACb;;AAEA;EACE,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,aAAa;AACf;;;;AAIA;;uBAEuB;;AAEvB;EACE,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,8BAA8B;EAC9B,iCAAiC;EACjC,6BAA6B;EAC7B,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,QAAQ;EACR,eAAe;EACf,gBAAgB;EAChB,2CAA2C;EAC3C,oCAAoC;AACtC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,kBAAkB;EAClB,yBAAyB;EACzB,eAAe;EACf,8BAA8B;EAC9B,mBAAmB;EACnB,2CAA2C;EAC3C,kBAAkB;EAClB,6BAA6B;AAC/B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,WAAW;EACX,+BAA+B;AACjC;;AAEA;EACE,SAAO;AACT;;AAEA;EACE,wBAAwB;EACxB,eAAe;EACf,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE;IACE,iBAAiB;IACjB,iBAAiB;EACnB;;EAEA;IACE,mBAAmB;EACrB;AACF;;;;;AAKA;;6BAE6B;;AAE7B;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,WAAW;EACX,+BAA+B;AACjC;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,MAAM;EACN,OAAO;AACT;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,YAAY;EACZ,8BAA8B;EAC9B,+BAA+B;EAC/B,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,gBAAgB;AAClB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,eAAe;EACf,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,wBAAwB;EACxB,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,8BAA8B;EAC9B,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,+BAA+B;EAC/B,yBAAyB;AAC3B;;;;AAIA;;wBAEwB;;AAExB;EACE,iDAAiD;EACjD,cAAc;EACd,mBAAmB;EACnB,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,0BAA0B;EAC1B,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;;;;AAKA;;6BAE6B;;AAE7B;EACE,kBAAkB;EAClB,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,WAAW;EACX,+BAA+B;AACjC;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,MAAM;EACN,OAAO;AACT;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,UAAU;EACV,SAAS;EACT,WAAW;EACX,YAAY;EACZ,+BAA+B;EAC/B,+BAA+B;EAC/B,UAAU;EACV,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ;AACF;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,SAAS;EACT,QAAQ;EACR,yCAAyC;EACzC,gBAAgB;EAChB,mBAAmB;EACnB,UAAU;EACV,kBAAkB;EAClB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,UAAU;EACV,mBAAmB;EACnB,yCAAyC;AAC3C;;;;AAIA;;uBAEuB;;AAEvB;EACE,kBAAkB;EAClB,4BAA4B;EAC5B,UAAU;AACZ;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,OAAO;EACP,MAAM;EACN,gDAAgD;EAChD,4BAA4B;EAC5B,2BAA2B;EAC3B,sBAAsB;EACtB,WAAW;EACX,YAAY;EACZ,aAAa;EACb,WAAW;AACb;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,WAAW;EACX,aAAa;EACb,WAAW;EACX,YAAY;EACZ,qCAAqC;EACrC,4BAA4B;AAC9B;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,8BAA8B;EAC9B,+BAA+B;EAC/B,6BAA6B;EAC7B,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,iBAAiB;EACjB,+BAA+B;EAC/B,+BAA+B;EAC/B,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,+BAA+B;AACjC;;AAEA;EACE,SAAO;AACT;;AAEA;EACE,wBAAwB;EACxB,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,aAAa;EACb,qBAAqB;EACrB,uBAAuB;AACzB;;AAEA;EACE;IACE,mBAAmB;EACrB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,gBAAgB;IAChB,iBAAiB;EACnB;AACF;;AAEA;EACE;IACE,kBAAkB;EACpB;AACF;;;;AAIA;;uBAEuB;;AAEvB;EACE,kBAAkB;AACpB;;AAEA;EACE,sDAAsD;EACtD,4BAA4B;EAC5B,sBAAsB;EACtB,2BAA2B;EAC3B,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,OAAO;EACP,MAAM;EACN,WAAW;EACX,YAAY;EACZ,gCAAgC;AAClC;;AAEA;EACE,8BAA8B;EAC9B,+BAA+B;EAC/B,kBAAkB;EAClB,WAAW;EACX,kBAAkB;EAClB,4CAA4C;AAC9C;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,6BAA6B;EAC7B,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,sCAAsC;AACxC;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,0BAA0B;EAC1B,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,QAAQ;EACR,yBAAyB;EACzB,eAAe;EACf,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,+BAA+B;EAC/B,+BAA+B;AACjC;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,+BAA+B;EAC/B,mBAAmB;EACnB,WAAW;EACX,UAAU;EACV,WAAW;EACX,qBAAqB;EACrB,6BAA6B;AAC/B;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,0BAA0B;EAC1B,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,4BAA4B;AAC9B;;;;;AAKA;;uBAEuB;;AAEvB;EACE,kBAAkB;EAClB,kDAAkD;EAClD,4BAA4B;EAC5B,2BAA2B;EAC3B,sBAAsB;EACtB,4BAA4B;EAC5B,UAAU;AACZ;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,8BAA8B;EAC9B,OAAO;EACP,MAAM;EACN,WAAW;EACX,YAAY;EACZ,WAAW;EACX,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,sBAAsB;EACtB,kBAAkB;EAClB,MAAM;EACN,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,YAAY;EACZ,aAAa;EACb,iBAAiB;EACjB,yBAAyB;EACzB,gCAAgC;EAChC,gDAAgD;AAClD;;AAEA;AACA,aAAa;EACX,+BAA+B;AACjC;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,UAAU;EACV,SAAS;EACT,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,mCAAmC;EACnC,6BAA6B;EAC7B,gDAAgD;EAChD,WAAW;AACb;;AAEA;EACE,OAAO;EACP,MAAM;AACR;;AAEA;EACE,cAAc;EACd,cAAc;EACd,yBAAyB;EACzB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,wBAAwB;EACxB,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA;EACE;IACE,cAAc;EAChB;AACF;;;;;AAKA;;uBAEuB;;AAEvB;EACE,kBAAkB;EAClB,8CAA8C;EAC9C,4BAA4B;EAC5B,2BAA2B;EAC3B,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,iBAAiB;EACjB,UAAU;AACZ;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,OAAO;EACP,MAAM;EACN,WAAW;EACX,YAAY;EACZ,+BAA+B;EAC/B,+BAA+B;EAC/B,WAAW;AACb;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,QAAQ;EACR,WAAW;EACX,UAAU;EACV,qCAAqC;EACrC,+BAA+B;EAC/B,WAAW;AACb;;AAEA;EACE,yBAAyB;EACzB,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,8BAA8B;EAC9B,wBAAwB;AAC1B;;AAEA;EACE,yBAAyB;AAC3B;;;;AAIA;;wBAEwB;AACxB,OAAO,8CAA8C,CAAC,iBAAiB,CAAC;AACxE;EACE,kBAAkB;EAClB,8BAA8B;EAC9B,+BAA+B;EAC/B,4BAA4B;EAC5B,mBAAmB;EACnB,6BAA6B;EAC7B,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,+BAA+B;AACjC;;AAEA;EACE,+BAA+B;EAC/B,6BAA6B;EAC7B,aAAa;AACf;;AAEA;EACE,+BAA+B;EAC/B,6BAA6B;EAC7B,aAAa;AACf;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,cAAc;AAChB;;AAEA;EACE,0BAA0B;EAC1B,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,+BAA+B;EAC/B,mBAAmB;EACnB,WAAW;EACX,UAAU;EACV,WAAW;EACX,qBAAqB;EACrB,6BAA6B;AAC/B;;AAEA;EACE,qCAAqC;EACrC,WAAW;AACb;;AAEA;CACC,WAAW;CACX,UAAU;CACV,kBAAkB;CAClB,6BAA6B;CAC7B,SAAS;AACV;;AAEA;CACC,cAAc;CACd,SAAS;CACT,kBAAkB;AACnB;;AAEA;CACC,YAAY;CACZ,WAAW;CACX,4BAA4B;CAC5B,QAAQ;CACR,0CAA0C;CAC1C,oCAAoC;CACpC,0BAA0B;CAC1B,kBAAkB;CAClB,YAAY;CACZ,SAAS;CACT,UAAU;CACV,6BAA6B;CAC7B,mBAAmB;CACnB,iBAAiB;AAClB;;AAEA;CACC,yCAAyC;AAC1C;;AAEA;CACC,UAAU;AACX;;AAEA;CACC,UAAU;AACX;;AAEA;CACC,WAAW;AACZ;;AAEA;CACC,WAAW;AACZ;;;AAGA;;wBAEwB;;AAExB,eAAe,6BAA6B,KAAK,kBAAkB,CAAC,mBAAmB,EAAE,yBAAyB,CAAC;AACnH,iBAAiB,aAAa,CAAC,sBAAsB,CAAC,mBAAmB,CAAC,uBAAuB,CAAC,kBAAkB;AACpH,uCAAuC,CAAC,sCAAsC,CAAC,iCAAiC,CAAC,kBAAkB;AACnI,iBAAiB,CAAC,oBAAoB,CAAC,UAAU,CAAC;AAClD,OAAO,aAAa,CAAC,uBAAuB,CAAC,mBAAmB,CAAC,SAAS,CAAC;AAC3E,WAAW,WAAW,CAAC;AACvB,uBAAuB,eAAe,CAAC,yBAAyB,CAAC,gBAAgB,CAAC,mBAAmB,CAAC,0BAA0B,CAAC;AACjI,QAAQ,eAAe,CAAC,gBAAgB,CAAC,WAAW,CAAC;AACrD,OAAO,eAAe,CAAC,WAAW,CAAC,gBAAgB,EAAE,iBAAiB,CAAC;AACvE,SAAS,cAAc,CAAC;AACxB;;wBAEwB;;AAExB;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,WAAW;AACb;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,0BAA0B;EAC1B,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,eAAe;AACjB;;;;AAIA;;uBAEuB;;AAEvB;EACE,kBAAkB;EAClB,iDAAiD;EACjD,4BAA4B;EAC5B,sBAAsB;EACtB,2BAA2B;EAC3B,UAAU;AACZ;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,OAAO;EACP,MAAM;EACN,4BAA4B;EAC5B,WAAW;EACX,WAAW;EACX,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,8BAA8B;EAC9B,+BAA+B;EAC/B,6BAA6B;AAC/B;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,+BAA+B;EAC/B,+BAA+B;EAC/B,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE;AACF;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,mBAAmB;EACnB,cAAc;EACd,uCAAuC;EACvC,YAAY;EACZ;AACF;;AAEA;EACE,kBAAkB;EAClB,uCAAuC;EACvC,cAAc;EACd,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE;IACE,iBAAiB;EACnB;AACF;;;;AAIA;;wBAEwB;;AAExB;EACE,cAAc;EACd,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,eAAe;EACf,yBAAyB;EACzB,gBAAgB;EAChB,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,+BAA+B;AACjC;;;;AAIA;;wBAEwB;;AAExB;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,gBAAgB;EAChB,6BAA6B,CAAC,yBAAyB;AACzD;;;;AAIA;EACE,UAAU;AACZ;;;;AAIA;EACE,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,+BAA+B;EAC/B,mBAAmB;EACnB,WAAW;EACX,UAAU;EACV,WAAW;EACX,qBAAqB;EACrB,6BAA6B;AAC/B;;AAEA;EACE,qCAAqC;EACrC,WAAW;AACb;;AAEA;CACC,WAAW;CACX,UAAU;CACV,kBAAkB;CAClB,6BAA6B;CAC7B,SAAS;AACV;;AAEA;CACC,cAAc;CACd,SAAS;CACT,kBAAkB;AACnB;;AAEA;CACC,YAAY;CACZ,WAAW;CACX,4BAA4B;CAC5B,QAAQ;CACR,0CAA0C;CAC1C,oCAAoC;CACpC,0BAA0B;CAC1B,kBAAkB;CAClB,YAAY;CACZ,SAAS;CACT,UAAU;CACV,6BAA6B;CAC7B,mBAAmB;CACnB,iBAAiB;AAClB;;AAEA;CACC,yCAAyC;AAC1C;;AAEA;CACC,UAAU;AACX;;AAEA;CACC,UAAU;AACX;;AAEA;CACC,WAAW;AACZ;;AAEA;CACC,WAAW;AACZ;;;;AAIA;;qBAEqB;;AAErB;EACE,0BAA0B;EAC1B,kBAAkB;AACpB;;AAEA;EACE,qCAAqC;EACrC,kBAAkB;EAClB,yBAAyB;EACzB,cAAc;EACd,mBAAmB;EACnB,+BAA+B;EAC/B,gBAAgB;EAChB,6BAA6B;AAC/B;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,qCAAqC;EACrC,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;AACrB;;;;;AAKA;;uBAEuB;;AAEvB;EACE,kBAAkB;AACpB;AACA;;uBAEuB;AACvB;IACI,kBAAkB;IAClB,UAAU;IACV,OAAO;IACP,mBAAmB;IACnB,cAAc;IACd,YAAY;IACZ,eAAe;IACf,WAAW;IACX,gBAAgB;IAChB,iBAAiB;IACjB,eAAe,CAAC;AACpB;;AAEA,iBAAiB,aAAa,CAAC,mBAAmB,CAAC,uBAAuB,CAAC;;;AAG3E;;uBAEuB;;AAEvB;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,4BAA4B;EAC5B,+BAA+B;EAC/B,8BAA8B;EAC9B,6BAA6B;EAC7B,6BAA6B;AAC/B;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,+BAA+B;AACjC;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,0BAA0B;EAC1B,YAAY;EACZ,SAAS;EACT,gBAAgB;EAChB,+BAA+B;EAC/B,yBAAyB;EACzB,+BAA+B;EAC/B,6BAA6B;EAC7B,UAAU;AACZ;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,SAAS;EACT,UAAU;EACV,cAAc;EACd,iDAAiD;EACjD,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;EACrB,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB,wBAAwB;AAC1B;;AAEA;EACE,iBAAiB;EACjB,0BAA0B;AAC5B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,eAAe;EACf,mBAAmB;EACnB,gBAAgB;EAChB,0BAA0B;EAC1B,2BAA2B;AAC7B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,0BAA0B;AAC5B;;;;;AAKA;;2BAE2B;;AAE3B;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,0BAA0B;AAC5B;;AAEA;EACE,6BAA6B;EAC7B,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,iCAAiC;EACjC,0CAA0C;EAC1C,aAAa;EACb,eAAe;EACf,kBAAkB;EAClB,cAAc;EACd,+BAA+B;AACjC;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;EAClB,wBAAwB;AAC1B;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,WAAW;EACX,WAAW;EACX,+BAA+B;EAC/B,OAAO;EACP,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,iCAAiC;EACjC,yBAAyB;EACzB,iBAAiB;EACjB,kBAAkB;EAClB,6BAA6B;AAC/B;;AAEA;EACE,8BAA8B;EAC9B,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,8BAA8B;EAC9B,+BAA+B;EAC/B,6BAA6B;EAC7B,cAAc;EACd,aAAa;AACf;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,eAAe;EACf,yBAAyB;EACzB,aAAa;AACf;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,oCAAoC;EACpC,mBAAmB;EACnB,iBAAiB;EACjB,yBAAyB;EACzB,6BAA6B;AAC/B;;AAEA;EACE,yBAAyB;EACzB,8BAA8B;AAChC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,0BAA0B;EAC1B,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,0BAA0B;AAC5B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,mBAAmB;EACnB,iCAAiC;AACnC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;EAChB,6BAA6B;AAC/B;;AAEA;EACE,iCAAiC;AACnC;;;;AAIA;EACE;IACE,sBAAsB;IACtB,eAAe;EACjB;;EAEA;IACE,SAAS;EACX;;EAEA;IACE,sBAAsB;IACtB,uBAAuB;EACzB;;EAEA;IACE,sBAAsB;IACtB,kBAAkB;IAClB,aAAa;EACf;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,sBAAsB;IACtB,kBAAkB;IAClB,iBAAiB;IACjB,6BAA6B;IAC7B,mBAAmB;IACnB,mBAAmB;EACrB;;EAEA;IACE,wBAAwB;EAC1B;;EAEA;IACE,gBAAgB;EAClB;AACF;;;;AAIA;;0BAE0B;;AAE1B;EACE,iCAAiC;EACjC,aAAa;EACb,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,WAAW;EACX,4CAA4C;EAC5C,SAAS;EACT,OAAO;AACT;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,WAAW;EACX,4CAA4C;EAC5C,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,4BAA4B;EAC5B,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,MAAM;EACN,eAAe;EACf,0BAA0B;EAC1B,uBAAuB;EACvB,YAAY;EACZ,0BAA0B;AAC5B;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,gCAAgC;EAChC,6BAA6B;AAC/B;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,0BAA0B;AAC5B;;AAEA;EACE,iBAAiB;EACjB,0BAA0B;AAC5B;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA;EACE,eAAe;EACf,0BAA0B;EAC1B,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,oCAAoC;EACpC,yBAAyB;EACzB,kBAAkB;EAClB,iBAAiB;EACjB,mBAAmB;EACnB,6BAA6B;AAC/B;;AAEA;EACE,8BAA8B;EAC9B,yBAAyB;AAC3B;;AAEA;EACE,8BAA8B;EAC9B,yBAAyB;EACzB,iBAAiB;EACjB,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;EACnB,qBAAqB;EACrB,6BAA6B;AAC/B;;AAEA;EACE,qCAAqC;EACrC,yBAAyB;AAC3B;;;;AAIA;;sBAEsB;;AAEtB;EACE,kBAAkB;EAClB,8BAA8B;EAC9B,mBAAmB;EACnB,6BAA6B;EAC7B,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,OAAO;EACP,MAAM;EACN,WAAW;EACX,YAAY;EACZ,8BAA8B;EAC9B,4BAA4B;EAC5B,2DAA2D;EAC3D,WAAW;AACb;;AAEA;EACE,WAAW;EACX,6DAA6D;AAC/D;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;EAChB,6BAA6B;AAC/B;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,aAAa;AACf;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,kBAAkB;EAClB,SAAS;EACT,kBAAkB;EAClB,kBAAkB;EAClB,mBAAmB;EACnB,+BAA+B;EAC/B,6BAA6B;EAC7B,6BAA6B;EAC7B,6BAA6B;AAC/B;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,YAAY;EACZ,8BAA8B;EAC9B,sDAAsD;EACtD,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,eAAe;EACf,yBAAyB;EACzB,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,kBAAkB;EAClB,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,UAAU;EACV,aAAa;EACb,oCAAoC;EACpC,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,gBAAgB;EAChB,eAAe;AACjB;;;AAGA;EACE;IACE,mBAAmB;EACrB;AACF;;;;;AAKA;;sBAEsB;;AAEtB;EACE,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,8BAA8B;EAC9B,aAAa;EACb,mBAAmB;EACnB,+BAA+B;EAC/B,gBAAgB;EAChB,6BAA6B;EAC7B,6BAA6B;AAC/B;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,eAAe;EACf,kBAAkB;EAClB,0BAA0B;AAC5B;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,+BAA+B;EAC/B,eAAe;EACf,8BAA8B;EAC9B,yBAAyB;EACzB,6BAA6B;AAC/B;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,kBAAkB;EAClB,SAAS;EACT,UAAU;EACV,SAAS;EACT,UAAU;EACV,6BAA6B;AAC/B;;AAEA;EACE,UAAU;EACV,WAAW;AACb;;AAEA;EACE,cAAc;EACd,yBAAyB;EACzB,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,mBAAmB;EACnB,+BAA+B;EAC/B,+BAA+B;EAC/B,6BAA6B;EAC7B,6BAA6B;AAC/B;;AAEA;EACE,+BAA+B;EAC/B,yBAAyB;AAC3B;;AAEA;EACE,2BAA2B;EAC3B,uBAAuB;EACvB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,OAAO;EACP,SAAS;EACT,WAAW;EACX,WAAW;EACX,mBAAmB;EACnB,8BAA8B;EAC9B,wCAAwC;EACxC,WAAW;AACb;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,QAAQ;AACV;;;;AAIA;;wBAEwB;;AAExB;EACE,+BAA+B;AACjC;;AAEA;EACE,aAAa;EACb,iCAAiC;EACjC,+BAA+B;AACjC;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,kBAAkB;EAClB,0BAA0B;AAC5B;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,0BAA0B;EAC1B,qBAAqB;EACrB,+BAA+B;AACjC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE;AACF;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,iCAAiC;AACnC;;;;AAIA;;uBAEuB;;AAEvB;EACE,kBAAkB;EAClB,4BAA4B;EAC5B,2BAA2B;EAC3B,sBAAsB;EACtB,+BAA+B;AACjC;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,6BAA6B;EAC7B,+BAA+B;EAC/B,WAAW;EACX,YAAY;EACZ,OAAO;EACP,MAAM;AACR;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,uBAAuB;EACvB,kBAAkB;EAClB,aAAa;EACb,YAAY;AACd;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,UAAU;EACV,YAAY;EACZ,WAAW;EACX,kBAAkB;EAClB,kBAAkB;EAClB,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,gCAAgC;AAClC;;AAEA;EACE;IACE,aAAa;EACf;AACF;;;;AAIA;;sBAEsB;;AAEtB;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,kBAAkB;EAClB,+BAA+B;EAC/B,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,SAAS;EACT,WAAW;EACX,4BAA4B;EAC5B,8BAA8B;AAChC;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,iBAAiB;EACjB,+BAA+B;EAC/B,wBAAwB;EACxB,kBAAkB;EAClB,kBAAkB;EAClB,yBAAyB;EACzB,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,+BAA+B;AACjC;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,SAAS;EACT,YAAY;EACZ,kBAAkB;EAClB,qCAAqC;AACvC;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,0BAA0B;EAC1B,eAAe;AACjB;;AAEA;EACE,0BAA0B;EAC1B,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,gBAAgB;EAChB,8CAA8C;AAChD;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,iCAAiC;EACjC,yBAAyB;EACzB,OAAO;EACP,MAAM;AACR;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,8BAA8B;AAChC;;;;;AAKA;;uBAEuB;;AAEvB;EACE,YAAY;EACZ,mBAAmB;EACnB,8BAA8B;EAC9B,0CAA0C;EAC1C,6BAA6B;AAC/B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,mBAAmB;EACnB,8BAA8B;EAC9B,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,uBAAuB;EACvB,2CAA2C;AAC7C;;AAEA;EACE,6BAA6B;EAC7B,uBAAuB;EACvB,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,2BAA2B;AAC7B;;AAEA;EACE,2CAA2C;AAC7C;;AAEA;;GAEG;;AAEH;EACE;IACE,mBAAmB;EACrB;;EAEA;IACE,eAAe;EACjB;AACF;;;;AAIA;;uBAEuB;;AAEvB;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,uCAAuC;EACvC,sCAAsC;EACtC,iCAAiC;EACjC,kBAAkB;EAClB,kBAAkB;EAClB,qBAAqB;EACrB,UAAU;AACZ;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,YAAY;EACZ,WAAW;EACX,MAAM;EACN,OAAO;EACP,qCAAqC;EACrC,aAAa;EACb,WAAW;AACb;;AAEA;EACE,eAAe;EACf,yBAAyB;EACzB,gBAAgB;EAChB,mBAAmB;EACnB,0BAA0B;AAC5B;;AAEA;EACE,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,iBAAiB;EACjB,yBAAyB;EACzB,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA;EACE,yBAAyB;EACzB,gCAAgC;AAClC;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,iCAAiC;EACjC,YAAY;EACZ,QAAQ;EACR,kBAAkB;EAClB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,0BAA0B;AAC5B;AACA;EACE,YAAY;AACd;;AAEA;EACE;IACE,kBAAkB;EACpB;EACA;IACE,cAAc;IACd,YAAY;EACd;EACA;IACE,sBAAsB;EACxB;AACF;;;;;AAKA;;uBAEuB;;AAEvB;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,gCAAgC;EAChC,yBAAyB;EACzB,cAAc;EACd,8BAA8B;EAC9B,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,6BAA6B;AAC/B;;AAEA;;EAEE,8BAA8B;EAC9B,yBAAyB;AAC3B;;;;;AAKA;;uBAEuB;;AAEvB;EACE,kBAAkB;EAClB,aAAa;EACb,+BAA+B;EAC/B,8BAA8B;EAC9B,6BAA6B;AAC/B;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,OAAO;EACP,SAAS;EACT,YAAY;EACZ,UAAU;EACV,8BAA8B;AAChC;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,oBAAoB;EACpB,iDAAiD;AACnD;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,eAAe;AACjB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,yBAAyB;EACzB,eAAe;AACjB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,YAAY;EACZ,aAAa;AACf;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;EACzB,eAAe;AACjB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,oCAAoC;EACpC,gCAAgC;AAClC;;AAEA;EACE,6BAA6B;EAC7B,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,8BAA8B;EAC9B,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,8BAA8B;AAChC;;;AAGA;EACE;IACE,kBAAkB;EACpB;AACF;;;;AAIA;;uBAEuB;;AAEvB;EACE,4BAA4B;EAC5B,iCAAiC;EACjC,sCAAsC;EACtC,iBAAiB;EACjB,WAAW;EACX,MAAM;EACN,OAAO;EACP,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,6BAA6B;EAC7B,WAAW;EACX,YAAY;EACZ,MAAM;EACN,OAAO;AACT;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,cAAc;EACd,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,QAAQ;EACR,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,mBAAmB;EACnB,+BAA+B;EAC/B,qBAAqB;EACrB,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,oCAAoC;EACpC,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,WAAW;EACX,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,mBAAmB;EACnB,oCAAoC;EACpC,qBAAqB;EACrB,eAAe;AACjB;;AAEA;EACE,8BAA8B;EAC9B,gCAAgC;AAClC;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,+BAA+B;EAC/B,aAAa;EACb,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,+BAA+B;EAC/B,6BAA6B;AAC/B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;;;;AAKA;;uBAEuB;;AAEvB;EACE,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,iBAAiB;EACjB,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,gBAAgB;AAClB;;;AAGA;EACE;IACE,gBAAgB;EAClB;AACF;;;;;AAKA;;wBAEwB;;AAExB;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;;;AAIA;;uBAEuB;;AAEvB;EACE,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,OAAO;EACP,SAAS;EACT,WAAW;EACX,YAAY;EACZ,8BAA8B;EAC9B,kCAAkC;EAClC,wBAAwB;EACxB,WAAW;AACb;;AAEA;EACE,kCAAkC;EAClC,WAAW;AACb;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,8CAA8C;EAC9C,iBAAiB;AACnB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,iBAAiB;AACnB;;AAEA;EACE;IACE,gBAAgB;EAClB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,mBAAmB;EACrB;AACF;;;;AAIA;;uBAEuB;;AAEvB;EACE,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,6BAA6B;AAC/B;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,iDAAiD;AACnD;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,kBAAkB;AACpB;;AAEA;;EAEE,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;;EAEE,gCAAgC;AAClC;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;;;AAIA;;uBAEuB;;AAEvB;EACE,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,OAAO;EACP,SAAS;EACT,WAAW;EACX,YAAY;EACZ,8BAA8B;EAC9B,+BAA+B;EAC/B,wBAAwB;EACxB,WAAW;AACb;;AAEA;EACE,kCAAkC;EAClC,WAAW;AACb;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,8CAA8C;EAC9C,iBAAiB;AACnB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,iBAAiB;AACnB;;AAEA;EACE;IACE,gBAAgB;EAClB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,mBAAmB;EACrB;AACF;;;;;AAKA;;uBAEuB;;AAEvB;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,WAAW;EACX,UAAU;EACV,aAAa;EACb,UAAU;EACV,qCAAqC;EACrC,kCAAkC;EAClC,WAAW;AACb;;AAEA;EACE,+BAA+B;EAC/B,WAAW;AACb;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,8CAA8C;EAC9C,iBAAiB;AACnB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE;IACE,gBAAgB;EAClB;AACF;;;AAGA;;uBAEuB;;AAEvB;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,+BAA+B;EAC/B,mBAAmB;EACnB,6BAA6B;EAC7B,iCAAiC;EACjC,6BAA6B;AAC/B;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;AAC3B;;;;AAIA;;uBAEuB;;AAEvB;EACE,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,WAAW;EACX,UAAU;EACV,aAAa;EACb,UAAU;EACV,qCAAqC;EACrC,kCAAkC;EAClC,WAAW;AACb;;AAEA;EACE,+BAA+B;EAC/B,WAAW;AACb;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,8CAA8C;EAC9C,iBAAiB;AACnB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE;IACE,mBAAmB;EACrB;AACF;;;;AAIA;;uBAEuB;;AAEvB;EACE,kBAAkB;EAClB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,+BAA+B;EAC/B,8BAA8B;EAC9B,6BAA6B;EAC7B,6BAA6B;EAC7B,UAAU;AACZ;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,kBAAkB;EAClB,4BAA4B;AAC9B;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;AACpB;;;;;AAKA;;qBAEqB;;AAErB;EACE,mBAAmB;AACrB;;AAEA;EACE,0BAA0B;EAC1B,kBAAkB;AACpB;;AAEA;EACE,qCAAqC;EACrC,kBAAkB;EAClB,yBAAyB;EACzB,cAAc;EACd,mBAAmB;EACnB,+BAA+B;EAC/B,gBAAgB;EAChB,6BAA6B;AAC/B;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,qCAAqC;EACrC,yBAAyB;AAC3B;;AAEA;EACE,wBAAwB;AAC1B;;;;;AAKA;;uBAEuB;;AAEvB;EACE,kBAAkB;EAClB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,+BAA+B;EAC/B,4BAA4B;EAC5B,8BAA8B;EAC9B,6BAA6B;EAC7B,6BAA6B;EAC7B,UAAU;AACZ;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;AACpB;;;;;AAKA;;qBAEqB;;AAErB;EACE,mBAAmB;AACrB;;AAEA;EACE,0BAA0B;EAC1B,kBAAkB;AACpB;;AAEA;EACE,qCAAqC;EACrC,kBAAkB;EAClB,yBAAyB;EACzB,cAAc;EACd,mBAAmB;EACnB,+BAA+B;EAC/B,gBAAgB;EAChB,6BAA6B;AAC/B;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,qCAAqC;EACrC,yBAAyB;AAC3B;;AAEA;EACE,wBAAwB;AAC1B;;;;AAIA;;uBAEuB;;AAEvB;EACE,kBAAkB;EAClB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,+BAA+B;EAC/B,4BAA4B;EAC5B,8BAA8B;EAC9B,6BAA6B;EAC7B,6BAA6B;EAC7B,UAAU;AACZ;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;AACpB;;;;;AAKA;;qBAEqB;;AAErB;EACE,mBAAmB;AACrB;;AAEA;EACE,0BAA0B;EAC1B,kBAAkB;AACpB;;AAEA;EACE,qCAAqC;EACrC,kBAAkB;EAClB,yBAAyB;EACzB,cAAc;EACd,mBAAmB;EACnB,+BAA+B;EAC/B,gBAAgB;EAChB,6BAA6B;AAC/B;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,qCAAqC;EACrC,yBAAyB;AAC3B;;AAEA;EACE,wBAAwB;AAC1B;;;;AAIA;;uBAEuB;;AAEvB;EACE,kBAAkB;AACpB;;;;AAIA;;uBAEuB;;AAEvB;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,UAAU;EACV,UAAU;EACV,aAAa;EACb,UAAU;EACV,+BAA+B;EAC/B,+BAA+B;EAC/B,uBAAuB;EACvB,WAAW;AACb;;AAEA;EACE,+BAA+B;EAC/B,WAAW;AACb;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,8CAA8C;EAC9C,iBAAiB;AACnB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE;IACE,gBAAgB;EAClB;AACF;;;;AAIA;;uBAEuB;;AAEvB;EACE,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,8CAA8C;EAC9C,iBAAiB;AACnB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;AACrB;;;;AAIA;;uBAEuB;;AAEvB;EACE,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,iCAAiC;EACjC,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,0BAA0B;EAC1B,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,YAAY;EACZ,aAAa;AACf;;AAEA;EACE,0BAA0B;EAC1B,kBAAkB;AACpB;;;AAGA;;uBAEuB;;AAEvB;EACE,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;;;AAIA;;uBAEuB;;AAEvB;EACE,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,iBAAiB;AACnB;;;;AAIA;;uBAEuB;;AAEvB;EACE,4BAA4B;EAC5B,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,gCAAgC;EAChC,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,kBAAkB,CAAC,mBAAmB;AACxC;;AAEA;EACE,kBAAkB;EAClB,+CAA+C;AACjD;;AAEA;EACE,SAAS;EACT,UAAU;EACV,iBAAiB;AACnB;;AAEA;EACE,qBAAqB;EACrB,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,+BAA+B;EAC/B,6BAA6B;AAC/B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,+BAA+B;EAC/B,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,gCAAgC;EAChC,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,oBAAoB;EACpB,kBAAkB;EAClB,eAAe;EACf,UAAU;AACZ;;AAEA;;;;;;;;;;;CAWC;;AAED;;;;;;;;;;;CAWC;;AAED,qBAAqB,qBAAqB,CAAC,mBAAmB,CAAC;AAC/D;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,yBAAyB;EACzB,6BAA6B,CAAC,eAAe;AAC/C;;AAEA;EACE,iBAAiB;EACjB,0BAA0B;AAC5B;;AAEA;EACE,kBAAkB;EAClB,0BAA0B;AAC5B;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,oBAAoB;AACtB;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,iBAAiB;EACjB,kBAAkB;EAClB,+BAA+B;EAC/B,8BAA8B;EAC9B,0BAA0B;EAC1B,6BAA6B;AAC/B;;AAEA;EACE,+BAA+B;EAC/B,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,+BAA+B;EAC/B,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,+BAA+B;EAE/B,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,eAAe;EACf,kBAAkB;EAClB,+BAA+B;EAC/B,+BAA+B;EAC/B,kBAAkB;EAElB,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,aAAa;AACf;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,iCAAiC;AACnC;;;AAGA;EACE;IACE,mBAAmB;EACrB;AACF;;AAEA;EACE;IACE,mBAAmB;EACrB;;EAEA;IACE,WAAW;IACX,gBAAgB;IAChB,gBAAgB;EAClB;;EAEA;IACE,cAAc;IACd,kBAAkB;EACpB;;AAEF;;AAEA;EACE;IACE,mBAAmB;EACrB;;EAEA;IACE,2BAA2B;IAC3B,gBAAgB;EAClB;;EAEA;IACE,UAAU;EACZ;AACF;;;;AAIA;;uBAEuB;;AAEvB;EACE,8BAA8B;AAChC;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,sCAAsC;AACxC;;AAEA;EACE,8BAA8B;EAC9B,0BAA0B;AAC5B;;AAEA;EACE,8BAA8B;EAC9B,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,4CAA4C;EAC5C,oCAAoC;AACtC;;;AAGA;EACE;IACE,uBAAuB;IACvB,mBAAmB;EACrB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,WAAW;IACX,kBAAkB;IAClB,OAAO;IACP,MAAM;IACN,UAAU;IACV,8BAA8B;IAC9B,YAAY;IACZ,4BAA4B;EAC9B;;EAEA;IACE,iBAAiB;EACnB;;AAEF;;AAEA;EACE;IACE,gBAAgB;IAChB,mBAAmB;IACnB,8BAA8B;EAChC;;EAEA;IACE,wBAAwB;IACxB,kDAAkD;EACpD;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,wBAAwB;EAC1B;AACF;;AAEA;EACE;MACI,mBAAmB;EACvB;AACF;;;;;AAKA;;uBAEuB;;AAEvB;EACE,mBAAmB;AACrB;;AAEA;EACE,sBAAsB;EACtB,8BAA8B;AAChC;;AAEA;;EAEE,aAAa;AACf;;AAEA;EACE,yBAAyB;EACzB,0BAA0B;AAC5B;;AAEA;EACE,yBAAyB;EACzB,iBAAiB;EACjB,kBAAkB;EAClB,gDAAgD;AAClD;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,6BAA6B;EAC7B,cAAc;AAChB;;AAEA;EACE,4CAA4C;EAC5C,oCAAoC;AACtC;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,kBAAkB;EAClB,iDAAiD;EACjD,4BAA4B;EAC5B,2BAA2B;EAC3B,sBAAsB;EACtB,UAAU;AACZ;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,4BAA4B;EAC5B,OAAO;EACP,MAAM;EACN,WAAW;EACX,YAAY;EACZ,YAAY;AACd;AACA,mBAAmB,aAAa,CAAC;AACjC;EACE,gBAAgB;EAChB,mBAAmB;EACnB,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,6BAA6B;AAC/B;;AAEA;EACE,sBAAsB;EACtB,wBAAwB;EACxB,sBAAsB;EACtB,8BAA8B;EAC9B,YAAY;AACd;AACA;EACE,8BAA8B;AAChC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;;;AAIA,2BAA2B;;;AAG3B,YAAY,mBAAmB,CAAC,aAAa,CAAC,cAAc,EAAE,WAAW,CAAC;AAC1E,cAAc,eAAe,EAAE,WAAW,CAAC,gBAAgB,CAAC;AAC5D,cAAc,8BAA8B,CAAC,6BAA6B,CAAC,kBAAkB,CAAC;AAC9F,YAAY,aAAa,CAAC,mBAAmB,CAAC,uBAAuB,CAAC,WAAW,CAAC,WAAW,CAAC,YAAY,CAAC,kBAAkB,CAAC,eAAe,EAAE;AAC/I,WAAW,mBAAmB,CAAC;AAC/B,cAAc,mBAAmB,CAAC,mBAAmB,CAAC,YAAY,CAAC;AACnE,SAAS,mBAAmB,CAAC;CAC5B,SAAS,mBAAmB,CAAC;AAC9B,SAAS,mBAAmB,CAAC;AAC7B,QAAQ,mBAAmB,CAAC;AAC5B,gBAAgB,kBAAkB,CAAC,eAAe,CAAC;AACnD,WAAW,WAAW,CAAC,eAAe,CAAC,gBAAgB,CAAC;AACxD,UAAU,kBAAkB,CAAC,OAAO,CAAC,SAAS,CAAC;AAC/C,cAAc,UAAU,CAAC;AACzB,4BAA4B,mBAAmB,CAAC;AAChD,WAAW,kBAAkB,CAAC,QAAQ,CAAC,SAAS,CAAC,YAAY,CAAC;AAC9D,eAAe,UAAU,CAAC;AAC1B,YAAY,mBAAmB,CAAC;AAChC,kBAAkB,8BAA8B,CAAC,6BAA6B,CAAC,kBAAkB,CAAC,eAAe,CAAC,aAAa,CAAC,kBAAkB,CAAC;AACnJ,iBAAiB,6BAA6B,CAAC,kBAAkB,CAAC;AAClE,UAAU,mBAAmB,CAAC;CAC7B,UAAU,mBAAmB,CAAC;CAC9B,UAAU,mBAAmB,CAAC;AAC/B,gBAAgB,aAAa,CAAC,8BAA8B,CAAC,mBAAmB,CAAC,kBAAkB,CAAC,WAAW,CAAC;;;AAGhH,kBAAkB,8BAA8B,CAAC,6BAA6B,CAAC,kBAAkB,CAAC,aAAa,CAAC,kBAAkB,CAAC,sBAAsB,EAAE,iBAAiB,CAAC;AAC7K,iBAAiB,mBAAmB,CAAC,yBAAyB,CAAC;AAC/D,aAAa,kBAAkB,CAAC,2BAA2B,CAAC,SAAS,CAAC,MAAM,CAAC;AAC7E,cAAc,kBAAkB,CAAC,iBAAiB,CAAC;AACnD,WAAW,0BAA0B,CAAC,gBAAgB,CAAC;AACvD,aAAa,wEAAwE,EAAE,mBAAmB,EAAE,aAAa,CAAC,yBAAyB,CAAC,kBAAkB,CAAC;;AAEvK,WAAW,eAAe,CAAC,gBAAgB,CAAC,cAAc,CAAC,iBAAiB,CAAC;AAC7E,YAAY,eAAe,CAAC,gBAAgB,CAAC,cAAc,CAAC,iBAAiB,CAAC;AAC9E,2BAA2B,kBAAkB,CAAC;AAC9C,oBAAoB,mBAAmB,CAAC;AACxC,kBAAkB,kBAAkB,CAAC,QAAQ,CAAC,SAAS,CAAC;AACxD,sBAAsB,UAAU,CAAC;;AAEjC,aAAa,4EAA4E,EAAE,yBAAyB,CAAC,mBAAmB,CAAC,aAAa,CAAC;AACvJ,eAAe,aAAa,CAAC,8BAA8B,CAAC,uBAAuB,CAAC;AACpF,cAAc,WAAW,CAAC,YAAY,CAAC;AACvC,WAAW,eAAe,CAAC,gBAAgB,CAAC,mBAAmB,CAAC,iBAAiB,CAAC,yBAAyB,CAAC;AAC5G,mBAAmB,aAAa,CAAC,0BAA0B,CAAC,QAAQ,CAAC;AACrE,cAAc,eAAe,EAAE,WAAW,CAAC;AAC3C,UAAU,mBAAmB,CAAC,wBAAwB,CAAC,cAAc,CAAC,kBAAkB,CAAC;AACzF,QAAQ,0BAA0B,CAAC;AACnC,eAAe,eAAe,CAAC;AAC/B,mBAAmB,eAAe,CAAC,gBAAgB,CAAC,iBAAiB,CAAC,iBAAiB,CAAC;AACxF,8BAA8B,eAAe,CAAC,cAAc,CAAC;AAC7D,wBAAwB,mBAAmB,EAAE,kBAAkB,CAAC,gBAAgB,CAAC,WAAW,CAAC;AAC7F,gBAAgB,4BAA4B,CAAC,qFAAqF,CAAC;AACnI,WAAW,4BAA4B,CAAC,qFAAqF,CAAC;AAC9H,eAAe,kBAAkB,CAAC,SAAS,CAAC,QAAQ,CAAC;AACrD,gBAAgB,aAAa,CAAC,QAAQ,CAAC;AACvC,gBAAgB,aAAa,CAAC,0BAA0B,CAAC,YAAY,CAAC,mBAAmB,CAAC;AAC1F,iBAAiB,cAAc,CAAC,gBAAgB;AAChD,WAAW,eAAe,CAAC,gBAAgB,CAAC,cAAc,CAAC;AAC3D,YAAY,WAAW,CAAC;AACxB,WAAW,eAAe,CAAC,gBAAgB,CAAC;AAC5C,mBAAmB,UAAU,CAAC;AAC9B,oBAAoB,mBAAmB,EAAE,iBAAiB,CAAC;;AAE3D,8BAA8B,4EAA4E,CAAC;AAC3G,YAAY,eAAe,CAAC,gBAAgB,CAAC;AAC7C,SAAS,mBAAmB,CAAC,4BAA4B,CAAC,eAAe,CAAC,WAAW,CAAC,gBAAgB,CAAC;AACvG,WAAW,eAAe,CAAC;AAC3B,aAAa,aAAa,CAAC,QAAQ,CAAC,uBAAuB,CAAC;AAC5D,aAAa,aAAa,CAAC,UAAU,CAAC,mBAAmB,CAAC,uBAAuB,CAAC,eAAe,CAAC,WAAW,CAAC,gBAAgB,CAAC;AAC/H,cAAc,4BAA4B,CAAC;AAC3C,gBAAgB,WAAW,CAAC,YAAY,CAAC,aAAa,EAAE,uBAAuB,CAAC,mBAAmB,CAAC;AACpG,WAAW,mBAAmB,CAAC;CAC9B,QAAQ,mBAAmB,CAAC;AAC7B,YAAY,mBAAmB,CAAC;AAChC,cAAc,8BAA8B,CAAC,2FAA2F,CAAC;AACzI,wBAAwB,iBAAiB,CAAC,kBAAkB,CAAC;AAC7D,iBAAiB,eAAe,EAAE,gBAAgB,CAAC,cAAc,CAAC;AAClE,wBAAwB,WAAW,CAAC,kBAAkB,CAAC,OAAO,EAAE,SAAS,CAAC,yDAAyD,CAAC,4BAA4B,CAAC,WAAW,CAAC,YAAY,CAAC;AAC1L,cAAc,UAAU,CAAC,YAAY,CAAC;AACtC,UAAU,kBAAkB,CAAC,QAAQ,CAAC,SAAS,CAAC;AAChD,cAAc,UAAU,CAAC;AACzB,YAAY,eAAe,CAAC,gBAAgB,CAAC,iBAAiB,CAAC;AAC/D,aAAa,yBAAyB,CAAC,qBAAqB,CAAC;AAC7D,KAAK,eAAe,CAAC;AACrB,cAAc,2FAA2F,CAAC;AAC1G,cAAc,cAAc,CAAC;AAC7B,YAAY,kBAAkB,CAAC;AAC/B,eAAe,qBAAqB,CAAC,mBAAmB,CAAC,WAAW,CAAC;AACrE,sBAAsB,mBAAmB,CAAC,iBAAiB,CAAC;AAC5D,gBAAgB,kBAAkB,CAAC,OAAO,CAAC,SAAS,CAAC;AACrD,kBAAkB,kBAAkB,CAAC,QAAQ,CAAC,SAAS,CAAC;AACxD,oBAAoB,UAAU,CAAC;CAC9B,sBAAsB,UAAU,CAAC;;;AAGlC,yBAAyB;;;AAGzB,iBAAiB;AACjB;AACA,kBAAkB;AAClB,UAAU;AACV,iBAAiB;AACjB;;IAEI;AACJ,sBAAsB;AACtB,uCAAuC;AACvC,aAAa;AACb,mBAAmB;AACnB,gBAAgB;AAChB,YAAY;AACZ;;IAEI;AACJ,WAAW;AACX,YAAY;AACZ;;IAEI;AACJ,WAAW;AACX,YAAY;AACZ,kBAAkB;AAClB,iBAAiB;AACjB;;IAEI,iBAAiB,aAAa,CAAC,6BAA6B,CAAC;;AAEjE,qBAAqB;;AAErB,mCAAmC;AACnC;EACE,8CAA8C,CAAC,yBAAyB,CAAC;;AAE3E,qGAAqG;EACnG,0BAA0B,8BAA8B,CAAC;;EAEzD,4BAA4B,gBAAgB,CAAC,eAAe,CAAC;EAC7D,uCAAuC,aAAa,CAAC;EACrD,sDAAsD,wBAAwB,EAAE,eAAe,CAAC,gBAAgB,CAAC;EACjH,4DAA4D,wBAAwB,CAAC;EACrF,uCAAuC,wBAAwB,CAAC;EAChE,gCAAgC,gBAAgB,EAAE,iBAAiB,CAAC,oBAAoB,EAAE,0BAA0B,CAAC;EACrH,2CAA2C,kBAAkB,KAAK,iBAAiB,CAAC;EACpF,gBAAgB,0BAA0B,CAAC,iBAAiB,CAAC,WAAW,CAAC,iBAAiB,CAAC,aAAa,CAAC,mBAAmB,CAAC,UAAU,CAAC;EACxI,2BAA2B,aAAa,CAAC,mBAAmB,CAAC,QAAQ,CAAC;EACtE,2BAA2B,eAAe,GAAG,iBAAiB,CAAC,cAAc,CAAC,aAAa,CAAC;;AAE9F,iCAAiC;;AAEjC,yCAAyC;AACzC;EACE,8CAA8C,CAAC,yBAAyB,CAAC;;AAE3E,qGAAqG;EACnG,0BAA0B,8BAA8B,CAAC;;EAEzD,4BAA4B,gBAAgB,CAAC,eAAe,CAAC;EAC7D,uCAAuC,aAAa,CAAC;EACrD,sDAAsD,wBAAwB,EAAE,eAAe,CAAC,gBAAgB,CAAC;EACjH,4DAA4D,wBAAwB,CAAC;EACrF,uCAAuC,wBAAwB,CAAC;EAChE,gCAAgC,gBAAgB,EAAE,iBAAiB,CAAC,oBAAoB,EAAE,0BAA0B,CAAC;EACrH,2CAA2C,kBAAkB,KAAK,iBAAiB,CAAC;EACpF,gBAAgB,0BAA0B,CAAC,iBAAiB,CAAC,WAAW,CAAC,iBAAiB,CAAC,aAAa,CAAC,mBAAmB,CAAC,UAAU,CAAC;EACxI,2BAA2B,aAAa,CAAC,mBAAmB,CAAC,QAAQ,CAAC;EACtE,2BAA2B,eAAe,GAAG,iBAAiB,CAAC,cAAc,CAAC,aAAa,CAAC;EAC5F,aAAa,gBAAgB,CAAC,eAAe,CAAC,gBAAgB,CAAC;;AAEjE,kCAAkC;;EAEhC,wBAAwB,uBAAuB,EAAE,6BAA6B,CAAC;EAC/E,uCAAuC,mBAAmB,CAAC;EAC3D,kCAAkC,mBAAmB,CAAC;EACtD,oBAAoB,uBAAuB,CAAC,6BAA6B,CAAC;EAC1E,sBAAsB,aAAa,CAAC,8BAA8B,CAAC,eAAe,CAAC,mBAAmB,CAAC;EACvG,MAAM,eAAe,CAAC,gBAAgB,CAAC,wBAAwB,CAAC;EAChE,QAAQ,yBAAyB,CAAC;EAClC,iBAAiB,yBAAyB,CAAC,mBAAmB,CAAC,kBAAkB,CAAC,aAAa,CAAC,kBAAkB,CAAC,mBAAmB,CAAC;;GAEtI,cAAc,mBAAmB,CAAC,WAAW,CAAC,gBAAgB,CAAC,kBAAkB,EAAE,WAAW,CAAC,UAAU,CAAC,eAAe,CAAC,kBAAkB,CAAC,kBAAkB,CAAC,mBAAmB,CAAC,eAAe,CAAC,WAAW,CAAC;;EAEjN,aAAa,aAAa,CAAC,mBAAmB,CAAC,8BAA8B,CAAC,gBAAgB,CAAC;EAC/F,WAAW,gBAAgB,CAAC,kBAAkB,CAAC,cAAc,CAAC,gBAAgB,CAAC,6BAA6B,CAAC;EAC7G,YAAY,cAAc,CAAC,eAAe,CAAC;EAC3C,YAAY,eAAe,CAAC,gBAAgB,CAAC,wBAAwB,CAAC;EACtE,QAAQ,mBAAmB,CAAC,YAAY,EAAE,WAAW,CAAC,kBAAkB,CAAC,eAAe,CAAC,kBAAkB,CAAC,mBAAmB,CAAC;EAChI,YAAY,eAAe,CAAC,cAAc,EAAE,gBAAgB,CAAC;;EAE7D,gCAAgC;EAChC,UAAU,6BAA6B,CAAC,gBAAgB,CAAC,aAAa,CAAC,mBAAmB,CAAC,0CAA0C,CAAC,mBAAmB,CAAC;EAC1J,qBAAqB,aAAa,CAAC,gBAAgB,CAAC,qCAAqC,CAAC,sCAAsC,CAAC;EACjI,eAAe,aAAa,CAAC,UAAU,CAAC,oBAAoB,CAAC;;EAE7D,oBAAoB,aAAa,CAAC,sBAAsB,CAAC,mBAAmB,CAAC,UAAU,CAAC;EACxF,+BAA+B,mBAAmB,CAAC,YAAY,CAAC;EAChE,KAAK,+BAA+B,CAAC,eAAe,CAAC,gBAAgB,CAAC,UAAU,CAAC,kBAAkB,CAAC;EACpG,gBAAgB,eAAe,CAAC,gBAAgB,CAAC,wBAAwB,EAAE;EAC3E,UAAU,mBAAmB,CAAC;;EAE9B,aAAa,iCAAiC,EAAE,kBAAkB,CAAC,OAAO,CAAC,QAAQ,CAAC,SAAS,CAAC,kBAAkB,CAAC,eAAe,CAAC,WAAW,CAAC,4BAA4B,CAAC;GACzK,UAAU,8BAA8B,CAAC,eAAe,CAAC,gBAAgB,CAAC,UAAU,CAAC,kBAAkB,CAAC;EACzG,WAAW,0BAA0B,CAAC;;EAEtC;;EAEA,qBAAqB,aAAa,CAAC;MAC/B,cAAc,iBAAiB,CAAC;MAChC,qBAAqB,oBAAoB,CAAC;;EAE9C;;;;EAIA,iBAAiB,sBAAsB,CAAC,qBAAqB,CAAC;AAChE,sCAAsC,kBAAkB,CAAC;AACzD,2CAA2C,kBAAkB,CAAC,QAAQ,CAAC,SAAS,CAAC,4CAA4C,CAAC;AAC9H,0BAA0B,kBAAkB,CAA2C,aAAa,CAC7E,8BAA8B,KAAK,UAAU,CAAC;AACrE,yCAAyC,uBAAuB,CAC9B,8BAA8B,CAAC;AACjE,kDAAkD,2BAA2B,CAAC;AAC9E,6BAA6B,kBAAkB;AAC/C,aAAa,CAAiC,SAAO,CAAgD,kBAAkB,CAA0B,gBAAgB,CAAC;AAClK,oDAAoD,kBAAkB,CAAkC,SAAO,CAAC,WAAW,CAAC,WAAW;AACvI,QAAQ,CAAC;AACT,mCAAmC,yBAAyB,CAAC;AAC7D,0DAA0D,yBAAyB,CAAC;AACpF,wCAAwC,WAAW,CAAC;AACpD,2CAA2C,qBAAqB,CAAC,WAAW,CAAC,YAAY,CAAC,eAAe,CAAC,iBAAiB;AAC3H,kBAAkB,CAAC,+BAA+B,CAAC,kBAAkB,CAAC;AACtE,yDAAyD,oCAAoC,CAAC,WAAW,CAAC;AAC1G,2CAA2C,yBAAyB,CAAC;AACrE,+DAA+D,oCAAoC,CAAC,sBAAsB,CAAC;AAC3H,6DAA6D,yBAAyB,CAAC;AACvF,4DAA4D,oCAAoC,CAAC,WAAW,CAAC,eAAe,CAAC;AAC7H,mEAAmE,gBAAgB,EAAE,iCAAiC,EAAE,iBAAiB,CAAC;AAC1I,+CAA+C,yBAAyB,CAAC;AACzE,kEAAkE,oCAAoC,EAAE,sBAAsB,CAAC;AAC/H,qDAAqD,sBAAsB,CAAC;AAC5E,uDAAuD,sBAAsB,CAAC;AAC9E,sBAAsB,iBAAiB,CAAC,+BAA+B,CAAC,kBAAkB,CAAC;AAC3F,kBAAkB,eAAe,CAAC;;;AAGlC,uCAAuC","sourcesContent":["\r\n/*=====================================================\r\nTable of contents\r\n=======================================================\r\n\r\n=======================================================*/\r\n\r\n\r\n/*====================\r\n1. Google fonts\r\n======================*/\r\n\r\n/*@import url('https://fonts.googleapis.com/css2?family=Yantramanav:wght@100;300;400;500;700;900&amp;family=Roboto:wght@100;300;400;500;700;900&amp;display=swap');*/\r\n\r\n@import url('https://fonts.googleapis.com/css2?family=Caveat:wght@400;500&family=Jost:ital,wght@0,200;0,300;0,400;0,500;0,600;0,700;0,800;1,100;1,300;1,400;1,500;1,600&family=Poppins&display=swap');\r\n\r\n/*====================\r\n2. Theme variables\r\n======================*/\r\n\r\n:root {\r\n/*    --body-font:'Jost', sans-serif;*/\r\n --body-font: 'Roboto', sans-serif;\r\n  --heading-font: 'Jost', sans-serif;\r\n  --theme-color: #116E63;\r\n  --theme-color2: #f58634;\r\n  --theme-color-light: rgb(17, 110, 99, 0.09);\r\n  --theme-bg-light: #F2F3F5;\r\n  --body-text-color: #757F95;\r\n  --color-white: #ffffff;\r\n  --color-black: #ffffff;\r\n  --color-dark: #19232B;\r\n  --hero-overlay-color: #000000;\r\n  --slider-arrow-bg: rgba(255, 255, 255, 0.2);\r\n  --box-shadow: 0 0 40px 5px rgb(0 0 0 / 5%);\r\n  --box-shadow2: 0 0 15px rgba(0, 0, 0, 0.17);\r\n  --transition: all .5s ease-in-out;\r\n  --transition2: all .3s ease-in-out;\r\n  --border-info-color: rgba(0, 0, 0, 0.08);\r\n  --border-info-color2: rgba(0, 0, 0, 0.05);\r\n  --border-white-color: rgba(255, 255, 255, 0.08);\r\n  --border-white-color2: rgba(255, 255, 255, 0.05);\r\n  --footer-bg: #012758;\r\n  --footer-bg2: #116E63;\r\n  --footer-text-color: #F5FAFF;\r\n  --heading-border: #c7c2c2;\r\n    \r\n}\r\n\r\n\r\n\r\n/*====================\r\n3. General css\r\n======================*/\r\n\r\n*,\r\n*:before,\r\n*:after {\r\n  box-sizing: inherit;\r\n}\r\n\r\n* {\r\n  scroll-behavior: inherit !important;\r\n}\r\n\r\nhtml,\r\nbody {\r\n  height: auto;\r\n  width: 100%;\r\n  margin: 0;\r\n  padding: 0;\r\n  overflow-x: hidden;\r\n  box-sizing: border-box;\r\n \r\n}\r\n\r\nbody {\r\n  font-family: var(--body-font);\r\n  font-style: normal;\r\n  font-size: 16px;\r\n  font-weight: normal;\r\n  color: var(--body-text-color);\r\n  line-height: 1.8;\r\n}\r\n\r\na {\r\n  color:  var(--color-dark);\r\n  display: inline-block;\r\n}\r\n\r\na,\r\na:active,\r\na:focus,\r\na:hover {\r\n  outline: none;\r\n  -webkit-transition: all 0.3s ease-out 0s;\r\n  -moz-transition: all 0.3s ease-out 0s;\r\n  -o-transition: all 0.3s ease-out 0s;\r\n  -ms-transition: all 0.3s ease-out 0s;\r\n  transition: all 0.3s ease-out 0s;\r\n  text-decoration: none;\r\n}\r\n\r\na:hover {\r\n  color: var(--color-blue);\r\n}\r\n\r\nul {\r\n  margin: 0;\r\n  padding: 0;\r\n}\r\n\r\nli {\r\n  list-style: none;\r\n}\r\n\r\nh1,\r\nh2,\r\nh3,\r\nh4,\r\nh5,\r\nh6 {\r\n  color:  var(--color-dark);\r\n  margin: 0px;\r\n  font-weight: 600;\r\n  font-family: var(--heading-font);\r\n  line-height: 1;\r\n}\r\n\r\nh1 {\r\n  font-size: 40px;\r\n}\r\n\r\nh2 {\r\n  font-size: 35px;\r\n}\r\n\r\nh3 {\r\n  font-size: 28px;\r\n}\r\n\r\nh4 {\r\n  font-size: 22px;\r\n}\r\n\r\nh5 {\r\n  font-size: 18px;\r\n}\r\n\r\nh6 {\r\n  font-size: 16px;\r\n}\r\n\r\np {\r\n  margin: 0px;\r\n}\r\n\r\n.img,\r\nimg {\r\n  max-width: 100%;\r\n  -webkit-transition: all 0.3s ease-out 0s;\r\n  -moz-transition: all 0.3s ease-out 0s;\r\n  -ms-transition: all 0.3s ease-out 0s;\r\n  -o-transition: all 0.3s ease-out 0s;\r\n  transition: all 0.3s ease-out 0s;\r\n  height: auto;\r\n}\r\n\r\nlabel {\r\n  color: #999;\r\n  cursor: pointer;\r\n  font-weight: 400;\r\n}\r\n\r\n*::-moz-selection {\r\n  background: #d6b161;\r\n  color: var(--color-white);\r\n  text-shadow: none;\r\n}\r\n\r\n::-moz-selection {\r\n  background: #555;\r\n  color: var(--color-white);\r\n  text-shadow: none;\r\n}\r\n\r\n::selection {\r\n  background: #555;\r\n  color: var(--color-white);\r\n  text-shadow: none;\r\n}\r\n\r\n*::-moz-placeholder {\r\n  color: #999;\r\n  font-size: 16px;\r\n  opacity: 1;\r\n}\r\n\r\n*::placeholder {\r\n  color: #999;\r\n  font-size: 16px;\r\n  opacity: 1;\r\n}\r\n\r\n\r\n\r\n/*====================\r\n4. Preloader\r\n======================*/\r\n\r\n.preloader {\r\n  position: fixed;\r\n  width: 100%;\r\n  height: 100%;\r\n  background: var(--theme-color);\r\n  top: 0;\r\n  left: 0;\r\n  z-index: 9999;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n}\r\n\r\n.loader-book {\r\n  border: 5px solid var(--color-white);\r\n  width: 100px;\r\n  height: 61px;\r\n  position: relative;\r\n  perspective: 150px;\r\n}\r\n\r\n.loader-book-page {\r\n  display: block;\r\n  width: 50px;\r\n  height: 60px;\r\n  border: 5px solid var(--color-white);\r\n  border-left: 5px solid var(--color-white);\r\n  margin: 0;\r\n  position: absolute;\r\n  right: -4px;\r\n  top: -4px;\r\n  overflow: hidden;\r\n  background: var(--theme-color);\r\n  transform-style: preserve-3d;\r\n  -webkit-transform-origin: left center;\r\n  transform-origin: left center;\r\n}\r\n\r\n.loader-book-page:nth-child(1) {\r\n  -webkit-animation: loader-book 1.2s cubic-bezier(0, .39, 1, .68) 1.6s infinite;\r\n  animation: loader-book 1.2s cubic-bezier(0, .39, 1, .68) 1.6s infinite;\r\n}\r\n\r\n.loader-book-page:nth-child(2) {\r\n  -webkit-animation: loader-book 1.2s cubic-bezier(0, .39, 1, .68) 1.45s infinite;\r\n  animation: loader-book 1.2s cubic-bezier(0, .39, 1, .68) 1.45s infinite;\r\n}\r\n\r\n.loader-book-page:nth-child(3) {\r\n  -webkit-animation: loader-book 1.2s cubic-bezier(0, .39, 1, .68) 1.2s infinite;\r\n  animation: loader-book 1.2s cubic-bezier(0, .39, 1, .68) 1.2s infinite;\r\n}\r\n\r\n@-webkit-keyframes loader-book {\r\n  0% {\r\n    -webkit-transform: rotateY( 0deg);\r\n    transform: rotateY( 0deg);\r\n  }\r\n  20% {\r\n    background: var(--theme-color2);\r\n  }\r\n  40% {\r\n    background: var(--theme-color2);\r\n    -webkit-transform: rotateY( -180deg);\r\n    transform: rotateY( -180deg);\r\n  }\r\n  100% {\r\n    background: var(--theme-color);\r\n    -webkit-transform: rotateY( -180deg);\r\n    transform: rotateY( -180deg);\r\n  }\r\n}\r\n\r\n@keyframes loader-book {\r\n  0% {\r\n    transform: rotateY( 0deg);\r\n  }\r\n  20% {\r\n    background: var(--theme-color2);\r\n  }\r\n  40% {\r\n    background: var(--theme-color2);\r\n    transform: rotateY( -180deg);\r\n  }\r\n  100% {\r\n    background: var(--theme-color);\r\n    transform: rotateY( -180deg);\r\n  }\r\n}\r\n\r\n\r\n\r\n\r\n/*===================\r\n5. Theme default css\r\n======================*/\r\n\r\n.ovrflow-hidden {\r\n  overflow: hidden;\r\n}\r\n\r\n.position-relative {\r\n  position: relative;\r\n  z-index: 1;\r\n}\r\n\r\n.text-right {\r\n  text-align: right;\r\n}\r\n\r\n.space-between {\r\n  display: flex;\r\n  justify-content: space-between;\r\n  align-items: center;\r\n}\r\n\r\n.c-pd {\r\n  padding: 0 7rem;\r\n}\r\n\r\n.s-pd {\r\n  padding: 0 12rem;\r\n}\r\n\r\n.h-100 {\r\n  height: 100%;\r\n}\r\n\r\n.h-100vh {\r\n  height: 100vh;\r\n}\r\n\r\n.bg {\r\n  background: var(--theme-bg-light);\r\n}\r\n\r\n\r\n\r\n\r\n/*====================\r\n6. Margin & padding\r\n======================*/\r\n\r\n.pb-140 {\r\n  padding-bottom: 140px;\r\n}\r\n\r\n.pd-50 {\r\n  padding: 50px 0;\r\n}\r\n\r\n.py-120 {\r\n  padding: 120px 0;\r\n}\r\n\r\n.pt-120 {\r\n  padding-top: 120px;\r\n}\r\n\r\n.pb-120 {\r\n  padding-bottom: 120px;\r\n}\r\n\r\n.pt-0 {\r\n  padding-top: 0px;\r\n}\r\n\r\n.pt-10 {\r\n  padding-top: 10px;\r\n}\r\n\r\n.pt-20 {\r\n  padding-top: 20px;\r\n}\r\n\r\n.pt-30 {\r\n  padding-top: 30px;\r\n}\r\n\r\n.pt-40 {\r\n  padding-top: 40px;\r\n}\r\n\r\n.pt-50 {\r\n  padding-top: 50px;\r\n}\r\n\r\n.pt-60 {\r\n  padding-top: 60px;\r\n}\r\n\r\n.pt-70 {\r\n  padding-top: 70px;\r\n}\r\n\r\n.pt-80 {\r\n  padding-top: 80px;\r\n}\r\n\r\n.pt-90 {\r\n  padding-top: 90px;\r\n}\r\n\r\n.pt-100 {\r\n  padding-top: 100px;\r\n}\r\n\r\n.pb-0 {\r\n  padding-bottom: 0px;\r\n}\r\n\r\n.pb-10 {\r\n  padding-bottom: 10px;\r\n}\r\n\r\n.pb-20 {\r\n  padding-bottom: 20px;\r\n}\r\n\r\n.pb-30 {\r\n  padding-bottom: 30px;\r\n}\r\n\r\n.pb-40 {\r\n  padding-bottom: 40px;\r\n}\r\n\r\n.pb-50 {\r\n  padding-bottom: 50px;\r\n}\r\n\r\n.pb-60 {\r\n  padding-bottom: 60px;\r\n}\r\n\r\n.pb-70 {\r\n  padding-bottom: 70px;\r\n}\r\n\r\n.pb-80 {\r\n  padding-bottom: 80px;\r\n}\r\n\r\n.pb-90 {\r\n  padding-bottom: 90px;\r\n}\r\n\r\n.pb-100 {\r\n  padding-bottom: 100px;\r\n}\r\n\r\n.mt-0 {\r\n  margin-top: 0px;\r\n}\r\n\r\n.mt-10 {\r\n  margin-top: 10px;\r\n}\r\n\r\n.mt-20 {\r\n  margin-top: 20px;\r\n}\r\n\r\n.mt-30 {\r\n  margin-top: 30px;\r\n}\r\n\r\n.mt-40 {\r\n  margin-top: 40px;\r\n}\r\n\r\n.mt-50 {\r\n  margin-top: 50px;\r\n}\r\n\r\n.mt-60 {\r\n  margin-top: 60px;\r\n}\r\n\r\n.mt-70 {\r\n  margin-top: 70px;\r\n}\r\n\r\n.mt-80 {\r\n  margin-top: 80px;\r\n}\r\n\r\n.mt-90 {\r\n  margin-top: 90px;\r\n}\r\n\r\n.mt-100 {\r\n  margin-top: 100px;\r\n}\r\n\r\n.mt-120 {\r\n  margin-top: 120px;\r\n}\r\n\r\n.mb-0 {\r\n  margin-bottom: 0px;\r\n}\r\n\r\n.mb-10 {\r\n  margin-bottom: 10px;\r\n}\r\n\r\n.mb-20 {\r\n  margin-bottom: 20px;\r\n}\r\n\r\n.mb-30 {\r\n  margin-bottom: 30px;\r\n}\r\n\r\n.mb-40 {\r\n  margin-bottom: 40px;\r\n}\r\n\r\n.mb-50 {\r\n  margin-bottom: 50px;\r\n}\r\n\r\n.mb-60 {\r\n  margin-bottom: 60px;\r\n}\r\n\r\n.mb-70 {\r\n  margin-bottom: 70px;\r\n}\r\n\r\n.mb-80 {\r\n  margin-bottom: 80px;\r\n}\r\n\r\n.mb-90 {\r\n  margin-bottom: 90px;\r\n}\r\n\r\n.mb-100 {\r\n  margin-bottom: 100px;\r\n}\r\n\r\n.mb-120 {\r\n  margin-bottom: 120px;\r\n}\r\n\r\n.mr-300 {\r\n  margin-right: 300px;\r\n}\r\n\r\n.ml-300 {\r\n  margin-left: 300px;\r\n}\r\n\r\n\r\n/*====================\r\n1. inner all wraper\r\n======================*/\r\n\r\n\r\n   .pd-dashboard-banner-bg {background-position: 50%;background-repeat: no-repeat;background-size: cover;border-radius: 14px;\r\n    padding-top: 154px;position: relative;}\r\n        \r\n  .pd-instructor-wrap {padding: 0 36px 0 48px;transform: translateY(46px);}\r\n        \r\n     .pd-instructor-avatar {flex: 0 0 auto;margin-right: 40px;}\r\n        \r\n    .pd-instructor-title {color: var(--color-white);display: inline-block;font-size: 22px;font-weight: 600;margin-bottom: 2px;}\r\n    .pd-instructor-rating{margin-right: 10px;}\r\n        \r\n    .pd-instructor-content{margin-top: 32px;}\r\n    .pd-instructor-rating i{ color: var(--theme-color2);}\r\n    .pd-instructor-rate span {color: var(--color-white);font-size: 16px;font-weight: 400;}\r\n        \r\n    .pd-instructor-avatar img{background-color: var(--color-white);border-radius: 50%;height: 166px;-o-object-fit: cover;\r\n    object-fit: cover;padding: 8px;width: 166px;}\r\n        \r\n  .pd-banner .form-group input[type=\"search\"]{max-width: 840px;}\r\n        \r\n .bg_all{background: #f2f3f8;}\r\n\r\n.pd_outerall{position: relative;z-index: 1;}\r\n.pd-user-sidebar {margin-right: 4px;}\r\n.pd-user-wrap {background-color: var(--color-white);border-radius: 10px;box-shadow: 0 1px 1px 0 rgba(3, 11, 30, .14), 0 1px 2px 1px rgba(3, 11, 30, .06);display: block;padding: 28px 22px 12px 18px;}\r\n.pd-user-menu {padding: 0 0 12px;}\r\n.pd-user-menu ul li:not(:last-of-type) {margin-bottom: 5px;}\r\n.pd-user-menu-title {color: #8f9195;font-size: 12px;font-weight: 500;letter-spacing: .24px;padding: 6px 16px 4px;text-transform: uppercase;    margin-bottom: 15px;}\r\n.pd-user-menu ul li a { border-radius: 8px;color: #4f5158;display: flex;font-size: 15px;font-weight: 500;padding: 6px 16px 8px;\r\ntransition: all .3s ease-out 0s;}\r\n.pd-user-menu ul li a span {display: inline-block;transform: translateY(-1px);width: 30px;}\r\n.pd-user-menu ul li a.active {background-color: var(--theme-color2);border-radius: 8px;box-shadow: 0 0 1px 0 #1438b5, 0 1px 2px 0 rgba(20, 56, 181, .25);color: var(--color-white);}\r\n.pd-user-menu ul li a:hover {background: rgba(85, 109, 245, .14);color: #0b5ed7;}\r\n.pd-user-banner {border: 1px solid #e6e8f0;border-radius: 8px;margin-top: 20px;padding: 25px 0 27px 16px;position: relative;z-index: 1;}\r\n.pd-user-banner-text {width: 50%;}\r\n.pd-user-banner-title {color: #303651;font-size: 20px;font-weight: 600;line-height: 24px;margin-bottom: 14px;}\r\n.pd-user-banner-shape {bottom: 8px;position: absolute;right: 0;z-index: -1;}\r\n.pd-user-banner-btn .theme-btn {padding: 4px 10px;border-radius: 6px;font-size: 12px;text-transform: none;}\r\n\r\n.pd-sidebar-box-right {background-color: var(--color-white);border-radius: 16px;\r\n    box-shadow: 0 1px 1px rgba(3, 11, 30, .14), 0 1px 2px rgba(3, 11, 30, .06);\r\n    padding: 46px 34px;}\r\n\r\n\r\ntextarea::-webkit-input-placeholder {color: #999!important; font-size: 14px!important; opacity: 1;}\r\n.theme-btn.whatsapp{background: #00b890;}\r\n.location-text{font-size: 14px;}\r\n.location-area{width: 30px; height: 30px;border: 1px solid #767873;border-radius: 50%;display: inline-block;text-align: center;line-height: 30px;margin-right: 10px;}\r\n.location-area i{color: #f9b418;}\r\n.slider_wrap{background: #d9ecfd; border-radius: 6px;position: relative;background-repeat: no-repeat;}\r\n\r\n.slider_wrap:before {\r\n    content: \" \";\r\n    /* background-image: url(../../assets/img/bg/curve.png); */\r\n    position: absolute;\r\n    width: 100%;\r\n    height: 100%;\r\n    background-repeat: no-repeat;\r\n    background-position: left top;\r\n    left: -23px;\r\n    background-size: 40%;\r\n    top: -22px;\r\n}\r\n.result h4{font-size: 30px;line-height: 40px;padding-top: 40px;padding-left: 20px;}\r\n.years{color: var(--theme-color2);}\r\n.video_wraper{border-radius: 5px;}\r\n\r\n.pb-130{padding-bottom: 130px;}\r\n\r\n\r\n.video_wraper.last-thumb::before {\r\n    content: \"\";\r\n    position: absolute;\r\n    width: 100%;\r\n    height: 100%;\r\n    left: -0.5px;\r\n    top: 0;\r\n    background: rgba(11, 28, 57, .7);\r\n    z-index: +1;border-radius: 5px;\r\n}\r\n.more_text{position: absolute;left: 50%;top: 50%;    transform: translate(-50%, -50%);color: #fff;font-size: 28px;font-weight: 600;z-index: +2;line-height: 26px;}\r\n.bg2{background: #fff7f0;}\r\n.doubt-title{font-size: 32px;font-weight: 700;color: #9b4e08;font-family: 'Jost';text-align: center;line-height:1;}\r\n.evolve{font-size: 36px;font-weight: 300;color: #21201f;line-height: 1;padding-bottom: 12px;font-family: 'Jost';}\r\n.org-clr{color: var(--theme-color2);}\r\n\r\n.schedule label.hide {\r\n    margin: 0;\r\n    position: absolute;\r\n    right: 3px;\r\n    top: 24%;\r\n}\r\n.schedule label span {\r\n    background: #000;\r\n    border-radius: 4px;\r\n    color: var(--color-white);\r\n    cursor: pointer;\r\n    font-size: 15px;\r\n    font-weight: 500;\r\n    padding: 14px 25px;\r\n    transition: all .3s ease-out 0s;\r\n}\r\n\r\n.slv_btn .theme-btn{border-radius: 10px; padding: 10px;}\r\n.btn_center{display: flex;justify-content: flex-end;align-items: center;}\r\n.topper_title{font-family: 'Jost';font-size: 26px;color: #093285;font-weight: 500;}\r\n.name_title{font-size: 18px;font-weight: 500;color: #222;font-family: 'Jost';}\r\n.course_title{font-size: 12px;font-weight: 500;color: #222;font-family: 'Jost';}\r\n.topr_ctr{transform: translateY(50%);}\r\n.find_center{display: flex;justify-content: space-between;}\r\n.frm_inpt select, .frm_inpt input{border: none;background: none; padding: 0;border-radius: 0;}\r\n.form_row label{font-size: 16px;color: var(--theme-color2);font-weight: 500;}\r\n.form_row select{font-size: 14px;color: #434242;}\r\n.video_head h6{line-height: 24px;}\r\n\r\n.pd-dashboard-course-meta span {\r\n    color: #8f9195;\r\n    display: inline-block;\r\n    font-size: 14px;\r\n    margin-right: 10px;\r\n}\r\n\r\n.pd_10{padding: 5px 10px;}\r\n.video_title i{font-size: 12px;}\r\n\r\n.meet_title{font-family: 'Jost';font-size: 22px;color: #093285;font-weight: 500;}\r\n.pos_title{font-size: 18px;font-weight: 500;color: #222;font-family: 'Jost';}\r\n.course_title{font-size: 12px;font-weight: 500;color: #222;font-family: 'Jost';}\r\n\r\n.pd_branches .course-item{padding: 0; }\r\n.heading_branch {background: #fda31b;border-radius:12px 12px 0 0;padding: 8px 12px;color: #fff;font-size: 22px;font-weight: 500;    font-family: 'Jost';}\r\n\r\n.common_round{float: left; width: 30px;height: 30px;background: #fef3e9;border: 1px solid #f9b418;line-height: 30px;text-align: center;border-radius: 50%;}\r\n\r\n.common_round i{font-size: 16px; color: #f9b418;font-weight: 600;}\r\n\r\n.info_txt{font-size: 14px; color: #222;}\r\n.banner_pd_bottom{padding-bottom: 100px!important;}\r\n.banner_social{margin-top: -80px;}\r\n.theme-btn.veryfied{background: #e2f0e9;border: 1px solid #84c8a2;color:#1da45f;}\r\n.theme-btn.veryfied i{font-size: 16px;}\r\n.theme-btn.connect{background: #fff;border: 1px solid #fda31b;color: #fda31b;}\r\n.theme-btn.connect i{font-size: 16px;}\r\n.theme-btn.share{background: #fff;border: 1px solid #fda31b;color: #fda31b;}\r\n.theme-btn.share i{font-size: 16px;}\r\n\r\n.profile_img_chng{position: absolute;top: 50px;right: 50px;width: 50px; height: 50px;border-radius: 50%;background: #fff;line-height: 62px;text-align: center;z-index: +2;}\r\n.profile_img_chng i{font-size: 32px;}\r\n.pd-profile-pic-btn{width: 50px;height: 50px;position: absolute;background: #fff;border: 3px solid #fda31b;border-radius: 50%;line-height: 50px;text-align: center;left: 110px; top: 110px;}\r\n.pd-profile-pic-btn i{font-size: 24px;color: var(--theme-color2);font-weight: 600;}\r\n\r\n.slider_wrap .owl-carousel .owl-item img {display: block;width: 78%;}\r\n\r\n.meet-slider.owl-carousel .owl-item img{ width: 88%;}\r\n\r\n.form-control {padding: 15px 20px;}\r\n\r\n.topper-slider .owl-nav {width: 100%;opacity: 0;visibility: hidden;transition: var(--transition);margin: 0;}\r\n\r\n        .topper-slider:hover .owl-nav {display: block;opacity: 1; visibility: visible;}\r\n\r\n        .topper-slider .owl-nav button {height: 48px;width: 48px;line-height: 45px !important;top: 50%;background: var(--theme-color2) !important;color: var(--color-white) !important;font-size: 25px !important;position: absolute;border: none;margin: 0;\r\n        padding: 0;transition: var(--transition);border-radius: 100%;margin-top: -24px;\r\n        }\r\n\r\n        .topper-slider .owl-nav button:hover {background: var(--theme-color) !important;}\r\n\r\n        .topper-slider .owl-nav .owl-prev { left: -24px;}\r\n\r\n        .topper-slider .owl-nav .owl-prev:hover {left: -24px;}\r\n\r\n        .topper-slider .owl-nav .owl-next { right: -24px;}\r\n\r\n        .topper-slider .owl-nav .owl-next:hover {right: -24px;}\r\n\r\n        /*video slider---------------------------------*/\r\n\r\n        .video-slider .owl-nav,\r\n        .meet-slider .owl-nav,  .result-slider .owl-nav {width: 100%;opacity: 0;visibility: hidden;\r\n        transition: var(--transition);margin: 0;}\r\n\r\n        .video-slider:hover .owl-nav,\r\n        .meet-slider:hover .owl-nav,  .result-slider:hover .owl-nav {\r\n            display: block;\r\n            opacity: 1;\r\n            visibility: visible;\r\n        }\r\n\r\n        .video-slider .owl-nav button,\r\n        .meet-slider .owl-nav button, .result-slider .owl-nav button {height: 48px;width: 48px;line-height: 45px !important;\r\n        top: 50%;background: var(--theme-color2) !important; color: var(--color-white) !important;font-size: 25px !important;\r\n         position: absolute;border: none;margin: 0;padding: 0;transition: var(--transition);border-radius: 100%;margin-top: -24px;}\r\n\r\n        .video-slider .owl-nav button:hover,\r\n        .meet-slider .owl-nav button:hover, .result-slider .owl-nav button:hover  {\r\n            background: var(--theme-color) !important;\r\n        }\r\n\r\n        .video-slider .owl-nav .owl-prev,\r\n        .meet-slider .owl-nav .owl-prev, .result-slider .owl-nav .owl-prev{left: -24px;}\r\n\r\n        .video-slider .owl-nav .owl-prev:hover,\r\n        .meet-slider .owl-nav .owl-prev:hover,  .result-slider .owl-nav .owl-prev:hover {\r\n            left: -24px;}\r\n\r\n        .video-slider .owl-nav .owl-next,\r\n        .meet-slider .owl-nav .owl-next, .result-slider .owl-nav .owl-next {right: -24px;}\r\n\r\n        .video-slider .owl-nav .owl-next:hover,\r\n        .meet-slider .owl-nav .owl-next:hover, .reslut-slider .owl-nav .owl-next:hover {right: -24px;}\r\n\r\n@media only screen and (max-width: 767px) {\r\n    .tp-instructor-info {\r\n        flex-wrap: wrap;\r\n    }\r\n    \r\n    .banner_social{margin-top: 20px;} \r\n    \r\n    .add-dvd{display: inline-block!important;}\r\n    \r\n    .find_center{display: inherit;}\r\n    \r\n    .pd-instructor-wrap {\r\n        transform: translateY(-50px);\r\n    }\r\n}\r\n\r\n    \r\n\r\n/*====================\r\n7. Site title css\r\n======================*/\r\n\r\n.site-heading {\r\n  margin-bottom: 40px;\r\n  position: relative;\r\n  z-index: 1;\r\n}\r\n\r\n.site-title-tagline {\r\n  text-transform: uppercase;\r\n  letter-spacing: 4px;\r\n  font-size: 18px;\r\n  font-weight: 700;\r\n  color: var(--theme-color2);\r\n  position: relative;\r\n  border-bottom: 2px solid var(--theme-color2);\r\n}\r\n\r\n.site-title-tagline i{\r\n  line-height: 0;\r\n  font-size: 20px;\r\n}\r\n\r\n.site-title {\r\n  font-weight: 500;\r\n  text-transform: capitalize;\r\n  font-size: 34px;\r\n  color:  var(--color-dark);\r\n  margin-top: 10px;\r\n  margin-bottom: 0;\r\n  position: relative;\r\n}\r\n\r\n.site-title span{\r\n  color: var(--theme-color2);\r\n}\r\n\r\n.site-heading p {\r\n  margin-top: 15px;\r\n}\r\n\r\n.heading-divider {\r\n  display: inline-block;\r\n  position: relative;\r\n  width: 90px;\r\n  height: 10px; \r\n  border: 3px solid rgba(33, 46, 84, 1);\r\n  border-right-color: transparent;\r\n}\r\n\r\n.heading-divider.light{\r\n  border-color: rgba(255, 255, 255, 0.2);\r\n  border-right-color: transparent;\r\n}\r\n\r\n.heading-divider::after {\r\n  position: absolute;\r\n  content: '';\r\n  width: 30px;\r\n  background-color: var(--theme-color);\r\n  top: 0;\r\n  bottom: 0;\r\n  left: 18px;\r\n}\r\n\r\n\r\n\r\n\r\n/*====================\r\n8. Theme button\r\n======================*/\r\n\r\n.theme-btn {\r\n  font-size: 14px;\r\n  color: var(--color-white);\r\n  padding: 14px 20px;\r\n  transition: var(--transition);\r\n  text-transform: uppercase;\r\n  position: relative;\r\n  border-radius: 50px 50px 50px 0;\r\n  font-weight: 600;\r\n  letter-spacing: 1px;\r\n  cursor: pointer;\r\n  text-align: center;\r\n  overflow: hidden;\r\n  border: none;\r\n  background: var(--theme-color2);\r\n  box-shadow: var(--box-shadow);\r\n  z-index: 1;\r\n}\r\n\r\n.theme-btn::before {\r\n  content: \"\";\r\n  height: 300px;\r\n  width: 300px;\r\n  background:  var(--theme-color);\r\n  border-radius: 50%;\r\n  position: absolute;\r\n  top: 50%;\r\n  left: 50%;\r\n  transform: translateY(-50%) translateX(-50%) scale(0);\r\n  transition: 0.5s cubic-bezier(0.25, 0.46, 0.45, 0.94);\r\n  z-index: -1;\r\n}\r\n\r\n.theme-btn:hover {\r\n  color: var(--color-white);\r\n}\r\n\r\n.theme-btn:hover::before {\r\n  transform: translateY(-50%) translateX(-50%) scale(1);\r\n}\r\n\r\n.theme-btn i {\r\n  margin-left: 5px;\r\n}\r\n\r\n.theme-btn span {\r\n  margin-right: 5px;\r\n}\r\n\r\n.theme-btn2{\r\n  background: var(--color-white);\r\n  color: var(--color-dark);\r\n}\r\n\r\n.theme-btn2::before{\r\n  background: var(--theme-color);\r\n}\r\n\r\n.theme-btn2:hover{\r\n  color: var(--color-white);\r\n}\r\n\r\n\r\n\r\n\r\n/*====================\r\n9. Container\r\n======================*/\r\n\r\n@media (min-width: 1200px) {\r\n  .container,\r\n  .container-sm,\r\n  .container-md,\r\n  .container-lg,\r\n  .container-xl {\r\n    max-width: 1200px;\r\n  }\r\n}\r\n\r\n\r\n\r\n/*====================\r\n10. Scroll top css\r\n======================*/\r\n\r\n#scroll-top {\r\n  position: fixed;\r\n  bottom: -20px;\r\n  right: 30px;\r\n  z-index: 99;\r\n  font-size: 20px;\r\n  border: none;\r\n  outline: none;\r\n  border-radius: 50px;\r\n  color: var(--color-white);\r\n  background-color: var(--theme-color2);\r\n  cursor: pointer;\r\n  width: 50px;\r\n  height: 50px;\r\n  line-height: 50px;\r\n  text-align: center;\r\n  box-shadow: var(--box-shadow2);\r\n  transition: var(--transition);\r\n  opacity: 0;\r\n  visibility: hidden;\r\n  z-index: 1;\r\n}\r\n\r\n#scroll-top.active{\r\n  opacity: 1;\r\n  visibility: visible;\r\n  bottom: 20px;\r\n}\r\n\r\n\r\n@media all and (min-width: 768px) and (max-width: 1199px) {\r\n  #scroll-top.active {\r\n    bottom: 100px;\r\n  }\r\n}\r\n\r\n\r\n\r\n/*====================\r\n11. Header top css\r\n======================*/\r\n\r\n.header-top {\r\n  padding: 9px 0 10px 0;\r\n  position: relative;\r\n  background: #f2f3f8;\r\n  z-index: 1;\r\n}\r\n\r\n/*\r\n.header-top::before{\r\n  content: \"\";\r\n  position: absolute;\r\n  left: 0;\r\n  top: 0;\r\n  bottom: -1px;\r\n  width: 30%;\r\n  background: var(--theme-color2);\r\n  z-index: -1;\r\n}\r\n*/\r\n\r\n.header-top-wrap {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: space-between;\r\n}\r\n\r\n.header-top-contact ul {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 20px;\r\n}\r\n\r\n.header-top-contact ul li{\r\n  display: flex;\r\n  gap: 10px;\r\n  border-right: 1px solid rgba(255, 255, 255, .2);\r\n  padding-right: 20px;\r\n}\r\n\r\n.header-top-contact ul li:last-child{\r\n  border: none;\r\n  padding-right: 0;\r\n}\r\n\r\n.header-top-contact ul li a {\r\n  color: #000;\r\n  font-weight: 400;\r\n}\r\n\r\n.header-top-contact ul li a i{\r\n  color: var(--theme-color2);\r\n  margin-right: 5px;\r\n}\r\n\r\n.header-top-social span{\r\n  color: #000;\r\n  font-weight: 500;\r\n}\r\n\r\n.header-top-social a {\r\n  width: 35px;\r\n  height: 35px;\r\n  line-height: 35px;\r\n  color: var(--theme-color2);\r\n  font-size: 16px;\r\n  text-align: center;\r\n  margin-left: 5px;\r\n  border-radius: 50px;\r\n  transition: all .5s ease-in-out;\r\n}\r\n\r\n.header-top-social a:hover {\r\n  color: var(--theme-color2);\r\n}\r\n\r\n\r\n@media all and (max-width: 1199px) {\r\n  .header-top-contact ul{\r\n    gap: 10px;\r\n  }\r\n\r\n  .header-top-social a{\r\n    width: 34px;\r\n    height: 34px;\r\n    line-height: 37px;\r\n    margin-left: 0;\r\n  }\r\n}\r\n\r\n@media all and (max-width: 992px) {\r\n  .header-top {\r\n    display: none;\r\n  }\r\n}\r\n\r\n\r\n\r\n/*====================\r\n12. Navbar css\r\n======================*/\r\n\r\n.navbar {\r\n  background: var(--color-white);\r\n  padding-top: 0px;\r\n  padding-bottom: 0px;\r\n  z-index: 999;\r\n}\r\n\r\n.custom-nav{\r\n  background: var(--color-white);\r\n  position: relative;\r\n}\r\n\r\n.navbar.fixed-top {\r\n  background: var(--color-white) !important;\r\n  box-shadow: var(--box-shadow2);\r\n  animation: slide-down 0.7s;\r\n}\r\n\r\n\r\n@keyframes slide-down {\r\n  0% {\r\n    transform: translateY(-100%);\r\n  }\r\n\r\n  100% {\r\n    transform: translateY(0);\r\n  }\r\n}\r\n\r\n.navbar .navbar-brand .logo-display {\r\n  display: block;\r\n}\r\n\r\n.navbar .navbar-brand .logo-scrolled {\r\n  display: none;\r\n}\r\n\r\n.navbar.fixed-top .navbar-brand .logo-display {\r\n  display: none;\r\n}\r\n\r\n.navbar.fixed-top .navbar-brand .logo-scrolled {\r\n  display: block;\r\n}\r\n\r\n.navbar .navbar-toggler:focus {\r\n  outline: none;\r\n  box-shadow: none;\r\n}\r\n\r\n.navbar-toggler-mobile-icon {\r\n  display: inline-block;\r\n  width: inherit;\r\n  height: inherit;\r\n}\r\n\r\n.navbar-brand {\r\n  margin-right: 0;\r\n}\r\n\r\n.navbar-brand img {\r\n  width: 200px;\r\n}\r\n\r\n.navbar .dropdown-toggle::after {\r\n  display: inline-block;\r\n  margin-left: 5px;\r\n  vertical-align: baseline;\r\n  font-family: 'Font Awesome 6 Pro';\r\n  content: \"\\f107\";\r\n  font-weight: 600;\r\n  border: none;\r\n  font-size: 14px;\r\n}\r\n\r\n@media all and (max-width: 1199px) {\r\n  .nav-right {\r\n    margin-left: 25px !important;\r\n  }\r\n\r\n  .navbar .nav-item .nav-link {\r\n    margin-right: 15px;\r\n  }\r\n\r\n  .navbar-brand img{ width: 166px; }\r\n\r\n  .navbar .nav-right-btn {\r\n    display: flex;\r\n  }\r\n}\r\n\r\n@media all and (min-width: 992px) {\r\n  .navbar .nav-item .nav-link {\r\n    margin-right: 8px;\r\n    padding: 20px 0 30px 0;\r\n    font-size: 12px;\r\n    font-weight: 400;\r\n    color: #000;\r\n    text-transform: capitalize;\r\n  }\r\n\r\n  .navbar .nav-item:last-child .nav-link {\r\n    margin-right: 0;\r\n  }\r\n\r\n  .navbar .nav-item .dropdown-menu {\r\n    display: block;\r\n    opacity: 0;\r\n    visibility: hidden;\r\n    transition: .3s;\r\n    margin-top: 0;\r\n    border: none;\r\n    left: -15px;\r\n    border-radius: 0px;\r\n    border-top: 4px solid var(--theme-color2);\r\n    background: var(--theme-color);\r\n    width: 220px;\r\n    box-shadow: var(--box-shadow);\r\n  }\r\n\r\n  .navbar .nav-item .dropdown-menu li {\r\n    border-bottom: 1px solid var(--border-white-color);\r\n  }\r\n\r\n  .navbar .nav-item .dropdown-menu li:last-child {\r\n    margin-bottom: 0;\r\n    border-bottom: none;\r\n  }\r\n\r\n  .navbar .nav-item .dropdown-menu .dropdown-item {\r\n    font-size: 16px;\r\n    padding: 8px 25px;\r\n    font-weight: 500;\r\n    color:  var(--color-white);\r\n    position: relative;\r\n    overflow: hidden;\r\n    text-transform: capitalize;\r\n    transition: all .3s ease-in-out;\r\n  }\r\n\r\n  .navbar .nav-item .dropdown-menu .dropdown-item:hover {\r\n    background: transparent;\r\n    color: var(--theme-color2);\r\n    padding-left: 32px;\r\n  }\r\n\r\n  .navbar .nav-item .dropdown-menu .dropdown-item::before {\r\n    content: \"//\";\r\n    position: absolute;\r\n    left: 15px;\r\n    top: 8px;\r\n    color: var(--theme-color2);\r\n    opacity: 0;\r\n    visibility: hidden;\r\n    transition: var(--transition);\r\n    z-index: -1;\r\n  }\r\n\r\n  .navbar .nav-item .dropdown-menu .dropdown-item:hover::before {\r\n    opacity: 1;\r\n    visibility: visible;\r\n  }\r\n\r\n  .navbar .nav-item .nav-link {\r\n    position: relative;\r\n  }\r\n\r\n  .navbar .nav-item .nav-link.active,\r\n  .navbar .nav-item:hover .nav-link {\r\n    color: var(--theme-color2);\r\n  }\r\n\r\n  .navbar .nav-item:hover .dropdown-menu {\r\n    transition: .3s;\r\n    opacity: 1;\r\n    visibility: visible;\r\n    top: 100%;\r\n    transform: rotateX(0deg);\r\n  }\r\n\r\n  .navbar .dropdown-menu-end {\r\n    right: 0;\r\n    left: auto;\r\n  }\r\n\r\n  .navbar .dropdown-menu.fade-down {\r\n    top: 80%;\r\n    transform: rotateX(-75deg);\r\n    transform-origin: 0% 0%;\r\n  }\r\n\r\n  .navbar .dropdown-menu.fade-up {\r\n    top: 140%;\r\n  }\r\n\r\n  .navbar #main_nav {\r\n    justify-content: flex-end;\r\n  }\r\n\r\n  /* nav right */\r\n  .nav-right {\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n    gap: 30px;\r\n    margin-left: 45px;\r\n  }\r\n\r\n  .nav-right-link {\r\n    position: relative;\r\n    font-size: 20px;\r\n    color:  var(--color-dark);\r\n    transition: var(--transition);\r\n  }\r\n\r\n  .nav-right-link:hover {\r\n    color: var(--theme-color) !important;\r\n  }\r\n\r\n  .nav-right .sidebar-btn .nav-right-link,\r\n  .nav-right .search-btn .nav-right-link {\r\n    border: none;\r\n    background: transparent;\r\n    color: var(--color-dark);\r\n    font-size: 28px;\r\n    padding-right: 0;\r\n  }\r\n\r\n  .nav-right .search-btn .nav-right-link {\r\n    font-size: 20px;\r\n    padding: 0;\r\n  }\r\n\r\n  .nav-right .cart-btn .nav-right-link {\r\n    position: relative;\r\n    font-size: 20px;\r\n    padding: 0;\r\n    margin-right: 15px;\r\n  }\r\n\r\n  .nav-right .cart-btn span{\r\n    position: absolute;\r\n    right: -9px;\r\n    top: -2px;\r\n    width: 15px;\r\n    height: 15px;\r\n    line-height: 15px;\r\n    text-align: center;\r\n    font-size: 12px;\r\n    border-radius: 50px;\r\n    background: var(--theme-color);\r\n    color: var(--color-white);\r\n  }\r\n\r\n}\r\n\r\n\r\n/* mobile menu */\r\n.mobile-menu-right {\r\n  display: none;\r\n}\r\n\r\n@media all and (max-width: 991px) {\r\n  .navbar {\r\n    top: 0;\r\n    right: 0;\r\n    left: 0;\r\n    position: fixed;\r\n  }\r\n  .navbar-brand {\r\n    padding-left: 10px;\r\n  }\r\n\r\n  .navbar-brand img {\r\n    width: 130px;\r\n  }\r\n\r\n  .navbar-collapse {\r\n    max-height: 220px;\r\n    overflow: hidden;\r\n    overflow-y: auto;\r\n    padding: 0 20px;\r\n    background-color: var(--color-white);\r\n  }\r\n\r\n  .dropdown-toggle::after {\r\n    float: right;\r\n  }\r\n\r\n  .navbar .nav-item .nav-link {\r\n    color:  var(--color-dark);\r\n    font-weight: 700;\r\n    transition: var(--transition);\r\n  }\r\n\r\n  .navbar .nav-item .nav-link:hover {\r\n    color: var(--theme-color) !important;\r\n  }\r\n\r\n  .navbar-toggler {\r\n    padding: 0;\r\n    border: none;\r\n  }\r\n\r\n  .mobile-menu-right {\r\n    display: flex;\r\n    align-items: center;\r\n    gap: 20px;\r\n  }\r\n\r\n  .mobile-menu-right .nav-right-link {\r\n    background: transparent;\r\n    border: none;\r\n    font-size: 20px;\r\n    color: var(--color-dark);\r\n  }\r\n\r\n  .mobile-menu-right .nav-right-link:hover{\r\n    color: var(--theme-color);\r\n  }\r\n\r\n  .search-area.open{\r\n    top: 50px !important;\r\n  }\r\n\r\n  .navbar-toggler-mobile-icon {\r\n    font-size: 25px;\r\n    color:  var(--color-dark);\r\n    font-weight: 500;\r\n  }\r\n\r\n  .navbar .dropdown-menu {\r\n    border-radius: 0px;\r\n  }\r\n\r\n  .nav-right {\r\n    display: none;\r\n  }\r\n\r\n}\r\n\r\n\r\n/*============================\r\n13. Mega menu\r\n==============================*/\r\n\r\n@media (min-width: 992px){\r\n  .nav-item.mega-menu {\r\n    position: static;\r\n  }\r\n  \r\n  .navbar .nav-item.mega-menu .dropdown-menu{\r\n    width: 98%;\r\n    left: 12px;\r\n  } \r\n\r\n  .mega-menu .mega-content{\r\n    padding: 30px;\r\n  }\r\n\r\n  .mega-menu .mega-content h5{\r\n    color: var(--theme-color2);\r\n    font-size: 22px;\r\n    margin-bottom: 20px;\r\n  }\r\n\r\n  .navbar .nav-item.mega-menu .dropdown-menu .dropdown-item{\r\n    padding-left: 0;\r\n  }\r\n\r\n  .navbar .nav-item.mega-menu .dropdown-menu .dropdown-item::before{\r\n    left: 0;\r\n  }\r\n\r\n  .navbar .nav-item.mega-menu .dropdown-menu .dropdown-item:hover{\r\n    padding-left: 15px;\r\n  }\r\n\r\n  .menu-about-logo{\r\n    margin-top: 15px;\r\n    margin-bottom: 15px;\r\n  }\r\n\r\n  .menu-about-logo img{\r\n    width: 180px;\r\n  }\r\n\r\n  .menu-about p{\r\n    color: var(--color-white);\r\n  }\r\n}\r\n\r\n\r\n@media (max-width: 991px){\r\n  .menu-about-logo{\r\n    display: none;\r\n  }\r\n\r\n  .mega-menu .mega-content h5{\r\n    margin: 15px 0;\r\n  }\r\n}\r\n\r\n\r\n\r\n/*============================\r\n14. Multi level dropdown menu\r\n==============================*/\r\n\r\n.navbar .nav-item .dropdown-submenu {\r\n  position: relative;\r\n}\r\n\r\n.navbar .nav-item .dropdown-submenu .dropdown-menu::before {\r\n  display: none;\r\n}\r\n\r\n.navbar .nav-item .dropdown-submenu a::after {\r\n  transform: rotate(-90deg);\r\n  position: absolute;\r\n  right: 15px;\r\n  top: 10px;\r\n  font-weight: 600;\r\n}\r\n\r\n.navbar .nav-item .dropdown-submenu a:hover {\r\n  background: transparent;\r\n  color: var(--color-white);\r\n}\r\n\r\n.navbar .nav-item .dropdown-submenu .dropdown-menu {\r\n  top: 120%;\r\n  left: 100%;\r\n  opacity: 0;\r\n  visibility: hidden;\r\n}\r\n\r\n.navbar .nav-item .dropdown-submenu:hover .dropdown-menu {\r\n  top: 0;\r\n  opacity: 1;\r\n  visibility: visible;\r\n}\r\n\r\n@media all and (max-width: 991px) {\r\n  .navbar .nav-item .dropdown-submenu .dropdown-menu {\r\n    margin: 0 17px;\r\n  }\r\n\r\n  .navbar .nav-item .dropdown-submenu .dropdown-menu {\r\n    opacity: unset;\r\n    visibility: unset;\r\n  }\r\n\r\n  .navbar .nav-item .dropdown-submenu a::after {\r\n    top: 4px;\r\n  }\r\n\r\n  .navbar .nav-item .dropdown-submenu a:hover {\r\n    color: var(--theme-color);\r\n  }\r\n}\r\n\r\n\r\n\r\n/*====================\r\n15. Search popup css \r\n======================*/\r\n\r\n.search-popup {\r\n  position: fixed;\r\n  left: 0;\r\n  top: 0;\r\n  height: 100vh;\r\n  width: 100%;\r\n  z-index: 99999;\r\n  margin-top: -540px;\r\n  transform: translateY(-100%);\r\n  background-color: rgba(0, 0, 0, .8);\r\n  transition: all 1500ms cubic-bezier(0.860, 0.000, 0.070, 1.000);\r\n  transition-timing-function: cubic-bezier(0.860, 0.000, 0.070, 1.000);\r\n}\r\n\r\n.sidenav-bar-visible .search-popup {\r\n  width: 80%;\r\n}\r\n\r\n.search-active .search-popup {\r\n  transform: translateY(0%);\r\n  margin-top: 0;\r\n}\r\n\r\n.search-popup .close-search {\r\n  position: absolute;\r\n  left: 0;\r\n  right: 0;\r\n  top: 75%;\r\n  border: none;\r\n  margin: 0 auto;\r\n  margin-top: -200px;\r\n  text-align: center;\r\n  background: var(--theme-color2);\r\n  text-align: center;\r\n  width: 50px;\r\n  height: 50px;\r\n  color: var(--color-white);\r\n  font-size: 20px;\r\n  cursor: pointer;\r\n  border-radius: 50px;\r\n  box-shadow: 0 0 10px rgba(0, 0, 0, 0.05);\r\n  transition: all 500ms ease;\r\n  opacity: 0;\r\n  visibility: hidden;\r\n}\r\n\r\n.search-popup .close-search:hover{\r\n  background: var(--theme-color);\r\n}\r\n\r\n.search-active .search-popup .close-search {\r\n  visibility: visible;\r\n  opacity: 1;\r\n  top: 50%;\r\n  transition-delay: 1500ms;\r\n}\r\n\r\n.search-popup form {\r\n  position: absolute;\r\n  max-width: 700px;\r\n  top: 50%;\r\n  left: 15px;\r\n  right: 15px;\r\n  margin: -35px auto 0;\r\n  transform: scaleX(0);\r\n  transform-origin: center;\r\n  transition: all 300ms ease;\r\n}\r\n\r\n.search-active .search-popup form {\r\n  transform: scaleX(1);\r\n  transition-delay: 1200ms;\r\n}\r\n\r\n.search-popup .form-group {\r\n  position: relative;\r\n  margin: 0px;\r\n  overflow: hidden;\r\n}\r\n\r\n.search-popup .form-group input[type=\"text\"], \r\n.search-popup .form-group input[type=\"search\"] {\r\n  position: relative;\r\n  width: 100%;\r\n  height: 65px;\r\n  outline: none;\r\n  border-radius: 8px;\r\n  border: none;\r\n  padding: 0 100px 0 35px;\r\n  transition: all 500ms ease;\r\n  text-transform: capitalize;\r\n}\r\n\r\n.search-popup .form-group input[type=\"submit\"],\r\n.search-popup .form-group button {\r\n  position: absolute;\r\n  right: 10px;\r\n  top: 9px;\r\n  background: var(--theme-color2);\r\n  text-align: center;\r\n  font-size: 20px;\r\n  color: var(--color-white);\r\n  padding: 6px 18px;\r\n  border-radius: 8px;\r\n  border: none;\r\n  cursor: pointer;\r\n  transition: all 500ms ease;\r\n}\r\n\r\n.search-popup .form-group input[type=\"submit\"]:hover,\r\n.search-popup .form-group button:hover {\r\n  background: var(--theme-color);\r\n  color: var(--color-white);\r\n}\r\n\r\n\r\n\r\n/*====================\r\n16. Main section css \r\n======================*/\r\n\r\n.main {\r\n  margin-top: 0rem;\r\n}\r\n\r\n\r\n\r\n/*====================\r\n17. Hero css \r\n======================*/\r\n.offcanvas .contact-form .form-group .form-control{padding: 12px 20px;}\r\n.enquire_now{position: fixed !important;top: 50%;right: -40px;z-index: +9;transform: rotate(90deg);top: 50%;}\r\nbutton.enquire_now{border-radius: 0 0 10px 10px;}\r\n.tooltip_bx{background: var(--theme-color2);border-radius: 20px;padding: 4px 10px;font-size: 11px;position: absolute;color: #fff;top: 0px;right: 62px;line-height: 1;}\r\n.tooltip_bx:before{content: \"\";width: 0;height: 0;position: absolute;border-bottom: 11px solid var(--theme-color2); border-right: 12px solid transparent;\r\nleft: 40%;transform: rotate(316deg);bottom: -4px;}\r\n.nav-right-btn i{font-size: 20px; color: #ff7900;}\r\n.scan-me .tooltip_bx{right: -13px;}\r\n.orange{color: #f58634;}\r\n.offcanvas-header{border-bottom: 1px solid #ccc;}\r\n.hero-section {\r\n  position: relative;\r\n}\r\n\r\n.hero-single {\r\n  padding-top: 20px;\r\n  padding-bottom: 30px;\r\n  background-position: center !important;\r\n  background-size: cover !important;\r\n  background-repeat: no-repeat !important;\r\n  background: #f2f3f8;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  position: relative;\r\n  z-index: 1;\r\n}\r\n.hero-section .form-group button{\r\n   position: absolute;\r\n   right: 0px;\r\n    top: 0px;\r\n    background: var(--color-dark);\r\n    text-align: center;\r\n    font-size: 20px;\r\n    color: var(--color-white);\r\n    padding: 6px 18px;\r\n    border-radius: 8px;\r\n    border: none;\r\n    cursor: pointer;\r\n    transition: all 500ms ease;line-height: 42px;\r\n}\r\n\r\nh2.site-title::before {\r\n  position: absolute;\r\n  content: '';\r\n  width: 25px;\r\n  border-bottom: 3px solid var(--theme-color2);\r\n  bottom: -8px;\r\n  left: 0;\r\n}\r\n\r\nh2.site-title::after {\r\n  position: absolute;\r\n  content: '';\r\n  width: 90px;\r\n  border-bottom: 3px solid var(--heading-border);\r\n  bottom: -8px;\r\n  left: 32px;\r\n}\r\n\r\n.srch_glass{position: absolute;\r\n    left: 20px;\r\n    line-height: 55px;}\r\n   \r\n.banner_padhai1{\r\n  position: absolute;\r\n  left: 0;\r\n  top: 0;\r\n  /* background-image: url(../img/logo/element1.png); */\r\n  background-repeat: no-repeat;\r\n  width: 100%;\r\n  height: 100%;\r\n  background-size: 8%;\r\n}  \r\n.banner_padhai{position: relative;}\r\n.banner_padhai2{\r\n    position: absolute;\r\n    /* background-image: url(../img/logo/element2.png); */\r\n    background-repeat: no-repeat;\r\n    width: 100%;\r\n    height: 100%;\r\n    background-size: 8%;\r\n    background-position: right bottom;\r\n    right: 0;\r\n    bottom: 0;} \r\n\r\n.srch_area{position: relative  !important;\r\n    max-width: 700px !important;\r\n    margin: auto !important}\r\n\r\n.layer_up{position: relative;z-index: +3;}\r\n\r\n    \r\n .form-group input[type=\"search\"]{max-width: 700px;\r\n    width: 100%;\r\n    height: 55px!important;\r\n    outline: none;\r\n    border-radius: 8px;\r\n    border: none;\r\n    padding: 0 100px 0 35px;\r\n    text-transform: capitalize;\r\n    background: #fff;border: 1px solid #a5a5a1;\r\n}\r\n\r\n\r\n.hero-single .hero-content {\r\n  height: 100%;\r\n}\r\n\r\n.hero-single .hero-content .hero-title {\r\n  color: var(--color-dark);\r\n  font-size: 50px;\r\n  font-weight: 700;\r\n  margin: 10px 0;\r\n  text-transform: uppercase;\r\n}\r\n\r\n.hero-single .hero-content .hero-title span{\r\n  color: var(--theme-color2);\r\n}\r\n\r\n.hero-single .hero-content .hero-sub-title {\r\n  display: inline-block;\r\n  color: var(--theme-color2);\r\n  font-size: 25px;\r\n  letter-spacing: 6px;\r\n  font-weight: 800;\r\n  position: relative;\r\n  text-transform: uppercase;\r\n  border-bottom: 3px solid var(--theme-color2);\r\n}\r\n\r\n.hero-single .hero-content p {\r\n  color: var(--theme-color2);\r\n  line-height: 30px;\r\n  font-size: 28px;\r\n  font-weight: 400;\r\n  margin-bottom: 20px;\r\n}\r\n\r\n.hero-single .hero-content .hero-btn {\r\n  gap: 1rem;\r\n  display: flex;\r\n  margin-top: 35px;\r\n  justify-content: start;\r\n}\r\n\r\n.hero-single .hero-img::before{\r\n  content: \"\";\r\n  position: absolute;\r\n  width: 500px;\r\n  height: 500px;\r\n  background: var(--theme-color);\r\n  right: 100px;\r\n  bottom: 0px;\r\n  border-radius: 50%;\r\n  filter: blur(150px);\r\n  z-index: -1;\r\n}\r\n\r\n.hero-single .hero-img{\r\n  position: absolute;\r\n  right: 100px;\r\n  bottom: 120px;\r\n  width: 50%;\r\n  z-index: -1;\r\n}\r\n\r\n.hero-slider.owl-theme .owl-nav {\r\n  margin-top: 0px;\r\n}\r\n\r\n.hero-slider.owl-theme .owl-nav [class*=owl-] {\r\n  color: var(--color-white);\r\n  font-size: 25px;\r\n  margin: 0;\r\n  padding: 0;\r\n  background: var(--slider-arrow-bg);\r\n  display: inline-block;\r\n  cursor: pointer;\r\n  height: 55px;\r\n  width: 55px;\r\n  line-height: 55px;\r\n  border-radius: 50px;\r\n  text-align: center;\r\n  transition: var(--transition);\r\n}\r\n\r\n.hero-slider.owl-theme .owl-nav [class*=owl-]:hover {\r\n  background: var(--color-white);\r\n  color: var(--theme-color);\r\n}\r\n\r\n.hero-slider.owl-theme .owl-nav .owl-prev {\r\n  left: 40px;\r\n}\r\n\r\n.hero-slider.owl-theme .owl-nav .owl-next {\r\n  right: 40px;\r\n}\r\n\r\n.hero-slider.owl-theme .owl-nav .owl-prev,\r\n.hero-slider.owl-theme .owl-nav .owl-next {\r\n  position: absolute;\r\n  top: 50%;\r\n  transform: translate(0, -50%);\r\n}\r\n\r\n@media all and (max-width: 1199px) {\r\n\r\n  .hero-single .hero-content .hero-title {\r\n    font-size: 37px;\r\n  }\r\n\r\n  .hero-slider.owl-theme .owl-nav .owl-prev,\r\n  .hero-slider.owl-theme .owl-nav .owl-next {\r\n    top: unset;\r\n    bottom: 30px !important;\r\n  }\r\n\r\n  .hero-slider.owl-theme .owl-nav .owl-prev {\r\n    left: unset;\r\n    right: 120px;\r\n  }\r\n\r\n  .hero-slider.owl-theme .owl-nav .owl-next {\r\n    right: 40px;\r\n  }\r\n\r\n}\r\n\r\n@media all and (max-width: 991px) {\r\n\r\n  .hero-single .hero-content .hero-title {\r\n    font-size: 50px;\r\n  }\r\n\r\n  .hero-single .hero-img {\r\n    position: relative;\r\n    width: 100%;\r\n    right: unset;\r\n    bottom: unset;\r\n    margin-top: 50px;\r\n  }\r\n\r\n  .hero-single .hero-img::before{\r\n    width: 250px;\r\n    height: 250px;\r\n  }\r\n\r\n}\r\n\r\n@media all and (max-width: 767px) {\r\n\r\n  /* /exam css start-------------/ */\r\n  .title_slc{font-size: 24px!important;}\r\n    .course_name_hold{font-size: 12px!important;}\r\n    .read_boy img {width: 56% !important;}\r\n    .expert_right_img img{width: 62%!important;}\r\n    .expert_right_img{ right: -99px!important;}\r\n    .round_thumb img{width: 70%!important;}\r\n    .student_right {right: -279px!important;}\r\n    .student_right img {width: 46%!important;}\r\n    .scholor1 img{opacity: 0.1!important;}\r\n    .application_bg-title{font-size: 22px!important;}\r\n    .award{display: unset!important;}\r\n    .no-one{line-height: 30px;}\r\n    .most-title{font-size: 32px!important;}\r\n/* /exam css end-------------/ */\r\n\r\n    .hero-single .hero-content p{}\r\n    .counter-box .icon{width: 70px!important; height: 70px!important;line-height: 60px!important;}\r\n    .counter-box{gap: 0!important;}\r\n    .site-title{font-size: 26px;}\r\n    .hero-single .hero-content .hero-title{font-size: 28px;}\r\n    .hero-single .hero-content .hero-sub-title {font-size: 18px;}\r\n    .counter-box .icon::before{left: 7px!important;top: 7px!important;}\r\n\r\n  .hero-single .hero-content .hero-btn {\r\n    gap: 1rem;\r\n  }\r\n\r\n}\r\n\r\n\r\n.study-abroad .event-item{padding: 0;border-radius: 10px 10px 10px 0;}\r\n.study-abroad .event-img img{border-radius: 10px 10px 10px 0;}\r\n/*===================\r\n18. Play btn\r\n=====================*/\r\n\r\n.play-btn {\r\n  display: inline-block;\r\n  padding: 0;\r\n  height: 75px;\r\n  width: 75px;\r\n  line-height: 75px;\r\n  font-size: 20px;\r\n  text-align: center;\r\n  background: var(--theme-color2);\r\n  color: var(--color-white) !important;\r\n  position: absolute;\r\n  border-radius: 50%;\r\n  z-index: 1;\r\n}\r\n\r\n.play-btn i::after {\r\n  content: \"\";\r\n  position: absolute;\r\n  height: 100%;\r\n  width: 100%;\r\n  top: 0;\r\n  left: 0;\r\n  z-index: -1;\r\n  background-color: var(--theme-color2);\r\n  border-radius: 50px;\r\n  animation: ripple-wave 1s linear infinite;\r\n  -webkit-transform: scale(1);\r\n  transform: scale(1);\r\n  transition: all 0.5s ease-in-out;\r\n}\r\n\r\n@keyframes ripple-wave {\r\n  0% {\r\n    opacity: 0.8;\r\n    -webkit-transform: scale(0.9);\r\n    transform: scale(0.9);\r\n  }\r\n\r\n  100% {\r\n    opacity: 0;\r\n    -webkit-transform: scale(2);\r\n    transform: scale(2);\r\n  }\r\n}\r\n\r\n\r\n\r\n/*====================\r\n19. About css \r\n======================*/\r\n\r\n.about-area{\r\n  position: relative;\r\n}\r\n\r\n.about-left{\r\n  margin-right: 20px;\r\n}\r\n\r\n.about-img{\r\n  display: flex;\r\n  gap: 30px;\r\n  position: relative;\r\n}\r\n\r\n.about-img .img-1{\r\n  border-radius: 80px 80px 0 80px;\r\n}\r\n\r\n.about-img .img-2{\r\n  border-radius: 50%;\r\n  border: 2px dashed var(--theme-color2);\r\n  padding: 8px;\r\n}\r\n\r\n.about-img .img-3{\r\n  border-radius: 0 80px 80px 80px;\r\n}\r\n\r\n.about-experience{\r\n  display: flex;\r\n  align-items: center;\r\n  text-align: center;\r\n  background: var(--theme-color2);\r\n  padding: 15px 20px 15px 15px;\r\n  color: var(--color-white);\r\n  border-radius: 50px 50px 50px 0;\r\n  box-shadow: 0 0 40px 5px rgb(0 0 0 / 10%);\r\n}\r\n\r\n.about-experience-icon{\r\n  color: var(--theme-color);\r\n  font-size: 65px;\r\n  width: 90px;\r\n  height: 90px;\r\n  line-height: 70px;\r\n  text-align: center;\r\n  margin: auto;\r\n  background: var(--color-white);\r\n  border-radius: 50px;\r\n  margin-bottom: 5px;\r\n}\r\n\r\n.about-experience-icon img{\r\n  width: 65px;\r\n}\r\n\r\n.about-right {\r\n  position: relative;\r\n  display: block;\r\n}\r\n\r\n.about-content {\r\n  margin-top: 30px;\r\n  padding-bottom: 20px;\r\n  border-bottom: 1px solid var(--border-info-color);\r\n}\r\n\r\n.about-item {\r\n  position: relative;\r\n  display: flex;\r\n  gap: 12px;\r\n  margin-bottom: 25px;\r\n}\r\n\r\n.about-item-icon {\r\n  width: 70px;\r\n  height: 70px;\r\n  line-height: 58px;\r\n  text-align: center;\r\n  margin-bottom: 12px;\r\n  background: var(--theme-color2);\r\n  border-radius: 50px;\r\n  font-size: 45px;\r\n  color: var(--theme-color);\r\n  box-shadow: -5px 5px 0 var(--theme-color-light);\r\n}\r\n\r\n.about-item-icon img{\r\n  width: 45px;\r\n  filter: brightness(0) invert(1);\r\n}\r\n\r\n.about-item-content {\r\n  flex: 1;\r\n}\r\n\r\n.about-item-content h5 {\r\n  font-size: 22px;\r\n  margin-bottom: 5px;\r\n}\r\n\r\n.about-quote{\r\n  position: relative;\r\n  color: var(--color-dark);\r\n  padding: 20px 22px;\r\n  background: var(--theme-color-light);\r\n  border-radius: 20px;\r\n}\r\n\r\n.about-quote i{\r\n  position: absolute;\r\n  font-size: 45px;\r\n  color: var(--theme-color);\r\n  right: 15px;\r\n  bottom: -15px;\r\n}\r\n\r\n.about-bottom{\r\n  display: flex;\r\n  flex-wrap: wrap;\r\n  gap: 25px;\r\n  margin-top: 30px;\r\n}\r\n\r\n.about-phone{\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 12px;\r\n}\r\n\r\n.about-phone .icon{\r\n  width: 48px;\r\n  height: 48px;\r\n  line-height: 48px;\r\n  background: var(--theme-color);\r\n  color: var(--color-white);\r\n  border-radius: 50px;\r\n  text-align: center;\r\n  font-size: 22px;\r\n  box-shadow: -5px 5px 0 var(--theme-color-light);\r\n}\r\n\r\n.about-phone .number{\r\n  line-height: 1;\r\n}\r\n\r\n.about-phone .number span{\r\n  color: var(--theme-color2);\r\n  font-weight: 500;\r\n}\r\n\r\n.about-phone .number h6{\r\n  font-size: 20px;\r\n  margin-top: 8px;\r\n}\r\n\r\n.about-phone .number h6 a{\r\n  color: var(--theme-color);\r\n}\r\n\r\n\r\n@media all and (max-width: 991px) {\r\n\r\n  /* /exam css start-------------/ */\r\n    .student_right{right: -216px!important;} \r\n    .scholor1 img{opacity: 0.1!important;}\r\n    .student_right img {width: 42%!important;}\r\n    .scholorship .theme-btn{padding: 2px 8px!important;}\r\n    .add-bld{font-size: 30px!important;}\r\n     .banner_exm_lft img{opacity: 0.2!important;}\r\n    .banner_exm_right img{opacity: 0.2!important;}\r\n    .nws_scroll{padding-top: 50px!important;}\r\n\r\n    /* /exam css end-------------/ */\r\n  .about-right {\r\n    margin-top: 30px;\r\n  }\r\n}\r\n\r\n@media all and (max-width: 767px) {\r\n  .about-item {\r\n    margin-top: 30px;\r\n  }\r\n}\r\n\r\n/*====================\r\n20. universities \r\n======================*/\r\n.explore_course.universities .course-meta{justify-content: space-between;}\r\n.explore_course.universities .course-item{border-radius: 4px;padding: 0;}\r\n.pd_20{padding: 20px;}\r\n.universities .course-tag2 {\r\n    position: absolute;\r\n    right:0;\r\n    bottom: 0;\r\n    background: var(--theme-color2);\r\n    color: var(--color-white);\r\n    border-radius: 20px 20px 0 0;\r\n    padding: 2px 16px;\r\n    margin-bottom: 10px;\r\n    display: inline-block;\r\n    box-shadow: var(--box-shadow2);\r\n    z-index: 1;font-size: 12px;margin: auto;\r\n}\r\n\r\n\r\n\r\n/*====================\r\n20. courses \r\n======================*/\r\n.explore_course .theme-btn{padding: 7px 20px;border-radius: 10px;}\r\n/*====================\r\n20. exam \r\n======================*/\r\n.pd-20{padding: 20px 0 0px 20px;}\r\n.exams .curve {\r\n    width: 0;\r\n    height: 0;\r\n    position: absolute;\r\n    bottom: -17px;\r\n    border-top: 15px solid #24272b;\r\n    border-left: 15px solid transparent;\r\n    left: -33px;\r\n}\r\n.exams .course-tag{left: -33px;bottom: -14px; padding: 12px 30px; }\r\n\r\n/*====================\r\n20. learn from the best \r\n======================*/\r\n.tchr_info_wraper{background: #fff;position: absolute;padding: 20px;border-radius: 10px;bottom: 34px; z-index: +99;left: 50%;transform: translateX(-50%);width: 320px;}\r\n.learn .event-item{padding: 0;}\r\n.learn .course-meta{display: inherit;} \r\n.learn .course-meta p{font-size: 14px;} \r\n.learn .event-img img{border-radius: 10px 10px 10px 0;}\r\n.register_btn{position: absolute;left: 50%;transform: translateX(-50%);width: 175px;}\r\n.learn .theme-btn{border-radius: 10px; padding: 7px 20px;}\r\n    \r\n\r\n/*====================\r\n20. Course css \r\n======================*/\r\n.add-norm{font-family: jost; font-size: 28px;color: #3a294b;font-weight: 300;line-height: 40px;}\r\n.add-bld{font-family: jost; font-size: 38px;color: #3a294b;font-weight: 600;}\r\n.course-area{\r\n  position: relative;\r\n}\r\n\r\n.course-item{\r\n  position: relative;\r\n  background: var(--color-white);\r\n  padding: 20px;\r\n  border-radius: 10px 10px 10px 0;\r\n  margin-bottom: 25px;\r\n  box-shadow: var(--box-shadow)!important;border: 1px solid #bfc4c8;\r\n    \r\n}\r\n\r\n.sec_bg{background: #ffe4cc;}\r\n.add-dvd{display: flex;justify-content: space-between;align-items: center;}\r\n\r\n.curve{width: 0;\r\n    height: 0;\r\n    position: absolute;\r\n    bottom: -27px;\r\n    border-top: 15px solid #24272b;\r\n    border-left: 15px solid transparent;\r\n    left: -33px;}\r\n\r\n.course-tag{\r\n  position: absolute;\r\n  left: -33px;\r\n  bottom: -23px;\r\n  background: var(--theme-color2);\r\n  color: var(--color-white);\r\n  border-radius: 40px 40px 40px 0;\r\n  padding: 2px 10px;\r\n  margin-bottom: 10px;\r\n  display: inline-block;\r\n  box-shadow: var(--box-shadow2);\r\n  z-index: 1;font-size: 12px;\r\n}\r\n\r\n.course-img{\r\n  position: relative;\r\n}\r\n\r\n.course-img img{\r\n  border-radius: 10px 10px 10px 0;\r\n  height:300px;\r\n}\r\n\r\n\r\n.course-item:hover .course-img::before{\r\n\topacity: 0.5;\r\n\tvisibility: visible;\r\n}\r\n\r\n.course-img a {\r\n\tposition: absolute;\r\n\ttop: 50%;\r\n\tleft: 50%;\r\n\twidth: 50px;\r\n\theight: 50px;\r\n\tline-height: 50px;\r\n\tborder-radius: 100%;\r\n\tline-height: 50px;\r\n\tpadding: 0;\r\n\tmargin: -25px 0 0 -25px;\r\n\tcolor: var(--color-white);\r\n\tbackground: var(--theme-color2);\r\n\ttransform: scale(3);\r\n\topacity: 0;\r\n\tvisibility: hidden;\r\n\ttransition: var(--transition);\r\n\tz-index: 1;\r\n}\r\n\r\n.explore_course .course-meta{justify-content: end;}\r\n.explore_course .course-bottom{padding: 5px 0;margin-top: 0;}\r\n.explore_course .course-bottom-left span{font-size: 15px;}\r\n\r\n.course-item:hover .course-img a{\r\n\ttransform: scale(1);\r\n\topacity: 1;\r\n\tvisibility: visible;\r\n}\r\n\r\n.course-item:hover .course-img a:hover{\r\n\tbackground: var(--color-white);\r\n\tcolor: var(--theme-color2);\r\n}\r\n\r\n.course-meta{\r\n  display: flex;\r\n  justify-content: space-between;\r\n  align-items: center;\r\n  margin: 5px 0;\r\n}\r\n\r\n.course-meta-left{\r\n  font-weight: 500;\r\n}\r\n\r\n.course-meta-left i{\r\n  color: var(--theme-color2);\r\n}\r\n\r\n.course-rating{\r\n  color: var(--theme-color2);\r\n  font-weight: 500;\r\n}\r\n\r\n.course-title{\r\n  margin-bottom: 10px;\r\n}\r\n\r\n.course-title:hover{\r\n  color: var(--theme-color2);\r\n}\r\n\r\n.course-bottom{\r\n  display: flex;\r\n  justify-content: space-between;\r\n  align-items: center;\r\n  padding-top: 15px;\r\n  margin-top: 15px;\r\n  border-top: 1px solid var(--border-info-color);\r\n}\r\n\r\n.course-bottom-left span{\r\n  margin-right: 10px;\r\n  font-weight: 500;\r\n}\r\n\r\n.course-bottom-left i{\r\n  color: var(--theme-color2);\r\n  margin-right: 8px;\r\n}\r\n\r\n.course-price{\r\n  display: inline-block;\r\n  background: var(--theme-color2);\r\n  color: var(--color-white);\r\n  padding: 1px 10px;\r\n  border-radius: 50px 50px 50px 0;\r\n  font-weight: 500;font-size: 12px;\r\n}\r\n\r\n.course-sidebar .form-select{\r\n  padding: 12px 15px;\r\n  box-shadow: none;\r\n  border-radius: 8px;\r\n}\r\n\r\n.course-sidebar .form-select:focus{\r\n  border-color: var(--theme-color);\r\n}\r\n\r\n.course-sidebar .form-check-input{\r\n  margin-top: 7.5px;\r\n  box-shadow: none;\r\n}\r\n\r\n.course-sidebar .form-check-input:focus{\r\n  border-color: var(--theme-color);\r\n}\r\n\r\n.course-sidebar .form-check-label{\r\n  color: var(--color-dark);\r\n}\r\n\r\n@media all and (max-width: 991px) {\r\n  .course-sidebar {\r\n    margin-top: 40px;\r\n  }\r\n}\r\n\r\n\r\n\r\n\r\n/*====================\r\n21. Course single css \r\n======================*/\r\n\r\n.course-details-img{\r\n  position: relative;\r\n}\r\n\r\n.course-details-img .play-btn{\r\n  position: absolute;\r\n  left: 50%;\r\n  top: 50%;\r\n  transform: translate(-50%, -50%);\r\n}\r\n\r\n.course-details img{\r\n  border-radius: 20px;\r\n}\r\n\r\n.course-single-info .single-info{\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 10px;\r\n  margin-bottom: 20px;\r\n}\r\n\r\n.course-single-info .author img{\r\n\twidth: 50px;\r\n\theight: 50px;\r\n\tborder-radius: 100%;\r\n}\r\n\r\n.course-single-info .single-info i{\r\n\twidth: 50px;\r\n\theight: 50px;\r\n\tline-height: 45px;\r\n\tborder-radius: 100%;\r\n\tfont-size: 29px;\r\n\tcolor: var(--theme-color2);\r\n\tborder: 2px solid var(--theme-color2);\r\n\tfont-size: 20px;\r\n  text-align: center;\r\n}\r\n\r\n.course-single-info .single-info-content{\r\n  margin-top: 5px;\r\n}\r\n\r\n.course-single-info .single-info h4{\r\n\tfont-size: 16px;\r\n\ttext-transform: uppercase;\r\n}\r\n\r\n.course-single-list i{\r\n  color: var(--theme-color2);\r\n  margin-right: 12px;\r\n}\r\n\r\n.course-feature-list a{\r\n  display: block;\r\n  padding: 10px 0;\r\n  font-weight: 500;\r\n  color: var(--color-dark);\r\n  border-bottom: 1px solid var(--border-info-color);\r\n}\r\n\r\n.course-feature-list a:last-child{\r\n  border-bottom: none;\r\n}\r\n\r\n.course-feature-list a span{\r\n  float: right;\r\n}\r\n\r\n.course-feature-list a i{\r\n  color: var(--theme-color2);\r\n  width: 24px;\r\n}\r\n\r\n.course-single-sidebar .theme-btn{\r\n  width: 100%;\r\n  margin-top: 30px;\r\n}\r\n\r\n.course-single-sidebar .theme-btn::before{\r\n  width: 350px;\r\n  height: 350px;\r\n}\r\n\r\n\r\n\r\n/*====================\r\n22. Feature css \r\n======================*/\r\n\r\n.feature-area {\r\n  position: relative;\r\n  z-index: 1;\r\n}\r\n\r\n.fa-negative{\r\n  margin-top: -150px;\r\n  margin-right: 20px;\r\n}\r\n\r\n.feature-item {\r\n  position: relative;\r\n  padding: 20px 25px;\r\n  background: var(--color-white);\r\n  border-radius: 50px 50px 50px 0px;\r\n  box-shadow: var(--box-shadow);\r\n  z-index: 1;\r\n}\r\n\r\n.feature-item .count{\r\n  position: absolute;\r\n  right: 30px;\r\n  top: 0px;\r\n  font-size: 50px;\r\n  font-weight: 800;\r\n  -webkit-text-stroke: 2px var(--theme-color);\r\n  -webkit-text-fill-color: transparent;\r\n}\r\n\r\n.feature-icon {\r\n  width: 80px;\r\n  height: 80px;\r\n  line-height: 65px;\r\n  border-radius: 50%;\r\n  text-align: center;\r\n  color: var(--color-white);\r\n  font-size: 60px;\r\n  background: var(--theme-color);\r\n  margin-bottom: 25px;\r\n  box-shadow: 5px 5px 0 var(--theme-bg-light);\r\n  position: relative;\r\n  transition: var(--transition);\r\n}\r\n\r\n.feature-item:hover .feature-icon {\r\n  transform: rotateY(360deg);\r\n}\r\n\r\n.feature-icon img{\r\n  width: 48px;\r\n  filter: brightness(0) invert(1);\r\n}\r\n\r\n.feature-content{\r\n  flex: 1;\r\n}\r\n\r\n.feature-content h4 {\r\n  color: var(--color-dark);\r\n  font-size: 22px;\r\n  font-weight: 600;\r\n  margin-bottom: 10px;\r\n}\r\n\r\n.feature-content p{\r\n  color: var(--color-dark);\r\n}\r\n\r\n@media all and (max-width: 1199px) {\r\n  .fa-negative {\r\n    margin-top: -50px;\r\n    margin-left: 20px;\r\n  }\r\n\r\n  .feature-item.active::before{\r\n    transform: scale(1);\r\n  }\r\n}\r\n\r\n\r\n\r\n\r\n/* ========================\r\n23. Portfolio css \r\n=========================== */\r\n\r\n.portfolio-area{\r\n  position: relative;\r\n}\r\n\r\n.portfolio-item {\r\n  position: relative;\r\n  width: 100%;\r\n  margin-bottom: 25px;\r\n}\r\n\r\n.portfolio-img {\r\n  height: 100%;\r\n}\r\n\r\n.portfolio-img img {\r\n  width: 100%;\r\n  border-radius: 50px 50px 50px 0;\r\n}\r\n\r\n.portfolio-content {\r\n  position: absolute;\r\n  width: 100%;\r\n  height: 100%;\r\n  top: 0;\r\n  left: 0;\r\n}\r\n\r\n.portfolio-info {\r\n  position: absolute;\r\n  left: 20px;\r\n  right: 20px;\r\n  bottom: 20px;\r\n  background: var(--color-white);\r\n  border-radius: 50px 50px 50px 0;\r\n  padding: 20px;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: space-between;\r\n  transition: 0.3s;\r\n}\r\n\r\n.portfolio-item:hover .portfolio-info{\r\n  bottom: 30px;\r\n}\r\n\r\n.portfolio-subtitle {\r\n  font-size: 14px;\r\n  color: var(--theme-color);\r\n  margin-bottom: 7px;\r\n  letter-spacing: 2px;\r\n  text-transform: uppercase;\r\n}\r\n\r\n.portfolio-subtitle span {\r\n  color: var(--theme-color);\r\n}\r\n\r\n.portfolio-title {\r\n  color: var(--color-dark);\r\n  font-size: 24px;\r\n}\r\n\r\n.portfolio-btn {\r\n  width: 50px;\r\n  height: 50px;\r\n  line-height: 50px;\r\n  background: var(--theme-color);\r\n  color: var(--color-white);\r\n  text-align: center;\r\n  font-size: 24px;\r\n  border-radius: 50px;\r\n}\r\n\r\n.portfolio-btn:hover{\r\n  background: var(--theme-color2);\r\n  color: var(--color-white);\r\n}\r\n\r\n\r\n\r\n/* ======================\r\n24. Portfolio single\r\n====================== */\r\n\r\n.portfolio-sidebar .portfolio-sidebar-content ul li {\r\n  border-bottom: 1px solid var(--border-info-color);\r\n  display: block;\r\n  margin-bottom: 10px;\r\n  padding-bottom: 10px;\r\n  font-size: 16px;\r\n  font-weight: 600;\r\n  line-height: 33px;\r\n}\r\n\r\n.portfolio-sidebar .portfolio-sidebar-content ul li:last-child {\r\n  border-bottom: none;\r\n}\r\n\r\n.portfolio-sidebar-title {\r\n  margin-bottom: 30px;\r\n  font-size: 26px;\r\n  font-weight: 600;\r\n}\r\n\r\n.portfolio-sidebar .portfolio-sidebar-content ul li span {\r\n  display: block;\r\n  font-weight: normal;\r\n  margin: 0;\r\n}\r\n\r\n.portfolio-sidebar .portfolio-sidebar-content .rating a {\r\n  color: var(--theme-color2);\r\n}\r\n\r\n.new-portfolio {\r\n  background: var(--theme-color) !important;\r\n}\r\n\r\n.new-portfolio h4 {\r\n  color: var(--color-white);\r\n  margin-bottom: 30px;\r\n  font-size: 28px;\r\n}\r\n\r\n.new-portfolio .theme-btn::before{\r\n  background: var(--color-dark);\r\n}\r\n\r\n.portfolio-single-list i {\r\n  color: var(--theme-color2);\r\n  margin-right: 10px;\r\n}\r\n\r\n.portfolio-details h3 {\r\n  font-weight: 700;\r\n}\r\n\r\n.portfolio-details img{\r\n  border-radius: 20px;\r\n}\r\n\r\n\r\n\r\n\r\n/* ========================\r\n25. Gallery css \r\n=========================== */\r\n\r\n.gallery-item {\r\n  position: relative;\r\n  width: 100%;\r\n  margin-bottom: 25px;\r\n}\r\n\r\n.gallery-img {\r\n  height: 100%;\r\n}\r\n\r\n.gallery-img img {\r\n  width: 100%;\r\n  border-radius: 50px 50px 50px 0;\r\n}\r\n\r\n.gallery-content {\r\n  position: absolute;\r\n  width: 100%;\r\n  height: 100%;\r\n  top: 0;\r\n  left: 0;\r\n}\r\n\r\n.gallery-content::before {\r\n  content: \"\";\r\n  position: absolute;\r\n  left: 10px;\r\n  top: 10px;\r\n  right: 10px;\r\n  bottom: 10px;\r\n  background: var(--theme-color2);\r\n  border-radius: 50px 50px 50px 0;\r\n  opacity: 0;\r\n  visibility: hidden;\r\n  transition: 0.3s;\r\n}\r\n\r\n.gallery-content:hover::before {\r\n  opacity: 0.9;\r\n  visibility: visible\r\n}\r\n\r\n.gallery-link {\r\n  width: 70px;\r\n  height: 70px;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  position: absolute;\r\n  left: 50%;\r\n  top: 50%;\r\n  transform: translate(-50%, -50%) scale(0);\r\n  transition: 0.5s;\r\n  border-radius: 50px;\r\n  opacity: 0;\r\n  visibility: hidden;\r\n  font-size: 60px;\r\n  color: var(--color-white);\r\n}\r\n\r\n.gallery-link:hover {\r\n  color: var(--color-white);\r\n}\r\n\r\n.gallery-content:hover .gallery-link {\r\n  opacity: 1;\r\n  visibility: visible;\r\n  transform: translate(-50%, -50%) scale(1);\r\n}\r\n\r\n\r\n\r\n/*====================\r\n26. Choose css \r\n======================*/\r\n\r\n.choose-area{\r\n  position: relative;\r\n  background: var(--footer-bg);\r\n  z-index: 1;\r\n}\r\n\r\n.choose-area::before{\r\n  content: \"\";\r\n  position: absolute;\r\n  left: 0;\r\n  top: 0;\r\n  /* background-image: url(../img/shape/01.png); */\r\n  background-repeat: no-repeat;\r\n  background-position: center;\r\n  background-size: cover;\r\n  width: 100%;\r\n  height: 100%;\r\n  opacity: 0.08;\r\n  z-index: -1;\r\n}\r\n\r\n.choose-content-wrap{\r\n  margin-top: 30px;\r\n}\r\n\r\n.choose-img {\r\n  position: relative;\r\n  margin-left: 50px;\r\n}\r\n\r\n.choose-img::before{\r\n  content: \"\";\r\n  position: absolute;\r\n  left: -15px;\r\n  bottom: -15px;\r\n  width: 100%;\r\n  height: 100%;\r\n  border: 5px solid var(--theme-color2);\r\n  border-radius: 30% 0 30% 30%;\r\n}\r\n\r\n.choose-img img{\r\n  border-radius: 30% 0 30% 30%;\r\n}\r\n\r\n.choose-item{\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 10px;\r\n  background: var(--color-white);\r\n  border-radius: 50px 50px 50px 0;\r\n  box-shadow: var(--box-shadow);\r\n  padding: 15px 15px 15px 0;\r\n  overflow: hidden;\r\n}\r\n\r\n.choose-item-icon{\r\n  width: 80px;\r\n  height: 80px;\r\n  line-height: 75px;\r\n  text-align: right;\r\n  background: var(--theme-color2);\r\n  border-radius: 50px 50px 50px 0;\r\n  padding-right: 12px;\r\n  margin-left: -12px;\r\n}\r\n\r\n.choose-item-icon i{\r\n  color: var(--theme-color);\r\n  font-size: 50px;\r\n}\r\n\r\n.choose-item-icon img{\r\n  width: 45px;\r\n  filter: brightness(0) invert(1);\r\n}\r\n\r\n.choose-item-info{\r\n  flex: 1;\r\n}\r\n\r\n.choose-item-info h4{\r\n  color: var(--color-dark);\r\n  margin-bottom: 10px;\r\n  font-size: 21px;\r\n}\r\n\r\n.choose-video-wrap{\r\n  height: 100%;\r\n  width: 100%;\r\n  display: flex;\r\n  align-items: flex-end;\r\n  justify-content: center;\r\n}\r\n\r\n@media all and (max-width: 991px) {\r\n  .choose-content-info{\r\n    margin-right: 100px;\r\n  }\r\n\r\n  .choose-video-wrap{\r\n    padding-top: 210px;\r\n  }\r\n\r\n  .choose-img{\r\n    margin-top: 50px;\r\n    margin-left: 10px;\r\n  }\r\n}\r\n\r\n@media all and (max-width: 767px) {\r\n  .choose-content-info{\r\n    margin-right: 40px;\r\n  }\r\n}\r\n\r\n\r\n\r\n/*====================\r\n27. Testimonial css \r\n======================*/\r\n\r\n.testimonial-area {\r\n  position: relative;\r\n}\r\n\r\n.ts-bg{\r\n  /* background-image: url(../img/testimonial/bg.jpg); */\r\n  background-repeat: no-repeat;\r\n  background-size: cover;\r\n  background-position: center;\r\n  position: relative;\r\n}\r\n\r\n.ts-bg::before{\r\n  content: \"\";\r\n  position: absolute;\r\n  left: 0;\r\n  top: 0;\r\n  width: 100%;\r\n  height: 100%;\r\n  background: rgba(1, 39, 88, .85);\r\n}\r\n\r\n.testimonial-item {\r\n  background: var(--color-white);\r\n  border-radius: 40px 40px 40px 0;\r\n  padding: 25px 25px;\r\n  margin: 6px;\r\n  position: relative;\r\n  border-bottom: 5px solid var(--theme-color2);\r\n}\r\n\r\n.testimonial-content{\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 10px;\r\n  margin-top: 20px;\r\n}\r\n\r\n.testimonial-quote p {\r\n  color: var(--body-text-color);\r\n  font-style: italic;\r\n  font-weight: 500;\r\n}\r\n\r\n.testimonial-author-info{\r\n  margin: 15px 0 10px 0;\r\n}\r\n\r\n.testimonial-author-img {\r\n  width: 75px;\r\n  padding: 4px;\r\n  border-radius: 50px;\r\n  border: 2px dashed var(--theme-color2);\r\n}\r\n\r\n.testimonial-author-img img {\r\n  border-radius: 50%;\r\n}\r\n\r\n.testimonial-author-info h4 {\r\n  font-size: 20px;\r\n  color:  var(--color-dark);\r\n  margin-bottom: 2px;\r\n}\r\n\r\n.testimonial-author-info p {\r\n  color: var(--theme-color2);\r\n  font-weight: 500;\r\n}\r\n\r\n.testimonial-quote-icon {\r\n  position: absolute;\r\n  right: 0px;\r\n  top: 0px;\r\n  color: var(--color-white);\r\n  font-size: 30px;\r\n  width: 40px;\r\n  height: 40px;\r\n  line-height: 41px;\r\n  text-align: center;\r\n  background: var(--theme-color2);\r\n  border-radius: 50px 50px 50px 0;\r\n}\r\n\r\n.testimonial-area .owl-dots {\r\n  text-align: center;\r\n  margin-top: 30px;\r\n}\r\n\r\n.testimonial-area .owl-dots .owl-dot span {\r\n  background: var(--theme-color2);\r\n  border-radius: 50px;\r\n  margin: 5px;\r\n  width: 8px;\r\n  height: 8px;\r\n  display: inline-block;\r\n  transition: var(--transition);\r\n}\r\n\r\n.testimonial-area .owl-dots .owl-dot.active span {\r\n  width: 20px;\r\n}\r\n\r\n.testimonial-rate {\r\n  color: var(--theme-color2);\r\n  margin-bottom: 15px;\r\n}\r\n\r\n.testimonial-area2.ts-bg{\r\n  padding-top: 120px;\r\n  background-attachment: fixed;\r\n}\r\n\r\n\r\n\r\n\r\n/*====================\r\n28. Counter css \r\n======================*/\r\n\r\n.counter-area {\r\n  position: relative;\r\n  /* background-image: url(../img/counter/01.jpg); */\r\n  background-repeat: no-repeat;\r\n  background-position: center;\r\n  background-size: cover;\r\n  background-attachment: fixed;\r\n  z-index: 1;\r\n}\r\n\r\n.counter-area::before{\r\n  content: \"\";\r\n  position: absolute;\r\n  background: var(--theme-color);\r\n  left: 0;\r\n  top: 0;\r\n  width: 100%;\r\n  height: 100%;\r\n  opacity: .7;\r\n  z-index: -1;\r\n}\r\n\r\n.counter-box {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  flex-direction: column;\r\n  text-align: center;\r\n  gap: 0;\r\n  position: relative;\r\n  z-index: 1;\r\n}\r\n\r\n.counter-box .icon {\r\n  position: relative;\r\n  text-align: center;\r\n  font-size: 60px;\r\n  width: 100px;\r\n  height: 100px;\r\n  line-height: 88px;\r\n  color: var(--color-white);\r\n  background:  var(--theme-color2);\r\n  border-radius: 30% 70% 70% 30% / 30% 30% 70% 70%;\r\n}\r\n\r\n.counter-box .icon img{\r\npadding: 20px;\r\n  filter: brightness(0) invert(1);\r\n}\r\n\r\n.counter-box .icon::before{\r\n  content: \"\";\r\n  position: absolute;\r\n  left: 10px;\r\n  top: 10px;\r\n  width: 100%;\r\n  height: 100%;\r\n  border-radius: 30px;\r\n  border: 3px solid var(--color-dark);\r\n  transition: var(--transition);\r\n  border-radius: 30% 70% 70% 30% / 30% 30% 70% 70%;\r\n  z-index: -1;\r\n}\r\n\r\n.counter-box:hover .icon::before{\r\n  left: 0;\r\n  top: 0;\r\n}\r\n\r\n.counter-box .counter {\r\n  display: block;\r\n  line-height: 1;\r\n  color: var(--color-white);\r\n  font-size: 50px;\r\n  font-weight: 600;\r\n}\r\n\r\n.counter-box .title {\r\n  color: var(--color-dark);\r\n  margin-top: 20px;\r\n  font-size: 20px;\r\n  font-weight: 600;\r\n  text-transform: capitalize;\r\n}\r\n\r\n@media all and (max-width: 991px) {\r\n  .counter-area .counter-box {\r\n    margin: 40px 0;\r\n  }\r\n}\r\n\r\n\r\n\r\n\r\n/*====================\r\n29. Cta css \r\n======================*/\r\n\r\n.cta-area{\r\n  position: relative;\r\n  /* background-image: url(../img/cta/01.jpg); */\r\n  background-repeat: no-repeat;\r\n  background-position: center;\r\n  background-size: cover;\r\n}\r\n\r\n.cta-content{\r\n  position: relative;\r\n  padding: 80px 40px;\r\n  margin-top: -40px;\r\n  z-index: 1;\r\n}\r\n\r\n.cta-content::before{\r\n  content: \"\";\r\n  position: absolute;\r\n  left: 0;\r\n  top: 0;\r\n  width: 100%;\r\n  height: 100%;\r\n  background: var(--theme-color2);\r\n  border-radius: 80px 80px 80px 0;\r\n  z-index: -1;\r\n}\r\n\r\n.cta-content::after{\r\n  content: \"\";\r\n  position: absolute;\r\n  left: 8px;\r\n  top: 8px;\r\n  bottom: 8px;\r\n  right: 8px;\r\n  border: 8px double var(--color-white);\r\n  border-radius: 70px 70px 70px 0;\r\n  z-index: -1;\r\n}\r\n\r\n.cta-content h1{\r\n  color: var(--color-white);\r\n  font-size: 45px;\r\n}\r\n\r\n.cta-content p{\r\n  color: var(--color-white);\r\n  margin-top: 15px;\r\n  margin-bottom: 30px;\r\n  font-size: 18px;\r\n}\r\n\r\n.cta-btn .theme-btn{\r\n  background: var(--color-white);\r\n  color: var(--color-dark);\r\n}\r\n\r\n.cta-btn .theme-btn:hover{\r\n  color: var(--color-white);\r\n}\r\n\r\n\r\n\r\n/* ===================\r\n30. Event css \r\n====================== */\r\n.dvder{border-top: 1px solid var(--border-info-color);padding-top: 10px;}\r\n.event-item{\r\n  position: relative;\r\n  background: var(--color-white);\r\n  border-radius: 20px 20px 20px 0;\r\n  padding: 20px 20px 20px 20px;\r\n  margin-bottom: 25px;\r\n  box-shadow: var(--box-shadow);\r\n  border: 1px solid #bfc4c8;\r\n}\r\n\r\n.event-location{\r\n  margin-bottom: 12px;\r\n}\r\n\r\n.event-location i{\r\n  color: var(--theme-color2);\r\n}\r\n\r\n.event-img{\r\n  position: relative;\r\n  overflow: hidden;\r\n  border-radius: 20px 20px 20px 0;\r\n}\r\n\r\n.event-img img{\r\n  border-radius: 40px 40px 40px 0;\r\n  box-shadow: var(--box-shadow);\r\n  height: 230px;\r\n}\r\n\r\n.teacher-img img{\r\n  border-radius: 40px 40px 40px 0;\r\n  box-shadow: var(--box-shadow);\r\n  height: 350px;\r\n}\r\n\r\n.event-item:hover .event-img img{\r\n  transform: scale(1.1);\r\n} \r\n\r\n.event-meta{\r\n  display: flex;\r\n  gap: 15px;\r\n  margin: 14px 0;\r\n}\r\n\r\n.event-meta i{\r\n  color: var(--theme-color2);\r\n  margin-right: 5px;\r\n}\r\n\r\n.event-title{\r\n  margin-bottom: 10px;\r\n}\r\n\r\n.event-title:hover{\r\n  color: var(--theme-color2);\r\n}\r\n\r\n.event-btn{\r\n  margin-top: 20px;\r\n}\r\n\r\n.event-btn .theme-btn{\r\n  padding: 11px 15px;\r\n}\r\n\r\n.event-slider .event-item{\r\n  box-shadow: none;\r\n  margin-bottom: 0;\r\n}\r\n\r\n.event-slider .owl-dots {\r\n  text-align: center;\r\n  margin-top: 10px;\r\n}\r\n\r\n.event-slider .owl-dots .owl-dot span {\r\n  background: var(--theme-color2);\r\n  border-radius: 50px;\r\n  margin: 5px;\r\n  width: 8px;\r\n  height: 8px;\r\n  display: inline-block;\r\n  transition: var(--transition);\r\n}\r\n\r\n.event-slider .owl-dots .owl-dot.active span {\r\n  background-color: var(--theme-color2);\r\n  width: 20px;\r\n}\r\n\r\n.event-slider .owl-nav {\r\n\twidth: 100%;\r\n\topacity: 0;\r\n\tvisibility: hidden;\r\n\ttransition: var(--transition);\r\n\tmargin: 0;\r\n}\r\n\r\n.event-slider:hover .owl-nav{\r\n\tdisplay: block;\r\n\topacity:1;\r\n\tvisibility:visible;\r\n}\r\n\r\n.event-slider .owl-nav button {\r\n\theight: 48px;\r\n\twidth: 48px;\r\n\tline-height: 45px !important;\r\n\ttop: 50%;\r\n\tbackground: var(--theme-color2) !important;\r\n\tcolor: var(--color-white) !important;\r\n\tfont-size: 25px !important;\r\n\tposition: absolute;\r\n\tborder: none;\r\n\tmargin: 0;\r\n\tpadding: 0;\r\n\ttransition: var(--transition);\r\n\tborder-radius: 100%;\r\n\tmargin-top: -24px;\r\n}\r\n\r\n.event-slider .owl-nav button:hover{\r\n\tbackground: var(--theme-color) !important;\r\n}\r\n\r\n.event-slider .owl-nav .owl-prev{\r\n\tleft:-75px;\r\n}\r\n\r\n.event-slider .owl-nav .owl-prev:hover{\r\n\tleft:-65px;\r\n}\r\n\r\n.event-slider .owl-nav .owl-next{\r\n\tright:-75px;\r\n}\r\n\r\n.event-slider .owl-nav .owl-next:hover{\r\n\tright:-65px;\r\n}\r\n\r\n\r\n/* ===================\r\n creators css \r\n====================== */\r\n\r\n.creators_wrap{box-shadow: var(--box-shadow);    padding: 30px 20px;border-radius: 20px; border: 1px solid #bfc4c8;}\r\n.application_bg {display: flex;flex-direction: column;align-items: center;justify-content: center;text-align: center;\r\nbackground-repeat: no-repeat !important;background-position: center !important;background-size: cover !important;position: relative;\r\npadding-top: 70px;padding-bottom: 50px;z-index: 1;}\r\n.award{display: flex;justify-content: center;align-items: center;gap: 2rem;}\r\n.award img{width: 70px;}\r\n.application_bg-title {font-size: 32px;color: var(--color-white);font-weight: 700;margin-bottom: 10px;text-transform: capitalize;}\r\n.no-one{font-size: 22px;font-weight: 600;color: #fff;}\r\n.click{font-size: 20px;color: #fff;font-weight: 600; padding-top: 20px;}\r\n.college{color: #f7a700;}\r\n/* ===================\r\n31. Event single css \r\n====================== */\r\n\r\n.event-details img{\r\n  border-radius: 20px;\r\n}\r\n\r\n.event-map{\r\n  margin-bottom: 20px;\r\n}\r\n\r\n.event-map iframe{\r\n  border-radius: 20px;\r\n  height: 400px;\r\n  width: 100%;\r\n}\r\n\r\n.event-content-single{\r\n  margin-bottom: 20px;\r\n}\r\n\r\n.event-content-single h5{\r\n  margin-bottom: 5px;\r\n}\r\n\r\n.event-content-single i{\r\n  color: var(--theme-color2);\r\n  margin-right: 5px;\r\n}\r\n\r\n.event-single-info p{\r\n  margin-bottom: 20px;\r\n}\r\n\r\n.event-author-info{\r\n  display: flex;\r\n  flex-direction: column;\r\n  align-items: center;\r\n  justify-content: center;\r\n  text-align: center;\r\n  gap: 10px;\r\n  margin-top: 50px;\r\n}\r\n\r\n.event-author-info img{\r\n  border-radius: 50%;\r\n}\r\n\r\n.event-author-info h5{\r\n  margin-top: 5px;\r\n}\r\n\r\n\r\n\r\n/*====================\r\n32. Enroll css \r\n======================*/\r\n\r\n.enroll-area{\r\n  position: relative;\r\n  /* background-image: url(../img/enroll/01.jpg); */\r\n  background-repeat: no-repeat;\r\n  background-size: cover;\r\n  background-position: center;\r\n  z-index: 1;\r\n}\r\n\r\n.enroll-area::before{\r\n  content: \"\";\r\n  position: absolute;\r\n  left: 0;\r\n  top: 0;\r\n  background: var(--footer-bg);\r\n  opacity: .8;\r\n  width: 100%;\r\n  height: 100%;\r\n  z-index: -1;\r\n}\r\n\r\n.enroll-left{\r\n  margin-right: 30px;\r\n}\r\n\r\n.enroll-form{\r\n  background: var(--color-white);\r\n  border-radius: 80px 80px 80px 0;\r\n  box-shadow: var(--box-shadow);\r\n}\r\n\r\n.enroll-form form{\r\n  padding: 30px;\r\n}\r\n\r\n.enroll-form-header{\r\n  background: var(--theme-color2);\r\n  border-radius: 50px 50px 50px 0;\r\n  padding: 20px 30px;\r\n}\r\n\r\n.enroll-form-header h3{\r\n  color: var(--color-white);\r\n}\r\n\r\n.enroll-form-header p{\r\n  color: var(--color-white);\r\n}\r\n\r\n.enroll-form .form-group {\r\n  margin-bottom: 20px\r\n}\r\n\r\n.enroll-form .form-group .form-control {\r\n  padding: 16px 22px;\r\n  font-size: 16px;\r\n  border-radius: 12px;\r\n  color: #6C757D;\r\n  background-color: var(--theme-bg-light);\r\n  border: none;\r\n  box-shadow: none\r\n}\r\n\r\n.enroll-form .form-group .form-select{\r\n  padding: 15px 22px;\r\n  background-color: var(--theme-bg-light);\r\n  color: #6C757D;\r\n  border: none;\r\n  box-shadow: none;\r\n  border-radius: 8px;\r\n}\r\n\r\n@media all and (max-width: 991px) {\r\n  .enroll-left{\r\n    margin-right: 0px;\r\n  }\r\n}\r\n\r\n\r\n\r\n/* ===================\r\n33. Skill css \r\n====================== */\r\n\r\n.progress-box {\r\n  margin: 30px 0;\r\n  position: relative;\r\n  z-index: 1;\r\n}\r\n\r\n.progress-box:last-child {\r\n  margin-bottom: 0;\r\n}\r\n\r\n.progress-box h5 {\r\n  color: var(--color-white);\r\n  font-size: 16px;\r\n  text-transform: uppercase;\r\n  font-weight: 600;\r\n  display: flex;\r\n  justify-content: space-between;\r\n  align-items: center;\r\n  margin-bottom: 15px;\r\n}\r\n\r\n.progress-box .progress {\r\n  height: 8px;\r\n  background: var(--color-white);\r\n  border-radius: 50px;\r\n}\r\n\r\n.progress-box .progress .progress-bar {\r\n  background: var(--theme-color2);\r\n}\r\n\r\n\r\n\r\n/* ===================\r\n34. Department css \r\n====================== */\r\n\r\n.explore-study-area{\r\n  position: relative;\r\n}\r\n\r\n.department-item{\r\n  position: relative;\r\n  border-radius: 10px;\r\n  padding: 20px;\r\n  margin-bottom: 25px;\r\n  overflow: hidden;\r\n  box-shadow: var(--box-shadow);border: 1px solid #ff7d08;\r\n} \r\n\r\n\r\n\r\n.department-item:hover::before{\r\n  opacity: 1;\r\n}\r\n\r\n\r\n\r\n.department-icon img{\r\n  width: 60px !important;\r\n}\r\n\r\n.department-title{\r\n  margin-bottom: 10px;\r\n}\r\n\r\n.department-title:hover{\r\n  color: var(--theme-color2);\r\n}\r\n\r\n.department-btn{\r\n  margin-top: 10px;\r\n}\r\n\r\n.department-btn a{\r\n  font-size: 14px;\r\n  font-weight: 500;\r\n  text-transform: uppercase;\r\n}\r\n\r\n.department-btn a:hover{\r\n  color: var(--theme-color2);\r\n}\r\n\r\n.department-btn a i{\r\n  margin-left: 5px;\r\n}\r\n\r\n.department-slider .department-item{\r\n  box-shadow: none;\r\n  margin-bottom: 0;\r\n}\r\n\r\n.department-slider .owl-dots {\r\n  text-align: center;\r\n  margin-top: 10px;\r\n}\r\n\r\n.department-slider .owl-dots .owl-dot span {\r\n  background: var(--theme-color2);\r\n  border-radius: 50px;\r\n  margin: 5px;\r\n  width: 8px;\r\n  height: 8px;\r\n  display: inline-block;\r\n  transition: var(--transition);\r\n}\r\n\r\n.department-slider .owl-dots .owl-dot.active span {\r\n  background-color: var(--theme-color2);\r\n  width: 20px;\r\n}\r\n\r\n.department-slider .owl-nav {\r\n\twidth: 100%;\r\n\topacity: 0;\r\n\tvisibility: hidden;\r\n\ttransition: var(--transition);\r\n\tmargin: 0;\r\n}\r\n\r\n.department-slider:hover .owl-nav{\r\n\tdisplay: block;\r\n\topacity:1;\r\n\tvisibility:visible;\r\n}\r\n\r\n.department-slider .owl-nav button {\r\n\theight: 48px;\r\n\twidth: 48px;\r\n\tline-height: 45px !important;\r\n\ttop: 50%;\r\n\tbackground: var(--theme-color2) !important;\r\n\tcolor: var(--color-white) !important;\r\n\tfont-size: 25px !important;\r\n\tposition: absolute;\r\n\tborder: none;\r\n\tmargin: 0;\r\n\tpadding: 0;\r\n\ttransition: var(--transition);\r\n\tborder-radius: 100%;\r\n\tmargin-top: -54px;\r\n}\r\n\r\n.department-slider .owl-nav button:hover{\r\n\tbackground: var(--theme-color) !important;\r\n}\r\n\r\n.department-slider .owl-nav .owl-prev{\r\n\tleft:-75px;\r\n}\r\n\r\n.department-slider .owl-nav .owl-prev:hover{\r\n\tleft:-65px;\r\n}\r\n\r\n.department-slider .owl-nav .owl-next{\r\n\tright:-75px;\r\n}\r\n\r\n.department-slider .owl-nav .owl-next:hover{\r\n\tright:-65px;\r\n}\r\n\r\n\r\n\r\n/*==================\r\n35. Department single\r\n====================*/\r\n\r\n.department-single-list i {\r\n  color: var(--theme-color2);\r\n  margin-right: 10px;\r\n}\r\n\r\n.department-download a {\r\n  border: 2px solid var(--theme-color2);\r\n  padding: 12px 20px;\r\n  color:  var(--color-dark);\r\n  display: block;\r\n  margin-bottom: 20px;\r\n  border-radius: 30px 30px 30px 0;\r\n  font-weight: 600;\r\n  transition: var(--transition);\r\n}\r\n\r\n.department-download a i {\r\n  margin-right: 10px;\r\n}\r\n\r\n.department-download a:hover {\r\n  background-color: var(--theme-color2);\r\n  color: var(--color-white);\r\n}\r\n\r\n.department-details h3 {\r\n  color:  var(--color-dark);\r\n}\r\n\r\n.department-details img{\r\n  border-radius: 20px;\r\n}\r\n\r\n\r\n\r\n\r\n/*====================\r\n36. Partner css \r\n======================*/\r\n\r\n.partner-area{\r\n  position: relative;\r\n}\r\n/*====================\r\n37. Blog css \r\n======================*/\r\n.ft_head {\r\n    position: absolute;\r\n    left: 28px;\r\n    top:8px;\r\n    background: #F2F3F5;\r\n    display: table;\r\n    margin: auto;\r\n    padding: 0 13px;\r\n    width: auto;\r\n    font-weight: 500;\r\n    font-family: jost;\r\n    font-size: 20px;z-index: +2\r\n}\r\n\r\n.department-icon{display: flex;align-items: center;justify-content: center;}\r\n\r\n\r\n/*====================\r\n37. Blog css \r\n======================*/\r\n\r\n.blog-area{\r\n  position: relative;\r\n}\r\n\r\n.blog-item{\r\n  position: relative;\r\n  margin-bottom: 25px;\r\n  padding: 20px 20px 15px 20px;\r\n  border-radius: 20px 20px 20px 0;\r\n  background: var(--color-white);\r\n  box-shadow: var(--box-shadow);\r\n  transition: var(--transition);\r\n}\r\n\r\n.blog-item-img{\r\n  position: relative;\r\n  overflow: hidden;\r\n  border-radius: 30px 30px 30px 0;\r\n}\r\n\r\n.blog-item-img img{\r\n  border-radius: 30px 30px 30px 0;\r\n}\r\n\r\n.blog-item:hover .blog-item-img img{\r\n  transform: scale(1.1);\r\n} \r\n\r\n.blog-date{\r\n  position: absolute;\r\n  padding: 4px 12px 4px 12px;\r\n  right: -10px;\r\n  top: 40px;\r\n  font-weight: 500;\r\n  background: var(--theme-color2);\r\n  color: var(--color-white);\r\n  border-radius: 50px 50px 50px 0;\r\n  box-shadow: var(--box-shadow);\r\n  z-index: 2;\r\n}\r\n\r\n.blog-item-info {\r\n  position: relative;\r\n}\r\n\r\n.blog-item-meta ul {\r\n  margin: 0;\r\n  padding: 0;\r\n  margin: 12px 0;\r\n  border-bottom: 1px solid var(--border-info-color);\r\n  padding-bottom: 14px;\r\n}\r\n\r\n.blog-item-meta ul li {\r\n  display: inline-block;\r\n  margin-right: 15px;\r\n  font-weight: 500;\r\n  position: relative;\r\n  color: var(--color-dark);\r\n}\r\n\r\n.blog-item-meta ul li i {\r\n  margin-right: 5px;\r\n  color: var(--theme-color2);\r\n}\r\n\r\n.blog-item-meta a:hover {\r\n  color: var(--theme-color2);\r\n}\r\n\r\n.blog-title {\r\n  font-size: 18px;\r\n  margin-bottom: 15px;\r\n  line-height: 1.2;\r\n  text-transform: capitalize;\r\n  font-weight: 600 !important;\r\n}\r\n\r\n.blog-item-info p {\r\n  margin-bottom: 16px;\r\n}\r\n\r\n.blog-item-info .theme-btn {\r\n  margin-top: 15px;\r\n  padding: 11px 15px;\r\n}\r\n\r\n.blog-item-info h4 a {\r\n  color: var(--color-dark);\r\n}\r\n\r\n.blog-item-info h4 a:hover {\r\n  color: var(--theme-color2);\r\n}\r\n\r\n\r\n\r\n\r\n/*========================\r\n38. Blog single css\r\n==========================*/\r\n\r\n.blog-single-content img{\r\n  border-radius: 20px;\r\n}\r\n\r\n.blog-thumb-img {\r\n  margin-bottom: 20px;\r\n}\r\n\r\n.blog-meta {\r\n  display: flex;\r\n  justify-content: space-between;\r\n  align-items: center;\r\n  margin-bottom: 20px;\r\n}\r\n\r\n.blog-meta .blog-meta-left ul {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 20px;\r\n}\r\n\r\n.blog-meta .blog-meta-left ul li{\r\n  font-weight: 500;\r\n}\r\n\r\n.blog-meta i {\r\n  margin-right: 5px;\r\n  color: var(--theme-color2);\r\n}\r\n\r\n.blog-meta a {\r\n  color: var(--body-text-color);\r\n  font-weight: 500;\r\n}\r\n\r\n.blog-meta a:hover {\r\n  color: var(--theme-color);\r\n}\r\n\r\n.blog-details-title {\r\n  font-size: 34px;\r\n  color:  var(--color-dark);\r\n}\r\n\r\n.blockqoute {\r\n  background: var(--theme-bg-light);\r\n  border-left: 5px solid var(--theme-color2);\r\n  padding: 30px;\r\n  font-size: 17px;\r\n  font-style: italic;\r\n  margin: 20px 0;\r\n  border-radius: 50px 50px 50px 0;\r\n}\r\n\r\n.blockqoute-author {\r\n  margin-top: 20px;\r\n  padding-left: 60px;\r\n  position: relative;\r\n  color: var(--color-dark);\r\n}\r\n\r\n.blockqoute-author::before {\r\n  content: \"\";\r\n  position: absolute;\r\n  height: 2px;\r\n  width: 40px;\r\n  background: var(--theme-color2);\r\n  left: 0;\r\n  top: 10px;\r\n}\r\n\r\n.blog-details-tags {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 20px;\r\n}\r\n\r\n.blog-details-tags h5 {\r\n  color: var(--color-dark);\r\n}\r\n\r\n.blog-details-tags ul {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 15px;\r\n}\r\n\r\n.blog-details-tags ul a {\r\n  background: var(--theme-bg-light);\r\n  color:  var(--color-dark);\r\n  padding: 6px 18px;\r\n  border-radius: 8px;\r\n  transition: var(--transition);\r\n}\r\n\r\n.blog-details-tags ul a:hover {\r\n  background: var(--theme-color);\r\n  color: var(--color-white);\r\n}\r\n\r\n.blog-author {\r\n  display: flex;\r\n  justify-content: start;\r\n  align-items: center;\r\n  background: var(--color-white);\r\n  border-radius: 50px 50px 50px 0;\r\n  box-shadow: var(--box-shadow);\r\n  margin: 50px 0;\r\n  padding: 20px;\r\n}\r\n\r\n.blog-author-img {\r\n  width: 320px;\r\n}\r\n\r\n.blog-author-img img{\r\n  border-radius: 40px 40px 40px 0;\r\n}\r\n\r\n.author-name {\r\n  font-size: 22px;\r\n  color: var(--theme-color);\r\n  margin: 8px 0;\r\n}\r\n\r\n.author-info {\r\n  padding: 0 20px;\r\n}\r\n\r\n.author-social {\r\n  margin-top: 10px;\r\n}\r\n\r\n.author-social a {\r\n  width: 35px;\r\n  height: 35px;\r\n  line-height: 31px;\r\n  text-align: center;\r\n  border: 2px solid var(--theme-color);\r\n  border-radius: 50px;\r\n  margin-right: 5px;\r\n  color: var(--theme-color);\r\n  transition: var(--transition);\r\n}\r\n\r\n.author-social a:hover {\r\n  color: var(--color-white);\r\n  background: var(--theme-color);\r\n}\r\n\r\n.blog-comments {\r\n  margin-bottom: 50px;\r\n}\r\n\r\n.blog-comments h3 {\r\n  color: var(--color-dark);\r\n}\r\n\r\n.blog-comments-wrapper {\r\n  margin: 30px 0;\r\n}\r\n\r\n.blog-comments-single {\r\n  display: flex;\r\n  justify-content: start;\r\n  align-items: flex-start;\r\n  margin-top: 50px;\r\n}\r\n\r\n.blog-comments-single img {\r\n  border-radius: 50%;\r\n}\r\n\r\n.blog-comments-content {\r\n  padding: 0 0 0 20px;\r\n}\r\n\r\n.blog-comments-content span {\r\n  font-size: 14px;\r\n  color: var(--theme-color2);\r\n  font-weight: 500;\r\n}\r\n\r\n.blog-comments-content a {\r\n  font-weight: 500;\r\n  margin-top: 5px;\r\n  color: var(--theme-color2);\r\n}\r\n\r\n.blog-comments-content a:hover {\r\n  color: var(--theme-color);\r\n}\r\n\r\n.blog-comments-content h5 {\r\n  color: var(--color-dark);\r\n}\r\n\r\n.blog-comments-reply {\r\n  margin-left: 50px;\r\n}\r\n\r\n.blog-comments-form {\r\n  padding: 30px;\r\n  margin-top: 50px;\r\n  border-radius: 20px;\r\n  background: var(--theme-bg-light);\r\n}\r\n\r\n.blog-comments-form h3 {\r\n  margin-bottom: 20px;\r\n}\r\n\r\n.blog-comments-form .form-group {\r\n  margin-bottom: 20px;\r\n}\r\n\r\n.blog-comments-form .form-control {\r\n  padding: 15px 20px;\r\n  border-radius: 12px;\r\n  box-shadow: none;\r\n  transition: var(--transition);\r\n}\r\n\r\n.blog-comments-form .form-control:focus {\r\n  border-color: var(--theme-color2);\r\n}\r\n\r\n\r\n\r\n@media all and (max-width: 767px) {\r\n  .blog-meta {\r\n    flex-direction: column;\r\n    font-size: 15px;\r\n  }\r\n\r\n  .blog-meta .blog-meta-left ul {\r\n    gap: 10px;\r\n  }\r\n\r\n  .blog-details-tags {\r\n    flex-direction: column;\r\n    align-items: flex-start;\r\n  }\r\n\r\n  .blog-author {\r\n    flex-direction: column;\r\n    text-align: center;\r\n    padding: 25px;\r\n  }\r\n\r\n  .author-info{\r\n    margin-top: 25px;\r\n  }\r\n\r\n  .blog-comments-single {\r\n    flex-direction: column;\r\n    text-align: center;\r\n    padding: 30px 0px;\r\n    box-shadow: var(--box-shadow);\r\n    margin-bottom: 30px;\r\n    border-radius: 10px;\r\n  }\r\n\r\n  .blog-comments-single img{\r\n    margin: 0 auto 20px auto;\r\n  }\r\n\r\n  .blog-comments-reply {\r\n    margin-left: 0px;\r\n  }\r\n}\r\n\r\n\r\n\r\n/*=======================\r\n39. Widget sidebar css\r\n=========================*/\r\n\r\n.widget {\r\n  background: var(--theme-bg-light);\r\n  padding: 30px;\r\n  margin-bottom: 30px;\r\n  border-radius: 20px;\r\n}\r\n\r\n.widget .widget-title {\r\n  padding-bottom: 10px;\r\n  margin-bottom: 30px;\r\n  position: relative;\r\n  font-size: 22px;\r\n  color:  var(--color-dark);\r\n}\r\n\r\n.widget .widget-title::before {\r\n  position: absolute;\r\n  content: '';\r\n  width: 15px;\r\n  border-bottom: 3px solid var(--theme-color2);\r\n  bottom: 0;\r\n  left: 0;\r\n}\r\n\r\n.widget .widget-title::after {\r\n  position: absolute;\r\n  content: '';\r\n  width: 30px;\r\n  border-bottom: 3px solid var(--theme-color2);\r\n  bottom: 0;\r\n  left: 22px;\r\n}\r\n\r\n.widget .search-form .form-control {\r\n  padding: 12px 15px 12px 15px;\r\n  border-radius: 8px;\r\n  box-shadow: none;\r\n}\r\n\r\n.widget .search-form {\r\n  position: relative;\r\n}\r\n\r\n.widget .search-form .form-control:focus {\r\n  border-color: var(--theme-color);\r\n}\r\n\r\n.widget .search-form button {\r\n  position: absolute;\r\n  right: 0;\r\n  top: 0;\r\n  font-size: 18px;\r\n  padding: 8px 18px 6px 18px;\r\n  background: transparent;\r\n  border: none;\r\n  color: var(--theme-color2);\r\n}\r\n\r\n.widget .category-list a {\r\n  display: block;\r\n  padding: 10px 0;\r\n  font-weight: 500;\r\n  border-bottom: 1px solid #ced4da;\r\n  transition: var(--transition);\r\n}\r\n\r\n.widget .category-list a:last-child {\r\n  margin-bottom: 0px;\r\n  border-bottom: none;\r\n}\r\n\r\n.widget .category-list a:hover {\r\n  padding-left: 10px;\r\n  color: var(--theme-color2);\r\n}\r\n\r\n.widget .category-list a i {\r\n  margin-right: 5px;\r\n  color: var(--theme-color2);\r\n}\r\n\r\n.widget .category-list a span {\r\n  float: right;\r\n}\r\n\r\n.widget .recent-post-single {\r\n  display: flex;\r\n  justify-content: start;\r\n  align-items: center;\r\n  margin-bottom: 20px;\r\n}\r\n\r\n.widget .recent-post-img {\r\n  margin-right: 20px;\r\n}\r\n\r\n.widget .recent-post-img img {\r\n  width: 120px;\r\n  border-radius: 10px;\r\n}\r\n\r\n.widget .recent-post-bio h6 {\r\n  font-size: 18px;\r\n  font-weight: 600;\r\n  text-transform: capitalize;\r\n}\r\n\r\n.widget .recent-post-bio span {\r\n  font-size: 14px;\r\n  color: var(--theme-color2);\r\n  font-weight: 500;\r\n}\r\n\r\n.widget .recent-post-bio span i {\r\n  margin-right: 5px;\r\n}\r\n\r\n.widget .recent-post-bio h6 a:hover {\r\n  color: var(--theme-color2);\r\n}\r\n\r\n.widget .social-share-link a {\r\n  width: 35px;\r\n  height: 35px;\r\n  line-height: 31px;\r\n  border: 2px solid var(--theme-color);\r\n  color: var(--theme-color);\r\n  text-align: center;\r\n  margin-right: 5px;\r\n  border-radius: 50px;\r\n  transition: var(--transition);\r\n}\r\n\r\n.widget .social-share-link a:hover {\r\n  background: var(--theme-color);\r\n  color: var(--color-white);\r\n}\r\n\r\n.widget .tag-list a {\r\n  background: var(--color-white);\r\n  color:  var(--color-dark);\r\n  padding: 5px 15px;\r\n  margin-bottom: 10px;\r\n  margin-right: 10px;\r\n  border-radius: 10px;\r\n  display: inline-block;\r\n  transition: var(--transition);\r\n}\r\n\r\n.widget .tag-list a:hover {\r\n  background-color: var(--theme-color2);\r\n  color: var(--color-white);\r\n}\r\n\r\n\r\n\r\n/*===================\r\n40. Contact us css \r\n=====================*/\r\n\r\n.contact-wrapper {\r\n  position: relative;\r\n  background: var(--color-white);\r\n  border-radius: 20px;\r\n  box-shadow: var(--box-shadow);\r\n  z-index: 1;\r\n}\r\n\r\n.contact-img{\r\n  position: relative;\r\n  padding-left: 20px;\r\n}\r\n\r\n.contact-img::before{\r\n  content: \"\";\r\n  position: absolute;\r\n  left: 0;\r\n  top: 0;\r\n  width: 50px;\r\n  height: 100%;\r\n  background: var(--theme-color);\r\n  border-radius: 20px 0 0 20px;\r\n  clip-path: polygon(100% 0, 20% 50%, 100% 100%, 0 100%, 0 0);\r\n  z-index: -1;\r\n}\r\n\r\n.contact-img img{\r\n  width: 100%;\r\n  clip-path: polygon(100% 0, 100% 100%, 10% 100%, 0 50%, 10% 0);\r\n}\r\n\r\n.contact-form{\r\n  padding: 25px 0 0 0;\r\n}\r\n\r\n.contact-form-header {\r\n  margin-bottom: 30px;\r\n}\r\n\r\n.contact-form-header h2 {\r\n  font-size: 30px;\r\n  font-weight: 700;\r\n  margin-bottom: 10px;\r\n  color:  var(--color-dark);\r\n}\r\n\r\n.contact-form .form-group {\r\n  margin-bottom: 25px;\r\n}\r\n\r\n.contact-form .form-group .form-control {\r\n  padding: 15px 20px;\r\n  border-radius: 12px;\r\n  box-shadow: none;\r\n  transition: var(--transition);\r\n}\r\n\r\n.contact-form .form-group .form-control:focus {\r\n  border-color: var(--theme-color2);\r\n}\r\n\r\n.contact-map {\r\n  margin-bottom: -9px;\r\n}\r\n\r\n.contact-map iframe {\r\n  width: 100%;\r\n  height: 450px;\r\n}\r\n\r\n.contact-content {\r\n  margin-bottom: 50px;\r\n}\r\n\r\n.contact-info {\r\n  display: flex;\r\n  flex-direction: column;\r\n  align-items: center;\r\n  text-align: center;\r\n  gap: 35px;\r\n  padding: 30px 20px;\r\n  position: relative;\r\n  margin-bottom: 25px;\r\n  border-radius: 50px 50px 50px 0;\r\n  background:var(--color-white);\r\n  box-shadow: var(--box-shadow);\r\n  transition: var(--transition);\r\n}\r\n\r\n.contact-info::before{\r\n  content: \"\";\r\n  position: absolute;\r\n  left: 20px;\r\n  right: 20px;\r\n  bottom: -8px;\r\n  background: var(--theme-color);\r\n  clip-path: polygon(20% 0%, 80% 0%, 100% 100%, 0% 100%);\r\n  height: 20px;\r\n  z-index: -1;\r\n}\r\n\r\n.contact-info-icon{\r\n  font-size: 35px;\r\n  color: var(--color-white);\r\n  width: 70px;\r\n  height: 70px;\r\n  line-height: 70px;\r\n  text-align: center;\r\n  position: relative;\r\n  border-radius: 30px;\r\n  background: var(--theme-color);\r\n}\r\n\r\n.contact-info-icon::before{\r\n  content: \"\";\r\n  position: absolute;\r\n  left: -15px;\r\n  right: -15px;\r\n  top: -15px;\r\n  bottom: -15px;\r\n  border: 3px solid var(--theme-color);\r\n  border-radius: 40px;\r\n}\r\n\r\n.contact-info h5 {\r\n  font-size: 20px;\r\n  font-weight: 600;\r\n  margin-bottom: 8px;\r\n  color:  var(--color-dark);\r\n}\r\n\r\n.contact-info p{\r\n  color:  var(--color-dark);\r\n  font-weight: 500;\r\n  font-size: 16px;\r\n}\r\n\r\n\r\n@media all and (max-width: 768px) {\r\n  .contact-content {\r\n    margin-bottom: 50px;\r\n  }\r\n}\r\n\r\n\r\n\r\n\r\n/*===================\r\n41. Team css \r\n=====================*/\r\n\r\n.team-area {\r\n  position: relative;\r\n  overflow: hidden;\r\n}\r\n\r\n.team-item {\r\n  position: relative;\r\n  background: var(--color-white);\r\n  padding: 15px;\r\n  margin-bottom: 25px;\r\n  border-radius: 60px 60px 60px 0;\r\n  overflow: hidden;\r\n  box-shadow: var(--box-shadow);\r\n  transition: var(--transition);\r\n}\r\n\r\n.team-item:hover {\r\n  transform: translateY(-10px);\r\n}\r\n\r\n.team-img img{\r\n  border-radius: 50px 50px 50px 0;\r\n}\r\n\r\n.team-content {\r\n  margin-top: 15px;\r\n  position: relative;\r\n}\r\n\r\n.team-bio h5 {\r\n  font-size: 22px;\r\n  margin-top: 5px;\r\n  margin-bottom: 5px;\r\n  text-transform: capitalize;\r\n}\r\n\r\n.team-bio span {\r\n  font-size: 13px;\r\n  font-weight: 500;\r\n  color: var(--theme-color);\r\n  text-transform: uppercase;\r\n  letter-spacing: 2px;\r\n}\r\n\r\n.team-bio h5 a:hover {\r\n  color:  var(--theme-color);\r\n}\r\n\r\n.team-social-btn {\r\n  position: absolute;\r\n  right: -5px;\r\n  bottom: 25px;\r\n  width: 45px;\r\n  height: 45px;\r\n  line-height: 45px;\r\n  padding-left: 12px;\r\n  border-radius: 50px 50px 0 50px;\r\n  cursor: pointer;\r\n  background: var(--theme-color);\r\n  color: var(--color-white);\r\n  transition: var(--transition);\r\n}\r\n\r\n.team-item:hover .team-social-btn{\r\n  background: var(--theme-color2);\r\n}\r\n\r\n.team-social {\r\n  position: absolute;\r\n  margin-bottom: 10px;\r\n  text-align: center;\r\n  top: 50px;\r\n  right: 0px;\r\n  bottom: 0;\r\n  opacity: 0;\r\n  transition: var(--transition);\r\n}\r\n\r\n.team-item:hover .team-social {\r\n  opacity: 1;\r\n  right: 30px;\r\n}\r\n\r\n.team-social a {\r\n  display: block;\r\n  color: var(--color-white);\r\n  width: 40px;\r\n  height: 40px;\r\n  line-height: 40px;\r\n  margin-bottom: 10px;\r\n  border-radius: 50px 50px 50px 0;\r\n  background: var(--theme-color2);\r\n  box-shadow: var(--box-shadow);\r\n  transition: var(--transition);\r\n}\r\n\r\n.team-social a:hover {\r\n  background:  var(--theme-color);\r\n  color: var(--color-white);\r\n}\r\n\r\n.team-area2 .team-item{\r\n  padding: 0px 30px 30px 30px;\r\n  background: transparent;\r\n  box-shadow: none;\r\n  overflow: unset;\r\n}\r\n\r\n.team-area2 .team-item::before{\r\n  content: \"\";\r\n  position: absolute;\r\n  left: 0;\r\n  bottom: 0;\r\n  width: 100%;\r\n  height: 80%;\r\n  border-radius: 15px;\r\n  background: var(--color-white);\r\n  box-shadow: var(--box-shadow) !important;\r\n  z-index: -1;\r\n}\r\n\r\n.team-area2 .team-img img{\r\n  border-radius: 50px 50px 50px 0;\r\n}\r\n\r\n.team-area2 .team-content{\r\n  margin-top: 30px;\r\n}\r\n\r\n.team-area2 .team-social-btn{\r\n  bottom: 39px;\r\n}\r\n\r\n.team-area2 .team-social-btn{\r\n  right: 0;\r\n}\r\n\r\n\r\n\r\n/* ===================\r\n42. Team single css \r\n====================== */\r\n\r\n.team-single-img img{\r\n  border-radius: 50px 50px 50px 0;\r\n}\r\n\r\n.team-details{\r\n  padding: 45px;\r\n  background: var(--theme-bg-light);\r\n  border-radius: 50px 50px 50px 0;\r\n}\r\n\r\n.team-details strong{\r\n  color: var(--theme-color2);\r\n}\r\n\r\n.team-details-info{\r\n  margin: 20px 0;\r\n}\r\n\r\n.team-details-info li{\r\n  margin-bottom: 10px;\r\n}\r\n\r\n.team-details-info a:hover{\r\n  color: var(--theme-color2);\r\n}\r\n\r\n.team-details-info a i{\r\n  margin-right: 10px;\r\n  color: var(--theme-color2);\r\n}\r\n\r\n.team-details-social a{\r\n  margin-right: 15px;\r\n  font-size: 20px;\r\n  color: var(--theme-color2);\r\n  display: inline-block;\r\n  transition: all .5s ease-in-out;\r\n}\r\n\r\n.team-details-social a:hover{\r\n  color: var(--theme-color);\r\n}\r\n\r\n.biography{\r\n  padding-right: 20px;\r\n  margin-bottom: 30px;\r\n}\r\n\r\n.team-skill .progress-box h5{\r\n  color: var(--color-dark)\r\n}\r\n\r\n.team-skill .pull-right{\r\n  color: var(--theme-color2);\r\n}\r\n\r\n.team-skill .progress-box .progress{\r\n  background: var(--theme-bg-light);\r\n}\r\n\r\n\r\n\r\n/*====================\r\n43. Video css \r\n======================*/\r\n\r\n.video-content {\r\n  position: relative;\r\n  background-repeat: no-repeat;\r\n  background-position: center;\r\n  background-size: cover;\r\n  border-radius: 80px 80px 80px 0;\r\n}\r\n\r\n.video-content::before {\r\n  content: \"\";\r\n  position: absolute;\r\n  background: rgba(3, 2, 7, .2);\r\n  border-radius: 80px 80px 80px 0;\r\n  width: 100%;\r\n  height: 100%;\r\n  left: 0;\r\n  top: 0;\r\n}\r\n\r\n.video-wrapper {\r\n  position: relative;\r\n  display: flex;\r\n  justify-content: center;\r\n  border-radius: 5px;\r\n  height: 350px;\r\n  z-index: 100;\r\n}\r\n\r\n.video-wrapper img {\r\n  border-radius: 12px;\r\n}\r\n\r\n.video-area .play-btn {\r\n  display: inline-block;\r\n  padding: 0;\r\n  height: 75px;\r\n  width: 75px;\r\n  text-align: center;\r\n  position: absolute;\r\n  border-radius: 50%;\r\n  top: 50%;\r\n  left: 50%;\r\n  transform: translate(-50%, -50%);\r\n}\r\n\r\n@media all and (max-width: 767px) {\r\n  .video-wrapper {\r\n    height: 250px;\r\n  }\r\n}\r\n\r\n\r\n\r\n/*===================\r\n44. Pricing css \r\n=====================*/\r\n\r\n.pricing-area{\r\n  position: relative;\r\n}\r\n\r\n.pricing-item{\r\n  position: relative;\r\n  padding: 20px 40px;\r\n  text-align: center;\r\n  border-radius: 50px 50px 50px 0;\r\n  background: var(--color-white);\r\n  margin-bottom: 25px;\r\n}\r\n\r\n.pricing-item::before{\r\n  content: \"\";\r\n  position: absolute;\r\n  left: 50px;\r\n  right: 50px;\r\n  top: -5px;\r\n  height: 5px;\r\n  border-radius: 10px 10px 0 0;\r\n  background: var(--theme-color);\r\n}\r\n\r\n.pricing-icon{\r\n  width: 100px;\r\n  height: 100px;\r\n  line-height: 90px;\r\n  background: var(--theme-color2);\r\n  margin: 20px auto 0 auto;\r\n  position: relative;\r\n  border-radius: 50%;\r\n  color: var(--color-white);\r\n  font-size: 70px;\r\n}\r\n\r\n.pricing-icon img{\r\n  width: 60px;\r\n  filter: brightness(0) invert(1);\r\n}\r\n\r\n.pricing-icon::before{\r\n  content: \"\";\r\n  position: absolute;\r\n  left: -8px;\r\n  right: -8px;\r\n  top: -8px;\r\n  bottom: -8px;\r\n  border-radius: 50%;\r\n  border: 3px solid var(--theme-color2);\r\n}\r\n\r\n.pricing-header-content{\r\n  margin: 30px 0 20px 0;\r\n}\r\n\r\n.pricing-header-content h4{\r\n  margin-bottom: 20px;\r\n  color: var(--theme-color2);\r\n  font-size: 30px;\r\n}\r\n\r\n.pricing-duration{\r\n  color: var(--theme-color2);\r\n  font-size: 16px;\r\n}\r\n\r\n.pricing-amount{\r\n  font-size: 60px;\r\n  color: var(--theme-color);\r\n}\r\n\r\n.pricing-feature ul{\r\n  padding-top: 10px;\r\n  margin-bottom: 25px;\r\n  text-align: left;\r\n  border-top: 1px solid var(--border-info-color);\r\n}\r\n\r\n.pricing-feature ul li{\r\n  position: relative;\r\n  margin: 10px 0;\r\n  padding-left: 25px;\r\n}\r\n\r\n.pricing-feature ul li::before{\r\n  content: \"\\f560\";\r\n  position: absolute;\r\n  font-family: \"Font Awesome 6 Pro\";\r\n  color: var(--theme-color);\r\n  left: 0;\r\n  top: 0;\r\n}\r\n\r\n.pricing-feature .theme-btn{\r\n  width: 100%;\r\n}\r\n\r\n.pricing-item.active{\r\n  background: var(--theme-color);\r\n}\r\n\r\n.pricing-item.active::before{\r\n  background: var(--theme-color2);\r\n}\r\n\r\n.pricing-item.active .pricing-amount{\r\n  color: var(--color-white);\r\n}\r\n\r\n.pricing-item.active ul li{\r\n  color: var(--color-white);\r\n}\r\n\r\n.pricing-item.active ul li::before{\r\n  color: var(--color-white);\r\n}\r\n\r\n.pricing-item.active .theme-btn{\r\n  background: var(--theme-color2);\r\n}\r\n\r\n.pricing-item.active .theme-btn:hover{\r\n  color: var(--theme-color);\r\n}\r\n\r\n.pricing-item.active .theme-btn::before{\r\n  background: var(--color-white);\r\n}\r\n\r\n\r\n\r\n\r\n/*====================\r\n45. Faq css \r\n======================*/\r\n\r\n.faq-area .accordion-item {\r\n  border: none;\r\n  margin-bottom: 30px;\r\n  background: var(--color-white);\r\n  border-radius: 30px 30px 30px 0 !important;\r\n  box-shadow: var(--box-shadow);\r\n}\r\n\r\n.faq-area .accordion-item span {\r\n  width: 45px;\r\n  height: 45px;\r\n  margin-right: 15px;\r\n}\r\n\r\n.faq-area .accordion-item i {\r\n  width: 45px;\r\n  height: 45px;\r\n  line-height: 45px;\r\n  border-radius: 50px;\r\n  background: var(--theme-color);\r\n  text-align: center;\r\n  color: var(--color-white);\r\n}\r\n\r\n.faq-area .accordion-button:not(.collapsed) {\r\n  color: var(--theme-color);\r\n  background: transparent;\r\n  box-shadow: inset 0 -1px 0 rgb(0 0 0 / 13%);\r\n}\r\n\r\n.accordion-button {\r\n  border-radius: 0px !important;\r\n  background: transparent;\r\n  font-weight: 600;\r\n  font-size: 20px;\r\n  color:  var(--color-dark);\r\n  box-shadow: none !important;\r\n}\r\n\r\n.accordion-button:not(.collapsed) {\r\n  border-bottom: 1px solid var(--theme-color);\r\n}\r\n\r\n/* .accordion-button:not(.collapsed)::after {\r\n  background-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='%23212529'%3e%3cpath fill-rule='evenodd' d='M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z'/%3e%3c/svg%3e\");\r\n} */\r\n\r\n@media all and (max-width: 991px) {\r\n  .faq-right {\r\n    margin-bottom: 50px;\r\n  }\r\n\r\n  .accordion-button {\r\n    font-size: 16px;\r\n  }\r\n}\r\n\r\n\r\n\r\n/*====================\r\n46. Breadcrumb css\r\n======================*/\r\n\r\n.site-breadcrumb {\r\n  display: flex;\r\n  flex-direction: column;\r\n  align-items: center;\r\n  justify-content: center;\r\n  text-align: center;\r\n  background-repeat: no-repeat !important;\r\n  background-position: center !important;\r\n  background-size: cover !important;\r\n  position: relative;\r\n  padding-top: 170px;\r\n  padding-bottom: 150px;\r\n  z-index: 1;\r\n}\r\n\r\n.site-breadcrumb::before {\r\n  content: \"\";\r\n  position: absolute;\r\n  height: 100%;\r\n  width: 100%;\r\n  top: 0;\r\n  left: 0;\r\n  background: var(--hero-overlay-color);\r\n  opacity: 0.65;\r\n  z-index: -1;\r\n}\r\n\r\n.site-breadcrumb .breadcrumb-title {\r\n  font-size: 45px;\r\n  color: var(--color-white);\r\n  font-weight: 700;\r\n  margin-bottom: 10px;\r\n  text-transform: capitalize;\r\n}\r\n\r\n.site-breadcrumb .breadcrumb-menu {\r\n  position: relative;\r\n  z-index: 1;\r\n}\r\n\r\n.site-breadcrumb .breadcrumb-menu li {\r\n  position: relative;\r\n  display: inline-block;\r\n  margin-left: 25px;\r\n  color: var(--color-white);\r\n  font-weight: 500;\r\n  text-transform: capitalize;\r\n}\r\n\r\n.site-breadcrumb .breadcrumb-menu li a {\r\n  color: var(--color-white);\r\n  transition: all 0.5s ease-in-out;\r\n}\r\n\r\n.site-breadcrumb .breadcrumb-menu li::before {\r\n  position: absolute;\r\n  content: '\\f101';\r\n  font-family: 'Font Awesome 6 Pro';\r\n  right: -21px;\r\n  top: 1px;\r\n  text-align: center;\r\n  font-size: 16px;\r\n  color: var(--color-white);\r\n}\r\n\r\n.site-breadcrumb .breadcrumb-menu li:first-child {\r\n  margin-left: 0;\r\n}\r\n\r\n.site-breadcrumb .breadcrumb-menu li:last-child:before {\r\n  display: none;\r\n}\r\n\r\n.site-breadcrumb .breadcrumb-menu li a:hover {\r\n  color: var(--theme-color);\r\n}\r\n\r\n.site-breadcrumb .breadcrumb-menu li.active {\r\n  color: var(--theme-color2);\r\n}\r\n.mobile_list{\r\n  display:none;\r\n}\r\n\r\n@media (max-width: 991px) {\r\n  .site-breadcrumb {\r\n    padding-top: 230px;\r\n  }\r\n  .mobile_list{\r\n    display: block;\r\n    margin: 10px;;\r\n  }\r\n  .mobile_view{\r\n    right: auto !important;\r\n  }\r\n}\r\n\r\n\r\n\r\n\r\n/*====================\r\n47. Pagination css \r\n======================*/\r\n\r\n.pagination {\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n  margin-top: 40px;\r\n}\r\n\r\n.pagination .page-link {\r\n  border: none;\r\n  background:  var(--theme-color2);\r\n  color: var(--color-white);\r\n  margin: 0 10px;\r\n  border-radius: 12px !important;\r\n  width: 40px;\r\n  height: 40px;\r\n  line-height: 28px;\r\n  text-align: center;\r\n  transition: var(--transition);\r\n}\r\n\r\n.pagination .page-link:hover,\r\n.pagination .page-item.active .page-link {\r\n  background: var(--theme-color);\r\n  color: var(--color-white);\r\n}\r\n\r\n\r\n\r\n\r\n/*====================\r\n48. Auth css \r\n======================*/\r\n\r\n.login-form {\r\n  position: relative;\r\n  padding: 40px;\r\n  border-radius: 50px 50px 50px 0;\r\n  background: var(--color-white);\r\n  box-shadow: var(--box-shadow);\r\n}\r\n\r\n.login-form::before{\r\n  content: \"\";\r\n  position: absolute;\r\n  left: 0;\r\n  top: 50px;\r\n  bottom: 50px;\r\n  width: 4px;\r\n  background: var(--theme-color);\r\n}\r\n\r\n.login-form .login-header {\r\n  text-align: center;\r\n  margin-bottom: 20px;\r\n  padding-bottom: 20px;\r\n  border-bottom: 1px solid var(--border-info-color);\r\n}\r\n\r\n.login-form .login-header img {\r\n  width: 200px;\r\n  margin-bottom: 10px;\r\n}\r\n\r\n.login-form .login-header h3 {\r\n  color: var(--theme-color);\r\n  margin-bottom: 5px;\r\n  font-weight: 800;\r\n}\r\n\r\n.login-form .login-header p {\r\n  font-size: 20px;\r\n}\r\n\r\n.login-form .login-footer {\r\n  margin-top: 25px;\r\n}\r\n\r\n.login-form .login-footer p {\r\n  text-align: center;\r\n}\r\n\r\n.login-form .login-footer a {\r\n  color: var(--theme-color);\r\n  transition: .5s;\r\n}\r\n\r\n.login-form .login-footer a:hover {\r\n  color:  var(--theme-color2);\r\n}\r\n\r\n.login-form .form-group {\r\n  margin-bottom: 20px;\r\n}\r\n\r\n.login-form label {\r\n  color:  var(--color-dark);\r\n  margin-bottom: 5px;\r\n}\r\n\r\n.login-form .form-group .form-control {\r\n  border: 1px solid #e8e8e8;\r\n  border-radius: 8px;\r\n  padding: 12px 18px;\r\n  box-shadow: none;\r\n  transition: .5s;\r\n}\r\n\r\n.login-form .form-group .form-control:focus {\r\n  border-color: var(--theme-color);\r\n}\r\n\r\n.login-form .form-check-input {\r\n  box-shadow: none;\r\n}\r\n\r\n.login-form .form-check-input:focus{\r\n  border-color: var(--theme-color);\r\n}\r\n\r\n.login-form .forgot-pass {\r\n  color: var(--theme-color);\r\n  transition: .5s;\r\n}\r\n\r\n.login-form .forgot-pass:hover {\r\n  color:  var(--theme-color2);\r\n}\r\n\r\n.login-form .theme-btn {\r\n  width: 100%;\r\n}\r\n\r\n.login-form .theme-btn::before{\r\n  width: 420px;\r\n  height: 420px;\r\n}\r\n\r\n.login-form .theme-btn i {\r\n  margin-right: 5px;\r\n}\r\n\r\n.login-form .form-check-input {\r\n  margin-top: 6.3px;\r\n}\r\n\r\n.login-form .form-check-label a {\r\n  color: var(--theme-color);\r\n  transition: .5s;\r\n}\r\n\r\n.login-form .form-check-label a:hover {\r\n  color: var(--theme-color);\r\n}\r\n\r\n.form-check-input:checked {\r\n  background-color: var(--theme-color);\r\n  border-color: var(--theme-color);\r\n}\r\n\r\n.social-login {\r\n  border-top: 1px solid #F1F1F1;\r\n  margin-top: 15px;\r\n}\r\n\r\n.social-login p {\r\n  margin: 10px 0;\r\n}\r\n\r\n.social-login-list {\r\n  text-align: center;\r\n}\r\n\r\n.social-login-list a {\r\n  width: 40px;\r\n  height: 40px;\r\n  line-height: 40px;\r\n  background: var(--theme-color);\r\n  border-radius: 50px;\r\n  margin: 5px;\r\n}\r\n\r\n.social-login-list a i {\r\n  color: var(--color-white);\r\n}\r\n\r\n.social-login-list a:hover {\r\n  background:  var(--color-dark);\r\n}\r\n\r\n\r\n@media only screen and (max-width: 991px) {\r\n  .login-form {\r\n    padding: 40px 20px;\r\n  }\r\n}\r\n\r\n\r\n\r\n/*====================\r\n49. Coming soon css \r\n======================*/\r\n\r\n.coming-soon {\r\n  background-repeat: no-repeat;\r\n  background-size: cover !important;\r\n  background-position: center !important;\r\n  min-height: 100vh;\r\n  width: 100%;\r\n  top: 0;\r\n  left: 0;\r\n  position: relative;\r\n}\r\n\r\n.coming-soon .container {\r\n  position: relative;\r\n}\r\n\r\n.coming-soon:before {\r\n  position: absolute;\r\n  content: '';\r\n  background: rgba(0, 0, 0, .7);\r\n  width: 100%;\r\n  height: 100%;\r\n  top: 0;\r\n  left: 0;\r\n}\r\n\r\n.coming-soon .newsletter-form {\r\n  position: relative;\r\n  margin-top: 30px;\r\n}\r\n\r\n.coming-soon .newsletter-form .input-newsletter {\r\n  height: 55px;\r\n  display: block;\r\n  width: 100%;\r\n  border: none;\r\n  border-radius: 10px;\r\n  font-size: 14px;\r\n  padding-top: 0;\r\n  padding-right: 0;\r\n  padding-bottom: 0;\r\n  padding-left: 25px;\r\n}\r\n\r\n.coming-soon .newsletter-form button {\r\n  position: absolute;\r\n  right: 4px;\r\n  top: 4px;\r\n  bottom: 4px;\r\n  height: auto;\r\n  border: none;\r\n  border-radius: 10px;\r\n  background: var(--theme-color2);\r\n  display: inline-block;\r\n  color: var(--color-white);\r\n  padding-left: 30px;\r\n  padding-right: 30px;\r\n  font-weight: 500;\r\n  transition: .5s;\r\n}\r\n\r\n.coming-soon .newsletter-form button:hover {\r\n  background-color: var(--theme-color);\r\n  color: var(--color-white);\r\n}\r\n\r\n.coming-social {\r\n  margin-top: 30px;\r\n  text-align: center;\r\n}\r\n\r\n.coming-social a {\r\n  color: var(--color-white);\r\n  margin: 5px;\r\n  width: 40px;\r\n  height: 40px;\r\n  line-height: 36px;\r\n  text-align: center;\r\n  border-radius: 50px;\r\n  border: 2px solid var(--color-white);\r\n  display: inline-block;\r\n  transition: .5s;\r\n}\r\n\r\n.coming-social a:hover {\r\n  background: var(--theme-color);\r\n  border-color: var(--theme-color);\r\n}\r\n\r\n.countdown-wrap {\r\n  margin-top: 30px;\r\n}\r\n\r\n.countdown-single {\r\n  background: var(--theme-color2);\r\n  padding: 20px;\r\n  margin: 10px;\r\n  position: relative;\r\n  overflow: hidden;\r\n  border-radius: 50px 50px 50px 0;\r\n  box-shadow: var(--box-shadow);\r\n}\r\n\r\n.countdown-single h2 {\r\n  color: var(--color-white);\r\n}\r\n\r\n.countdown-single h5 {\r\n  color: var(--color-white);\r\n}\r\n\r\n\r\n\r\n\r\n/*====================\r\n50. Error css \r\n======================*/\r\n\r\n.error-wrapper {\r\n  text-align: center;\r\n}\r\n\r\n.error-wrapper h1 {\r\n  font-size: 250px;\r\n  letter-spacing: 5px;\r\n  font-weight: bold;\r\n  color: var(--theme-color);\r\n}\r\n\r\n.error-wrapper h1 span {\r\n  color:  var(--color-dark);\r\n}\r\n\r\n.error-wrapper h2 {\r\n  margin-top: 30px;\r\n  margin-bottom: 10px;\r\n}\r\n\r\n.error-wrapper img {\r\n  width: 100%;\r\n}\r\n\r\n.error-wrapper .theme-btn {\r\n  margin-top: 30px;\r\n}\r\n\r\n\r\n@media all and (max-width: 767px) {\r\n  .error-wrapper h1 {\r\n    font-size: 160px;\r\n  }\r\n}\r\n\r\n\r\n\r\n\r\n/*====================\r\n51. Terms/privacy css \r\n====================== */\r\n\r\n.terms-content:not(:last-child) {\r\n  margin-bottom: 54px;\r\n}\r\n\r\n.terms-content:first-child {\r\n  margin-top: -3px;\r\n}\r\n\r\n.terms-content .terms-list {\r\n  margin-top: 37px;\r\n}\r\n\r\n.terms-content h3 {\r\n  margin-bottom: 23px;\r\n  position: relative;\r\n}\r\n\r\n.terms-content p:not(:last-child) {\r\n  margin-bottom: 26px;\r\n}\r\n\r\n.terms-list li:not(:last-child) {\r\n  margin-bottom: 16px;\r\n}\r\n\r\n\r\n\r\n/*====================\r\n52. How Apply\r\n======================*/\r\n\r\n.how-apply{\r\n  position: relative;\r\n}\r\n\r\n.how-apply .content-img{\r\n  margin-left: 30px;\r\n  position: relative;\r\n  z-index: 1;\r\n}\r\n\r\n.how-apply .content-img::before{\r\n  content: \"\";\r\n  position: absolute;\r\n  left: 0;\r\n  bottom: 0;\r\n  width: 100%;\r\n  height: 100%;\r\n  background: var(--theme-color);\r\n  border-radius: 100px 100px 100px 0;\r\n  transform: rotate(-8deg);\r\n  z-index: -1;\r\n}\r\n\r\n.how-apply .content-img img{\r\n  border-radius: 100px 100px 100px 0;\r\n  width: 100%;\r\n}\r\n\r\n.how-apply .content-list li{\r\n  margin-top: 8px;\r\n}\r\n\r\n.how-apply .content-list i{\r\n  color: var(--theme-color);\r\n  margin-right: 8px;\r\n}\r\n\r\n.how-apply .content-btn{\r\n  margin-top: 40px;\r\n}\r\n\r\n.apply-details .details-wrapper{\r\n  border-top: 1px solid var(--border-info-color);\r\n  padding-top: 60px;\r\n}\r\n\r\n.apply-details .content-list li{\r\n  margin-top: 8px;\r\n}\r\n\r\n.apply-details .content-list i{\r\n  color: var(--theme-color);\r\n  margin-right: 8px;\r\n}\r\n\r\n@media all and (max-width: 991px) {\r\n  .how-apply .content-img{\r\n    margin-left: 0px;\r\n  }\r\n\r\n  .how-apply .content-info{\r\n    margin-bottom: 70px;\r\n  }\r\n\r\n  .apply-details .details-left{\r\n    margin-bottom: 40px;\r\n  }\r\n}\r\n\r\n\r\n\r\n/*====================\r\n53. Application css \r\n======================*/\r\n\r\n.application{\r\n  position: relative;\r\n}\r\n\r\n.application-form{\r\n  padding: 40px;\r\n  border-radius: 10px;\r\n  background: var(--color-white);\r\n  box-shadow: var(--box-shadow);\r\n}\r\n\r\n.application-form h3{\r\n  padding-bottom: 15px;\r\n  margin-bottom: 30px;\r\n  border-bottom: 1px solid var(--border-info-color);\r\n}\r\n\r\n.application-form .form-group{\r\n  margin-bottom: 18px;\r\n}\r\n\r\n.application-form .form-group label{\r\n  color: #212536;\r\n  margin-bottom: 5px;\r\n}\r\n\r\n.application-form .form-control,\r\n.application-form .form-select{\r\n  padding: 12px 18px;\r\n  border-radius: 8px;\r\n  box-shadow: none;\r\n}\r\n\r\n.application-form .form-control:focus,\r\n.application-form .form-select:focus{\r\n  border-color: var(--theme-color);\r\n}\r\n\r\n.application-form .form-check-input{\r\n  margin-top: 6.5px;\r\n  box-shadow: none;\r\n}\r\n\r\n.application-form .form-check-input:focus{\r\n  border-color: var(--theme-color);\r\n}\r\n\r\n.application-form .form-check a{\r\n  color: var(--theme-color);\r\n}\r\n\r\n.application-form .form-check label{\r\n  color: #212536;\r\n  font-weight: 500;\r\n}\r\n\r\n.application-form .theme-btn{\r\n  margin-top: 30px;\r\n}\r\n\r\n\r\n\r\n/*====================\r\n54. Campus tour css \r\n======================*/\r\n\r\n.campus-tour{\r\n  position: relative;\r\n}\r\n\r\n.campus-tour .content-img{\r\n  margin-left: 30px;\r\n  position: relative;\r\n  z-index: 1;\r\n}\r\n\r\n.campus-tour .content-img::before{\r\n  content: \"\";\r\n  position: absolute;\r\n  left: 0;\r\n  bottom: 0;\r\n  width: 100%;\r\n  height: 100%;\r\n  background: var(--theme-color);\r\n  border-radius: 50px 50px 50px 0;\r\n  transform: rotate(-8deg);\r\n  z-index: -1;\r\n}\r\n\r\n.campus-tour .content-img img{\r\n  border-radius: 100px 100px 100px 0;\r\n  width: 100%;\r\n}\r\n\r\n.campus-tour .content-btn{\r\n  margin-top: 40px;\r\n}\r\n\r\n.tour-details .details-wrapper{\r\n  border-top: 1px solid var(--border-info-color);\r\n  padding-top: 60px;\r\n}\r\n\r\n.tour-details .content-list li{\r\n  margin-top: 8px;\r\n}\r\n\r\n.tour-details .content-list i{\r\n  color: var(--theme-color);\r\n  margin-right: 8px;\r\n}\r\n\r\n@media all and (max-width: 991px) {\r\n  .campus-tour .content-img{\r\n    margin-left: 0px;\r\n  }\r\n\r\n  .campus-tour .content-info{\r\n    margin-bottom: 70px;\r\n  }\r\n\r\n  .tour-details .details-left{\r\n    margin-bottom: 40px;\r\n  }\r\n}\r\n\r\n\r\n\r\n\r\n/*====================\r\n55. Campus life css \r\n======================*/\r\n\r\n.campus-life{\r\n  position: relative;\r\n}\r\n\r\n.campus-life .content-img{\r\n  margin-right: 30px;\r\n  position: relative;\r\n  z-index: 1;\r\n}\r\n\r\n.campus-life .content-img::before{\r\n  content: \"\";\r\n  position: absolute;\r\n  left: -30px;\r\n  top: -30px;\r\n  bottom: -30px;\r\n  width: 80%;\r\n  border: 7px solid var(--theme-color2);\r\n  border-radius: 100px 100px 100px 0;\r\n  z-index: -1;\r\n}\r\n\r\n.campus-life .content-img img{\r\n  border-radius: 90px 90px 90px 0;\r\n  width: 100%;\r\n}\r\n\r\n.campus-life .content-btn{\r\n  margin-top: 40px;\r\n}\r\n\r\n.campus-life-details .details-wrapper{\r\n  border-top: 1px solid var(--border-info-color);\r\n  padding-top: 60px;\r\n}\r\n\r\n.campus-life-details .content-list li{\r\n  margin-top: 8px;\r\n}\r\n\r\n.campus-life-details .content-list i{\r\n  color: var(--theme-color);\r\n  margin-right: 8px;\r\n}\r\n\r\n.campus-life-details .details-item{\r\n  margin-bottom: 40px;\r\n}\r\n\r\n.campus-life-details .details-item img{\r\n  border-radius: 20px;\r\n}\r\n\r\n@media all and (max-width: 991px) {\r\n  .campus-life .content-info{\r\n    margin-top: 70px;\r\n  }\r\n}\r\n\r\n\r\n/*====================\r\n56. Notice board css \r\n======================*/\r\n\r\n.notice-board{\r\n  position: relative;\r\n}\r\n\r\n.notice-item{\r\n  padding: 25px 25px;\r\n  border-radius: 50px 50px 50px 0;\r\n  margin-bottom: 25px;\r\n  border: 2px solid transparent;\r\n  background: var(--theme-bg-light);\r\n  transition: var(--transition);\r\n}\r\n\r\n.notice-item:hover{\r\n  border-color: var(--theme-color);\r\n}\r\n\r\n.notice-item h4:hover{\r\n  color: var(--theme-color);\r\n}\r\n\r\n.notice-meta{\r\n  display: flex;\r\n  justify-content: space-between;\r\n  flex-wrap: wrap;\r\n  margin-top: 15px;\r\n}\r\n\r\n.notice-meta i{\r\n  color: var(--theme-color);\r\n}\r\n\r\n\r\n\r\n/*====================\r\n57. Student Activity css \r\n======================*/\r\n\r\n.activity{\r\n  position: relative;\r\n}\r\n\r\n.activity .content-img{\r\n  margin-left: 30px;\r\n  position: relative;\r\n  z-index: 1;\r\n}\r\n\r\n.activity .content-img::before{\r\n  content: \"\";\r\n  position: absolute;\r\n  left: -30px;\r\n  top: -30px;\r\n  bottom: -30px;\r\n  width: 80%;\r\n  border: 7px solid var(--theme-color2);\r\n  border-radius: 100px 100px 100px 0;\r\n  z-index: -1;\r\n}\r\n\r\n.activity .content-img img{\r\n  border-radius: 90px 90px 90px 0;\r\n  width: 100%;\r\n}\r\n\r\n.activity .content-btn{\r\n  margin-top: 40px;\r\n}\r\n\r\n.activity-details .details-wrapper{\r\n  border-top: 1px solid var(--border-info-color);\r\n  padding-top: 60px;\r\n}\r\n\r\n.activity-details .content-list li{\r\n  margin-top: 8px;\r\n}\r\n\r\n.activity-details .content-list i{\r\n  color: var(--theme-color);\r\n  margin-right: 8px;\r\n}\r\n\r\n.activity-details .details-item{\r\n  margin-bottom: 40px;\r\n}\r\n\r\n.activity-details .details-item img{\r\n  border-radius: 20px;\r\n}\r\n\r\n@media all and (max-width: 991px) {\r\n  .activity .content-info{\r\n    margin-bottom: 70px;\r\n  }\r\n}\r\n\r\n\r\n\r\n/*====================\r\n58. Facility css \r\n======================*/\r\n\r\n.facility-area {\r\n  position: relative;\r\n  display: block;\r\n  overflow: hidden;\r\n}\r\n\r\n.facility-item {\r\n  position: relative;\r\n  margin-bottom: 25px;\r\n  border-radius: 50px 50px 50px 0;\r\n  background: var(--color-white);\r\n  transition: var(--transition);\r\n  box-shadow: var(--box-shadow);\r\n  z-index: 1;\r\n}\r\n\r\n.facility-item:hover {\r\n  transform: translateY(-10px);\r\n}\r\n\r\n.facility-img {\r\n  position: relative;\r\n  z-index: 1;\r\n}\r\n\r\n.facility-img img{\r\n  border-radius: 50px 50px 50px 0;\r\n}\r\n\r\n.facility-content {\r\n  position: relative;\r\n  padding: 20px 20px 15px 20px;\r\n}\r\n\r\n.facility-arrow {\r\n  margin-top: 25px;\r\n}\r\n\r\n.facility-title a {\r\n  font-size: 22px;\r\n  font-weight: 600;\r\n  margin-bottom: 10px;\r\n  color:  var(--color-dark);\r\n}\r\n\r\n.facility-title a:hover {\r\n  color: var(--theme-color);\r\n}\r\n\r\n.facility-arrow .theme-btn{\r\n  padding: 12px 22px;\r\n}\r\n\r\n\r\n\r\n\r\n/*==================\r\n59. Facility single\r\n====================*/\r\n\r\n.facility-details img{\r\n  border-radius: 20px;\r\n}\r\n\r\n.facility-single-list i {\r\n  color: var(--theme-color2);\r\n  margin-right: 10px;\r\n}\r\n\r\n.facility-download a {\r\n  border: 2px solid var(--theme-color2);\r\n  padding: 12px 20px;\r\n  color:  var(--color-dark);\r\n  display: block;\r\n  margin-bottom: 20px;\r\n  border-radius: 50px 50px 50px 0;\r\n  font-weight: 600;\r\n  transition: var(--transition);\r\n}\r\n\r\n.facility-download a i {\r\n  margin-right: 10px;\r\n}\r\n\r\n.facility-download a:hover {\r\n  background-color: var(--theme-color2);\r\n  color: var(--color-white);\r\n}\r\n\r\n.facility-details h3 {\r\n  color: var(--color-dark);\r\n}\r\n\r\n\r\n\r\n\r\n/*====================\r\n60. Research css \r\n======================*/\r\n\r\n.research-area {\r\n  position: relative;\r\n  display: block;\r\n  overflow: hidden;\r\n}\r\n\r\n.research-item {\r\n  position: relative;\r\n  margin-bottom: 25px;\r\n  border-radius: 50px 50px 50px 0;\r\n  padding: 20px 20px 15px 20px;\r\n  background: var(--color-white);\r\n  transition: var(--transition);\r\n  box-shadow: var(--box-shadow);\r\n  z-index: 1;\r\n}\r\n\r\n.research-item:hover {\r\n  transform: translateY(-10px);\r\n}\r\n\r\n.research-img {\r\n  position: relative;\r\n  z-index: 1;\r\n}\r\n\r\n.research-img img{\r\n  border-radius: 40px 40px 40px 0;\r\n}\r\n\r\n.research-content {\r\n  position: relative;\r\n  margin-top: 15px;\r\n}\r\n\r\n.research-arrow {\r\n  margin-top: 25px;\r\n}\r\n\r\n.research-title a {\r\n  font-size: 22px;\r\n  font-weight: 600;\r\n  margin-bottom: 10px;\r\n  color:  var(--color-dark);\r\n}\r\n\r\n.research-title a:hover {\r\n  color: var(--theme-color);\r\n}\r\n\r\n.research-arrow .theme-btn{\r\n  padding: 12px 22px;\r\n}\r\n\r\n\r\n\r\n\r\n/*==================\r\n61. Research single\r\n====================*/\r\n\r\n.research-details img{\r\n  border-radius: 20px;\r\n}\r\n\r\n.research-single-list i {\r\n  color: var(--theme-color2);\r\n  margin-right: 10px;\r\n}\r\n\r\n.research-download a {\r\n  border: 2px solid var(--theme-color2);\r\n  padding: 12px 20px;\r\n  color:  var(--color-dark);\r\n  display: block;\r\n  margin-bottom: 20px;\r\n  border-radius: 50px 50px 50px 0;\r\n  font-weight: 600;\r\n  transition: var(--transition);\r\n}\r\n\r\n.research-download a i {\r\n  margin-right: 10px;\r\n}\r\n\r\n.research-download a:hover {\r\n  background-color: var(--theme-color2);\r\n  color: var(--color-white);\r\n}\r\n\r\n.research-details h3 {\r\n  color: var(--color-dark);\r\n}\r\n\r\n\r\n\r\n/*====================\r\n62. Club css \r\n======================*/\r\n\r\n.club-area {\r\n  position: relative;\r\n  display: block;\r\n  overflow: hidden;\r\n}\r\n\r\n.club-item {\r\n  position: relative;\r\n  margin-bottom: 25px;\r\n  border-radius: 50px 50px 50px 0;\r\n  padding: 20px 20px 15px 20px;\r\n  background: var(--color-white);\r\n  transition: var(--transition);\r\n  box-shadow: var(--box-shadow);\r\n  z-index: 1;\r\n}\r\n\r\n.club-item:hover {\r\n  transform: translateY(-10px);\r\n}\r\n\r\n.club-img {\r\n  position: relative;\r\n  z-index: 1;\r\n}\r\n\r\n.club-img img{\r\n  border-radius: 40px 40px 40px 0;\r\n}\r\n\r\n.club-content {\r\n  position: relative;\r\n  margin-top: 15px;\r\n}\r\n\r\n.club-arrow {\r\n  margin-top: 25px;\r\n}\r\n\r\n.club-title a {\r\n  font-size: 22px;\r\n  font-weight: 600;\r\n  margin-bottom: 10px;\r\n  color:  var(--color-dark);\r\n}\r\n\r\n.club-title a:hover {\r\n  color: var(--theme-color);\r\n}\r\n\r\n.club-arrow .theme-btn{\r\n  padding: 12px 22px;\r\n}\r\n\r\n\r\n\r\n\r\n/*==================\r\n63. Club single\r\n====================*/\r\n\r\n.club-details img{\r\n  border-radius: 20px;\r\n}\r\n\r\n.club-single-list i {\r\n  color: var(--theme-color2);\r\n  margin-right: 10px;\r\n}\r\n\r\n.club-download a {\r\n  border: 2px solid var(--theme-color2);\r\n  padding: 12px 20px;\r\n  color:  var(--color-dark);\r\n  display: block;\r\n  margin-bottom: 20px;\r\n  border-radius: 50px 50px 50px 0;\r\n  font-weight: 600;\r\n  transition: var(--transition);\r\n}\r\n\r\n.club-download a i {\r\n  margin-right: 10px;\r\n}\r\n\r\n.club-download a:hover {\r\n  background-color: var(--theme-color2);\r\n  color: var(--color-white);\r\n}\r\n\r\n.club-details h3 {\r\n  color: var(--color-dark);\r\n}\r\n\r\n\r\n\r\n/*====================\r\n64. Tuition fee css \r\n======================*/\r\n\r\n.tuition-fee{\r\n  position: relative;\r\n}\r\n\r\n\r\n\r\n/*====================\r\n65. Alumni css \r\n======================*/\r\n\r\n.alumni{\r\n  position: relative;\r\n}\r\n\r\n.alumni .content-img{\r\n  margin-right: 30px;\r\n  position: relative;\r\n  z-index: 1;\r\n}\r\n\r\n.alumni .content-img::before{\r\n  content: \"\";\r\n  position: absolute;\r\n  left: 30px;\r\n  top: -30px;\r\n  bottom: -30px;\r\n  width: 80%;\r\n  background: var(--theme-color2);\r\n  border-radius: 50px 50px 50px 0;\r\n  transform: rotate(5deg);\r\n  z-index: -1;\r\n}\r\n\r\n.alumni .content-img img{\r\n  border-radius: 50px 50px 50px 0;\r\n  width: 100%;\r\n}\r\n\r\n.alumni .content-btn{\r\n  margin-top: 40px;\r\n}\r\n\r\n.alumni-details .details-wrapper{\r\n  border-top: 1px solid var(--border-info-color);\r\n  padding-top: 60px;\r\n}\r\n\r\n.alumni-details .content-list li{\r\n  margin-top: 8px;\r\n}\r\n\r\n.alumni-details .content-list i{\r\n  color: var(--theme-color);\r\n  margin-right: 8px;\r\n}\r\n\r\n.alumni-details .details-item{\r\n  margin-bottom: 40px;\r\n}\r\n\r\n.alumni-details .details-item img{\r\n  border-radius: 20px;\r\n}\r\n\r\n@media all and (max-width: 991px) {\r\n  .alumni .content-info{\r\n    margin-top: 70px;\r\n  }\r\n}\r\n\r\n\r\n\r\n/*====================\r\n66. Scholarship css \r\n======================*/\r\n\r\n.scholarship{\r\n  position: relative;\r\n}\r\n\r\n.scholarship-content img{\r\n  border-radius: 20px;\r\n}\r\n\r\n.scholarship-item{\r\n  margin-bottom: 25px;\r\n}\r\n\r\n.scholarship-icon img{\r\n  width: 60px;\r\n}\r\n\r\n.scholarship-item h4{\r\n  margin-top: 20px;\r\n  margin-bottom: 10px;\r\n}\r\n\r\n.scholarship-details .details-wrapper{\r\n  border-top: 1px solid var(--border-info-color);\r\n  padding-top: 60px;\r\n}\r\n\r\n.scholarship-details .content-list li{\r\n  margin-top: 8px;\r\n}\r\n\r\n.scholarship-details .content-list i{\r\n  color: var(--theme-color);\r\n  margin-right: 8px;\r\n}\r\n\r\n.scholarship-details .details-item{\r\n  margin-bottom: 40px;\r\n}\r\n\r\n\r\n\r\n/*====================\r\n67. Fund css \r\n======================*/\r\n\r\n.fund-area{\r\n  position: relative;\r\n}\r\n\r\n.fund-content img{\r\n  border-radius: 20px;\r\n}\r\n\r\n.fund-contact{\r\n  margin: 20px 0;\r\n  background: var(--theme-bg-light);\r\n  padding: 30px;\r\n  border-radius: 10px;\r\n}\r\n\r\n.fund-contact li{\r\n  margin: 8px 0;\r\n}\r\n\r\n.fund-contact i{\r\n  color: var(--theme-color2);\r\n  margin-right: 5px;\r\n}\r\n\r\n.fund-btn{\r\n  margin-bottom: 20px;\r\n}\r\n\r\n.fund-btn .theme-btn{\r\n  width: 100%;\r\n}\r\n\r\n.fund-btn .theme-btn::before{\r\n  width: 400px;\r\n  height: 400px;\r\n}\r\n\r\n.fund-list i {\r\n  color: var(--theme-color2);\r\n  margin-right: 10px;\r\n}\r\n\r\n\r\n/*====================\r\n68. Athletic css \r\n======================*/\r\n\r\n.athletic{\r\n  position: relative;\r\n}\r\n\r\n.athletic-content img{\r\n  border-radius: 20px;\r\n}\r\n\r\n\r\n\r\n/*====================\r\n69. Health care css \r\n======================*/\r\n\r\n.health-care{\r\n  position: relative;\r\n}\r\n\r\n.health-care-content img{\r\n  border-radius: 20px;\r\n}\r\n\r\n.health-care-content .content-list li{\r\n  margin-top: 8px;\r\n}\r\n\r\n.health-care-content .content-list i{\r\n  color: var(--theme-color);\r\n  margin-right: 8px;\r\n}\r\n\r\n\r\n\r\n/*====================\r\n70. Footer css \r\n======================*/\r\n\r\n.footer-area {\r\n  background: var(--footer-bg);\r\n  position: relative;\r\n  z-index: 1;\r\n}\r\n\r\n.footer-shape{\r\n  position: absolute;\r\n  top: 50%;\r\n  left: 50%;\r\n  transform: translate(-50%, -50%);\r\n  opacity: .05;\r\n  z-index: -1;\r\n}\r\n\r\n.footer-widget-box {\r\n  margin-bottom: 20px;\r\n}\r\n\r\n.footer-widget {\r\n  position: relative;\r\n  z-index: 1;\r\n}\r\n\r\n.footer-logo img {\r\n  width: 220px;\r\n  margin-bottom: 25px;\r\n}\r\n\r\n.copyright {\r\n  position: relative;background: #ff7a00;\r\n}\r\n\r\n.copyright .copyright-wrapper{\r\n  padding: 15px 10px;\r\n  border-top: 1px solid var(--border-white-color);\r\n}\r\n\r\n.copyright .footer-menu {\r\n  margin: 0;\r\n  padding: 0;\r\n  text-align: right;\r\n}\r\n\r\n.copyright .footer-menu li {\r\n  display: inline-block;\r\n  margin-left: 25px;\r\n  font-size: 16px;\r\n}\r\n\r\n.copyright .footer-menu li a {\r\n  color: var(--footer-text-color);\r\n  transition: var(--transition);\r\n}\r\n\r\n.copyright .footer-menu li a:hover {\r\n  color: var(--theme-color2);\r\n}\r\n\r\n.copyright .copyright-text {\r\n  color: var(--footer-text-color);\r\n  margin-bottom: 0px;\r\n  font-size: 16px;\r\n}\r\n\r\n.copyright .copyright-text a {\r\n  /* color: var(--theme-color2); */\r\n  font-weight: 500;\r\n}\r\n\r\n.footer-widget-title {\r\n  color: var(--color-white);\r\n  position: relative;\r\n  padding-bottom: 20px;\r\n  margin-bottom: 0px;\r\n  font-size: 18px;\r\n  z-index: 1;\r\n}\r\n\r\n/*\r\n.footer-widget-title::before {\r\n  content: '';\r\n  position: absolute;\r\n  width: 90px;\r\n  height: 3px;\r\n  background: rgba(255, 255, 255, 0.2);\r\n  bottom: 0;\r\n  left: 0;\r\n  z-index: -1;\r\n}\r\n*/\r\n\r\n/*\r\n.footer-widget-title::after {\r\n  content: '';\r\n  position: absolute;\r\n  width: 30px;\r\n  height: 3px;\r\n  background: var(--theme-color2);\r\n  bottom: 0;\r\n  left: 18px;\r\n  z-index: -1;\r\n}\r\n*/\r\n\r\nul.copyright-text li{display: inline-block;padding-right: 10px;}\r\n.footer-list {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: .65rem;\r\n}\r\n\r\n.footer-list li a {\r\n  color: var(--color-white);\r\n  transition: var(--transition);font-size: 14px;\r\n}\r\n\r\n.footer-list li a i {\r\n  margin-right: 5px;\r\n  color: var(--theme-color2);\r\n}\r\n\r\n.footer-list li a:hover {\r\n  padding-left: 10px;\r\n  color: var(--theme-color2);\r\n}\r\n\r\n.footer-widget-box p {\r\n  color: var(--color-white);\r\n  padding-right: 18px;\r\n  margin-bottom: 20px;\r\n}\r\n\r\n.footer-social {\r\n  display: flex;\r\n  gap: 15px;\r\n  justify-content: end;\r\n}\r\n\r\n.footer-social li a i {\r\n  height: 38px;\r\n  width: 38px;\r\n  line-height: 38px;\r\n  text-align: center;\r\n  border-radius: 10px 10px 10px 0;\r\n  background: var(--color-white);\r\n  color: var(--theme-color2);\r\n  transition: var(--transition);\r\n}\r\n\r\n.footer-social li a i:hover {\r\n  background: var(--theme-color2);\r\n  color: var(--color-white);\r\n}\r\n\r\n.footer-contact li {\r\n  position: relative;\r\n  display: flex;\r\n  justify-content: start;\r\n  align-items: center;\r\n  color: var(--footer-text-color);\r\n  font-size: 16px;\r\n  margin-bottom: 15px;\r\n}\r\n\r\n.footer-contact li a {\r\n  color: var(--footer-text-color);\r\n  -webkit-transition: 0.3s;\r\n  transition: 0.3s;\r\n}\r\n\r\n.footer-contact li i {\r\n  width: 30px;\r\n  height: 30px;\r\n  line-height: 30px;\r\n  font-size: 16px;\r\n  margin-right: 15px;\r\n  border-radius: 10px 10px 10px 0;\r\n  background: var(--theme-color2);\r\n  text-align: center;\r\n  -webkit-transition: 0.3s;\r\n  transition: 0.3s;\r\n  color: var(--color-white);\r\n}\r\n\r\n.subscribe-form .form-control {\r\n  padding: 16px 20px;\r\n  border-radius: 12px;\r\n  box-shadow: none;\r\n  border: none;\r\n}\r\n\r\n.subscribe-form .theme-btn {\r\n  margin-top: 20px;\r\n  width: 100%;\r\n  padding: 14px;\r\n}\r\n\r\n.subscribe-form .theme-btn:hover {\r\n  color: var(--theme-color2);\r\n}\r\n\r\n.subscribe-form .theme-btn::before{\r\n  background: var(--color-white);\r\n}\r\n\r\n.subscribe-form .theme-btn:hover::after{\r\n  border-color: var(--theme-color2);\r\n}\r\n\r\n\r\n@media all and (max-width: 1199px) {\r\n  .footer-widget-box {\r\n    margin-bottom: 50px;\r\n  }\r\n}\r\n\r\n@media all and (max-width: 991px) {\r\n  .footer-widget-wrapper {\r\n    padding-bottom: 0px;\r\n  }\r\n\r\n  .copyright .footer-menu {\r\n    float: left;\r\n    margin-top: 20px;\r\n    text-align: left;\r\n  }\r\n\r\n  .copyright .footer-menu li {\r\n    margin-left: 0;\r\n    margin-right: 15px;\r\n  }\r\n\r\n}\r\n\r\n@media all and (max-width: 767px) {\r\n  .footer-widget-wrapper {\r\n    padding-bottom: 0px;\r\n  }\r\n\r\n  .footer-social {\r\n    justify-content: flex-start;\r\n    margin-top: 20px;\r\n  }\r\n\r\n  .copyright::before{\r\n    width: 40%;\r\n  }\r\n}\r\n\r\n\r\n\r\n/*====================\r\n71. Home 2\r\n======================*/\r\n\r\n.home-2 .header{\r\n  background: var(--theme-color);\r\n}\r\n\r\n.home-2 .header-top{\r\n  padding: 12px 0 13px 0;\r\n}\r\n\r\n.home-2 .header-top::before{\r\n  display: none;\r\n}\r\n\r\n.home-2 .header-top::after{\r\n  display: none;\r\n}\r\n\r\n.home-2 .header-top-contact ul li{\r\n  border-color: rgba(255, 255, 255, 0.5);\r\n}\r\n\r\n.home-2 .header-top-social a{\r\n  background: var(--color-white);\r\n  color: var(--theme-color2);\r\n}\r\n\r\n.home-2 .header-top-social a:hover{\r\n  background: var(--theme-color);\r\n  color: var(--color-white);\r\n}\r\n\r\n.home-2 .hero-single{\r\n  padding-top: 200px;\r\n  padding-bottom: 180px;\r\n}\r\n\r\n.home-2 .hero-single::before{\r\n  background: rgba(0, 0, 0, .65);\r\n}\r\n\r\n.home-2 .hero-single .hero-title span{\r\n  -webkit-text-stroke: 2px var(--theme-color2);\r\n  -webkit-text-fill-color: transparent;\r\n}\r\n\r\n\r\n@media all and (min-width: 1199px) {\r\n  .home-2 .navbar{\r\n    background: transparent;\r\n    padding-right: 25px;\r\n  }\r\n  \r\n  .home-2 .navbar.fixed-top{\r\n    padding-right: 0;\r\n  }\r\n  \r\n  .home-2 .navbar::before{\r\n    content: \"\";\r\n    position: absolute;\r\n    left: 0;\r\n    top: 0;\r\n    right: 11%;\r\n    background: var(--color-white);\r\n    height: 100%;\r\n    border-radius: 0 10px 10px 0;\r\n  }\r\n  \r\n  .home-2 .main{\r\n    margin-top: -3rem;\r\n  }\r\n  \r\n}\r\n\r\n@media all and (min-width: 992px) {\r\n  .home-2 .navbar .dropdown-menu{\r\n    border-top: none;\r\n    border-radius: 20px;\r\n    background: var(--color-white);\r\n  }\r\n  \r\n  .home-2 .navbar .dropdown-menu .dropdown-item{\r\n    color: var(--color-dark);\r\n    border-bottom: 1px dashed var(--border-info-color);\r\n  }\r\n  \r\n  .home-2 .navbar .dropdown-menu li:last-child .dropdown-item{\r\n    border-bottom: none;\r\n  }\r\n  \r\n  .home-2 .menu-about p{\r\n    color: var(--color-dark);\r\n  }\r\n}\r\n\r\n@media (max-width: 991px) {\r\n  .navbar .dropdown-menu {\r\n      border-radius: 20px;\r\n  }\r\n}\r\n\r\n\r\n\r\n\r\n/*====================\r\n72. Home 3\r\n======================*/\r\n\r\n.home-3 .theme-btn{\r\n  border-radius: 50px;\r\n}\r\n\r\n.home-3 .header-top{\r\n  padding: 12px 0 14px 0;\r\n  background: var(--theme-color);\r\n}\r\n\r\n.home-3 .header-top::before,\r\n.home-3 .header-top::after{\r\n  display: none;\r\n}\r\n\r\n.home-3 .header-top-news{\r\n  color: var(--color-white);\r\n  text-transform: capitalize;\r\n}\r\n\r\n.home-3 .header-top-menu a{\r\n  color: var(--color-white);\r\n  margin-right: 6px;\r\n  padding-right: 8px;\r\n  border-right: 1px solid rgba(255, 255, 255, 0.1);\r\n}\r\n\r\n.home-3 .header-top-menu a:last-child{\r\n  border-right: none;\r\n  margin-right: 0;\r\n  padding-right: 0;\r\n}\r\n\r\n.home-3 .header-top-menu a:hover{\r\n  color: var(--theme-color);\r\n}\r\n\r\n.home-3 .hero-single{\r\n  padding-bottom: 150px;\r\n}\r\n\r\n.home-3 .hero-single::before{\r\n  background: rgba(0, 0, 0, .6);\r\n  opacity: unset;\r\n}\r\n\r\n.home-3 .hero-single .hero-title span{\r\n  -webkit-text-stroke: 2px var(--theme-color2);\r\n  -webkit-text-fill-color: transparent;\r\n}\r\n\r\n.home-3 .counter-box .icon{\r\n  border-radius: 30px 30px 30px 0;\r\n}\r\n\r\n.home-3 .counter-box .icon::before{\r\n  border-radius: 30px 30px 30px 0;\r\n}\r\n\r\n.home-3 .footer-area{\r\n  position: relative;\r\n  /* background-image: url(../img/footer/01.jpg); */\r\n  background-repeat: no-repeat;\r\n  background-position: center;\r\n  background-size: cover;\r\n  z-index: 1;\r\n}\r\n\r\n.home-3 .footer-area::before{\r\n  content: \"\";\r\n  position: absolute;\r\n  background: var(--footer-bg);\r\n  left: 0;\r\n  top: 0;\r\n  width: 100%;\r\n  height: 100%;\r\n  opacity: .95;\r\n}\r\n.copyright-text a{ color:#ffffff;}\r\n.srch_area ul{\r\n  text-align: left;\r\n  background: #f2f3f8;\r\n  border: 1px solid #ccc;\r\n  border-radius: 5px;\r\n}\r\n\r\n.srch_area ul li{\r\n  padding: 10px;\r\n  border-bottom: 1px solid #ccc;\r\n}\r\n\r\n.institute_card .img {\r\n  width: 100% !important;\r\n  height: 186px !important;\r\n  border: 1px solid #ccc;\r\n  border-radius: 10px !important;\r\n  padding: 5px;\r\n}\r\n.institute_card .img img{\r\n  border-radius: 10px !important;\r\n}\r\n\r\n.institute_list{\r\n  margin-bottom: 20px;\r\n}\r\n\r\n.teacher_list{\r\n  margin-bottom: 20px;\r\n}\r\n\r\n\r\n\r\n/* new hom page css start */\r\n\r\n\r\n.nws_scroll{background: #ff7900;display: flex;padding: 8px 0; color: #fff;}\r\n.nws_scroll p{font-size: 14px; color: #fff;margin-bottom: 0;}\r\n.counter_wrap{background: var(--color-white);box-shadow: var(--box-shadow);border-radius: 6px;}\r\n.user_bx_pd{display: flex;align-items: center;justify-content: center;gap: .75rem;width: 100%;height: 100%;border-radius: 6px;padding: 20px 0; }\r\n.bg_use_pd{background: #fff3ed;}\r\n.use_icn_hold{background: #feab31;border-radius: 10px;padding: 8px;}\r\n.exm_bg1{background: #fffae8;}\r\n .exm_bg2{background: #f4f1ff;}\r\n.exm_bg3{background: #fff3ed;}\r\n.prp_bg{background: #06513c;}\r\n.selection_wrap{border-radius: 8px;padding: 40px 0;}\r\n.title_slc{color: #fff;font-size: 32px;font-weight: 500;}\r\n.read_boy{position: absolute;left: 0;bottom: 0;}\r\n.read_boy img{width: 78%;}\r\n.selection_wrap .theme-btn {border-radius: 10px;}\r\n.crcle_elm{position: absolute;right: 0;bottom: 0;right: -32px;}\r\n.crcle_elm img{width: 78%;}\r\n.bg_sec_all{background: #f5f6fa;}\r\n.course_name_hold{background: var(--color-white);box-shadow: var(--box-shadow);border-radius: 8px;font-size: 14px;padding: 10px;text-align: center;}\r\n.course_inr_wrap{box-shadow: var(--box-shadow);border-radius: 8px;}\r\n.bg_crse1{background: #faf2e2;}\r\n .bg_crse2{background: #e1f7d7;}\r\n .bg_crse3{background: #f5e7fe;}\r\n.exm_content_pd{display: flex;justify-content: space-between;align-items: center;padding: 10px 14px;border: 8px;}\r\n\r\n\r\n.fame_slider_item{background: var(--color-white);box-shadow: var(--box-shadow);border-radius: 8px;padding: 30px;text-align: center;border: 1px solid #ccc; padding-top: 57px;}\r\n.round_thumb img{border-radius: 100%;border: 5px solid #ff7900;}\r\n.round_thumb{position: absolute;transform: translateX(-50%);left: 50%;top: 0;}\r\n.fame_cnt_all{position: relative;padding-top: 79px;}\r\n.nrm_title{color: var(--theme-color2);font-weight: 500;}\r\n.bookfree_bx{background: linear-gradient(45deg,  #ffbd61 0%,#ffffff 63%,#ffffff 100%); border-radius: 12px; padding: 42px;border: 1px solid #eae7e7;position: relative;}\r\n\r\n.title_add{font-size: 30px;font-weight: 500;color: #222222;line-height: 32px;}\r\n.title_add2{font-size: 20px;font-weight: 500;color: #222222;line-height: 32px;}\r\n.bookfree_bx .form-control{padding: 15px 20px;}\r\n.bookfree_bx button{border-radius: 10px;}\r\n.expert_right_img{position: absolute;right: 0;bottom: 0;}\r\n.expert_right_img img{width: 82%;}\r\n\r\n.test_series{background: linear-gradient(to bottom,  #f8eefe 0%,#ffffff 63%,#ffffff 100%); border: 1px solid #e1e2e1;border-radius: 12px;padding: 16px;}\r\n.tst_logo_wrap{display: flex;justify-content: space-between;align-items: flex-start;}\r\n.logo_tst_srs{width: 44px;height: 44px;}\r\n.usr_count{font-size: 12px;background: #fff;border-radius: 30px;padding: 1px 10px;border: 1px solid #ebe3f1;}\r\n.total_test_wraper{display: flex;justify-content:flex-start;gap:1rem;}\r\n.tst_wrap_txt{font-size: 11px; color: #222;}\r\n.grn_wrap{background: #3fb766;color:var(--color-white);padding: 0 8px;border-radius: 4px;}\r\n.orange{color: var(--theme-color2);}\r\n.highligt_orng{font-size: 13px;}\r\n.test_series ul li{font-size: 12px;list-style: disc;line-height: 28px;margin-left: 14px;}\r\n.test_series ul li:last-child{font-size: 12px;color: #3fb766;}\r\n.test_series .theme-btn{border-radius: 10px; padding: 10px 20px;margin-top: 10px;width: 100%;}\r\n.test_series_pd{background: rgb(255,255,255);background: linear-gradient(185deg, rgba(255,255,255,1) 14%, rgba(223,243,229,1) 95%);}\r\n.spl_plans{background: rgb(255,255,255);background: linear-gradient(185deg, rgba(255,255,255,1) 14%, rgba(255,241,221,1) 95%);}\r\n.student_right{position: absolute;bottom: 0;right: 0;}\r\n.spl_pln_bx_wrp{display: flex;gap:1rem;}\r\n.spl_pln_bx_one{padding: 14px;border: 1px dashed #3fb766;width: 322px;border-radius: 10px;}\r\n.spl_text_orange{color: #ff7900;line-height: 1.3}\r\n.spl_price{font-size: 20px;font-weight: 600;color: #3fb766;}\r\n.dark_color{color: #222;}\r\n.login_txt{font-size: 20px;font-weight: 500;}\r\n.student_right img{width: 78%;}\r\n.tst_btn .theme-btn{border-radius: 30px; padding: 6px 20px;}\r\n\r\n.solved_question .test_series{background: linear-gradient(to bottom,  #ebfae4 0%,#ffffff 63%,#ffffff 100%);}\r\n.simulating{font-size: 20px;font-weight: 500;}\r\n.sof_box{background: #3fb766;border-radius: 20px 20px 0 0;font-size: 34px;color: #fff;font-weight: 700;}\r\n.mock-text{font-size: 18px;}\r\n.mk_test_blw{display: flex;gap:1rem;justify-content: center;}\r\n.tst_mok_bx1{display: flex;gap:0.3rem;align-items: center;justify-content: center;font-size: 24px;color: #fff;font-weight: 600;}\r\n.mkst_bdr_rgt{border-right: 2px solid #fff;}\r\n.wdth_mg_tst_bx{width: 40px;height: 60px;display: flex; justify-content: center;align-items: center;}\r\n.orange_bg{background: #eb763c;}\r\n .ylw_bg{background: #dda512;}\r\n.drk-grn_bg{background: #095747;}\r\n.green_grndt {background: rgb(255, 255, 255);background: linear-gradient(185deg, rgba(255, 255, 255, 1) 14%, rgba(223, 243, 229, 1) 95%);}\r\n.scholorship .theme-btn{padding: 2px 20px;border-radius: 6px;}\r\n.Scholorship_txt{font-size: 36px; font-weight: 600;color: #2e363b;}\r\n.Scholorship_txt:before{content: \"\";position: absolute;left: 0; top:-31px;background-image: url(../../assets/img/exam/scholor3.png);background-repeat: no-repeat;width: 100%;height: 100%;}\r\n.scholor2 img{width: 20%;opacity: 0.3;}\r\n.scholor1{position: absolute;right: 0;bottom: 0;}\r\n.scholor1 img{width: 70%;}\r\n.most-title{font-size: 36px;font-weight: 500;line-height: 38px;}\r\n.prepare_txt{font-size: 18px!important;color: #222!important;}\r\n.hub{font-size: 20px;}\r\n.orange_grndt{background: linear-gradient(185deg, rgba(255, 255, 255, 1) 14%, rgba(255, 241, 221, 1) 95%);}\r\n.theme2_color{color: #ff7900;}\r\nul.bnr_ftrs{text-align: center;}\r\nul.bnr_ftrs li{display: inline-block;padding-right: 12px;color: #222;}\r\n.start_btn .theme-btn{border-radius: 10px;padding: 6px 20px;}\r\n.banner_exm_lft{position: absolute;left: 0;bottom: 0;}\r\n.banner_exm_right{position: absolute;right: 0;bottom: 0;}\r\n.banner_exm_lft img{width: 70%;}\r\n .banner_exm_right img{width: 70%;}\r\n\r\n\r\n/* new hom page css end */\r\n\r\n\r\n/* feed page css*/\r\n.srch_glass {\r\nposition: absolute;\r\nleft: 22px;\r\nline-height: 55px;\r\n}\r\n    \r\n    .spl_cards {\r\nbackground-color: #fff;\r\nbox-shadow: 0 0 15px rgba(0, 0, 0, 0.1);\r\npadding: 20px;\r\nborder-radius: 16px;\r\nbackground: #FFF;\r\nborder: none;\r\n}\r\n    \r\n    .feed_img {\r\nwidth: 56px;\r\nheight: 56px;\r\n}\r\n    \r\n    .feed_img img {\r\nwidth: 100%;\r\nheight: 100%;\r\nborder-radius: 50%;\r\nobject-fit: cover;\r\n}\r\n    \r\n    .coment_all_wrap{display: flex;justify-content: space-around;}\r\n\r\n/* feed page css end*/\r\n\r\n/* exam detail page ui style start*/\r\n.fixed-scrll  nav ul li a.active{\r\n  background-color: var(--theme-color)!important;color: var(--color-white);} \r\n \r\n/*    .fixed-scrll nav{width: 1528px;height: 60px;position: fixed;top: 0;left: 0; background: #fff;}*/\r\n  .faq-area .accordion-item{border-radius: 10px !important;}\r\n  \r\n  .faq-area .accordion-button{font-weight: 400;font-size: 18px;}\r\n  .site-breadcrumb.test_series_pd:before{display: none;}\r\n  .site-breadcrumb.test_series_pd .breadcrumb-title{    color: var(--color-dark); font-size: 38px;font-weight: 500;}\r\n  .site-breadcrumb.test_series_pd .breadcrumb-menu li::before{color: var(--color-dark);}\r\n  .site-breadcrumb .breadcrumb-menu li a{color: var(--color-dark);}\r\n  .site-breadcrumb.test_series_pd{text-align: left; padding-top: 70px;padding-bottom: 50px; border-top: 1px solid #ccc;}\r\n  .site-breadcrumb.test_series_pd .theme-btn{border-radius: 8px;    padding: 6px 20px;}\r\n  .item__enrolled{color:  var(--theme-color);font-size: .75rem;width: 100%;margin-top: .5rem;display: flex;align-items: center;gap: .5rem;}\r\n  .exm_dls_banner_small_dsc{ display: flex;align-items: center;gap: 4px;}\r\n  .quiz_exm .course-bottom { font-size: 12px;  line-height: 28px;padding-top: 0;margin-top: 0;}\r\n\r\n/* exam detail page ui style end*/\r\n\r\n/* exam detail prev paper ui style start*/\r\n.fixed-scrll  nav ul li a.active{\r\n  background-color: var(--theme-color)!important;color: var(--color-white);} \r\n \r\n/*    .fixed-scrll nav{width: 1528px;height: 60px;position: fixed;top: 0;left: 0; background: #fff;}*/\r\n  .faq-area .accordion-item{border-radius: 10px !important;}\r\n  \r\n  .faq-area .accordion-button{font-weight: 400;font-size: 18px;}\r\n  .site-breadcrumb.test_series_pd:before{display: none;}\r\n  .site-breadcrumb.test_series_pd .breadcrumb-title{    color: var(--color-dark); font-size: 38px;font-weight: 500;}\r\n  .site-breadcrumb.test_series_pd .breadcrumb-menu li::before{color: var(--color-dark);}\r\n  .site-breadcrumb .breadcrumb-menu li a{color: var(--color-dark);}\r\n  .site-breadcrumb.test_series_pd{text-align: left; padding-top: 70px;padding-bottom: 50px; border-top: 1px solid #ccc;}\r\n  .site-breadcrumb.test_series_pd .theme-btn{border-radius: 8px;    padding: 6px 20px;}\r\n  .item__enrolled{color:  var(--theme-color);font-size: .75rem;width: 100%;margin-top: .5rem;display: flex;align-items: center;gap: .5rem;}\r\n  .exm_dls_banner_small_dsc{ display: flex;align-items: center;gap: 4px;}\r\n  .quiz_exm .course-bottom { font-size: 12px;  line-height: 28px;padding-top: 0;margin-top: 0;}\r\n  .whitebx_btn{min-width: 140px;padding-left: 0;padding-right: 0;}\r\n\r\n/*modal code start here----------*/\r\n  \r\n  .modal.exam_prepration{ --bs-modal-width: 520px; --bs-border-radius-lg: 1.2rem;} \r\n  .modal.exam_prepration .modal-header { background: #F4F7FC;}\r\n  .modal.exam_prepration .theme-btn{border-radius: 10px;}\r\n  .modal.stepingform {--bs-modal-width: 990px;--bs-border-radius-lg: 1.4rem;}\r\n  .step_right_plan_wrap{display: flex;justify-content: space-between;font-size: 1rem;margin-bottom: 1rem;}\r\n  .plan{font-size: 16px;font-weight: 600;color: var(--color-dark);}\r\n  .change{color: var(--theme-color);}\r\n  .foundation_wrap{border: 2px solid #ff7900;background: #f6f3f0;position: relative;padding: 1rem;border-radius: 8px;margin-bottom: 18px;}\r\n  \r\n   .recommended {background: #3fb766;width: auto;padding: 2px 6px;position: absolute; right: 36px;top: -13px;font-size: 14px;text-align: center;border-radius: 4px;font-family: 'Jost';cursor: pointer;color: #fff;}\r\n  \r\n  .common_wrap{display: flex;align-items: center;justify-content: space-between;text-align: left;}\r\n  .old-price{font-weight: 400;font-size: .875rem;color: #86a1ae;margin-bottom: 0;text-decoration: line-through;}\r\n  .price_drop{color: #3fb766;font-size: 11px;}\r\n  .price_bold{font-size: 16px;font-weight: 600;color: var(--color-dark);}\r\n  .coupon{background: #3fb766;padding: 4px; color: #fff;border-radius: 4px;font-size: 11px;text-align: center;margin-bottom: 28px;}\r\n  .total_save{font-size: 15px;color: #3fb766; font-weight: 500;}\r\n  \r\n  /*prev paper-------------------*/\r\n  .whitebox{box-shadow: var(--box-shadow);background: #fff;padding: 20px;border-radius: 10px;border: 1px solid var(--border-info-color);margin-bottom: 20px;}\r\n  .white_innerbox_wrap{display: grid;grid-gap: .75rem;grid-template-columns: repeat(2, 1fr);grid-template-columns: 1fr min-content;}\r\n  .text_wrp_prv{ display: grid;gap: .5rem;padding-bottom: 40px;}\r\n  \r\n  .prv_whtbx_cta_area{display: grid;grid-auto-flow: column;align-items: center;gap: .5rem;}\r\n  .prv_whtbx_cta_area .theme-btn{border-radius: 10px;padding: 8px;}\r\n  .pro{background: var(--theme-color2);font-size: 11px;padding: 4px 8px;color:#fff;border-radius: 5px;}\r\n  .off-paper-head{font-size: 15px;font-weight: 500;color: var(--color-dark); }\r\n  .no_space{white-space: nowrap;}\r\n  \r\n  .subjct_hold{background: rgba(223,243,229,0.5);;position: absolute;left: 0;right: 0;bottom: 0;padding: 10px 20px;font-size: 14px;color: #000;border-radius: 0 0 10px 10px;}\r\n   .free_ppr{background: var(--theme-color);font-size: 11px;padding: 4px 8px;color:#fff;border-radius: 5px;}\r\n  .icn_color{color: var(--theme-color2);}\r\n  \r\n  @media all and (max-width: 767px) {\r\n      \r\n  .white_innerbox_wrap{display: flow;}\r\n      .text_wrp_prv{padding-bottom: 0;}  \r\n      .white_innerbox_wrap{padding-bottom: 40px;}  \r\n      \r\n  }\r\n  \r\n  \r\n  \r\n  ul.form-stepper {counter-reset: section;margin-bottom: 1.5rem;}\r\nul.form-stepper .form-stepper-circle {position: relative;}\r\nul.form-stepper .form-stepper-circle span {position: absolute;top: 50%;left: 50%;transform: translateY(-50%) translateX(-50%);}\r\n.form-stepper-horizontal {position: relative;display: -webkit-box;display: -ms-flexbox;display: flex;-webkit-box-pack: justify;\r\n-ms-flex-pack: justify;justify-content: space-between;    width: 54%;}\r\nul.form-stepper > li:not(:last-of-type) {margin-bottom: 0.625rem;-webkit-transition: margin-bottom 0.4s;\r\n-o-transition: margin-bottom 0.4s;transition: margin-bottom 0.4s;}\r\n.form-stepper-horizontal > li:not(:last-of-type) {margin-bottom: 0 !important;}\r\n.form-stepper-horizontal li {position: relative;display: -webkit-box;display: -ms-flexbox;\r\ndisplay: flex;-webkit-box-flex: 1;-ms-flex: 1;flex: 1;-webkit-box-align: start;-ms-flex-align: start;align-items: start;-webkit-transition: 0.5s;transition: 0.5s;}\r\n.form-stepper-horizontal li:not(:last-child):after {position: relative;-webkit-box-flex: 1; -ms-flex: 1;flex: 1;height: 1px;content: \"\";\r\ntop: 19%;}\r\n.form-stepper-horizontal li:after {background-color: #d3d3d3;}\r\n.form-stepper-horizontal li.form-stepper-completed:after {background-color: #4da3ff;}\r\n.form-stepper-horizontal li:last-child {flex: unset;}\r\nul.form-stepper li a .form-stepper-circle {display: inline-block;width: 20px;height: 20px;margin-right: 0;line-height: 20px;\r\ntext-align: center;background: rgba(0, 0, 0, 0.38);border-radius: 50%;}\r\n.form-stepper .form-stepper-active .form-stepper-circle {background-color: #0b9ef0 !important;color: #fff;}\r\n.form-stepper .form-stepper-active .label {color: #0b9ef0 !important;}\r\n.form-stepper .form-stepper-active .form-stepper-circle:hover {background-color: #024f94 !important;color: #fff !important;}\r\n.form-stepper .form-stepper-unfinished .form-stepper-circle {background-color: #d3d3d3;}\r\n.form-stepper .form-stepper-completed .form-stepper-circle {background-color: #21ae51 !important;color: #fff;font-size: 12px;}\r\n.form-stepper .form-stepper-completed .form-stepper-circle:before {content: \"\\f00c\"; font-family: \"Font Awesome 6 Pro\"; line-height: 20px;}              \r\n.form-stepper .form-stepper-completed .label { color: #21ae51 !important;}\r\n.form-stepper .form-stepper-completed .form-stepper-circle:hover {background-color: #0e9594 !important; color: #fff !important;}\r\n.form-stepper .form-stepper-active span.text-muted { color: #fff !important;}\r\n.form-stepper .form-stepper-completed span.text-muted {color: #fff !important;}\r\n.form-stepper .label {font-size: 0.9rem;font-family: 'Jost', sans-serif;margin-top: 0.5rem;}\r\n.form-stepper a { cursor: default;}  \r\n     \r\n\r\n/* exam detail prev paper ui style end*/"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
